
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $72b03fdf46effee2$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 256, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194048) && ($dca0ddb82b882518$var$nextTransitionLane = 256);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_417) {
            var $dca0ddb82b882518$var$element$jscomp$inline_418 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_417 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_418.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = $dca0ddb82b882518$var$isSupported$jscomp$inline_417;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState$1 = null);
        $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState$1 = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$38);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, $dca0ddb82b882518$var$createEffectInstance(), create, createDeps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, createDeps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateEffect(create, createDeps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$41 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$41, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 124) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, $dca0ddb82b882518$var$createEffectInstance(), $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
}, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(init);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, init = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = init, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = init), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$thenableIndexCounter = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState = null;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects(wasDelayedCommit) {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects(wasDelayedCommit);
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$174, root$174 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1528 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1528 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1528++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1529 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1528], $dca0ddb82b882518$var$domEventName$jscomp$inline_1530 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531 = $dca0ddb82b882518$var$eventName$jscomp$inline_1529[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1529.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1530, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1531);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $dca0ddb82b882518$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $dca0ddb82b882518$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$244 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$244 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $dca0ddb82b882518$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$250)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane();
                            lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $acw62.version;
if ("19.1.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2257.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2257.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2257.inject($dca0ddb82b882518$var$internals$jscomp$inline_2256), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.1.1";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));





var $acw62 = parcelRequire("acw62");
/**
 * react-router v7.7.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $ee6d600502474136$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router-dom/node_modules/react-router/dist/development/chunk-C37GKA54.mjs"
});
var $ee6d600502474136$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $ee6d600502474136$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $ee6d600502474136$var$__typeError("Cannot " + msg);
var $ee6d600502474136$var$__privateGet = (obj, member, getter)=>($ee6d600502474136$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $ee6d600502474136$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $ee6d600502474136$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $ee6d600502474136$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($ee6d600502474136$export$e19cd5f9376f8cee || {});
var $ee6d600502474136$var$PopStateEventType = "popstate";
function $ee6d600502474136$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $ee6d600502474136$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ee6d600502474136$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $ee6d600502474136$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $ee6d600502474136$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $ee6d600502474136$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $ee6d600502474136$export$fe53371bee54353d(to);
    }
    return $ee6d600502474136$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $ee6d600502474136$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ee6d600502474136$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ee6d600502474136$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $ee6d600502474136$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ee6d600502474136$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $ee6d600502474136$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ee6d600502474136$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ee6d600502474136$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $ee6d600502474136$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $ee6d600502474136$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $ee6d600502474136$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ee6d600502474136$var$createKey()
    };
    return location;
}
function $ee6d600502474136$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $ee6d600502474136$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ee6d600502474136$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $ee6d600502474136$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ee6d600502474136$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $ee6d600502474136$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ee6d600502474136$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $ee6d600502474136$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($ee6d600502474136$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($ee6d600502474136$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $ee6d600502474136$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $ee6d600502474136$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $ee6d600502474136$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $ee6d600502474136$export$f4fcb186418daff5(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $ee6d600502474136$var$_map;
var $ee6d600502474136$export$b754276817659c2d = class {
    constructor(init){
        $ee6d600502474136$var$__privateAdd(this, $ee6d600502474136$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    get(context) {
        if ($ee6d600502474136$var$__privateGet(this, $ee6d600502474136$var$_map).has(context)) return $ee6d600502474136$var$__privateGet(this, $ee6d600502474136$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    set(context, value) {
        $ee6d600502474136$var$__privateGet(this, $ee6d600502474136$var$_map).set(context, value);
    }
};
$ee6d600502474136$var$_map = new WeakMap();
var $ee6d600502474136$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ee6d600502474136$var$isUnsupportedLazyRouteObjectKey(key) {
    return $ee6d600502474136$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $ee6d600502474136$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "unstable_middleware",
    "children"
]);
function $ee6d600502474136$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $ee6d600502474136$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $ee6d600502474136$var$isIndexRoute(route) {
    return route.index === true;
}
function $ee6d600502474136$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ee6d600502474136$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $ee6d600502474136$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($ee6d600502474136$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ee6d600502474136$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $ee6d600502474136$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $ee6d600502474136$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $ee6d600502474136$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ee6d600502474136$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ee6d600502474136$var$flattenRoutes(routes);
    $ee6d600502474136$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $ee6d600502474136$var$decodePath(pathname);
        matches = $ee6d600502474136$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $ee6d600502474136$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $ee6d600502474136$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $ee6d600502474136$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ee6d600502474136$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $ee6d600502474136$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $ee6d600502474136$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ee6d600502474136$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $ee6d600502474136$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $ee6d600502474136$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ee6d600502474136$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ee6d600502474136$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $ee6d600502474136$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $ee6d600502474136$var$paramRe = /^:[\w-]+$/;
var $ee6d600502474136$var$dynamicSegmentValue = 3;
var $ee6d600502474136$var$indexRouteValue = 2;
var $ee6d600502474136$var$emptySegmentValue = 1;
var $ee6d600502474136$var$staticSegmentValue = 10;
var $ee6d600502474136$var$splatPenalty = -2;
var $ee6d600502474136$var$isSplat = (s)=>s === "*";
function $ee6d600502474136$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ee6d600502474136$var$isSplat)) initialScore += $ee6d600502474136$var$splatPenalty;
    if (index) initialScore += $ee6d600502474136$var$indexRouteValue;
    return segments.filter((s)=>!$ee6d600502474136$var$isSplat(s)).reduce((score, segment)=>score + ($ee6d600502474136$var$paramRe.test(segment) ? $ee6d600502474136$var$dynamicSegmentValue : segment === "" ? $ee6d600502474136$var$emptySegmentValue : $ee6d600502474136$var$staticSegmentValue), initialScore);
}
function $ee6d600502474136$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ee6d600502474136$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ee6d600502474136$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $ee6d600502474136$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ee6d600502474136$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ee6d600502474136$var$normalizePathname($ee6d600502474136$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ee6d600502474136$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $ee6d600502474136$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ee6d600502474136$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ee6d600502474136$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify2(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $ee6d600502474136$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $ee6d600502474136$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ee6d600502474136$var$compilePath(path, caseSensitive = false, end = true) {
    $ee6d600502474136$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $ee6d600502474136$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $ee6d600502474136$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $ee6d600502474136$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $ee6d600502474136$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $ee6d600502474136$var$joinPaths([
        basename,
        pathname
    ]);
}
function $ee6d600502474136$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ee6d600502474136$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ee6d600502474136$var$normalizeSearch(search),
        hash: $ee6d600502474136$var$normalizeHash(hash)
    };
}
function $ee6d600502474136$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ee6d600502474136$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $ee6d600502474136$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $ee6d600502474136$var$getResolveToMatches(matches) {
    let pathMatches = $ee6d600502474136$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $ee6d600502474136$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $ee6d600502474136$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $ee6d600502474136$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $ee6d600502474136$var$getInvalidPathError("?", "pathname", "search", to));
        $ee6d600502474136$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $ee6d600502474136$var$getInvalidPathError("#", "pathname", "hash", to));
        $ee6d600502474136$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $ee6d600502474136$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ee6d600502474136$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $ee6d600502474136$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $ee6d600502474136$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $ee6d600502474136$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $ee6d600502474136$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $ee6d600502474136$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $ee6d600502474136$export$4051a07651545597(data2, init) {
    return new $ee6d600502474136$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $ee6d600502474136$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $ee6d600502474136$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ee6d600502474136$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $ee6d600502474136$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $ee6d600502474136$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $ee6d600502474136$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $ee6d600502474136$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $ee6d600502474136$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $ee6d600502474136$var$validMutationMethods = new Set($ee6d600502474136$var$validMutationMethodsArr);
var $ee6d600502474136$var$validRequestMethodsArr = [
    "GET",
    ...$ee6d600502474136$var$validMutationMethodsArr
];
var $ee6d600502474136$var$validRequestMethods = new Set($ee6d600502474136$var$validRequestMethodsArr);
var $ee6d600502474136$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $ee6d600502474136$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $ee6d600502474136$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $ee6d600502474136$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $ee6d600502474136$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $ee6d600502474136$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ee6d600502474136$var$isAbsoluteUrl = (url)=>$ee6d600502474136$var$ABSOLUTE_URL_REGEX.test(url);
var $ee6d600502474136$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $ee6d600502474136$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $ee6d600502474136$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $ee6d600502474136$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $ee6d600502474136$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let mapRouteProperties2 = init.mapRouteProperties || $ee6d600502474136$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $ee6d600502474136$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $ee6d600502474136$var$defaultDataStrategyWithMiddleware;
    let future = {
        unstable_middleware: false,
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ee6d600502474136$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $ee6d600502474136$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ee6d600502474136$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$ee6d600502474136$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$ee6d600502474136$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ee6d600502474136$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $ee6d600502474136$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ee6d600502474136$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $ee6d600502474136$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$ee6d600502474136$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ee6d600502474136$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $ee6d600502474136$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ee6d600502474136$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ee6d600502474136$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ee6d600502474136$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ee6d600502474136$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $ee6d600502474136$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ee6d600502474136$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $ee6d600502474136$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ee6d600502474136$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $ee6d600502474136$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $ee6d600502474136$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $ee6d600502474136$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ee6d600502474136$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $ee6d600502474136$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = new $ee6d600502474136$export$b754276817659c2d(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $ee6d600502474136$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $ee6d600502474136$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($ee6d600502474136$var$isErrorResult(result) && $ee6d600502474136$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $ee6d600502474136$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $ee6d600502474136$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$ee6d600502474136$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $ee6d600502474136$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $ee6d600502474136$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $ee6d600502474136$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $ee6d600502474136$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ee6d600502474136$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $ee6d600502474136$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($ee6d600502474136$var$isErrorResult(result)) {
            let boundaryMatch = $ee6d600502474136$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $ee6d600502474136$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $ee6d600502474136$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $ee6d600502474136$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $ee6d600502474136$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $ee6d600502474136$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$ee6d600502474136$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $ee6d600502474136$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $ee6d600502474136$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $ee6d600502474136$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$ee6d600502474136$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $ee6d600502474136$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ee6d600502474136$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $ee6d600502474136$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $ee6d600502474136$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $ee6d600502474136$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = new $ee6d600502474136$export$b754276817659c2d(init.unstable_getContext ? await init.unstable_getContext() : void 0);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ee6d600502474136$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ee6d600502474136$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ee6d600502474136$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ee6d600502474136$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $ee6d600502474136$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $ee6d600502474136$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($ee6d600502474136$var$isRedirectResult(actionResult) || $ee6d600502474136$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $ee6d600502474136$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($ee6d600502474136$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $ee6d600502474136$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $ee6d600502474136$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($ee6d600502474136$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ee6d600502474136$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ee6d600502474136$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ee6d600502474136$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ee6d600502474136$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $ee6d600502474136$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ee6d600502474136$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $ee6d600502474136$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $ee6d600502474136$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $ee6d600502474136$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $ee6d600502474136$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ee6d600502474136$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $ee6d600502474136$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ee6d600502474136$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $ee6d600502474136$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $ee6d600502474136$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $ee6d600502474136$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $ee6d600502474136$var$getDoneFetcher(void 0));
            return;
        }
        if ($ee6d600502474136$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $ee6d600502474136$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($ee6d600502474136$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $ee6d600502474136$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $ee6d600502474136$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $ee6d600502474136$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $ee6d600502474136$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($ee6d600502474136$var$isAbsoluteUrl(location)) {
                const url = $ee6d600502474136$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ee6d600502474136$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ee6d600502474136$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($ee6d600502474136$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $ee6d600502474136$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $ee6d600502474136$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $ee6d600502474136$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($ee6d600502474136$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $ee6d600502474136$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $ee6d600502474136$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $ee6d600502474136$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $ee6d600502474136$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $ee6d600502474136$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ee6d600502474136$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ee6d600502474136$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ee6d600502474136$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ee6d600502474136$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ee6d600502474136$export$386d57f03f0b2883;
        $ee6d600502474136$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $ee6d600502474136$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $ee6d600502474136$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $ee6d600502474136$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $ee6d600502474136$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$ee6d600502474136$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $ee6d600502474136$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $ee6d600502474136$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $ee6d600502474136$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $ee6d600502474136$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $ee6d600502474136$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ee6d600502474136$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $ee6d600502474136$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    return router;
}
function $ee6d600502474136$export$3336b097a6fbc59a(routes, opts) {
    $ee6d600502474136$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $ee6d600502474136$var$defaultMapRouteProperties;
    let dataRoutes = $ee6d600502474136$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, unstable_stream: stream, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $ee6d600502474136$var$createLocation("", $ee6d600502474136$export$fe53371bee54353d(url), null, "default");
        let matches = $ee6d600502474136$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $ee6d600502474136$export$b754276817659c2d();
        let respondOrStreamStaticContext = (ctx)=>{
            return stream ? stream(requestContext, ()=>Promise.resolve(ctx)) : respond ? respond(ctx) : ctx;
        };
        if (!$ee6d600502474136$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ee6d600502474136$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ee6d600502474136$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respondOrStreamStaticContext(staticContext);
        } else if (!matches) {
            let error = $ee6d600502474136$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ee6d600502474136$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return respondOrStreamStaticContext(staticContext);
        }
        if (stream || respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            $ee6d600502474136$export$f5708dca728d7177(requestContext instanceof $ee6d600502474136$export$b754276817659c2d, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            try {
                await $ee6d600502474136$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $ee6d600502474136$var$runMiddlewarePipeline({
                    request: request,
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, true, async ()=>{
                    if (stream) {
                        let res2 = await stream(requestContext, async (revalidationRequest)=>{
                            let result3 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
                            return $ee6d600502474136$export$3f1eb41d9a6a6a27(result3) ? result3 : {
                                location: location,
                                basename: basename,
                                ...result3
                            };
                        });
                        return res2;
                    }
                    $ee6d600502474136$export$f5708dca728d7177(respond, "Expected respond to be defined");
                    let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
                    if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result2)) return result2;
                    renderedStaticContext = {
                        location: location,
                        basename: basename,
                        ...result2
                    };
                    let res = await respond(renderedStaticContext);
                    return res;
                }, async (error, routeId)=>{
                    if ($ee6d600502474136$export$3f1eb41d9a6a6a27(error)) return error;
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $ee6d600502474136$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $ee6d600502474136$var$findNearestBoundary(matches, routeId).route.id);
                        return respondOrStreamStaticContext(staticContext);
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $ee6d600502474136$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $ee6d600502474136$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return respondOrStreamStaticContext(staticContext);
                    }
                });
                $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($ee6d600502474136$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, unstable_respond: respond } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $ee6d600502474136$var$createLocation("", $ee6d600502474136$export$fe53371bee54353d(url), null, "default");
        let matches = $ee6d600502474136$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $ee6d600502474136$export$b754276817659c2d();
        if (!$ee6d600502474136$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ee6d600502474136$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ee6d600502474136$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ee6d600502474136$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ee6d600502474136$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $ee6d600502474136$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (respond && matches.some((m)=>m.route.unstable_middleware || typeof m.route.lazy === "object" && m.route.lazy.unstable_middleware)) {
            $ee6d600502474136$export$f5708dca728d7177(requestContext instanceof $ee6d600502474136$export$b754276817659c2d, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            await $ee6d600502474136$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $ee6d600502474136$var$runMiddlewarePipeline({
                request: request,
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, true, async ()=>{
                let result2 = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result2)) return respond(result2);
                let error2 = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error2 !== void 0) throw error2;
                let value = result2.actionData ? Object.values(result2.actionData)[0] : Object.values(result2.loaderData)[0];
                return typeof value === "string" ? new Response(value) : Response.json(value);
            }, (error2)=>{
                if ($ee6d600502474136$export$3f1eb41d9a6a6a27(error2)) return respond(error2);
                return new Response(String(error2), {
                    status: 500,
                    statusText: "Unexpected Server Error"
                });
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $ee6d600502474136$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ee6d600502474136$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $ee6d600502474136$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $ee6d600502474136$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($ee6d600502474136$var$isDataStrategyResult(e) && $ee6d600502474136$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($ee6d600502474136$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ee6d600502474136$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $ee6d600502474136$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($ee6d600502474136$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($ee6d600502474136$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($ee6d600502474136$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $ee6d600502474136$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $ee6d600502474136$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($ee6d600502474136$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $ee6d600502474136$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $ee6d600502474136$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $ee6d600502474136$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $ee6d600502474136$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $ee6d600502474136$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                return $ee6d600502474136$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $ee6d600502474136$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $ee6d600502474136$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $ee6d600502474136$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $ee6d600502474136$var$callDataStrategyImpl(dataStrategy || $ee6d600502474136$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($ee6d600502474136$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $ee6d600502474136$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $ee6d600502474136$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $ee6d600502474136$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $ee6d600502474136$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $ee6d600502474136$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $ee6d600502474136$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $ee6d600502474136$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $ee6d600502474136$var$resolveTo(to ? to : ".", $ee6d600502474136$var$getResolveToMatches(contextualMatches), $ee6d600502474136$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $ee6d600502474136$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $ee6d600502474136$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $ee6d600502474136$export$fe53371bee54353d(path);
}
function $ee6d600502474136$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$ee6d600502474136$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ee6d600502474136$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ee6d600502474136$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ee6d600502474136$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $ee6d600502474136$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$ee6d600502474136$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$ee6d600502474136$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ee6d600502474136$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ee6d600502474136$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ee6d600502474136$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ee6d600502474136$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ee6d600502474136$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($ee6d600502474136$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $ee6d600502474136$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $ee6d600502474136$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $ee6d600502474136$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $ee6d600502474136$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $ee6d600502474136$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $ee6d600502474136$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (route.loader == null) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $ee6d600502474136$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($ee6d600502474136$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $ee6d600502474136$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $ee6d600502474136$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $ee6d600502474136$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $ee6d600502474136$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $ee6d600502474136$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $ee6d600502474136$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $ee6d600502474136$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($ee6d600502474136$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $ee6d600502474136$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $ee6d600502474136$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $ee6d600502474136$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ee6d600502474136$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $ee6d600502474136$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $ee6d600502474136$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$ee6d600502474136$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $ee6d600502474136$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $ee6d600502474136$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $ee6d600502474136$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$ee6d600502474136$var$isSameRoute(aChild, bChild)));
}
var $ee6d600502474136$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $ee6d600502474136$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $ee6d600502474136$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $ee6d600502474136$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $ee6d600502474136$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $ee6d600502474136$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $ee6d600502474136$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $ee6d600502474136$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $ee6d600502474136$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $ee6d600502474136$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $ee6d600502474136$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $ee6d600502474136$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $ee6d600502474136$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $ee6d600502474136$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $ee6d600502474136$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $ee6d600502474136$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $ee6d600502474136$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $ee6d600502474136$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $ee6d600502474136$var$isNonNullable(value) {
    return value !== void 0;
}
function $ee6d600502474136$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.unstable_middleware) return void 0;
        return $ee6d600502474136$var$loadLazyRouteProperty({
            key: "unstable_middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($ee6d600502474136$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $ee6d600502474136$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $ee6d600502474136$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.unstable_middleware)) return $ee6d600502474136$var$defaultDataStrategy(args);
    return $ee6d600502474136$var$runMiddlewarePipeline(args, false, ()=>$ee6d600502474136$var$defaultDataStrategy(args), (error, routeId)=>({
            [routeId]: {
                type: "error",
                result: error
            }
        }));
}
async function $ee6d600502474136$var$runMiddlewarePipeline(args, propagateResult, handler, errorHandler) {
    let { matches: matches, request: request, params: params, context: context } = args;
    let middlewareState = {
        handlerResult: void 0
    };
    try {
        let tuples = matches.flatMap((m)=>m.route.unstable_middleware ? m.route.unstable_middleware.map((fn)=>[
                    m.route.id,
                    fn
                ]) : []);
        let result = await $ee6d600502474136$var$callRouteMiddleware({
            request: request,
            params: params,
            context: context
        }, tuples, propagateResult, middlewareState, handler);
        return propagateResult ? result : middlewareState.handlerResult;
    } catch (e) {
        if (!middlewareState.middlewareError) throw e;
        let result = await errorHandler(middlewareState.middlewareError.error, middlewareState.middlewareError.routeId);
        if (propagateResult || !middlewareState.handlerResult) return result;
        return Object.assign(middlewareState.handlerResult, result);
    }
}
async function $ee6d600502474136$var$callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) {
        if (request.signal.reason) throw request.signal.reason;
        throw new Error(`Request aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
    }
    let tuple = middlewares[idx];
    if (!tuple) {
        middlewareState.handlerResult = await handler();
        return middlewareState.handlerResult;
    }
    let [routeId, middleware] = tuple;
    let nextCalled = false;
    let nextResult = void 0;
    let next = async ()=>{
        if (nextCalled) throw new Error("You may only call `next()` once per middleware");
        nextCalled = true;
        let result = await $ee6d600502474136$var$callRouteMiddleware(args, middlewares, propagateResult, middlewareState, handler, idx + 1);
        if (propagateResult) {
            nextResult = result;
            return nextResult;
        }
    };
    try {
        let result = await middleware({
            request: args.request,
            params: args.params,
            context: args.context
        }, next);
        if (nextCalled) {
            if (result === void 0) return nextResult;
            else return result;
        } else return next();
    } catch (error) {
        if (!middlewareState.middlewareError) middlewareState.middlewareError = {
            routeId: routeId,
            error: error
        };
        else if (middlewareState.middlewareError.error !== error) middlewareState.middlewareError = {
            routeId: routeId,
            error: error
        };
        throw error;
    }
}
function $ee6d600502474136$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $ee6d600502474136$var$loadLazyRouteProperty({
        key: "unstable_middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $ee6d600502474136$var$loadLazyRoute(match.route, $ee6d600502474136$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $ee6d600502474136$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $ee6d600502474136$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $ee6d600502474136$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $ee6d600502474136$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            if (isUsingNewApi || shouldLoad || handlerOverride && !$ee6d600502474136$export$cbae47800eb95bc3(request.method) && (match.route.lazy || match.route.loader)) return $ee6d600502474136$var$callLoaderOrAction({
                request: request,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $ee6d600502474136$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $ee6d600502474136$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $ee6d600502474136$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $ee6d600502474136$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let unstable_runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `unstable_runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $ee6d600502474136$var$runMiddlewarePipeline(typedDataStrategyArgs, false, ()=>cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                unstable_runClientMiddleware: ()=>{
                    throw new Error("Cannot call `unstable_runClientMiddleware()` from within an `unstable_runClientMiddleware` handler");
                }
            }), (error, routeId)=>({
                [routeId]: {
                    type: "error",
                    result: error
                }
            }));
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        unstable_runClientMiddleware: unstable_runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $ee6d600502474136$var$callLoaderOrAction({ request: request, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $ee6d600502474136$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ee6d600502474136$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ee6d600502474136$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $ee6d600502474136$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $ee6d600502474136$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($ee6d600502474136$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $ee6d600502474136$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $ee6d600502474136$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $ee6d600502474136$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($ee6d600502474136$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $ee6d600502474136$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $ee6d600502474136$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$ee6d600502474136$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $ee6d600502474136$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $ee6d600502474136$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($ee6d600502474136$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $ee6d600502474136$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $ee6d600502474136$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ee6d600502474136$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ee6d600502474136$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $ee6d600502474136$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ee6d600502474136$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ee6d600502474136$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ee6d600502474136$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $ee6d600502474136$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $ee6d600502474136$export$f5708dca728d7177(!$ee6d600502474136$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ee6d600502474136$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $ee6d600502474136$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $ee6d600502474136$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $ee6d600502474136$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ee6d600502474136$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $ee6d600502474136$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $ee6d600502474136$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($ee6d600502474136$var$isErrorResult(result)) {
            let boundaryMatch = $ee6d600502474136$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($ee6d600502474136$var$isRedirectResult(result)) $ee6d600502474136$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $ee6d600502474136$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ee6d600502474136$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $ee6d600502474136$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $ee6d600502474136$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $ee6d600502474136$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $ee6d600502474136$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ee6d600502474136$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ee6d600502474136$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $ee6d600502474136$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $ee6d600502474136$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($ee6d600502474136$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $ee6d600502474136$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(path) : path;
    return $ee6d600502474136$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $ee6d600502474136$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $ee6d600502474136$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $ee6d600502474136$var$isRedirectDataStrategyResult(result) {
    return $ee6d600502474136$export$3f1eb41d9a6a6a27(result.result) && $ee6d600502474136$var$redirectStatusCodes.has(result.result.status);
}
function $ee6d600502474136$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $ee6d600502474136$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $ee6d600502474136$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $ee6d600502474136$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ee6d600502474136$export$794b2760043cf8cd(statusCode) {
    return $ee6d600502474136$var$redirectStatusCodes.has(statusCode);
}
function $ee6d600502474136$export$6e80290866a84dd4(result) {
    return $ee6d600502474136$export$3f1eb41d9a6a6a27(result) && $ee6d600502474136$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $ee6d600502474136$var$isValidMethod(method) {
    return $ee6d600502474136$var$validRequestMethods.has(method.toUpperCase());
}
function $ee6d600502474136$export$cbae47800eb95bc3(method) {
    return $ee6d600502474136$var$validMutationMethods.has(method.toUpperCase());
}
function $ee6d600502474136$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ee6d600502474136$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ee6d600502474136$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $ee6d600502474136$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ee6d600502474136$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $ee6d600502474136$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $ee6d600502474136$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ee6d600502474136$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $ee6d600502474136$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $ee6d600502474136$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $ee6d600502474136$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($ee6d600502474136$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $ee6d600502474136$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($ee6d600502474136$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $ee6d600502474136$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $ee6d600502474136$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $ee6d600502474136$export$2eeee58951ff3c1c = $acw62.createContext(null);
$ee6d600502474136$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $ee6d600502474136$export$315e3ffb01f217 = $acw62.createContext(null);
$ee6d600502474136$export$315e3ffb01f217.displayName = "DataRouterState";
var $ee6d600502474136$export$717f757c655223f1 = $acw62.createContext(false);
function $ee6d600502474136$var$useIsRSCRouterContext() {
    return $acw62.useContext($ee6d600502474136$export$717f757c655223f1);
}
var $ee6d600502474136$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$ee6d600502474136$export$3681f408decb40d1.displayName = "ViewTransition";
var $ee6d600502474136$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$ee6d600502474136$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $ee6d600502474136$var$AwaitContext = $acw62.createContext(null);
$ee6d600502474136$var$AwaitContext.displayName = "Await";
var $ee6d600502474136$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$ee6d600502474136$export$3044ab7fdabeaee6.displayName = "Navigation";
var $ee6d600502474136$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$ee6d600502474136$export$e6a44b110a0c44d3.displayName = "Location";
var $ee6d600502474136$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$ee6d600502474136$export$aac280ed165a4397.displayName = "Route";
var $ee6d600502474136$var$RouteErrorContext = $acw62.createContext(null);
$ee6d600502474136$var$RouteErrorContext.displayName = "RouteError";
var $ee6d600502474136$export$945fecf35a8ef089 = true;
function $ee6d600502474136$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $ee6d600502474136$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $ee6d600502474136$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $ee6d600502474136$export$9c954a9d03d32f4a() {
    return $acw62.useContext($ee6d600502474136$export$e6a44b110a0c44d3) != null;
}
function $ee6d600502474136$export$45d76561a5302f2b() {
    $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($ee6d600502474136$export$e6a44b110a0c44d3).location;
}
function $ee6d600502474136$export$1b3f31771c5d07c() {
    return $acw62.useContext($ee6d600502474136$export$e6a44b110a0c44d3).navigationType;
}
function $ee6d600502474136$export$6c330e8992e8a295(pattern) {
    $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $ee6d600502474136$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$ee6d600502474136$export$81336c211d5ff295(pattern, $ee6d600502474136$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $ee6d600502474136$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $ee6d600502474136$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $ee6d600502474136$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    return isDataRoute ? $ee6d600502474136$var$useNavigateStable() : $ee6d600502474136$var$useNavigateUnstable();
}
function $ee6d600502474136$var$useNavigateUnstable() {
    $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($ee6d600502474136$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ee6d600502474136$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($ee6d600502474136$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $ee6d600502474136$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $ee6d600502474136$var$warning(activeRef.current, $ee6d600502474136$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $ee6d600502474136$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ee6d600502474136$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $ee6d600502474136$var$OutletContext = $acw62.createContext(null);
function $ee6d600502474136$export$4138103a3ae699cc() {
    return $acw62.useContext($ee6d600502474136$var$OutletContext);
}
function $ee6d600502474136$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $ee6d600502474136$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $ee6d600502474136$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ee6d600502474136$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($ee6d600502474136$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$ee6d600502474136$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $ee6d600502474136$export$5d3fca4a98652595(routes, locationArg) {
    return $ee6d600502474136$var$useRoutesImpl(routes, locationArg);
}
function $ee6d600502474136$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($ee6d600502474136$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $ee6d600502474136$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $ee6d600502474136$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $ee6d600502474136$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $ee6d600502474136$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $ee6d600502474136$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($ee6d600502474136$export$945fecf35a8ef089) {
        $ee6d600502474136$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $ee6d600502474136$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $ee6d600502474136$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $ee6d600502474136$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $ee6d600502474136$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $ee6d600502474136$var$DefaultErrorComponent() {
    let error = $ee6d600502474136$export$ed527bf60f6e05f2();
    let message = $ee6d600502474136$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($ee6d600502474136$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $ee6d600502474136$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$DefaultErrorComponent, null);
var $ee6d600502474136$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $ee6d600502474136$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($ee6d600502474136$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $ee6d600502474136$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $ee6d600502474136$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $ee6d600502474136$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $ee6d600502474136$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $ee6d600502474136$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $ee6d600502474136$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($ee6d600502474136$export$2eeee58951ff3c1c);
    $ee6d600502474136$export$f5708dca728d7177(ctx, $ee6d600502474136$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $ee6d600502474136$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($ee6d600502474136$export$315e3ffb01f217);
    $ee6d600502474136$export$f5708dca728d7177(state, $ee6d600502474136$var$getDataRouterConsoleError(hookName));
    return state;
}
function $ee6d600502474136$var$useRouteContext(hookName) {
    let route = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    $ee6d600502474136$export$f5708dca728d7177(route, $ee6d600502474136$var$getDataRouterConsoleError(hookName));
    return route;
}
function $ee6d600502474136$var$useCurrentRouteId(hookName) {
    let route = $ee6d600502474136$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $ee6d600502474136$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $ee6d600502474136$var$useRouteId() {
    return $ee6d600502474136$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $ee6d600502474136$export$d0fd4b7106de2769() {
    let state = $ee6d600502474136$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $ee6d600502474136$export$600dc272ed516c15() {
    let dataRouterContext = $ee6d600502474136$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $ee6d600502474136$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $ee6d600502474136$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $ee6d600502474136$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$ee6d600502474136$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $ee6d600502474136$export$1448a5050d252c4d() {
    let state = $ee6d600502474136$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $ee6d600502474136$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $ee6d600502474136$export$fd5d37484eab868d(routeId) {
    let state = $ee6d600502474136$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $ee6d600502474136$export$fdc00f3f26066d5e() {
    let state = $ee6d600502474136$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $ee6d600502474136$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $ee6d600502474136$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($ee6d600502474136$var$RouteErrorContext);
    let state = $ee6d600502474136$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $ee6d600502474136$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $ee6d600502474136$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($ee6d600502474136$var$AwaitContext);
    return value?._data;
}
function $ee6d600502474136$export$17f53340677d5831() {
    let value = $acw62.useContext($ee6d600502474136$var$AwaitContext);
    return value?._error;
}
var $ee6d600502474136$var$blockerId = 0;
function $ee6d600502474136$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $ee6d600502474136$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $ee6d600502474136$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $ee6d600502474136$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $ee6d600502474136$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$ee6d600502474136$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $ee6d600502474136$export$386d57f03f0b2883;
}
function $ee6d600502474136$var$useNavigateStable() {
    let { router: router } = $ee6d600502474136$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $ee6d600502474136$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $ee6d600502474136$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $ee6d600502474136$var$warning(activeRef.current, $ee6d600502474136$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $ee6d600502474136$var$alreadyWarned = {};
function $ee6d600502474136$var$warningOnce(key, cond, message) {
    if (!cond && !$ee6d600502474136$var$alreadyWarned[key]) {
        $ee6d600502474136$var$alreadyWarned[key] = true;
        $ee6d600502474136$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $ee6d600502474136$var$alreadyWarned2 = {};
function $ee6d600502474136$export$5b28268982f175ba(condition, message) {
    if (!condition && !$ee6d600502474136$var$alreadyWarned2[message]) {
        $ee6d600502474136$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $ee6d600502474136$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($ee6d600502474136$export$945fecf35a8ef089) {
            if (route.element) $ee6d600502474136$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($ee6d600502474136$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $ee6d600502474136$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($ee6d600502474136$export$945fecf35a8ef089) {
            if (route.errorElement) $ee6d600502474136$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $ee6d600502474136$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $ee6d600502474136$export$f30f7e456d254e83(routes, opts) {
    return $ee6d600502474136$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $ee6d600502474136$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $ee6d600502474136$export$e2fd2c03906469db,
        mapRouteProperties: $ee6d600502474136$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $ee6d600502474136$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $ee6d600502474136$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $ee6d600502474136$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $ee6d600502474136$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $acw62.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $ee6d600502474136$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $acw62.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $ee6d600502474136$var$MemoizedDataRoutes = $acw62.memo($ee6d600502474136$var$DataRoutes);
function $ee6d600502474136$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $ee6d600502474136$var$useRoutesImpl(routes, void 0, state, future);
}
function $ee6d600502474136$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $ee6d600502474136$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ee6d600502474136$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $ee6d600502474136$export$f5708dca728d7177($ee6d600502474136$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    $ee6d600502474136$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    let { pathname: locationPathname } = $ee6d600502474136$export$45d76561a5302f2b();
    let navigate = $ee6d600502474136$export$9770f232ac06a008();
    let path = $ee6d600502474136$var$resolveTo(to, $ee6d600502474136$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $ee6d600502474136$export$910ae8079b2c2852(props) {
    return $ee6d600502474136$export$a3be3530d8e40d0b(props.context);
}
function $ee6d600502474136$export$e7b0ac011bb776c6(props) {
    $ee6d600502474136$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $ee6d600502474136$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $ee6d600502474136$export$f5708dca728d7177(!$ee6d600502474136$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $ee6d600502474136$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $ee6d600502474136$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $ee6d600502474136$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $ee6d600502474136$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $ee6d600502474136$export$5d3fca4a98652595($ee6d600502474136$export$16da398f5434bdec(children), location);
}
function $ee6d600502474136$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$ResolveAwait, null, children));
}
var $ee6d600502474136$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $ee6d600502474136$var$ResolveAwait({ children: children }) {
    let data2 = $ee6d600502474136$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $ee6d600502474136$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $ee6d600502474136$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $ee6d600502474136$export$f5708dca728d7177(element.type === $ee6d600502474136$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $ee6d600502474136$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $ee6d600502474136$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $ee6d600502474136$export$9b5b6d122dea0c88 = $ee6d600502474136$export$16da398f5434bdec;
function $ee6d600502474136$export$daf73786167a7f72(matches) {
    return $ee6d600502474136$var$_renderMatches(matches);
}
function $ee6d600502474136$var$useRouteComponentProps() {
    return {
        params: $ee6d600502474136$export$99eaa27ddbbb95ef(),
        loaderData: $ee6d600502474136$export$1448a5050d252c4d(),
        actionData: $ee6d600502474136$export$fdc00f3f26066d5e(),
        matches: $ee6d600502474136$export$2378eb7f5ff86053()
    };
}
function $ee6d600502474136$export$6c4f3826290c37af({ children: children }) {
    const props = $ee6d600502474136$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $ee6d600502474136$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $ee6d600502474136$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $ee6d600502474136$var$useHydrateFallbackProps() {
    return {
        params: $ee6d600502474136$export$99eaa27ddbbb95ef(),
        loaderData: $ee6d600502474136$export$1448a5050d252c4d(),
        actionData: $ee6d600502474136$export$fdc00f3f26066d5e()
    };
}
function $ee6d600502474136$export$f8cff34f39c1932a({ children: children }) {
    const props = $ee6d600502474136$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $ee6d600502474136$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $ee6d600502474136$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $ee6d600502474136$var$useErrorBoundaryProps() {
    return {
        params: $ee6d600502474136$export$99eaa27ddbbb95ef(),
        loaderData: $ee6d600502474136$export$1448a5050d252c4d(),
        actionData: $ee6d600502474136$export$fdc00f3f26066d5e(),
        error: $ee6d600502474136$export$ed527bf60f6e05f2()
    };
}
function $ee6d600502474136$export$e5afde5c4b6d747b({ children: children }) {
    const props = $ee6d600502474136$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $ee6d600502474136$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $ee6d600502474136$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $ee6d600502474136$var$defaultMethod = "get";
var $ee6d600502474136$var$defaultEncType = "application/x-www-form-urlencoded";
function $ee6d600502474136$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $ee6d600502474136$var$isButtonElement(object) {
    return $ee6d600502474136$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $ee6d600502474136$var$isFormElement(object) {
    return $ee6d600502474136$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $ee6d600502474136$var$isInputElement(object) {
    return $ee6d600502474136$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $ee6d600502474136$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $ee6d600502474136$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$ee6d600502474136$var$isModifiedEvent(event);
}
function $ee6d600502474136$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $ee6d600502474136$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $ee6d600502474136$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $ee6d600502474136$var$_formDataSupportsSubmitter = null;
function $ee6d600502474136$var$isFormDataSubmitterSupported() {
    if ($ee6d600502474136$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $ee6d600502474136$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $ee6d600502474136$var$_formDataSupportsSubmitter = true;
    }
    return $ee6d600502474136$var$_formDataSupportsSubmitter;
}
var $ee6d600502474136$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $ee6d600502474136$var$getFormEncType(encType) {
    if (encType != null && !$ee6d600502474136$var$supportedFormEncTypes.has(encType)) {
        $ee6d600502474136$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$ee6d600502474136$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $ee6d600502474136$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($ee6d600502474136$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $ee6d600502474136$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $ee6d600502474136$var$defaultMethod;
        encType = $ee6d600502474136$var$getFormEncType(target.getAttribute("enctype")) || $ee6d600502474136$var$defaultEncType;
        formData = new FormData(target);
    } else if ($ee6d600502474136$var$isButtonElement(target) || $ee6d600502474136$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $ee6d600502474136$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $ee6d600502474136$var$defaultMethod;
        encType = $ee6d600502474136$var$getFormEncType(target.getAttribute("formenctype")) || $ee6d600502474136$var$getFormEncType(form.getAttribute("enctype")) || $ee6d600502474136$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$ee6d600502474136$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($ee6d600502474136$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $ee6d600502474136$var$defaultMethod;
        action = null;
        encType = $ee6d600502474136$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $ee6d600502474136$var$HOLE = -1;
var $ee6d600502474136$var$NAN = -2;
var $ee6d600502474136$var$NEGATIVE_INFINITY = -3;
var $ee6d600502474136$var$NEGATIVE_ZERO = -4;
var $ee6d600502474136$var$NULL = -5;
var $ee6d600502474136$var$POSITIVE_INFINITY = -6;
var $ee6d600502474136$var$UNDEFINED = -7;
var $ee6d600502474136$var$TYPE_BIGINT = "B";
var $ee6d600502474136$var$TYPE_DATE = "D";
var $ee6d600502474136$var$TYPE_ERROR = "E";
var $ee6d600502474136$var$TYPE_MAP = "M";
var $ee6d600502474136$var$TYPE_NULL_OBJECT = "N";
var $ee6d600502474136$var$TYPE_PROMISE = "P";
var $ee6d600502474136$var$TYPE_REGEXP = "R";
var $ee6d600502474136$var$TYPE_SET = "S";
var $ee6d600502474136$var$TYPE_SYMBOL = "Y";
var $ee6d600502474136$var$TYPE_URL = "U";
var $ee6d600502474136$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $ee6d600502474136$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $ee6d600502474136$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $ee6d600502474136$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $ee6d600502474136$var$UNDEFINED;
    if (input === null) return $ee6d600502474136$var$NULL;
    if (Number.isNaN(input)) return $ee6d600502474136$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $ee6d600502474136$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $ee6d600502474136$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $ee6d600502474136$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $ee6d600502474136$var$stringify.call(this, input, index);
    return index;
}
function $ee6d600502474136$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$ee6d600502474136$var$flatten.call(this, k)}":${$ee6d600502474136$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$ee6d600502474136$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$ee6d600502474136$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$ee6d600502474136$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$ee6d600502474136$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $ee6d600502474136$var$flatten.call(this, input2[i]) : $ee6d600502474136$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$ee6d600502474136$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$ee6d600502474136$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$ee6d600502474136$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$ee6d600502474136$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$ee6d600502474136$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$ee6d600502474136$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$ee6d600502474136$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $ee6d600502474136$var$flatten.call(this, k),
                                    $ee6d600502474136$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$ee6d600502474136$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$ee6d600502474136$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$ee6d600502474136$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$ee6d600502474136$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($ee6d600502474136$var$isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$ee6d600502474136$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$ee6d600502474136$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $ee6d600502474136$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $ee6d600502474136$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $ee6d600502474136$var$objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var $ee6d600502474136$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $ee6d600502474136$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $ee6d600502474136$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $ee6d600502474136$var$hydrate.call(this, startIndex);
}
function $ee6d600502474136$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $ee6d600502474136$var$UNDEFINED:
                set(void 0);
                continue;
            case $ee6d600502474136$var$NULL:
                set(null);
                continue;
            case $ee6d600502474136$var$NAN:
                set(NaN);
                continue;
            case $ee6d600502474136$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $ee6d600502474136$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $ee6d600502474136$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $ee6d600502474136$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $ee6d600502474136$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $ee6d600502474136$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $ee6d600502474136$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $ee6d600502474136$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $ee6d600502474136$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $ee6d600502474136$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $ee6d600502474136$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $ee6d600502474136$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $ee6d600502474136$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $ee6d600502474136$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $ee6d600502474136$var$globalObj && $ee6d600502474136$var$globalObj[errorType] ? new $ee6d600502474136$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $ee6d600502474136$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $ee6d600502474136$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $ee6d600502474136$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $ee6d600502474136$var$Deferred2();
    const reader = readable.pipeThrough($ee6d600502474136$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $ee6d600502474136$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $ee6d600502474136$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $ee6d600502474136$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $ee6d600502474136$var$unflatten.call(this, line)
    };
}
async function $ee6d600502474136$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $ee6d600502474136$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $ee6d600502474136$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $ee6d600502474136$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $ee6d600502474136$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $ee6d600502474136$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $ee6d600502474136$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $ee6d600502474136$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$ee6d600502474136$var$TYPE_PROMISE}${deferredId}:[["${$ee6d600502474136$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$ee6d600502474136$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$ee6d600502474136$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $ee6d600502474136$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$ee6d600502474136$var$TYPE_ERROR}${deferredId}:[["${$ee6d600502474136$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$ee6d600502474136$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$ee6d600502474136$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $ee6d600502474136$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $ee6d600502474136$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ee6d600502474136$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $ee6d600502474136$var$escapeHtml(html) {
    return html.replace($ee6d600502474136$var$ESCAPE_REGEX, (match)=>$ee6d600502474136$var$ESCAPE_LOOKUP[match]);
}
function $ee6d600502474136$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/invariant.ts
function $ee6d600502474136$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $ee6d600502474136$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $ee6d600502474136$var$SingleFetchNoResultError = class extends Error {
};
var $ee6d600502474136$export$ae9272e641ead836 = 202;
var $ee6d600502474136$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $ee6d600502474136$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$ee6d600502474136$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $ee6d600502474136$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $ee6d600502474136$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $ee6d600502474136$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $ee6d600502474136$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.unstable_runClientMiddleware(dataStrategy);
}
function $ee6d600502474136$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $ee6d600502474136$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $ee6d600502474136$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $ee6d600502474136$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $ee6d600502474136$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $ee6d600502474136$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $ee6d600502474136$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $ee6d600502474136$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($ee6d600502474136$export$3f1eb41d9a6a6a27(result.result) || $ee6d600502474136$export$972111febbeef05b(result.result) || $ee6d600502474136$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $ee6d600502474136$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $ee6d600502474136$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $ee6d600502474136$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $ee6d600502474136$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$ee6d600502474136$var$createDeferred2());
    let singleFetchDfd = $ee6d600502474136$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $ee6d600502474136$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $ee6d600502474136$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $ee6d600502474136$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $ee6d600502474136$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $ee6d600502474136$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $ee6d600502474136$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $ee6d600502474136$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $ee6d600502474136$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $ee6d600502474136$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $ee6d600502474136$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $ee6d600502474136$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $ee6d600502474136$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $ee6d600502474136$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $ee6d600502474136$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $ee6d600502474136$export$a30aa2a0fce6c468(request));
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $ee6d600502474136$export$f2680fa305b734ca(404, "Not Found", true);
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $ee6d600502474136$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($ee6d600502474136$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $ee6d600502474136$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $ee6d600502474136$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($ee6d600502474136$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$ee6d600502474136$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $ee6d600502474136$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $ee6d600502474136$export$4023ad4ecd4126a2(body, global) {
    return $ee6d600502474136$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $ee6d600502474136$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$ee6d600502474136$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $ee6d600502474136$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $ee6d600502474136$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $ee6d600502474136$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $ee6d600502474136$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $ee6d600502474136$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $ee6d600502474136$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $ee6d600502474136$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $ee6d600502474136$var$getModuleLinkHrefs(matches, manifest);
    return $ee6d600502474136$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $ee6d600502474136$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $ee6d600502474136$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $ee6d600502474136$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($ee6d600502474136$var$prefetchStyleLink));
}
async function $ee6d600502474136$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$ee6d600502474136$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$ee6d600502474136$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$ee6d600502474136$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($ee6d600502474136$var$prefetchStyleLink));
}
async function $ee6d600502474136$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $ee6d600502474136$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $ee6d600502474136$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $ee6d600502474136$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $ee6d600502474136$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $ee6d600502474136$var$dedupeLinkDescriptors(links.flat(1).filter($ee6d600502474136$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $ee6d600502474136$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $ee6d600502474136$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $ee6d600502474136$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $ee6d600502474136$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $ee6d600502474136$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $ee6d600502474136$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$ee6d600502474136$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($ee6d600502474136$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $ee6d600502474136$var$_isPreloadSupported;
function $ee6d600502474136$var$isPreloadSupported() {
    if ($ee6d600502474136$var$_isPreloadSupported !== void 0) return $ee6d600502474136$var$_isPreloadSupported;
    let el = document.createElement("link");
    $ee6d600502474136$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $ee6d600502474136$var$_isPreloadSupported;
}
function $ee6d600502474136$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $ee6d600502474136$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $ee6d600502474136$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $ee6d600502474136$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $ee6d600502474136$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $ee6d600502474136$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$RemixRootDefaultErrorBoundary, {
            error: $ee6d600502474136$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $ee6d600502474136$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $ee6d600502474136$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $ee6d600502474136$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$ee6d600502474136$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $ee6d600502474136$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $ee6d600502474136$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $ee6d600502474136$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $ee6d600502474136$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $ee6d600502474136$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $ee6d600502474136$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $ee6d600502474136$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $ee6d600502474136$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $ee6d600502474136$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $ee6d600502474136$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $ee6d600502474136$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $ee6d600502474136$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $ee6d600502474136$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$ee6d600502474136$var$getRouteComponents(route, routeModule, isSpaMode),
                unstable_middleware: routeModule.unstable_clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $ee6d600502474136$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $ee6d600502474136$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            async serverLoader () {
                                $ee6d600502474136$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $ee6d600502474136$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $ee6d600502474136$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $ee6d600502474136$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        async serverAction () {
                            $ee6d600502474136$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $ee6d600502474136$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $ee6d600502474136$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $ee6d600502474136$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $ee6d600502474136$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $ee6d600502474136$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $ee6d600502474136$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                unstable_middleware: route.hasClientMiddleware ? async ()=>{
                    let { unstable_clientMiddleware: unstable_clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $ee6d600502474136$var$invariant2(unstable_clientMiddleware, "No `unstable_clientMiddleware` export found");
                    return unstable_clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $ee6d600502474136$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $ee6d600502474136$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $ee6d600502474136$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $ee6d600502474136$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $ee6d600502474136$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $ee6d600502474136$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $ee6d600502474136$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $ee6d600502474136$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $ee6d600502474136$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $ee6d600502474136$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $ee6d600502474136$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        unstable_clientMiddleware: routeModule.unstable_clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $ee6d600502474136$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $ee6d600502474136$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $ee6d600502474136$var$nextPaths = /* @__PURE__ */ new Set();
var $ee6d600502474136$var$discoveredPathsMaxSize = 1e3;
var $ee6d600502474136$var$discoveredPaths = /* @__PURE__ */ new Set();
var $ee6d600502474136$var$URL_LIMIT = 7680;
function $ee6d600502474136$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $ee6d600502474136$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $ee6d600502474136$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $ee6d600502474136$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$ee6d600502474136$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($ee6d600502474136$var$discoveredPaths.has(path)) return;
        await $ee6d600502474136$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $ee6d600502474136$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$ee6d600502474136$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$ee6d600502474136$var$discoveredPaths.has(pathname)) $ee6d600502474136$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($ee6d600502474136$var$nextPaths.keys()).filter((path)=>{
                if ($ee6d600502474136$var$discoveredPaths.has(path)) {
                    $ee6d600502474136$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $ee6d600502474136$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $ee6d600502474136$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $ee6d600502474136$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $ee6d600502474136$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $ee6d600502474136$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    let url = new URL($ee6d600502474136$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $ee6d600502474136$var$URL_LIMIT) {
        $ee6d600502474136$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            if (sessionStorage.getItem($ee6d600502474136$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                console.error("Unable to discover routes due to manifest version mismatch.");
                return;
            }
            sessionStorage.setItem($ee6d600502474136$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        sessionStorage.removeItem($ee6d600502474136$var$MANIFEST_VERSION_STORAGE_KEY);
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$ee6d600502474136$var$addToFifoQueue(p, $ee6d600502474136$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $ee6d600502474136$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $ee6d600502474136$var$addToFifoQueue(path, queue) {
    if (queue.size >= $ee6d600502474136$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $ee6d600502474136$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $ee6d600502474136$var$useDataRouterContext2() {
    let context = $acw62.useContext($ee6d600502474136$export$2eeee58951ff3c1c);
    $ee6d600502474136$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $ee6d600502474136$var$useDataRouterStateContext() {
    let context = $acw62.useContext($ee6d600502474136$export$315e3ffb01f217);
    $ee6d600502474136$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $ee6d600502474136$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$ee6d600502474136$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $ee6d600502474136$var$useFrameworkContext() {
    let context = $acw62.useContext($ee6d600502474136$export$208d6a3bc3aa62bd);
    $ee6d600502474136$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $ee6d600502474136$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($ee6d600502474136$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $ee6d600502474136$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $ee6d600502474136$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $ee6d600502474136$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $ee6d600502474136$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $ee6d600502474136$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $ee6d600502474136$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $ee6d600502474136$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$ee6d600502474136$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $ee6d600502474136$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $ee6d600502474136$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $ee6d600502474136$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $ee6d600502474136$var$useDataRouterStateContext();
    let matches = $ee6d600502474136$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$ee6d600502474136$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$ee6d600502474136$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$ee6d600502474136$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href
    }) : null, keyedLinks.map(({ key: key, link: link })=>$ee6d600502474136$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $ee6d600502474136$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $ee6d600502474136$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$ee6d600502474136$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $ee6d600502474136$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $ee6d600502474136$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $ee6d600502474136$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $ee6d600502474136$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $ee6d600502474136$var$useFrameworkContext();
    let { basename: basename } = $ee6d600502474136$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $ee6d600502474136$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$ee6d600502474136$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$ee6d600502474136$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $ee6d600502474136$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$ee6d600502474136$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $ee6d600502474136$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $ee6d600502474136$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $ee6d600502474136$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $ee6d600502474136$var$useDataRouterStateContext();
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let _matches = $ee6d600502474136$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$ee6d600502474136$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $ee6d600502474136$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $ee6d600502474136$var$isHydrated = false;
function $ee6d600502474136$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $ee6d600502474136$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $ee6d600502474136$var$useDataRouterContext2();
    let { matches: routerMatches } = $ee6d600502474136$var$useDataRouterStateContext();
    let isRSCRouterContext = $ee6d600502474136$var$useIsRSCRouterContext();
    let enableFogOfWar = $ee6d600502474136$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $ee6d600502474136$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $ee6d600502474136$var$isHydrated = true;
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $ee6d600502474136$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($ee6d600502474136$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $ee6d600502474136$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $ee6d600502474136$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $ee6d600502474136$var$isHydrated || isRSCRouterContext ? [] : $ee6d600502474136$var$dedupe(manifest.entry.imports.concat($ee6d600502474136$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $ee6d600502474136$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $ee6d600502474136$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $ee6d600502474136$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $ee6d600502474136$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $ee6d600502474136$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $ee6d600502474136$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($ee6d600502474136$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $ee6d600502474136$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $ee6d600502474136$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $ee6d600502474136$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$ff0bf87698939488, null) : null)));
}
var $ee6d600502474136$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($ee6d600502474136$var$isBrowser) window.__reactRouterVersion = "7.7.1";
} catch (e) {}
function $ee6d600502474136$export$1f3f55432a00e06d(routes, opts) {
    return $ee6d600502474136$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $ee6d600502474136$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $ee6d600502474136$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $ee6d600502474136$export$9269a41d8c4635e,
        hydrationRouteProperties: $ee6d600502474136$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $ee6d600502474136$export$1ba7ed8a3a7b3765(routes, opts) {
    return $ee6d600502474136$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $ee6d600502474136$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $ee6d600502474136$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $ee6d600502474136$export$9269a41d8c4635e,
        hydrationRouteProperties: $ee6d600502474136$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $ee6d600502474136$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $ee6d600502474136$var$deserializeErrors(state.errors)
    };
    return state;
}
function $ee6d600502474136$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $ee6d600502474136$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $ee6d600502474136$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $ee6d600502474136$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ee6d600502474136$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $ee6d600502474136$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $ee6d600502474136$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$ee6d600502474136$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $ee6d600502474136$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ee6d600502474136$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $ee6d600502474136$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($ee6d600502474136$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $ee6d600502474136$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $ee6d600502474136$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $ee6d600502474136$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $ee6d600502474136$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $ee6d600502474136$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $ee6d600502474136$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$ee6d600502474136$export$a6c7ac8248d6e38a.displayName = "Link";
var $ee6d600502474136$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $ee6d600502474136$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($ee6d600502474136$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ee6d600502474136$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $ee6d600502474136$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$ee6d600502474136$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $ee6d600502474136$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $ee6d600502474136$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $ee6d600502474136$export$47c85c6e3a081d3();
    let formAction = $ee6d600502474136$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $ee6d600502474136$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$ee6d600502474136$export$a7fed597f4b8afd8.displayName = "Form";
function $ee6d600502474136$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($ee6d600502474136$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let matches = $ee6d600502474136$export$2378eb7f5ff86053();
    $ee6d600502474136$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $ee6d600502474136$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $ee6d600502474136$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$ee6d600502474136$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $ee6d600502474136$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $ee6d600502474136$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($ee6d600502474136$export$2eeee58951ff3c1c);
    $ee6d600502474136$export$f5708dca728d7177(ctx, $ee6d600502474136$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $ee6d600502474136$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($ee6d600502474136$export$315e3ffb01f217);
    $ee6d600502474136$export$f5708dca728d7177(state, $ee6d600502474136$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $ee6d600502474136$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $ee6d600502474136$export$9770f232ac06a008();
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let path = $ee6d600502474136$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($ee6d600502474136$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $ee6d600502474136$export$fe53371bee54353d(location) === $ee6d600502474136$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $ee6d600502474136$export$f1a78c17382fe22a(defaultInit) {
    $ee6d600502474136$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($ee6d600502474136$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $ee6d600502474136$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $ee6d600502474136$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $ee6d600502474136$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $ee6d600502474136$var$fetcherId = 0;
var $ee6d600502474136$var$getUniqueFetcherId = ()=>`__${String(++$ee6d600502474136$var$fetcherId)}__`;
function $ee6d600502474136$export$47c85c6e3a081d3() {
    let { router: router } = $ee6d600502474136$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let currentRouteId = $ee6d600502474136$var$useRouteId();
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $ee6d600502474136$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $ee6d600502474136$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $ee6d600502474136$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    $ee6d600502474136$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$ee6d600502474136$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $ee6d600502474136$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $ee6d600502474136$export$fe53371bee54353d(path);
}
function $ee6d600502474136$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $ee6d600502474136$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $ee6d600502474136$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($ee6d600502474136$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($ee6d600502474136$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $ee6d600502474136$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $ee6d600502474136$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $ee6d600502474136$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $ee6d600502474136$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $ee6d600502474136$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $ee6d600502474136$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $ee6d600502474136$export$fa996778a3a31087() {
    let state = $ee6d600502474136$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $ee6d600502474136$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $ee6d600502474136$var$savedScrollPositions = {};
function $ee6d600502474136$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $ee6d600502474136$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $ee6d600502474136$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $ee6d600502474136$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $ee6d600502474136$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($ee6d600502474136$export$3044ab7fdabeaee6);
    let location = $ee6d600502474136$export$45d76561a5302f2b();
    let matches = $ee6d600502474136$export$2378eb7f5ff86053();
    let navigation = $ee6d600502474136$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $ee6d600502474136$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $ee6d600502474136$var$getScrollRestorationKey(location, matches, basename, getKey);
            $ee6d600502474136$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $ee6d600502474136$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($ee6d600502474136$var$savedScrollPositions));
        } catch (error) {
            $ee6d600502474136$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $ee6d600502474136$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $ee6d600502474136$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($ee6d600502474136$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$ee6d600502474136$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $ee6d600502474136$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $ee6d600502474136$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $ee6d600502474136$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $ee6d600502474136$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $ee6d600502474136$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $ee6d600502474136$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($ee6d600502474136$export$3681f408decb40d1);
    $ee6d600502474136$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $ee6d600502474136$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $ee6d600502474136$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $ee6d600502474136$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $ee6d600502474136$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $ee6d600502474136$export$81336c211d5ff295(path.pathname, nextPath) != null || $ee6d600502474136$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $ee6d600502474136$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $ee6d600502474136$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $ee6d600502474136$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $ee6d600502474136$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $ee6d600502474136$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $ee6d600502474136$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $ee6d600502474136$var$serializeErrors(context.errors)
        };
        let json = $ee6d600502474136$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $acw62.createElement($ee6d600502474136$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $ee6d600502474136$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $ee6d600502474136$var$useRoutesImpl(routes, void 0, state, future);
}
function $ee6d600502474136$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($ee6d600502474136$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $ee6d600502474136$var$getStatelessNavigator() {
    return {
        createHref: $ee6d600502474136$var$createHref,
        encodeLocation: $ee6d600502474136$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $ee6d600502474136$export$69163f0b72ec60d9(routes, opts) {
    return $ee6d600502474136$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $ee6d600502474136$export$9269a41d8c4635e
    });
}
function $ee6d600502474136$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $ee6d600502474136$export$87cb1a9238dc3fba(routes, $ee6d600502474136$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                unstable_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $ee6d600502474136$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $ee6d600502474136$var$createHref,
        encodeLocation: $ee6d600502474136$var$encodeLocation,
        getFetcher () {
            return $ee6d600502474136$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $ee6d600502474136$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $ee6d600502474136$var$createHref(to) {
    return typeof to === "string" ? to : $ee6d600502474136$export$fe53371bee54353d(to);
}
function $ee6d600502474136$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $ee6d600502474136$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $ee6d600502474136$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $ee6d600502474136$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $ee6d600502474136$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $ee6d600502474136$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $ee6d600502474136$var$htmlEscape(str) {
    return str.replace($ee6d600502474136$var$ESCAPE_REGEX2, (match)=>$ee6d600502474136$var$ESCAPE_LOOKUP2[match]);
}


var $e444d6404c095fa5$var$t = "undefined" != typeof window ? window : void 0, $e444d6404c095fa5$var$e = "undefined" != typeof globalThis ? globalThis : $e444d6404c095fa5$var$t, $e444d6404c095fa5$var$i = null == $e444d6404c095fa5$var$e ? void 0 : $e444d6404c095fa5$var$e.navigator, $e444d6404c095fa5$var$r = null == $e444d6404c095fa5$var$e ? void 0 : $e444d6404c095fa5$var$e.document, $e444d6404c095fa5$var$s = null == $e444d6404c095fa5$var$e ? void 0 : $e444d6404c095fa5$var$e.location, $e444d6404c095fa5$var$n = null == $e444d6404c095fa5$var$e ? void 0 : $e444d6404c095fa5$var$e.fetch, $e444d6404c095fa5$var$o = null != $e444d6404c095fa5$var$e && $e444d6404c095fa5$var$e.XMLHttpRequest && "withCredentials" in new $e444d6404c095fa5$var$e.XMLHttpRequest ? $e444d6404c095fa5$var$e.XMLHttpRequest : void 0, $e444d6404c095fa5$var$a = null == $e444d6404c095fa5$var$e ? void 0 : $e444d6404c095fa5$var$e.AbortController, $e444d6404c095fa5$var$l = null == $e444d6404c095fa5$var$e ? void 0 : $e444d6404c095fa5$var$e.CompressionStream, $e444d6404c095fa5$var$u = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.userAgent;
function $e444d6404c095fa5$var$h() {
    return !(!$e444d6404c095fa5$var$t || !1 === $e444d6404c095fa5$var$t.navigator.onLine);
}
var $e444d6404c095fa5$var$d = "undefined" != typeof globalThis ? globalThis : $e444d6404c095fa5$var$t;
$e444d6404c095fa5$var$d && "undefined" == typeof self && ($e444d6404c095fa5$var$d.self = $e444d6404c095fa5$var$d), $e444d6404c095fa5$var$d && "undefined" == typeof File && ($e444d6404c095fa5$var$d.File = function() {});
var $e444d6404c095fa5$var$v = null != $e444d6404c095fa5$var$t ? $e444d6404c095fa5$var$t : {}, $e444d6404c095fa5$var$c = {
    DEBUG: !1,
    LIB_VERSION: "0.4.0",
    LIB_NAME: "browser-common"
};
function $e444d6404c095fa5$var$f(t, e, i, r, s, n, o) {
    try {
        var a = t[n](o), l = a.value;
    } catch (t) {
        return void i(t);
    }
    a.done ? e(l) : Promise.resolve(l).then(r, s);
}
function $e444d6404c095fa5$var$p(t) {
    return function() {
        var e = this, i = arguments;
        return new Promise(function(r, s) {
            var n = t.apply(e, i);
            function o(t) {
                $e444d6404c095fa5$var$f(n, r, s, o, a, "next", t);
            }
            function a(t) {
                $e444d6404c095fa5$var$f(n, r, s, o, a, "throw", t);
            }
            o(void 0);
        });
    };
}
function $e444d6404c095fa5$var$_() {
    return $e444d6404c095fa5$var$_ = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; arguments.length > e; e++){
            var i = arguments[e];
            for(var r in i)({}).hasOwnProperty.call(i, r) && (t[r] = i[r]);
        }
        return t;
    }, $e444d6404c095fa5$var$_.apply(null, arguments);
}
function $e444d6404c095fa5$var$g(t, e) {
    if (null == t) return {};
    var i = {};
    for(var r in t)if (({}).hasOwnProperty.call(t, r)) {
        if (-1 !== e.indexOf(r)) continue;
        i[r] = t[r];
    }
    return i;
}
var $e444d6404c095fa5$var$m = (t)=>{
    if ("string" != typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (e) {
        return t;
    }
};
function $e444d6404c095fa5$var$b(t) {
    return "string" == typeof t || t;
}
function $e444d6404c095fa5$var$y(t) {
    return "string" == typeof t ? t : void 0;
}
var $e444d6404c095fa5$var$w, $e444d6404c095fa5$var$x = [
    "$feature_flag",
    "$feature_flag_response",
    "$feature_flag_has_experiment",
    "$feature_flag_id",
    "$feature_flag_version",
    "$feature_flag_reason",
    "$feature_flag_request_id",
    "$feature_flag_evaluated_at",
    "$feature_flag_error",
    "locally_evaluated",
    "$groups",
    "$process_person_profile",
    "$geoip_disable",
    "$current_url",
    "$pathname",
    "$referring_domain",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx",
    "$session_id",
    "$window_id",
    "$lib",
    "$lib_version",
    "$device_id",
    "$is_server"
], $e444d6404c095fa5$var$E = function(t) {
    return t.AnonymousId = "anonymous_id", t.DistinctId = "distinct_id", t.Props = "props", t.EnablePersonProcessing = "enable_person_processing", t.PersonMode = "person_mode", t.FeatureFlagDetails = "feature_flag_details", t.FeatureFlags = "feature_flags", t.FeatureFlagPayloads = "feature_flag_payloads", t.BootstrapFeatureFlagDetails = "bootstrap_feature_flag_details", t.BootstrapFeatureFlags = "bootstrap_feature_flags", t.BootstrapFeatureFlagPayloads = "bootstrap_feature_flag_payloads", t.OverrideFeatureFlags = "override_feature_flags", t.Queue = "queue", t.AiQueue = "ai_queue", t.LogsQueue = "logs_queue", t.OptedOut = "opted_out", t.SessionId = "session_id", t.SessionStartTimestamp = "session_start_timestamp", t.SessionLastTimestamp = "session_timestamp", t.PersonProperties = "person_properties", t.GroupProperties = "group_properties", t.InstalledAppBuild = "installed_app_build", t.InstalledAppVersion = "installed_app_version", t.SessionReplay = "session_replay", t.PushRegistered = "push_registered", t.SessionReplayEventTriggerActivatedSession = "session_replay_event_trigger_activated_session", t.SurveyLastSeenDate = "survey_last_seen_date", t.SurveysSeen = "surveys_seen", t.Surveys = "surveys", t.RemoteConfig = "remote_config", t.FlagsEndpointWasHit = "flags_endpoint_was_hit", t.DeviceId = "device_id", t;
}({}), $e444d6404c095fa5$var$S = function(t) {
    return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
}({}), $e444d6404c095fa5$var$k = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
], $e444d6404c095fa5$var$T = [
    "token"
], $e444d6404c095fa5$var$R = "NativeGzipValidationError", $e444d6404c095fa5$var$P = (t)=>t.length >= 2 && 31 === t[0] && 139 === t[1], $e444d6404c095fa5$var$O = (t, e)=>t === $e444d6404c095fa5$var$S.GZipJS || e === $e444d6404c095fa5$var$S.GZipJS || "gzip" === e, $e444d6404c095fa5$var$I = (t)=>!(!t || "object" != typeof t) && "NotReadableError" === ("name" in t ? String(t.name) : ""), $e444d6404c095fa5$var$C = (t)=>{
    var e = new Error("Native gzip produced invalid output: " + t);
    throw e.name = $e444d6404c095fa5$var$R, e;
}, $e444d6404c095fa5$var$A = function() {
    var t = $e444d6404c095fa5$var$p(function*(t, e) {
        18 > t.size && $e444d6404c095fa5$var$C("too-short");
        var i = new Uint8Array((yield t.slice(0, 10).arrayBuffer()));
        $e444d6404c095fa5$var$P(i) && 8 === i[2] || $e444d6404c095fa5$var$C("invalid-header");
        var r = new DataView((yield t.slice(t.size - 8).arrayBuffer()));
        r.getUint32(0, !0) !== ((t)=>{
            for(var e = (()=>{
                if ($e444d6404c095fa5$var$w) return $e444d6404c095fa5$var$w;
                $e444d6404c095fa5$var$w = [];
                for(var t = 0; 256 > t; t++){
                    for(var e = t, i = 0; 8 > i; i++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                    $e444d6404c095fa5$var$w[t] = e >>> 0;
                }
                return $e444d6404c095fa5$var$w;
            })(), i = 4294967295, r = 0; t.length > r; r++)i = e[255 & (i ^ t[r])] ^ i >>> 8;
            return (4294967295 ^ i) >>> 0;
        })(e) && $e444d6404c095fa5$var$C("invalid-crc");
        var s = e.length >>> 0;
        r.getUint32(4, !0) !== s && $e444d6404c095fa5$var$C("invalid-size");
    });
    return function(e, i) {
        return t.apply(this, arguments);
    };
}();
function $e444d6404c095fa5$var$M() {
    return $e444d6404c095fa5$var$M = $e444d6404c095fa5$var$p(function*(t, e, i) {
        void 0 === e && (e = !0);
        try {
            var r = (new TextEncoder).encode(t), s = new globalThis.CompressionStream("gzip"), n = s.writable.getWriter(), o = n.write(r).then(()=>n.close()).catch(function() {
                var t = $e444d6404c095fa5$var$p(function*(t) {
                    try {
                        yield n.abort(t);
                    } catch (t) {}
                    throw t;
                });
                return function(e) {
                    return t.apply(this, arguments);
                };
            }()), a = new Response(s.readable).blob(), l = (yield Promise.all([
                a,
                o
            ]))[0];
            return yield $e444d6404c095fa5$var$A(l, r), l;
        } catch (t) {
            if (null != i && i.rethrow) throw t;
            return e && console.error("Failed to gzip compress data", t), null;
        }
    }), $e444d6404c095fa5$var$M.apply(this, arguments);
}
var $e444d6404c095fa5$var$F = [
    "amazonbot",
    "amazonproductbot",
    "app.hypefactors.com",
    "applebot",
    "archive.org_bot",
    "awariobot",
    "backlinksextendedbot",
    "baiduspider",
    "bingbot",
    "bingpreview",
    "chrome-lighthouse",
    "dataforseobot",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "leikibot",
    "linkedinbot",
    "meta-externalagent",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "sebot-wa",
    "sitebulb",
    "slackbot",
    "slurp",
    "trendictionbot",
    "turnitin",
    "twitterbot",
    "vercel-screenshot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "zoombot",
    "bot.htm",
    "bot.php",
    "(bot;",
    "bot/",
    "crawler",
    "ahrefsbot",
    "ahrefssiteaudit",
    "semrushbot",
    "siteauditbot",
    "splitsignalbot",
    "gptbot",
    "oai-searchbot",
    "chatgpt-user",
    "perplexitybot",
    "better uptime bot",
    "sentryuptimebot",
    "uptimerobot",
    "headlesschrome",
    "cypress",
    "google-hoteladsverifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleother",
    "google-cloudvertexbot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "google-inspectiontool",
    "bytespider"
], $e444d6404c095fa5$var$D = function(t, e) {
    if (void 0 === e && (e = []), !t) return !1;
    var i = t.toLowerCase();
    return $e444d6404c095fa5$var$F.concat(e).some((t)=>{
        var e = t.toLowerCase();
        return -1 !== i.indexOf(e);
    });
};
function $e444d6404c095fa5$var$N(t, e) {
    return -1 !== t.indexOf(e);
}
var $e444d6404c095fa5$var$U = function(t) {
    return t.trim();
}, $e444d6404c095fa5$var$L = function(t) {
    return t.replace(/^\$/, "");
};
function $e444d6404c095fa5$var$j(t) {
    var e, i = [];
    return null !== (e = JSON.stringify(t, function(t, e) {
        if ("bigint" == typeof e) return e.toString();
        if ("function" != typeof e && "symbol" != typeof e) {
            if (e instanceof Error) return {
                name: e.name,
                message: e.message,
                stack: e.stack
            };
            if (e && "object" == typeof e) {
                for(; i.length > 0 && i[i.length - 1] !== this;)i.pop();
                if (i.includes(e)) return "[Circular]";
                i.push(e);
            }
            return e;
        }
    })) && void 0 !== e ? e : "null";
}
var $e444d6404c095fa5$var$B = Object.prototype, $e444d6404c095fa5$var$z = $e444d6404c095fa5$var$B.hasOwnProperty, $e444d6404c095fa5$var$H = $e444d6404c095fa5$var$B.toString, $e444d6404c095fa5$var$q = Array.isArray || function(t) {
    return "[object Array]" === $e444d6404c095fa5$var$H.call(t);
}, $e444d6404c095fa5$var$V = (t)=>"function" == typeof t, $e444d6404c095fa5$var$W = (t)=>t === Object(t) && !$e444d6404c095fa5$var$q(t), $e444d6404c095fa5$var$G = (t)=>{
    if ($e444d6404c095fa5$var$W(t)) {
        for(var e in t)if ($e444d6404c095fa5$var$z.call(t, e)) return !1;
        return !0;
    }
    return !1;
}, $e444d6404c095fa5$var$K = (t)=>void 0 === t, $e444d6404c095fa5$var$J = (t)=>"[object String]" == $e444d6404c095fa5$var$H.call(t), $e444d6404c095fa5$var$Y = (t)=>$e444d6404c095fa5$var$J(t) && 0 === t.trim().length, $e444d6404c095fa5$var$Q = (t)=>null === t, $e444d6404c095fa5$var$X = (t)=>$e444d6404c095fa5$var$K(t) || $e444d6404c095fa5$var$Q(t), $e444d6404c095fa5$var$Z = (t)=>"[object Number]" == $e444d6404c095fa5$var$H.call(t) && t == t, $e444d6404c095fa5$var$tt = (t)=>$e444d6404c095fa5$var$Z(t) && t > 0, $e444d6404c095fa5$var$et = (t)=>"[object Boolean]" === $e444d6404c095fa5$var$H.call(t), $e444d6404c095fa5$var$it = (t)=>t instanceof FormData, $e444d6404c095fa5$var$rt = (t)=>$e444d6404c095fa5$var$N($e444d6404c095fa5$var$k, t), $e444d6404c095fa5$var$st = (t)=>$e444d6404c095fa5$var$N($e444d6404c095fa5$var$T, t);
function $e444d6404c095fa5$var$nt(t) {
    return null === t || "object" != typeof t;
}
function $e444d6404c095fa5$var$ot(t, e) {
    return ({}).toString.call(t) === "[object " + e + "]";
}
function $e444d6404c095fa5$var$at(t) {
    return "undefined" != typeof Event && $e444d6404c095fa5$var$lt(t, Event);
}
function $e444d6404c095fa5$var$lt(t, e) {
    try {
        return t instanceof e;
    } catch (t) {
        return !1;
    }
}
var $e444d6404c095fa5$var$ut = [
    !0,
    "true",
    1,
    "1",
    "yes"
], $e444d6404c095fa5$var$ht = (t)=>$e444d6404c095fa5$var$N($e444d6404c095fa5$var$ut, t), $e444d6404c095fa5$var$dt = [
    !1,
    "false",
    0,
    "0",
    "no"
];
function $e444d6404c095fa5$var$vt(t, e, i, r, s) {
    return e > i && (r.warn("min cannot be greater than max."), e = i), $e444d6404c095fa5$var$Z(t) ? t > i ? (r.warn(" cannot be  greater than max: " + i + ". Using max value instead."), i) : e > t ? (r.warn(" cannot be less than min: " + e + ". Using min value instead."), e) : t : (r.warn(" must be a number. using max or fallback. max: " + i + ", fallback: " + s), $e444d6404c095fa5$var$vt(s || i, e, i, r));
}
class $e444d6404c095fa5$var$ct {
    constructor(t){
        this.tt = {}, this.et = t.et, this.it = $e444d6404c095fa5$var$vt(t.bucketSize, 0, 100, t.rt), this.nt = $e444d6404c095fa5$var$vt(t.refillRate, 0, this.it, t.rt), this.st = $e444d6404c095fa5$var$vt(t.refillInterval, 0, 864e5, t.rt);
    }
    ot(t, e) {
        var i = Math.floor((e - t.lastAccess) / this.st);
        i > 0 && (t.tokens = Math.min(t.tokens + i * this.nt, this.it), t.lastAccess = t.lastAccess + i * this.st);
    }
    consumeRateLimit(t) {
        var e, i = Date.now(), r = String(t), s = this.tt[r];
        return s ? this.ot(s, i) : this.tt[r] = s = {
            tokens: this.it,
            lastAccess: i
        }, 0 === s.tokens || (s.tokens--, 0 === s.tokens && (null == (e = this.et) || e.call(this, t)), 0 === s.tokens);
    }
    stop() {
        this.tt = {};
    }
}
var $e444d6404c095fa5$var$ft = "Mobile", $e444d6404c095fa5$var$pt = "iOS", $e444d6404c095fa5$var$_t = "Android", $e444d6404c095fa5$var$gt = "Tablet", $e444d6404c095fa5$var$mt = $e444d6404c095fa5$var$_t + " " + $e444d6404c095fa5$var$gt, $e444d6404c095fa5$var$bt = "iPad", $e444d6404c095fa5$var$yt = "Apple", $e444d6404c095fa5$var$wt = $e444d6404c095fa5$var$yt + " Watch", $e444d6404c095fa5$var$xt = "Safari", $e444d6404c095fa5$var$Et = "BlackBerry", $e444d6404c095fa5$var$St = "Samsung", $e444d6404c095fa5$var$$t = $e444d6404c095fa5$var$St + "Browser", $e444d6404c095fa5$var$kt = $e444d6404c095fa5$var$St + " Internet", $e444d6404c095fa5$var$Tt = "Chrome", $e444d6404c095fa5$var$Rt = $e444d6404c095fa5$var$Tt + " OS", $e444d6404c095fa5$var$Pt = $e444d6404c095fa5$var$Tt + " " + $e444d6404c095fa5$var$pt, $e444d6404c095fa5$var$Ot = "Internet Explorer", $e444d6404c095fa5$var$It = $e444d6404c095fa5$var$Ot + " " + $e444d6404c095fa5$var$ft, $e444d6404c095fa5$var$Ct = "Opera", $e444d6404c095fa5$var$At = $e444d6404c095fa5$var$Ct + " Mini", $e444d6404c095fa5$var$Mt = "Edge", $e444d6404c095fa5$var$Ft = "Microsoft " + $e444d6404c095fa5$var$Mt, $e444d6404c095fa5$var$Dt = "Firefox", $e444d6404c095fa5$var$Nt = $e444d6404c095fa5$var$Dt + " " + $e444d6404c095fa5$var$pt, $e444d6404c095fa5$var$Ut = "Nintendo", $e444d6404c095fa5$var$Lt = "PlayStation", $e444d6404c095fa5$var$jt = "Xbox", $e444d6404c095fa5$var$Bt = $e444d6404c095fa5$var$_t + " " + $e444d6404c095fa5$var$ft, $e444d6404c095fa5$var$zt = $e444d6404c095fa5$var$ft + " " + $e444d6404c095fa5$var$xt, $e444d6404c095fa5$var$Ht = "Windows", $e444d6404c095fa5$var$qt = $e444d6404c095fa5$var$Ht + " Phone", $e444d6404c095fa5$var$Vt = "Nokia", $e444d6404c095fa5$var$Wt = "Ouya", $e444d6404c095fa5$var$Gt = "Generic", $e444d6404c095fa5$var$Kt = $e444d6404c095fa5$var$Gt + " " + $e444d6404c095fa5$var$ft.toLowerCase(), $e444d6404c095fa5$var$Jt = $e444d6404c095fa5$var$Gt + " " + $e444d6404c095fa5$var$gt.toLowerCase(), $e444d6404c095fa5$var$Yt = "Konqueror", $e444d6404c095fa5$var$Qt = "Oculus Browser", $e444d6404c095fa5$var$Xt = "Vivaldi", $e444d6404c095fa5$var$Zt = "Yandex", $e444d6404c095fa5$var$te = "Whale", $e444d6404c095fa5$var$ee = "DuckDuckGo", $e444d6404c095fa5$var$ie = "Pale Moon", $e444d6404c095fa5$var$re = "Waterfox", $e444d6404c095fa5$var$se = "Brave", $e444d6404c095fa5$var$ne = "Google Search App", $e444d6404c095fa5$var$oe = "(\\d+(\\.\\d+)?)", $e444d6404c095fa5$var$ae = new RegExp("Version/" + $e444d6404c095fa5$var$oe), $e444d6404c095fa5$var$le = new RegExp($e444d6404c095fa5$var$jt, "i"), $e444d6404c095fa5$var$ue = new RegExp($e444d6404c095fa5$var$Lt + " \\w+", "i"), $e444d6404c095fa5$var$he = new RegExp($e444d6404c095fa5$var$Ut + " \\w+", "i"), $e444d6404c095fa5$var$de = new RegExp($e444d6404c095fa5$var$Et + "|PlayBook|BB10", "i"), $e444d6404c095fa5$var$ve = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
}, $e444d6404c095fa5$var$ce = function(t, e, i, r) {
    e = e || "";
    var s = function(t) {
        return null != t && t.brave ? $e444d6404c095fa5$var$se : null;
    }(i);
    return s || (null != r && r.detectGoogleSearchApp && $e444d6404c095fa5$var$N(t, "GSA/") ? $e444d6404c095fa5$var$ne : $e444d6404c095fa5$var$N(t, " OPR/") && $e444d6404c095fa5$var$N(t, "Mini") ? $e444d6404c095fa5$var$At : $e444d6404c095fa5$var$N(t, " OPR/") ? $e444d6404c095fa5$var$Ct : $e444d6404c095fa5$var$de.test(t) ? $e444d6404c095fa5$var$Et : $e444d6404c095fa5$var$N(t, "IE" + $e444d6404c095fa5$var$ft) || $e444d6404c095fa5$var$N(t, "WPDesktop") ? $e444d6404c095fa5$var$It : $e444d6404c095fa5$var$N(t, "OculusBrowser") ? $e444d6404c095fa5$var$Qt : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$$t) ? $e444d6404c095fa5$var$kt : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$Mt) || $e444d6404c095fa5$var$N(t, "Edg/") ? $e444d6404c095fa5$var$Ft : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$Xt + "/") ? $e444d6404c095fa5$var$Xt : $e444d6404c095fa5$var$N(t, "YaBrowser/") ? $e444d6404c095fa5$var$Zt : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$te + "/") ? $e444d6404c095fa5$var$te : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$ee + "/") || $e444d6404c095fa5$var$N(t, "Ddg/") ? $e444d6404c095fa5$var$ee : $e444d6404c095fa5$var$N(t, "FBIOS") ? "Facebook " + $e444d6404c095fa5$var$ft : $e444d6404c095fa5$var$N(t, "UCWEB") || $e444d6404c095fa5$var$N(t, "UCBrowser") ? "UC Browser" : $e444d6404c095fa5$var$N(t, "CriOS") ? $e444d6404c095fa5$var$Pt : $e444d6404c095fa5$var$N(t, "CrMo") || $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$Tt) ? $e444d6404c095fa5$var$Tt : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$_t) && $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$xt) ? $e444d6404c095fa5$var$Bt : $e444d6404c095fa5$var$N(t, "FxiOS") ? $e444d6404c095fa5$var$Nt : $e444d6404c095fa5$var$N(t.toLowerCase(), $e444d6404c095fa5$var$Yt.toLowerCase()) ? $e444d6404c095fa5$var$Yt : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$se + "/") ? $e444d6404c095fa5$var$se : ((t, e)=>e && $e444d6404c095fa5$var$N(e, $e444d6404c095fa5$var$yt) || function(t) {
            return $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$xt) && !$e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$Tt) && !$e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$_t);
        }(t))(t, e) ? $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$ft) ? $e444d6404c095fa5$var$zt : $e444d6404c095fa5$var$xt : $e444d6404c095fa5$var$N(t, "PaleMoon/") ? $e444d6404c095fa5$var$ie : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$re + "/") ? $e444d6404c095fa5$var$re : $e444d6404c095fa5$var$N(t, $e444d6404c095fa5$var$Dt) ? $e444d6404c095fa5$var$Dt : $e444d6404c095fa5$var$N(t, "MSIE") || $e444d6404c095fa5$var$N(t, "Trident/") ? $e444d6404c095fa5$var$Ot : $e444d6404c095fa5$var$N(t, "Gecko") ? $e444d6404c095fa5$var$Dt : "");
}, $e444d6404c095fa5$var$fe = {
    [$e444d6404c095fa5$var$It]: [
        new RegExp("rv:" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Ft]: [
        new RegExp($e444d6404c095fa5$var$Mt + "?\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Tt]: [
        new RegExp("(" + $e444d6404c095fa5$var$Tt + "|CrMo)\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Pt]: [
        new RegExp("CriOS\\/" + $e444d6404c095fa5$var$oe)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$xt]: [
        $e444d6404c095fa5$var$ae
    ],
    [$e444d6404c095fa5$var$zt]: [
        $e444d6404c095fa5$var$ae
    ],
    [$e444d6404c095fa5$var$Ct]: [
        new RegExp("(Opera|OPR)\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Dt]: [
        new RegExp($e444d6404c095fa5$var$Dt + "\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Nt]: [
        new RegExp("FxiOS\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Yt]: [
        new RegExp("Konqueror[:/]?" + $e444d6404c095fa5$var$oe, "i")
    ],
    [$e444d6404c095fa5$var$Et]: [
        new RegExp($e444d6404c095fa5$var$Et + " " + $e444d6404c095fa5$var$oe),
        $e444d6404c095fa5$var$ae
    ],
    [$e444d6404c095fa5$var$Bt]: [
        new RegExp("android\\s" + $e444d6404c095fa5$var$oe, "i")
    ],
    [$e444d6404c095fa5$var$kt]: [
        new RegExp($e444d6404c095fa5$var$$t + "\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Qt]: [
        new RegExp("OculusBrowser\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Xt]: [
        new RegExp($e444d6404c095fa5$var$Xt + "\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Zt]: [
        new RegExp("YaBrowser\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$te]: [
        new RegExp($e444d6404c095fa5$var$te + "\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$se]: [
        new RegExp($e444d6404c095fa5$var$se + "\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$ee]: [
        new RegExp("(DuckDuckGo|Ddg)\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$ie]: [
        new RegExp("PaleMoon\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$re]: [
        new RegExp($e444d6404c095fa5$var$re + "\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$ne]: [
        new RegExp("GSA\\/" + $e444d6404c095fa5$var$oe)
    ],
    [$e444d6404c095fa5$var$Ot]: [
        new RegExp("(rv:|MSIE )" + $e444d6404c095fa5$var$oe)
    ],
    Mozilla: [
        new RegExp("rv:" + $e444d6404c095fa5$var$oe)
    ]
}, $e444d6404c095fa5$var$pe = function(t, e, i, r) {
    var s = $e444d6404c095fa5$var$ce(t, e, i, r), n = $e444d6404c095fa5$var$fe[s];
    if ($e444d6404c095fa5$var$K(n)) return null;
    for(var o = 0; n.length > o; o++){
        var a = t.match(n[o]);
        if (a) return parseFloat(a[a.length - 2]);
    }
    return null;
}, $e444d6404c095fa5$var$_e = [
    [
        new RegExp($e444d6404c095fa5$var$jt + "; " + $e444d6404c095fa5$var$jt + " (.*?)[);]", "i"),
        (t)=>[
                $e444d6404c095fa5$var$jt,
                t && t[1] || ""
            ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Ut, "i"),
        [
            $e444d6404c095fa5$var$Ut,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Lt, "i"),
        [
            $e444d6404c095fa5$var$Lt,
            ""
        ]
    ],
    [
        $e444d6404c095fa5$var$de,
        [
            $e444d6404c095fa5$var$Et,
            ""
        ]
    ],
    [
        new RegExp($e444d6404c095fa5$var$Ht, "i"),
        (t, e)=>{
            if (/Phone/.test(e) || /WPDesktop/.test(e)) return [
                $e444d6404c095fa5$var$qt,
                ""
            ];
            if (new RegExp($e444d6404c095fa5$var$ft).test(e) && !/IEMobile\b/.test(e)) return [
                $e444d6404c095fa5$var$Ht + " " + $e444d6404c095fa5$var$ft,
                ""
            ];
            var i = /Windows NT ([0-9.]+)/i.exec(e);
            if (i && i[1]) {
                var r = $e444d6404c095fa5$var$ve[i[1]] || "";
                return /arm/i.test(e) && (r = "RT"), [
                    $e444d6404c095fa5$var$Ht,
                    r
                ];
            }
            return [
                $e444d6404c095fa5$var$Ht,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (t)=>t && t[3] ? [
                $e444d6404c095fa5$var$pt,
                [
                    t[3],
                    t[4],
                    t[5] || "0"
                ].join(".")
            ] : [
                $e444d6404c095fa5$var$pt,
                ""
            ]
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (t)=>{
            var e = "";
            return t && t.length >= 3 && (e = $e444d6404c095fa5$var$K(t[2]) ? t[3] : t[2]), [
                "watchOS",
                e
            ];
        }
    ],
    [
        new RegExp("(" + $e444d6404c095fa5$var$_t + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + $e444d6404c095fa5$var$_t + ")", "i"),
        (t)=>t && t[2] ? [
                $e444d6404c095fa5$var$_t,
                [
                    t[2],
                    t[3],
                    t[4] || "0"
                ].join(".")
            ] : [
                $e444d6404c095fa5$var$_t,
                ""
            ]
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (t)=>{
            var e = [
                "Mac OS X",
                ""
            ];
            return t && t[1] && (e[1] = [
                t[1],
                t[2],
                t[3] || "0"
            ].join(".")), e;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            $e444d6404c095fa5$var$Rt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], $e444d6404c095fa5$var$ge = function(t) {
    return $e444d6404c095fa5$var$he.test(t) ? $e444d6404c095fa5$var$Ut : $e444d6404c095fa5$var$ue.test(t) ? $e444d6404c095fa5$var$Lt : $e444d6404c095fa5$var$le.test(t) ? $e444d6404c095fa5$var$jt : new RegExp($e444d6404c095fa5$var$Wt, "i").test(t) ? $e444d6404c095fa5$var$Wt : new RegExp("(" + $e444d6404c095fa5$var$qt + "|WPDesktop)", "i").test(t) ? $e444d6404c095fa5$var$qt : /iPad/.test(t) ? $e444d6404c095fa5$var$bt : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? $e444d6404c095fa5$var$wt : $e444d6404c095fa5$var$de.test(t) ? $e444d6404c095fa5$var$Et : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp($e444d6404c095fa5$var$Vt, "i").test(t) ? $e444d6404c095fa5$var$Vt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp($e444d6404c095fa5$var$ft).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? $e444d6404c095fa5$var$_t : $e444d6404c095fa5$var$mt : new RegExp("(pda|" + $e444d6404c095fa5$var$ft + ")", "i").test(t) ? $e444d6404c095fa5$var$Kt : new RegExp($e444d6404c095fa5$var$gt, "i").test(t) && !new RegExp($e444d6404c095fa5$var$gt + " pc", "i").test(t) ? $e444d6404c095fa5$var$Jt : "";
}, $e444d6404c095fa5$var$me = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function $e444d6404c095fa5$var$be(t, e) {
    var i;
    return "string" == typeof (i = t) && $e444d6404c095fa5$var$me.test(i) ? t : e();
}
function $e444d6404c095fa5$var$ye(t) {
    return t ? t.split("#")[0] : t;
}
function $e444d6404c095fa5$var$we(t, e) {
    var i = setTimeout(t, e);
    return (null == i ? void 0 : i.unref) && (null == i || i.unref()), i;
}
function $e444d6404c095fa5$var$xe(t, e, i) {
    return $e444d6404c095fa5$var$Ee.apply(this, arguments);
}
function $e444d6404c095fa5$var$Ee() {
    return ($e444d6404c095fa5$var$Ee = $e444d6404c095fa5$var$p(function*(t, e, i) {
        var r;
        try {
            return yield Promise.race([
                t,
                new Promise((t, s)=>{
                    r = $e444d6404c095fa5$var$we(()=>{
                        try {
                            null == i || i(), t();
                        } catch (t) {
                            s(t);
                        }
                    }, e);
                })
            ]);
        } finally{
            clearTimeout(r);
        }
    })).apply(this, arguments);
}
var $e444d6404c095fa5$var$Se = (t)=>t instanceof Error, $e444d6404c095fa5$var$$e = {
    trace: {
        text: "TRACE",
        number: 1
    },
    debug: {
        text: "DEBUG",
        number: 5
    },
    info: {
        text: "INFO",
        number: 9
    },
    warn: {
        text: "WARN",
        number: 13
    },
    error: {
        text: "ERROR",
        number: 17
    },
    fatal: {
        text: "FATAL",
        number: 21
    }
}, $e444d6404c095fa5$var$ke = $e444d6404c095fa5$var$$e.info;
function $e444d6404c095fa5$var$Te(t) {
    if ($e444d6404c095fa5$var$et(t)) return {
        boolValue: t
    };
    if ("number" == typeof t) return Number.isFinite(t) ? Number.isInteger(t) ? {
        intValue: t
    } : {
        doubleValue: t
    } : {
        stringValue: String(t)
    };
    if ("string" == typeof t) return {
        stringValue: t
    };
    if ($e444d6404c095fa5$var$q(t)) return {
        arrayValue: {
            values: t.map((t)=>$e444d6404c095fa5$var$Te(t))
        }
    };
    try {
        return {
            stringValue: JSON.stringify(t)
        };
    } catch (e) {
        return {
            stringValue: String(t)
        };
    }
}
function $e444d6404c095fa5$var$Re(t) {
    var e = [];
    for(var i in t){
        var r = t[i];
        $e444d6404c095fa5$var$Q(r) || $e444d6404c095fa5$var$K(r) || e.push({
            key: i,
            value: $e444d6404c095fa5$var$Te(r)
        });
    }
    return e;
}
function $e444d6404c095fa5$var$Pe(t, e) {
    var i = $e444d6404c095fa5$var$$e[t.level || "info"] || $e444d6404c095fa5$var$ke, r = i.text, s = i.number, n = String(Date.now()) + "000000", o = {};
    e.distinctId && (o.posthogDistinctId = e.distinctId), e.sessionId && (o.sessionId = e.sessionId), e.windowId && (o["window.id"] = e.windowId), $e444d6404c095fa5$var$X(e.sessionStartTimestamp) || (o.sessionStartTimestamp = String(e.sessionStartTimestamp)), $e444d6404c095fa5$var$X(e.lastActivityTimestamp) || (o.lastActivityTimestamp = String(e.lastActivityTimestamp)), e.currentUrl && (o["url.full"] = e.currentUrl), e.screenName && (o["screen.name"] = e.screenName), e.appState && (o["app.state"] = e.appState), e.activeFeatureFlags && e.activeFeatureFlags.length > 0 && (o.feature_flags = e.activeFeatureFlags);
    var a = $e444d6404c095fa5$var$_({}, o, t.attributes || {}), l = {
        timeUnixNano: n,
        observedTimeUnixNano: n,
        severityNumber: s,
        severityText: r,
        body: {
            stringValue: t.body
        },
        attributes: $e444d6404c095fa5$var$Re(a)
    };
    return t.trace_id && (l.traceId = t.trace_id), t.span_id && (l.spanId = t.span_id), $e444d6404c095fa5$var$K(t.trace_flags) || (l.flags = t.trace_flags), l;
}
function $e444d6404c095fa5$var$Oe(t, e, i) {
    return $e444d6404c095fa5$var$_({}, t.resourceAttributes, {
        "service.name": t.serviceName || "unknown_service"
    }, t.environment && {
        "deployment.environment": t.environment
    }, t.serviceVersion && {
        "service.version": t.serviceVersion
    }, {
        "telemetry.sdk.name": e,
        "telemetry.sdk.version": i
    });
}
function $e444d6404c095fa5$var$Ie(t, e, i, r) {
    return {
        resourceLogs: [
            {
                resource: {
                    attributes: $e444d6404c095fa5$var$Re(e)
                },
                scopeLogs: [
                    {
                        scope: {
                            name: i,
                            version: r
                        },
                        logRecords: t
                    }
                ]
            }
        ]
    };
}
let $e444d6404c095fa5$var$Ce = class {
    constructor(t, e, i, r, s, n, o){
        var a;
        void 0 === n && (n = ()=>Promise.resolve()), this._instance = t, this.Ne = e, this.rt = i, this.ut = r, this.ht = s, this.dt = n, this.vt = o, this.ct = null, this.ft = 0, this.yt = 0, this.bt = 0, this._t = 0, this.wt = !1, this.kt = e.maxBufferSize, this.xt = Math.max(null !== (a = e.maxQueueSize) && void 0 !== a ? a : e.maxBufferSize, e.maxBufferSize), this.St = e.flushIntervalMs, this.Ct = e.maxBatchRecordsPerPost, this.Mt = e.rateCapWindowMs, this.Tt = e.maxLogsPerInterval;
    }
    reset() {
        this.Et(), this.ct = null, this.bt = 0, this._t = 0, this.wt = !1, this.ft = 0, this.yt = 0, this.Ct = this.Ne.maxBatchRecordsPerPost;
    }
    onReconnect() {
        this.yt = 0, this.It();
    }
    captureLog(t) {
        if (!this._instance.isDisabled && !this._instance.optedOut && null != t && t.body) {
            var e = this.Pt(t);
            if (null !== e) {
                if (e.body) {
                    if (this.Rt()) {
                        var i = {
                            record: $e444d6404c095fa5$var$Pe(e, this.ut())
                        };
                        this.ht(()=>this.At(i));
                    }
                } else this.rt.info("Log was rejected in beforeSend function");
            }
        }
    }
    Pt(t) {
        var e = this.Ne.beforeSend;
        if (!e) return t;
        var i = $e444d6404c095fa5$var$q(e) ? e : [
            e
        ], r = t;
        for (var s of i)try {
            var n = s(r);
            if (!n) return this.rt.info("Log was rejected in beforeSend function"), null;
            r = n;
        } catch (t) {
            return this.rt.error("Error in beforeSend function for log:", t), null;
        }
        return r;
    }
    Rt() {
        if (void 0 === this.Tt) return !0;
        var t = Date.now(), e = t - this.bt;
        return this.Mt > e && e >= 0 || (this.bt = t, this._t = 0, this.wt = !1), this.Tt > this._t ? (this._t++, !0) : (this.wt || (this.rt.warn("captureLog dropping logs: exceeded " + this.Tt + " logs per " + this.Mt + "ms"), this.wt = !0), !1);
    }
    flush() {
        var t = this;
        return $e444d6404c095fa5$var$p(function*() {
            if (!t._instance.isDisabled) return t.ct || (t.ct = t.Ft().finally(()=>{
                t.ct = null;
            })), t.ct;
        })();
    }
    Ft() {
        var t = this;
        return $e444d6404c095fa5$var$p(function*() {
            var e;
            t.Et();
            var i = null !== (e = t._instance.getPersistedProperty($e444d6404c095fa5$var$E.LogsQueue)) && void 0 !== e ? e : [];
            if (0 !== i.length) for(var r = i.length, s = 0; i.length > 0 && r > s;){
                var n, o;
                t.ft = 0;
                var a = Math.min(i.length, t.Ct), l = i.slice(0, a), u = $e444d6404c095fa5$var$Ie(l.map((t)=>t.record), t.Lt(), null !== (n = t.vt) && void 0 !== n ? n : t._instance.getLibraryId(), t._instance.getLibraryVersion()), h = yield t._instance.Ot(u);
                if ("too-large" === h.kind && l.length > 1) t.Ct = Math.max(1, Math.floor(l.length / 2)), t.rt.warn("Received 413 when sending logs batch of size " + l.length + ", reducing batch size to " + t.Ct);
                else {
                    if ("retry-later" === h.kind) throw h.error;
                    if ("too-large" === h.kind ? t.rt.warn("Dropping a single log record after 413 with batch size 1 \u2014 the record is larger than the server cap and cannot be split further.") : "ok" === h.kind && t.Ne.maxBatchRecordsPerPost > t.Ct && (t.Ct = Math.min(t.Ne.maxBatchRecordsPerPost, t.Ct + 1)), yield t.Dt(l.length), i = null !== (o = t._instance.getPersistedProperty($e444d6404c095fa5$var$E.LogsQueue)) && void 0 !== o ? o : [], s += l.length, "fatal" === h.kind) throw h.error;
                }
            }
        })();
    }
    Dt(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            var i, r = Math.max(0, t - e.ft), s = null !== (i = e._instance.getPersistedProperty($e444d6404c095fa5$var$E.LogsQueue)) && void 0 !== i ? i : [];
            e._instance.setPersistedProperty($e444d6404c095fa5$var$E.LogsQueue, s.slice(r)), yield e.dt();
        })();
    }
    Lt() {
        return $e444d6404c095fa5$var$Oe(this.Ne, this._instance.getLibraryId(), this._instance.getLibraryVersion());
    }
    At(t) {
        var e;
        if (!this._instance.optedOut) {
            var i = null !== (e = this._instance.getPersistedProperty($e444d6404c095fa5$var$E.LogsQueue)) && void 0 !== e ? e : [];
            this.xt > i.length || (i.shift(), this.ft++, this.rt.info("Logs queue is full, dropping oldest record.")), i.push(t), this._instance.setPersistedProperty($e444d6404c095fa5$var$E.LogsQueue, i), this.kt > i.length ? this.$t() : this.It();
        }
    }
    $t(t) {
        void 0 === t && (t = this.St), this.Nt || (this.Nt = $e444d6404c095fa5$var$we(()=>{
            this.Nt = void 0, this.It();
        }, t));
    }
    qt() {
        var t = Math.min(Math.max(0, this.yt - 1), 6);
        return this.St * Math.pow(2, t);
    }
    jt() {
        var t = this._instance.getPersistedProperty($e444d6404c095fa5$var$E.LogsQueue);
        return !!t && t.length > 0;
    }
    shutdown(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            e.Et();
            var i = e.flush().catch(()=>{});
            void 0 !== t ? yield $e444d6404c095fa5$var$xe(i, t) : yield i;
        })();
    }
    flushWithTimeout(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            var i = e.flush();
            yield $e444d6404c095fa5$var$xe(i, t, ()=>{
                i.catch(()=>{});
            });
        })();
    }
    It() {
        this.flush().then(()=>{
            this.yt = 0;
        }, (t)=>{
            this.yt++, this.rt.error("PostHog logs flush failed:", t);
        }).finally(()=>{
            !this._instance.isDisabled && this.jt() && this.$t(this.qt());
        });
    }
    Et() {
        this.Nt && (clearTimeout(this.Nt), this.Nt = void 0);
    }
};
var $e444d6404c095fa5$var$Ae = [
    0,
    5,
    10,
    25,
    50,
    75,
    100,
    250,
    500,
    750,
    1e3,
    2500,
    5e3,
    7500,
    1e4
];
function $e444d6404c095fa5$var$Me(t) {
    return String(t) + "000000";
}
function $e444d6404c095fa5$var$Fe(t, e, i, r) {
    var s = "";
    return r && (s = Object.keys(r).sort().map((t)=>JSON.stringify(t) + ":" + JSON.stringify(r[t])).join(",")), t + "\0" + e + "\0" + (null != i ? i : "") + "\0" + s;
}
let $e444d6404c095fa5$var$De = class {
    constructor(t, e, i){
        this._instance = t, this.Ne = e, this.rt = i, this.Bt = new Map, this.ct = null, this.Ht = !1, this.Ut = new Map, this.zt = new Set, this.Wt = 0;
    }
    count(t, e, i) {
        void 0 === e && (e = 1), this.Vt({
            name: t,
            type: "count",
            value: e,
            unit: null == i ? void 0 : i.unit,
            attributes: null == i ? void 0 : i.attributes
        });
    }
    gauge(t, e, i) {
        this.Vt({
            name: t,
            type: "gauge",
            value: e,
            unit: null == i ? void 0 : i.unit,
            attributes: null == i ? void 0 : i.attributes
        });
    }
    histogram(t, e, i) {
        this.Vt({
            name: t,
            type: "histogram",
            value: e,
            unit: null == i ? void 0 : i.unit,
            attributes: null == i ? void 0 : i.attributes
        });
    }
    flush() {
        var t = this, e = this.ct, i = function() {
            var i = $e444d6404c095fa5$var$p(function*() {
                e && (yield e.catch(()=>{})), yield t.Zt();
            });
            return function() {
                return i.apply(this, arguments);
            };
        }(), r = i().finally(()=>{
            this.ct === r && (this.ct = null);
        });
        return this.ct = r, r;
    }
    drainWindow() {
        if (0 === this.Bt.size) return null;
        var t = this.Bt;
        return this.Bt = new Map, this.Ht = !1, this.Ut = new Map, this.zt = new Set, this.Gt(t);
    }
    reset() {
        this.Wt++, this.Et(), this.Bt = new Map, this.ct = null, this.Ht = !1, this.Ut = new Map, this.zt = new Set;
    }
    Vt(t) {
        if (!this._instance.isDisabled && !this._instance.optedOut) {
            var e = this.Pt(t);
            if (null !== e) {
                if (e.name && "string" == typeof e.name) {
                    if ("number" == typeof e.value && Number.isFinite(e.value)) {
                        if ("count" === e.type && 0 > e.value) this.rt.warn("Dropping count '" + e.name + "': counters are monotonic, value must be >= 0");
                        else {
                            var i, r;
                            try {
                                i = e.attributes ? $e444d6404c095fa5$var$_({}, e.attributes) : void 0, r = $e444d6404c095fa5$var$Fe(e.type, e.name, e.unit, i);
                            } catch (t) {
                                return void this.rt.warn("Dropping metric '" + e.name + "': attributes could not be serialized", t);
                            }
                            var s = this.Bt.get(r);
                            if (!s) {
                                if (!this.Qt()) return;
                                s = {
                                    name: e.name,
                                    type: e.type,
                                    unit: e.unit,
                                    attributes: i,
                                    windowStartMs: Date.now()
                                }, this.Bt.set(r, s);
                            }
                            var n = this.Ut.get(e.name);
                            void 0 === n ? this.Ut.set(e.name, e.type) : n === e.type || this.zt.has(e.name) || (this.zt.add(e.name), this.rt.warn("Metric name '" + e.name + "' is already used as a " + n + "; recording it as a " + e.type + " too will blend both series in charts. Use a distinct name.")), this.Kt(s, e.value), this.$t();
                        }
                    } else this.rt.warn("Dropping metric '" + e.name + "': value must be a finite number");
                } else this.rt.warn("Dropping metric with empty name");
            }
        }
    }
    Qt() {
        return this.Ne.maxSeriesPerFlush > this.Bt.size || (this.Ht || (this.Ht = !0, this.rt.warn("Metric series cap reached (" + this.Ne.maxSeriesPerFlush + " per flush window); dropping new series until the next flush. Reduce attribute cardinality.")), !1);
    }
    Kt(t, e) {
        var i;
        switch(t.type){
            case "count":
                t.total = (null !== (i = t.total) && void 0 !== i ? i : 0) + e;
                break;
            case "gauge":
                t.last = e;
                break;
            case "histogram":
                t.hist || (t.hist = {
                    count: 0,
                    sum: 0,
                    min: e,
                    max: e,
                    bucketCounts: new Array($e444d6404c095fa5$var$Ae.length + 1).fill(0)
                });
                var r = t.hist;
                r.count += 1, r.sum += e, r.min = Math.min(r.min, e), r.max = Math.max(r.max, e), r.bucketCounts[function(t, e) {
                    for(var i = 0; e.length > i; i++)if (e[i] >= t) return i;
                    return e.length;
                }(e, $e444d6404c095fa5$var$Ae)] += 1;
        }
    }
    Pt(t) {
        var e = this.Ne.beforeSend;
        if (!e) return t;
        var i = $e444d6404c095fa5$var$q(e) ? e : [
            e
        ], r = t;
        for (var s of i)try {
            var n = s(r);
            if (!n) return this.rt.info("Metric was rejected in beforeSend function"), null;
            r = n;
        } catch (t) {
            return this.rt.error("Error in beforeSend function for metric:", t), null;
        }
        return r;
    }
    $t() {
        this.Nt || (this.Nt = $e444d6404c095fa5$var$we(()=>{
            this.Nt = void 0, this.flush().catch((t)=>{
                this.rt.error("Metrics flush failed:", t);
            });
        }, this.Ne.flushIntervalMs));
    }
    Et() {
        this.Nt && (clearTimeout(this.Nt), this.Nt = void 0);
    }
    Zt() {
        var t = this;
        return $e444d6404c095fa5$var$p(function*() {
            if (0 !== t.Bt.size) {
                var e = t.Bt;
                t.Bt = new Map, t.Ht = !1, t.Ut = new Map, t.zt = new Set;
                var i = t.Wt, r = yield t._instance.Jt(t.Gt(e));
                if (i === t.Wt) switch(r.kind){
                    case "ok":
                        return;
                    case "retry-later":
                        return t.Yt(e), void t.$t();
                    case "too-large":
                        return void t.rt.warn("Metrics batch exceeded the server size limit and was dropped");
                    case "fatal":
                        return void t.rt.error("Failed to send metrics batch:", r.error);
                }
            }
        })();
    }
    Gt(t) {
        var e, i, r, s;
        return e = this.Xt(t), i = function(t, e, i) {
            return $e444d6404c095fa5$var$_({}, t.resourceAttributes, {
                "service.name": t.serviceName || "unknown_service"
            }, t.environment && {
                "deployment.environment": t.environment
            }, t.serviceVersion && {
                "service.version": t.serviceVersion
            }, {
                "telemetry.sdk.name": e,
                "telemetry.sdk.version": i
            });
        }(this.Ne, this._instance.getLibraryId(), this._instance.getLibraryVersion()), r = this._instance.getLibraryId(), s = this._instance.getLibraryVersion(), {
            resourceMetrics: [
                {
                    resource: {
                        attributes: $e444d6404c095fa5$var$Re(i)
                    },
                    scopeMetrics: [
                        {
                            scope: {
                                name: r,
                                version: s
                            },
                            metrics: e
                        }
                    ]
                }
            ]
        };
    }
    Xt(t) {
        var e = $e444d6404c095fa5$var$Me(Date.now()), i = new Map;
        for (var r of t.values()){
            var s, n = $e444d6404c095fa5$var$Fe(r.type, r.name, r.unit, void 0), o = i.get(n);
            o || (o = $e444d6404c095fa5$var$_({
                name: r.name
            }, r.unit && {
                unit: r.unit
            }), "count" === r.type ? o.sum = {
                aggregationTemporality: 1,
                isMonotonic: !0,
                dataPoints: []
            } : "gauge" === r.type ? o.gauge = {
                dataPoints: []
            } : o.histogram = {
                aggregationTemporality: 1,
                dataPoints: []
            }, i.set(n, o));
            var a = $e444d6404c095fa5$var$Re(null !== (s = r.attributes) && void 0 !== s ? s : {}), l = $e444d6404c095fa5$var$Me(r.windowStartMs);
            if ("count" === r.type) {
                var u, h = {
                    attributes: a,
                    startTimeUnixNano: l,
                    timeUnixNano: e,
                    asDouble: null !== (u = r.total) && void 0 !== u ? u : 0
                };
                o.sum.dataPoints.push(h);
            } else if ("gauge" === r.type) {
                var d, v = {
                    attributes: a,
                    timeUnixNano: e,
                    asDouble: null !== (d = r.last) && void 0 !== d ? d : 0
                };
                o.gauge.dataPoints.push(v);
            } else r.hist && o.histogram.dataPoints.push({
                attributes: a,
                startTimeUnixNano: l,
                timeUnixNano: e,
                count: r.hist.count,
                sum: r.hist.sum,
                min: r.hist.min,
                max: r.hist.max,
                bucketCounts: r.hist.bucketCounts,
                explicitBounds: $e444d6404c095fa5$var$Ae
            });
        }
        return Array.from(i.values());
    }
    Yt(t) {
        var e, i;
        for (var r of t){
            var s = r[0], n = r[1], o = this.Bt.get(s);
            if (o) switch(o.windowStartMs = Math.min(o.windowStartMs, n.windowStartMs), o.type){
                case "count":
                    o.total = (null !== (e = o.total) && void 0 !== e ? e : 0) + (null !== (i = n.total) && void 0 !== i ? i : 0);
                    break;
                case "gauge":
                    break;
                case "histogram":
                    if (n.hist) {
                        if (o.hist) {
                            o.hist.count += n.hist.count, o.hist.sum += n.hist.sum, o.hist.min = Math.min(o.hist.min, n.hist.min), o.hist.max = Math.max(o.hist.max, n.hist.max);
                            for(var a = 0; o.hist.bucketCounts.length > a; a++)o.hist.bucketCounts[a] += n.hist.bucketCounts[a];
                        } else o.hist = n.hist;
                    }
            }
            else this.Qt() && this.Bt.set(s, n);
        }
    }
};
var $e444d6404c095fa5$var$Ne, $e444d6404c095fa5$var$Ue, $e444d6404c095fa5$var$Le;
function $e444d6404c095fa5$var$je(t) {
    var e = globalThis._posthogChunkIds;
    if (e) {
        var i = Object.keys(e);
        return $e444d6404c095fa5$var$Le && i.length === $e444d6404c095fa5$var$Ue || ($e444d6404c095fa5$var$Ue = i.length, $e444d6404c095fa5$var$Le = i.reduce((i, r)=>{
            $e444d6404c095fa5$var$Ne || ($e444d6404c095fa5$var$Ne = {});
            var s = $e444d6404c095fa5$var$Ne[r];
            if (s) i[s[0]] = s[1];
            else for(var n = t(r), o = n.length - 1; o >= 0; o--){
                var a = n[o], l = null == a ? void 0 : a.filename, u = e[r];
                if (l && u) {
                    i[l] = u, $e444d6404c095fa5$var$Ne[r] = [
                        l,
                        u
                    ];
                    break;
                }
            }
            return i;
        }, {})), $e444d6404c095fa5$var$Le;
    }
}
class $e444d6404c095fa5$var$Be {
    constructor(t, e, i){
        void 0 === i && (i = []), this.coercers = t, this.stackParser = e, this.modifiers = i;
    }
    buildFromUnknown(t, e) {
        void 0 === e && (e = {});
        var i = e && e.mechanism || {
            handled: !0,
            type: "generic"
        }, r = this.buildCoercingContext(i, e, 0).apply(t), s = this.buildParsingContext(e), n = this.parseStacktrace(r, s);
        return {
            $exception_list: this.convertToExceptionList(n, i),
            $exception_level: "error"
        };
    }
    modifyFrames(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            for (var i of t)i.stacktrace && i.stacktrace.frames && $e444d6404c095fa5$var$q(i.stacktrace.frames) && (i.stacktrace.frames = yield e.applyModifiers(i.stacktrace.frames));
            return t;
        })();
    }
    coerceFallback(t) {
        var e;
        return {
            type: "Error",
            value: "Unknown error",
            stack: null == (e = t.syntheticException) ? void 0 : e.stack,
            synthetic: !0
        };
    }
    parseStacktrace(t, e) {
        var i, r;
        return null != t.cause && (i = this.parseStacktrace(t.cause, e)), "" != t.stack && null != t.stack && (r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? e.skipFirstLines : 0), e.chunkIdMap)), $e444d6404c095fa5$var$_({}, t, {
            cause: i,
            stack: r
        });
    }
    applyChunkIds(t, e) {
        return t.map((t)=>(t.filename && e && (t.chunk_id = e[t.filename]), t));
    }
    applyCoercers(t, e) {
        for (var i of this.coercers)if (i.match(t)) return i.coerce(t, e);
        return this.coerceFallback(e);
    }
    applyModifiers(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            var i = t;
            for (var r of e.modifiers)i = yield r(i);
            return i;
        })();
    }
    convertToExceptionList(t, e) {
        var i, r, s, n = {
            type: t.type,
            value: t.value,
            mechanism: {
                type: null !== (i = e.type) && void 0 !== i ? i : "generic",
                handled: null === (r = e.handled) || void 0 === r || r,
                synthetic: null !== (s = t.synthetic) && void 0 !== s && s
            }
        };
        t.stack && (n.stacktrace = {
            type: "raw",
            frames: t.stack
        });
        var o = [
            n
        ];
        return null != t.cause && o.push(...this.convertToExceptionList(t.cause, $e444d6404c095fa5$var$_({}, e, {
            handled: !0
        }))), o;
    }
    buildParsingContext(t) {
        var e;
        return {
            chunkIdMap: $e444d6404c095fa5$var$je(this.stackParser),
            skipFirstLines: null !== (e = t.skipFirstLines) && void 0 !== e ? e : 1
        };
    }
    buildCoercingContext(t, e, i) {
        void 0 === i && (i = 0);
        var r = (i, r)=>{
            if (4 >= r) {
                var s = this.buildCoercingContext(t, e, r);
                return this.applyCoercers(i, s);
            }
        };
        return $e444d6404c095fa5$var$_({}, e, {
            syntheticException: 0 == i ? e.syntheticException : void 0,
            mechanism: t,
            apply: (t)=>r(t, i),
            next: (t)=>r(t, i + 1)
        });
    }
}
var $e444d6404c095fa5$var$ze = "?";
function $e444d6404c095fa5$var$He(t, e, i, r, s) {
    var n = {
        platform: t,
        filename: e,
        function: "<anonymous>" === i ? $e444d6404c095fa5$var$ze : i,
        in_app: !0
    };
    return $e444d6404c095fa5$var$K(r) || (n.lineno = r), $e444d6404c095fa5$var$K(s) || (n.colno = s), n;
}
var $e444d6404c095fa5$var$qe = (t, e)=>{
    var i = -1 !== t.indexOf("safari-extension"), r = -1 !== t.indexOf("safari-web-extension");
    return i || r ? [
        -1 !== t.indexOf("@") ? t.split("@")[0] : $e444d6404c095fa5$var$ze,
        i ? "safari-extension:" + e : "safari-web-extension:" + e
    ] : [
        t,
        e
    ];
}, $e444d6404c095fa5$var$Ve = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, $e444d6404c095fa5$var$We = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $e444d6404c095fa5$var$Ge = /\((\S*)(?::(\d+))(?::(\d+))\)/, $e444d6404c095fa5$var$Ke = (t, e)=>{
    var i = $e444d6404c095fa5$var$Ve.exec(t);
    if (i) return $e444d6404c095fa5$var$He(e, i[1], $e444d6404c095fa5$var$ze, +i[2], +i[3]);
    var r = $e444d6404c095fa5$var$We.exec(t);
    if (r) {
        if (r[2] && 0 === r[2].indexOf("eval")) {
            var s = $e444d6404c095fa5$var$Ge.exec(r[2]);
            s && (r[2] = s[1], r[3] = s[2], r[4] = s[3]);
        }
        var n = $e444d6404c095fa5$var$qe(r[1] || $e444d6404c095fa5$var$ze, r[2]);
        return $e444d6404c095fa5$var$He(e, n[1], n[0], r[3] ? +r[3] : void 0, r[4] ? +r[4] : void 0);
    }
}, $e444d6404c095fa5$var$Je = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, $e444d6404c095fa5$var$Ye = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, $e444d6404c095fa5$var$Qe = (t, e)=>{
    var i = $e444d6404c095fa5$var$Je.exec(t);
    if (i) {
        if (i[3] && i[3].indexOf(" > eval") > -1) {
            var r = $e444d6404c095fa5$var$Ye.exec(i[3]);
            r && (i[1] = i[1] || "eval", i[3] = r[1], i[4] = r[2], i[5] = "");
        }
        var s = i[3], n = i[1] || $e444d6404c095fa5$var$ze, o = $e444d6404c095fa5$var$qe(n, s);
        return $e444d6404c095fa5$var$He(e, s = o[1], n = o[0], i[4] ? +i[4] : void 0, i[5] ? +i[5] : void 0);
    }
}, $e444d6404c095fa5$var$Xe = /\(error: (.*)\)/;
class $e444d6404c095fa5$var$Ze {
    match(t) {
        return this.isDOMException(t) || this.isDOMError(t);
    }
    coerce(t, e) {
        var i = $e444d6404c095fa5$var$J(t.stack);
        return {
            type: this.getType(t),
            value: this.getValue(t),
            stack: i ? t.stack : void 0,
            cause: t.cause ? e.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return this.isDOMError(t) ? "DOMError" : "DOMException";
    }
    getValue(t) {
        var e = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
        return t.message ? e + ": " + t.message : e;
    }
    isDOMException(t) {
        return $e444d6404c095fa5$var$ot(t, "DOMException");
    }
    isDOMError(t) {
        return $e444d6404c095fa5$var$ot(t, "DOMError");
    }
}
class $e444d6404c095fa5$var$ti {
    match(t) {
        return function(t) {
            switch(({}).toString.call(t)){
                case "[object Error]":
                case "[object Exception]":
                case "[object DOMException]":
                case "[object DOMError]":
                case "[object WebAssembly.Exception]":
                    return !0;
                default:
                    return $e444d6404c095fa5$var$lt(t, Error);
            }
        }(t);
    }
    coerce(t, e) {
        return {
            type: this.getType(t),
            value: this.getMessage(t, e),
            stack: this.getStack(t),
            cause: t.cause ? e.next(t.cause) : void 0,
            synthetic: !1
        };
    }
    getType(t) {
        return t.name || t.constructor.name;
    }
    getMessage(t, e) {
        var i = t.message;
        return String(i.error && "string" == typeof i.error.message ? i.error.message : i);
    }
    getStack(t) {
        return t.stacktrace || t.stack || void 0;
    }
}
class $e444d6404c095fa5$var$ei {
    constructor(){}
    match(t) {
        return !!$e444d6404c095fa5$var$ot(t, "ErrorEvent") && (null != t.error || this.fe(t));
    }
    coerce(t, e) {
        var i;
        if (null != t.error) return e.apply(t.error);
        var r = e.apply(t.message);
        return $e444d6404c095fa5$var$_({}, r, {
            stack: null !== (i = this.pe(t)) && void 0 !== i ? i : r.stack,
            synthetic: !0
        });
    }
    fe(t) {
        return $e444d6404c095fa5$var$J(t.message) && t.message.length > 0;
    }
    pe(t) {
        var e = t;
        if ($e444d6404c095fa5$var$J(e.filename) && e.filename.length > 0) {
            var i, r, s = null !== (i = e.lineno) && void 0 !== i ? i : 0, n = null !== (r = e.colno) && void 0 !== r ? r : 0;
            return "Error\n    at " + e.filename + ":" + s + ":" + n;
        }
    }
}
var $e444d6404c095fa5$var$ii = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
class $e444d6404c095fa5$var$ri {
    match(t) {
        return "string" == typeof t;
    }
    coerce(t, e) {
        var i, r = this.getInfos(t), s = r[0], n = r[1];
        return {
            type: null != s ? s : "Error",
            value: null != n ? n : t,
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
    getInfos(t) {
        var e = "Error", i = t, r = t.match($e444d6404c095fa5$var$ii);
        return r && (e = r[1], i = r[2]), [
            e,
            i
        ];
    }
}
var $e444d6404c095fa5$var$si = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function $e444d6404c095fa5$var$ni(t, e) {
    void 0 === e && (e = 40);
    var i = Object.keys(t);
    if (i.sort(), !i.length) return "[object has no keys]";
    for(var r = i.length; r > 0; r--){
        var s = i.slice(0, r).join(", ");
        if (e >= s.length) return r === i.length ? s : s.length > e ? s.slice(0, e) + "..." : s;
    }
    return "";
}
class $e444d6404c095fa5$var$oi {
    match(t) {
        return "object" == typeof t && null !== t;
    }
    coerce(t, e) {
        var i, r, s = this.getErrorPropertyFromObject(t);
        return s ? e.apply(s) : {
            type: this.getType(t),
            value: this.getValue(t),
            stack: null !== (i = this.getStack(t)) && void 0 !== i ? i : null == (r = e.syntheticException) ? void 0 : r.stack,
            level: this.isSeverityLevel(t.level) ? t.level : "error",
            synthetic: !0
        };
    }
    getType(t) {
        return $e444d6404c095fa5$var$at(t) ? t.constructor.name : "Error";
    }
    getValue(t) {
        if ("name" in t && "string" == typeof t.name) {
            var e = "'" + t.name + "' captured as exception";
            return "message" in t && "string" == typeof t.message && (e += " with message: '" + t.message + "'"), e;
        }
        if ("message" in t && "string" == typeof t.message) return t.message;
        var i = this.getObjectClassName(t);
        return (i && "Object" !== i ? "'" + i + "'" : "Object") + " captured as exception with keys: " + $e444d6404c095fa5$var$ni(t);
    }
    isSeverityLevel(t) {
        return $e444d6404c095fa5$var$J(t) && !$e444d6404c095fa5$var$Y(t) && $e444d6404c095fa5$var$si.indexOf(t) >= 0;
    }
    getStack(t) {
        try {
            return $e444d6404c095fa5$var$J(t.stacktrace) && t.stacktrace.length > 0 ? t.stacktrace : $e444d6404c095fa5$var$J(t.stack) && t.stack.length > 0 ? t.stack : void 0;
        } catch (t) {
            return;
        }
    }
    getErrorPropertyFromObject(t) {
        for(var e in t)if (({}).hasOwnProperty.call(t, e)) {
            var i = t[e];
            if ($e444d6404c095fa5$var$Se(i)) return i;
        }
    }
    getObjectClassName(t) {
        try {
            var e = Object.getPrototypeOf(t);
            return e ? e.constructor.name : void 0;
        } catch (t) {
            return;
        }
    }
}
class $e444d6404c095fa5$var$ai {
    match(t) {
        return $e444d6404c095fa5$var$at(t);
    }
    coerce(t, e) {
        var i, r = t.constructor.name;
        return {
            type: r,
            value: r + " captured as exception with keys: " + $e444d6404c095fa5$var$ni(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$li {
    match(t) {
        return $e444d6404c095fa5$var$nt(t);
    }
    coerce(t, e) {
        var i;
        return {
            type: "Error",
            value: "Primitive value captured as exception: " + String(t),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        };
    }
}
class $e444d6404c095fa5$var$ui {
    match(t) {
        return $e444d6404c095fa5$var$ot(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
    }
    isCustomEventWrappingRejection(t) {
        if (!$e444d6404c095fa5$var$at(t)) return !1;
        try {
            var e = t.detail;
            return null != e && "object" == typeof e && "reason" in e;
        } catch (t) {
            return !1;
        }
    }
    coerce(t, e) {
        var i, r = this.getUnhandledRejectionReason(t);
        return $e444d6404c095fa5$var$nt(r) ? {
            type: "UnhandledRejection",
            value: "Non-Error promise rejection captured with value: " + String(r),
            stack: null == (i = e.syntheticException) ? void 0 : i.stack,
            synthetic: !0
        } : e.apply(r);
    }
    getUnhandledRejectionReason(t) {
        try {
            if ("reason" in t) return t.reason;
            if ("detail" in t && null != t.detail && "object" == typeof t.detail && "reason" in t.detail) return t.detail.reason;
        } catch (t) {}
        return t;
    }
}
var $e444d6404c095fa5$var$hi = "$message", $e444d6404c095fa5$var$di = "$timestamp", $e444d6404c095fa5$var$vi = new Set([
    $e444d6404c095fa5$var$hi,
    $e444d6404c095fa5$var$di
]), $e444d6404c095fa5$var$ci = {
    enabled: !0,
    max_bytes: 32768
};
function $e444d6404c095fa5$var$fi(t) {
    var e;
    return t ? {
        enabled: null !== (e = t.enabled) && void 0 !== e ? e : $e444d6404c095fa5$var$ci.enabled,
        max_bytes: $e444d6404c095fa5$var$_i(t.max_bytes, $e444d6404c095fa5$var$ci.max_bytes)
    } : $e444d6404c095fa5$var$_({}, $e444d6404c095fa5$var$ci);
}
class $e444d6404c095fa5$var$pi {
    constructor(t){
        this.Ke = [], this.Je = 0, this.Ne = $e444d6404c095fa5$var$fi(t);
    }
    setConfig(t) {
        this.Ne = $e444d6404c095fa5$var$fi(t), this.Xe();
    }
    add(t) {
        var e = function(t) {
            var e;
            try {
                e = $e444d6404c095fa5$var$j(t);
            } catch (t) {
                return;
            }
            try {
                var i = JSON.parse(e);
                if (!$e444d6404c095fa5$var$W(i)) return;
                var r = i, s = r[$e444d6404c095fa5$var$hi], n = r[$e444d6404c095fa5$var$di];
                if (!$e444d6404c095fa5$var$J(s) || 0 === s.trim().length) return;
                if (!$e444d6404c095fa5$var$J(n) && !$e444d6404c095fa5$var$Z(n)) return;
                return {
                    step: r,
                    json: e
                };
            } catch (t) {
                return;
            }
        }(t);
        if (e) {
            var i = function(t) {
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t).length;
                for(var e = encodeURIComponent(t), i = 0, r = 0; e.length > r; r++)"%" === e[r] ? (i += 1, r += 2) : i += 1;
                return i;
            }(e.json);
            i > this.Ne.max_bytes || (this.Ke.push({
                step: e.step,
                bytes: i
            }), this.Je += i, this.Xe());
        }
    }
    getAttachable() {
        return this.Ke.map((t)=>t.step);
    }
    clear() {
        this.Ke = [], this.Je = 0;
    }
    size() {
        return this.Ke.length;
    }
    Xe() {
        for(; this.Je > this.Ne.max_bytes && this.Ke.length > 0;){
            var t = this.Ke.shift();
            t && (this.Je -= t.bytes);
        }
    }
}
function $e444d6404c095fa5$var$_i(t, e) {
    if (!$e444d6404c095fa5$var$Z(t) || t === 1 / 0 || t === -1 / 0) return e;
    var i = Math.floor(t);
    return 0 > i ? e : i;
}
var $e444d6404c095fa5$var$gi = function(e, i) {
    var r = (void 0 === i ? {} : i).debugEnabled, s = {
        k (i) {
            if ($e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$c.DEBUG || $e444d6404c095fa5$var$t.POSTHOG_DEBUG || r) && !$e444d6404c095fa5$var$K($e444d6404c095fa5$var$t.console) && $e444d6404c095fa5$var$t.console) {
                for(var s = ("__rrweb_original__" in $e444d6404c095fa5$var$t.console[i]) ? $e444d6404c095fa5$var$t.console[i].__rrweb_original__ : $e444d6404c095fa5$var$t.console[i], n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; n > a; a++)o[a - 1] = arguments[a];
                s(e, ...o);
            }
        },
        debug () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("debug", ...e);
        },
        info () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("log", ...e);
        },
        warn () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("warn", ...e);
        },
        error () {
            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
            s.k("error", ...e);
        },
        critical () {
            for(var t = arguments.length, i = new Array(t), r = 0; t > r; r++)i[r] = arguments[r];
            console.error(e, ...i);
        },
        uninitializedWarning (t) {
            s.error("You must initialize PostHog before calling " + t);
        },
        createLogger: (t, i)=>$e444d6404c095fa5$var$gi(e + " " + t, i)
    };
    return s;
}, $e444d6404c095fa5$var$mi = $e444d6404c095fa5$var$gi("[PostHog.js]"), $e444d6404c095fa5$var$bi = $e444d6404c095fa5$var$mi.createLogger, $e444d6404c095fa5$var$yi = $e444d6404c095fa5$var$bi("[ExternalScriptsLoader]"), $e444d6404c095fa5$var$wi = (t, e, i)=>{
    if (t.config.disable_external_dependency_loading) return $e444d6404c095fa5$var$yi.warn(e + " was requested but loading of external scripts is disabled."), i("Loading of external scripts is disabled");
    var s = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.querySelectorAll("script");
    if (s) {
        for(var n, o = function() {
            if (s[a].src === e) {
                var t = s[a];
                return t.__posthog_loading_callback_fired ? {
                    v: i()
                } : (t.addEventListener("load", (e)=>{
                    t.__posthog_loading_callback_fired = !0, i(void 0, e);
                }), t.onerror = (t)=>i(t), {
                    v: void 0
                });
            }
        }, a = 0; s.length > a; a++)if (n = o()) return n.v;
    }
    var l = ()=>{
        if (!$e444d6404c095fa5$var$r) return i("document not found");
        var s = $e444d6404c095fa5$var$r.createElement("script");
        if (s.type = "text/javascript", s.crossOrigin = "anonymous", s.src = e, s.onload = (t)=>{
            s.__posthog_loading_callback_fired = !0, i(void 0, t);
        }, s.onerror = (t)=>i(t), t.config.prepare_external_dependency_script && (s = t.config.prepare_external_dependency_script(s)), !s) return i("prepare_external_dependency_script returned null");
        if ("head" === t.config.external_scripts_inject_target) $e444d6404c095fa5$var$r.head.appendChild(s);
        else {
            var n, o = $e444d6404c095fa5$var$r.querySelectorAll("body > script");
            o.length > 0 ? null == (n = o[0].parentNode) || n.insertBefore(s, o[0]) : $e444d6404c095fa5$var$r.body.appendChild(s);
        }
    };
    null != $e444d6404c095fa5$var$r && $e444d6404c095fa5$var$r.body ? l() : null == $e444d6404c095fa5$var$r || $e444d6404c095fa5$var$r.addEventListener("DOMContentLoaded", l);
};
$e444d6404c095fa5$var$v.__PosthogExtensions__ = $e444d6404c095fa5$var$v.__PosthogExtensions__ || {}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadExternalDependency = (t, e, i)=>{
    if ("remote-config" !== e) {
        var r;
        if (t.config.strict_script_versioning) r = t.requestRouter.endpointFor("assets", "/static/" + t.version + "/" + e + ".js");
        else {
            var s = "/static/" + e + ".js?v=" + t.version;
            if ("toolbar" === e) {
                var n = 3e5;
                s = s + "&t=" + Math.floor(Date.now() / n) * n;
            }
            r = t.requestRouter.endpointFor("assets", s);
        }
        $e444d6404c095fa5$var$wi(t, r, i);
    } else {
        var o = t.requestRouter.endpointFor("assets", "/array/" + t.config.token + "/config.js");
        $e444d6404c095fa5$var$wi(t, o, i);
    }
}, $e444d6404c095fa5$var$v.__PosthogExtensions__.loadSiteApp = (t, e, i)=>{
    var r = t.requestRouter.endpointFor("api", e);
    $e444d6404c095fa5$var$wi(t, r, i);
};
$e444d6404c095fa5$var$c.DEBUG = !1, $e444d6404c095fa5$var$c.LIB_VERSION = "1.413.3", $e444d6404c095fa5$var$c.LIB_NAME = "web";
var $e444d6404c095fa5$var$xi = "$people_distinct_id", $e444d6404c095fa5$var$Ei = "$device_id", $e444d6404c095fa5$var$Si = "$device_model", $e444d6404c095fa5$var$$i = "__alias", $e444d6404c095fa5$var$ki = "__timers", $e444d6404c095fa5$var$Ti = "$autocapture_disabled_server_side", $e444d6404c095fa5$var$Ri = "$heatmaps_enabled_server_side", $e444d6404c095fa5$var$Pi = "$exception_capture_enabled_server_side", $e444d6404c095fa5$var$Oi = "$error_tracking_suppression_rules", $e444d6404c095fa5$var$Ii = "$error_tracking_capture_extension_exceptions", $e444d6404c095fa5$var$Ci = "$web_vitals_enabled_server_side", $e444d6404c095fa5$var$Ai = "$dead_clicks_enabled_server_side", $e444d6404c095fa5$var$Mi = "$product_tours_enabled_server_side", $e444d6404c095fa5$var$Fi = "$web_vitals_allowed_metrics", $e444d6404c095fa5$var$Di = "$session_recording_remote_config", $e444d6404c095fa5$var$Ni = "$replay_sample_rate", $e444d6404c095fa5$var$Ui = "$replay_override_sampling", $e444d6404c095fa5$var$Li = "$replay_override_linked_flag", $e444d6404c095fa5$var$ji = "$replay_override_url_trigger", $e444d6404c095fa5$var$Bi = "$replay_override_event_trigger", $e444d6404c095fa5$var$zi = "$sesid", $e444d6404c095fa5$var$Hi = "$session_is_sampled", $e444d6404c095fa5$var$qi = "$enabled_feature_flags", $e444d6404c095fa5$var$Vi = "$active_feature_flags", $e444d6404c095fa5$var$Wi = "$early_access_features", $e444d6404c095fa5$var$Gi = "$feature_flag_details", $e444d6404c095fa5$var$Ki = "$feature_flag_payloads", $e444d6404c095fa5$var$Ji = "$feature_flag_request_id", $e444d6404c095fa5$var$Yi = "$minimal_flag_called_events", $e444d6404c095fa5$var$Qi = "$override_feature_flags", $e444d6404c095fa5$var$Xi = "$override_feature_flag_payloads", $e444d6404c095fa5$var$Zi = "$stored_person_properties", $e444d6404c095fa5$var$tr = "$stored_group_properties", $e444d6404c095fa5$var$er = "$surveys", $e444d6404c095fa5$var$ir = "$surveys_loaded_at", $e444d6404c095fa5$var$rr = "$surveys_activated", $e444d6404c095fa5$var$sr = "$surveys_activated_session", $e444d6404c095fa5$var$nr = "$surveys_activated_timestamps", $e444d6404c095fa5$var$or = "ph_product_tours", $e444d6404c095fa5$var$ar = "$flag_call_reported", $e444d6404c095fa5$var$lr = "$flag_call_reported_session_id", $e444d6404c095fa5$var$ur = "$feature_flag_errors", $e444d6404c095fa5$var$hr = "$feature_flag_evaluated_at", $e444d6404c095fa5$var$dr = "$user_state", $e444d6404c095fa5$var$vr = "$client_session_props", $e444d6404c095fa5$var$cr = "$capture_rate_limit", $e444d6404c095fa5$var$fr = "$initial_campaign_params", $e444d6404c095fa5$var$pr = "$initial_referrer_info", $e444d6404c095fa5$var$_r = "$initial_person_info", $e444d6404c095fa5$var$gr = "$epp", $e444d6404c095fa5$var$mr = "$posthog_cookieless", $e444d6404c095fa5$var$br = "$cookieless_mode", $e444d6404c095fa5$var$yr = "$sdk_debug_extensions_init_method", $e444d6404c095fa5$var$wr = "$sdk_debug_extensions_init_time_ms", $e444d6404c095fa5$var$xr = "$sdk_debug_recording_script_not_loaded", $e444d6404c095fa5$var$Er = "PostHog loadExternalDependency extension not found.", $e444d6404c095fa5$var$Sr = "on_reject", $e444d6404c095fa5$var$$r = "always", $e444d6404c095fa5$var$kr = "anonymous", $e444d6404c095fa5$var$Tr = "identified", $e444d6404c095fa5$var$Rr = "identified_only", $e444d6404c095fa5$var$Pr = "visibilitychange", $e444d6404c095fa5$var$Or = "beforeunload", $e444d6404c095fa5$var$Ir = "$pageview", $e444d6404c095fa5$var$Cr = "$pageleave", $e444d6404c095fa5$var$Ar = "$identify", $e444d6404c095fa5$var$Mr = "$groupidentify";
function $e444d6404c095fa5$var$Fr(t, e) {
    $e444d6404c095fa5$var$q(t) && t.forEach(e);
}
function $e444d6404c095fa5$var$Dr(t, e) {
    if (!$e444d6404c095fa5$var$X(t)) {
        if ($e444d6404c095fa5$var$q(t)) t.forEach(e);
        else if ($e444d6404c095fa5$var$it(t)) t.forEach((t, i)=>e(t, i));
        else for(var i in t)$e444d6404c095fa5$var$z.call(t, i) && e(t[i], i);
    }
}
var $e444d6404c095fa5$var$Nr = function(t) {
    for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
    for (var s of i)for(var n in s)void 0 !== s[n] && (t[n] = s[n]);
    return t;
};
function $e444d6404c095fa5$var$Ur(t) {
    for(var e = Object.keys(t), i = e.length, r = new Array(i); i--;)r[i] = [
        e[i],
        t[e[i]]
    ];
    return r;
}
var $e444d6404c095fa5$var$Lr = function(t) {
    try {
        return t();
    } catch (t) {
        return;
    }
}, $e444d6404c095fa5$var$jr = function(t) {
    return function() {
        try {
            for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
            return t.apply(this, i);
        } catch (t) {
            $e444d6404c095fa5$var$mi.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), $e444d6404c095fa5$var$mi.critical(t);
        }
    };
}, $e444d6404c095fa5$var$Br = function(t) {
    var e = {};
    return $e444d6404c095fa5$var$Dr(t, function(t, i) {
        ($e444d6404c095fa5$var$J(t) && t.length > 0 || $e444d6404c095fa5$var$Z(t)) && (e[i] = t);
    }), e;
};
var $e444d6404c095fa5$var$zr = [
    "herokuapp.com",
    "vercel.app",
    "netlify.app"
];
function $e444d6404c095fa5$var$Hr(t) {
    var e = null == t ? void 0 : t.hostname;
    if (!$e444d6404c095fa5$var$J(e)) return !1;
    var i = e.split(".").slice(-2).join(".");
    for (var r of $e444d6404c095fa5$var$zr)if (i === r) return !1;
    return !0;
}
function $e444d6404c095fa5$var$qr(t, e, i, r) {
    var s = null != r ? r : {}, n = s.capture, o = s.passive;
    null == t || t.addEventListener(e, i, {
        capture: void 0 !== n && n,
        passive: void 0 === o || o
    });
}
function $e444d6404c095fa5$var$Vr(t) {
    return "ph_toolbar_internal" === t.name;
}
var $e444d6404c095fa5$var$Wr = (t)=>{
    if ($e444d6404c095fa5$var$r) {
        try {
            for(var e = t + "=", i = $e444d6404c095fa5$var$r.cookie.split(";").filter((t)=>t.length), s = 0; i.length > s; s++){
                for(var n = i[s]; " " == n.charAt(0);)n = n.substring(1, n.length);
                if (0 === n.indexOf(e)) return decodeURIComponent(n.substring(e.length, n.length));
            }
        } catch (t) {}
        return null;
    }
};
Math.trunc || (Math.trunc = function(t) {
    return 0 > t ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
    return $e444d6404c095fa5$var$Z(t) && isFinite(t) && Math.floor(t) === t;
});
class $e444d6404c095fa5$var$Gr {
    constructor(t){
        if (this.bytes = t, 16 !== t.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(t, e, i, r) {
        if (!Number.isInteger(t) || !Number.isInteger(e) || !Number.isInteger(i) || !Number.isInteger(r) || 0 > t || 0 > e || 0 > i || 0 > r || t > 0xffffffffffff || e > 4095 || i > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
        var s = new Uint8Array(16);
        return s[0] = t / Math.pow(2, 40), s[1] = t / Math.pow(2, 32), s[2] = t / Math.pow(2, 24), s[3] = t / Math.pow(2, 16), s[4] = t / 256, s[5] = t, s[6] = 112 | e >>> 8, s[7] = e, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new $e444d6404c095fa5$var$Gr(s);
    }
    toString() {
        for(var t = "", e = 0; this.bytes.length > e; e++)t = t + (this.bytes[e] >>> 4).toString(16) + (15 & this.bytes[e]).toString(16), 3 !== e && 5 !== e && 7 !== e && 9 !== e || (t += "-");
        if (36 !== t.length) throw new Error("Invalid UUIDv7 was generated");
        return t;
    }
    clone() {
        return new $e444d6404c095fa5$var$Gr(this.bytes.slice(0));
    }
    equals(t) {
        return 0 === this.compareTo(t);
    }
    compareTo(t) {
        for(var e = 0; 16 > e; e++){
            var i = this.bytes[e] - t.bytes[e];
            if (0 !== i) return Math.sign(i);
        }
        return 0;
    }
}
class $e444d6404c095fa5$var$Kr {
    generate() {
        var t = this.generateOrAbort();
        if (!$e444d6404c095fa5$var$K(t)) return t;
        this.S = 0;
        var e = this.generateOrAbort();
        if ($e444d6404c095fa5$var$K(e)) throw new Error("Could not generate UUID after timestamp reset");
        return e;
    }
    generateOrAbort() {
        var t = Date.now();
        if (t > this.S) this.S = t, this.C();
        else {
            if (this.S >= t + 1e4) return;
            this.I++, this.I > 4398046511103 && (this.S++, this.C());
        }
        return $e444d6404c095fa5$var$Gr.fromFieldsV7(this.S, Math.trunc(this.I / Math.pow(2, 30)), this.I & Math.pow(2, 30) - 1, this.A.nextUint32());
    }
    C() {
        this.I = 1024 * this.A.nextUint32() + (1023 & this.A.nextUint32());
    }
    constructor(){
        this.S = 0, this.I = 0, this.A = new $e444d6404c095fa5$var$Qr;
    }
}
var $e444d6404c095fa5$var$Jr, $e444d6404c095fa5$var$Yr = (t)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var e = 0; t.length > e; e++)t[e] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return t;
};
$e444d6404c095fa5$var$t && !$e444d6404c095fa5$var$K($e444d6404c095fa5$var$t.crypto) && crypto.getRandomValues && ($e444d6404c095fa5$var$Yr = (t)=>crypto.getRandomValues(t));
class $e444d6404c095fa5$var$Qr {
    nextUint32() {
        return this.R.length > this.O || ($e444d6404c095fa5$var$Yr(this.R), this.O = 0), this.R[this.O++];
    }
    constructor(){
        this.R = new Uint32Array(8), this.O = 1 / 0;
    }
}
var $e444d6404c095fa5$var$Xr = ()=>$e444d6404c095fa5$var$Zr().toString(), $e444d6404c095fa5$var$Zr = ()=>($e444d6404c095fa5$var$Jr || ($e444d6404c095fa5$var$Jr = new $e444d6404c095fa5$var$Kr)).generate(), $e444d6404c095fa5$var$ts = "", $e444d6404c095fa5$var$es = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
var $e444d6404c095fa5$var$is = {
    N: ()=>!!$e444d6404c095fa5$var$r,
    j (t) {
        $e444d6404c095fa5$var$mi.error("cookieStore error: " + t);
    },
    P: $e444d6404c095fa5$var$Wr,
    H (t) {
        var e;
        try {
            e = JSON.parse($e444d6404c095fa5$var$is.P(t)) || {};
        } catch (t) {}
        return e;
    },
    F (t, e, i, s, n) {
        if (!$e444d6404c095fa5$var$r) return !1;
        try {
            var o = "", a = "", l = function(t, e) {
                if (e) {
                    var i = function(t, e) {
                        if (void 0 === e && (e = $e444d6404c095fa5$var$r), $e444d6404c095fa5$var$ts) return $e444d6404c095fa5$var$ts;
                        if (!e) return "";
                        if ([
                            "localhost",
                            "127.0.0.1"
                        ].includes(t)) return "";
                        for(var i = t.split("."), s = Math.min(i.length, 8), n = "dmn_chk_" + $e444d6404c095fa5$var$Xr(); !$e444d6404c095fa5$var$ts && s--;){
                            var o = i.slice(s).join("."), a = n + "=1;domain=." + o + ";path=/";
                            e.cookie = a + ";max-age=3", e.cookie.includes(n) && (e.cookie = a + ";max-age=0", $e444d6404c095fa5$var$ts = o);
                        }
                        return $e444d6404c095fa5$var$ts;
                    }(t);
                    if (!i) {
                        var s = ((t)=>{
                            var e = t.match($e444d6404c095fa5$var$es);
                            return e ? e[0] : "";
                        })(t);
                        s !== i && $e444d6404c095fa5$var$mi.info("Warning: cookie subdomain discovery mismatch", s, i), i = s;
                    }
                    return i ? "; domain=." + i : "";
                }
                return "";
            }($e444d6404c095fa5$var$r.location.hostname, s);
            if (i) {
                var u = new Date;
                u.setTime(u.getTime() + 864e5 * i), o = "; expires=" + u.toUTCString();
            }
            n && (a = "; secure");
            var h = t + "=" + encodeURIComponent(JSON.stringify(e)) + o + "; SameSite=Lax; path=/" + l + a;
            return h.length > 3686.4 && $e444d6404c095fa5$var$mi.warn("cookieStore warning: large cookie, len=" + h.length), $e444d6404c095fa5$var$r.cookie = h, !0;
        } catch (t) {
            return !1;
        }
    },
    q (t, e) {
        if (null != $e444d6404c095fa5$var$r && $e444d6404c095fa5$var$r.cookie) try {
            $e444d6404c095fa5$var$is.F(t, "", -1, e);
        } catch (t) {
            return;
        }
    }
}, $e444d6404c095fa5$var$rs = null, $e444d6404c095fa5$var$ss = {
    N () {
        if (!$e444d6404c095fa5$var$Q($e444d6404c095fa5$var$rs)) return $e444d6404c095fa5$var$rs;
        var e = !0;
        if ($e444d6404c095fa5$var$K($e444d6404c095fa5$var$t)) e = !1;
        else try {
            var i = "__mplssupport__";
            $e444d6404c095fa5$var$ss.F(i, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$ss.P(i) && (e = !1), $e444d6404c095fa5$var$ss.q(i);
        } catch (t) {
            e = !1;
        }
        return e || $e444d6404c095fa5$var$mi.error("localStorage unsupported; falling back to cookie store"), $e444d6404c095fa5$var$rs = e, e;
    },
    j (t) {
        $e444d6404c095fa5$var$mi.error("localStorage error: " + t);
    },
    P (e) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage.getItem(e);
        } catch (t) {
            $e444d6404c095fa5$var$ss.j(t);
        }
        return null;
    },
    H (t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$ss.P(t)) || {};
        } catch (t) {}
        return null;
    },
    F (e, i) {
        try {
            return null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.setItem(e, JSON.stringify(i)), !0;
        } catch (t) {
            $e444d6404c095fa5$var$ss.j(t);
        }
        return !1;
    },
    q (e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(e);
        } catch (t) {
            $e444d6404c095fa5$var$ss.j(t);
        }
    }
}, $e444d6404c095fa5$var$ns = [
    $e444d6404c095fa5$var$Ei,
    "distinct_id",
    $e444d6404c095fa5$var$zi,
    $e444d6404c095fa5$var$Hi,
    $e444d6404c095fa5$var$gr,
    $e444d6404c095fa5$var$_r,
    $e444d6404c095fa5$var$dr
], $e444d6404c095fa5$var$os = {}, $e444d6404c095fa5$var$as = {
    N: ()=>!0,
    j (t) {
        $e444d6404c095fa5$var$mi.error("memoryStorage error: " + t);
    },
    P: (t)=>$e444d6404c095fa5$var$os[t] || null,
    H: (t)=>$e444d6404c095fa5$var$os[t] || null,
    F: (t, e)=>($e444d6404c095fa5$var$os[t] = e, !0),
    q (t) {
        delete $e444d6404c095fa5$var$os[t];
    }
}, $e444d6404c095fa5$var$ls = null, $e444d6404c095fa5$var$us = {
    N () {
        if (!$e444d6404c095fa5$var$Q($e444d6404c095fa5$var$ls)) return $e444d6404c095fa5$var$ls;
        if ($e444d6404c095fa5$var$ls = !0, $e444d6404c095fa5$var$K($e444d6404c095fa5$var$t)) $e444d6404c095fa5$var$ls = !1;
        else try {
            var e = "__support__";
            $e444d6404c095fa5$var$us.F(e, "xyz"), '"xyz"' !== $e444d6404c095fa5$var$us.P(e) && ($e444d6404c095fa5$var$ls = !1), $e444d6404c095fa5$var$us.q(e);
        } catch (t) {
            $e444d6404c095fa5$var$ls = !1;
        }
        return $e444d6404c095fa5$var$ls;
    },
    j (t) {
        $e444d6404c095fa5$var$mi.error("sessionStorage error: ", t);
    },
    P (e) {
        try {
            return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.sessionStorage.getItem(e);
        } catch (t) {
            $e444d6404c095fa5$var$us.j(t);
        }
        return null;
    },
    H (t) {
        try {
            return JSON.parse($e444d6404c095fa5$var$us.P(t)) || null;
        } catch (t) {}
        return null;
    },
    F (e, i) {
        try {
            return null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.setItem(e, JSON.stringify(i)), !0;
        } catch (t) {
            $e444d6404c095fa5$var$us.j(t);
        }
        return !1;
    },
    q (e) {
        try {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.sessionStorage.removeItem(e);
        } catch (t) {
            $e444d6404c095fa5$var$us.j(t);
        }
    }
};
class $e444d6404c095fa5$var$hs {
    constructor(t){
        this._instance = t;
    }
    get Ne() {
        return this._instance.config;
    }
    get consent() {
        return this.ti() ? 0 : this.ei;
    }
    isOptedOut() {
        return this.Ne.cookieless_mode === $e444d6404c095fa5$var$$r || this.isRejected() || -1 === this.consent && this.Ne.cookieless_mode === $e444d6404c095fa5$var$Sr;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    isExplicitlyOptedOut() {
        return 0 === this.consent;
    }
    isRejected() {
        return 0 === this.consent || -1 === this.consent && this.Ne.opt_out_capturing_by_default;
    }
    optInOut(t) {
        this.ii.F(this.ri, t ? 1 : 0, this.Ne.cookie_expiration, this.Ne.cross_subdomain_cookie, this.Ne.secure_cookie);
    }
    reset() {
        this.ii.q(this.ri, this.Ne.cross_subdomain_cookie);
    }
    get ri() {
        var t = this._instance.config, e = t.token, i = t.opt_out_capturing_cookie_prefix;
        return t.consent_persistence_name || (i ? i + e : "__ph_opt_in_out_" + e);
    }
    get ei() {
        var t = this.ii.P(this.ri);
        return $e444d6404c095fa5$var$ht(t) ? 1 : $e444d6404c095fa5$var$N($e444d6404c095fa5$var$dt, t) ? 0 : -1;
    }
    get ii() {
        var t = this.Ne.opt_out_capturing_persistence_type, e = "localStorage" === t ? $e444d6404c095fa5$var$ss : $e444d6404c095fa5$var$is;
        if (!this.ni || this.ni !== e) {
            this.ni = e;
            var i = "localStorage" === t ? $e444d6404c095fa5$var$is : $e444d6404c095fa5$var$ss;
            i.P(this.ri) && (this.ni.P(this.ri) || this.optInOut($e444d6404c095fa5$var$ht(i.P(this.ri))), i.q(this.ri, this.Ne.cross_subdomain_cookie));
        }
        return this.ni;
    }
    ti() {
        return !!this.Ne.respect_dnt && [
            null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.doNotTrack,
            null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.msDoNotTrack,
            $e444d6404c095fa5$var$v.doNotTrack
        ].some((t)=>$e444d6404c095fa5$var$ht(t));
    }
}
function $e444d6404c095fa5$var$ds(t, e) {
    var i, r = null == t || null == (i = t.config) ? void 0 : i.get_current_url;
    if (!$e444d6404c095fa5$var$V(r)) return e;
    try {
        var s = r(e);
        return $e444d6404c095fa5$var$J(s) && s ? s : e;
    } catch (t) {
        return $e444d6404c095fa5$var$mi.error("Error in get_current_url, falling back to window.location.href", t), e;
    }
}
var $e444d6404c095fa5$var$vs = "__POSTHOG_TOOLBAR__", $e444d6404c095fa5$var$cs = 1, $e444d6404c095fa5$var$fs = 3, $e444d6404c095fa5$var$ps = 11;
function $e444d6404c095fa5$var$_s(t) {
    return t instanceof Element && (t.id === $e444d6404c095fa5$var$vs || !(null == t.closest || !t.closest(".toolbar-global-fade-container")));
}
function $e444d6404c095fa5$var$gs(t) {
    return !!t && t.nodeType === $e444d6404c095fa5$var$cs;
}
function $e444d6404c095fa5$var$ms(t, e) {
    return !!t && !!t.tagName && t.tagName.toLowerCase() === e.toLowerCase();
}
function $e444d6404c095fa5$var$bs(t) {
    return !!t && t.nodeType === $e444d6404c095fa5$var$fs;
}
function $e444d6404c095fa5$var$ys(t) {
    return !!t && t.nodeType === $e444d6404c095fa5$var$ps && $e444d6404c095fa5$var$gs(t.host);
}
var $e444d6404c095fa5$var$ws = 1e3;
function $e444d6404c095fa5$var$xs(t) {
    return t ? $e444d6404c095fa5$var$U(t).split(/\s+/) : [];
}
function $e444d6404c095fa5$var$Es(e, i) {
    var r = function(e) {
        var i, r = null == $e444d6404c095fa5$var$t || null == (i = $e444d6404c095fa5$var$t.location) ? void 0 : i.href;
        return $e444d6404c095fa5$var$K(r) ? void 0 : $e444d6404c095fa5$var$ds(e, r);
    }(i);
    return !!(r && e && e.some((t)=>r.match(t)));
}
function $e444d6404c095fa5$var$Ss(t) {
    var e = "";
    switch(typeof t.className){
        case "string":
            e = t.className;
            break;
        case "object":
            e = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
            break;
        default:
            e = "";
    }
    return $e444d6404c095fa5$var$xs(e);
}
function $e444d6404c095fa5$var$$s(t) {
    return $e444d6404c095fa5$var$X(t) ? null : $e444d6404c095fa5$var$U(t).split(/(\s+)/).filter((t)=>$e444d6404c095fa5$var$Js(t)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function $e444d6404c095fa5$var$ks(t) {
    var e = "";
    return $e444d6404c095fa5$var$js(t) && !$e444d6404c095fa5$var$Bs(t) && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Dr(t.childNodes, function(t) {
        var i;
        $e444d6404c095fa5$var$bs(t) && t.textContent && (e += null !== (i = $e444d6404c095fa5$var$$s(t.textContent)) && void 0 !== i ? i : "");
    }), $e444d6404c095fa5$var$U(e);
}
function $e444d6404c095fa5$var$Ts(t) {
    var e;
    return $e444d6404c095fa5$var$K(t.target) ? t.srcElement || null : null != (e = t.target) && e.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
var $e444d6404c095fa5$var$Rs = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function $e444d6404c095fa5$var$Ps(t, e) {
    if ($e444d6404c095fa5$var$K(e)) return !0;
    var i, r = function(t) {
        if (e.some((e)=>(function(t, e) {
                var i = t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector;
                try {
                    return !!i && i.call(t, e);
                } catch (t) {
                    return !1;
                }
            })(t, e))) return {
            v: !0
        };
    };
    for (var s of t)if (i = r(s)) return i.v;
    return !1;
}
function $e444d6404c095fa5$var$Os(t) {
    var e = t.parentNode;
    return !(!e || !$e444d6404c095fa5$var$gs(e)) && e;
}
var $e444d6404c095fa5$var$Is = [
    ".ph-no-autocapture",
    "[data-ph-no-autocapture]"
], $e444d6404c095fa5$var$Cs = [
    "next",
    "previous",
    "prev",
    ">",
    "<"
], $e444d6404c095fa5$var$As = [
    ...$e444d6404c095fa5$var$Cs,
    "+",
    "-",
    "\u2212",
    "\u2013"
], $e444d6404c095fa5$var$Ms = (t, e)=>/[a-z0-9]/i.test(e) ? t.includes(e) : t === e, $e444d6404c095fa5$var$Fs = [
    ".ph-no-rageclick",
    ".ph-no-capture"
], $e444d6404c095fa5$var$Ds = [
    "",
    "text",
    "search",
    "email",
    "password",
    "url",
    "tel",
    "number"
];
function $e444d6404c095fa5$var$Ns(e, i) {
    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Us(e)) return !1;
    var r, s, n, o, a;
    if ($e444d6404c095fa5$var$et(i) ? (r = !!i && $e444d6404c095fa5$var$Fs, s = void 0, n = !1) : (r = null !== (o = null == i ? void 0 : i.css_selector_ignorelist) && void 0 !== o ? o : $e444d6404c095fa5$var$Fs, s = null == i ? void 0 : i.content_ignorelist, n = null !== (a = null == i ? void 0 : i.ignore_text_selection) && void 0 !== a && a), !1 === r) return !1;
    if (n && function(t) {
        return !(!t || !$e444d6404c095fa5$var$gs(t)) && (!!$e444d6404c095fa5$var$ms(t, "textarea") || ($e444d6404c095fa5$var$ms(t, "input") ? $e444d6404c095fa5$var$N($e444d6404c095fa5$var$Ds, (t.getAttribute("type") || "").toLowerCase()) : function(t) {
            if (t.isContentEditable) return !0;
            var e = null == t.getAttribute ? void 0 : t.getAttribute("contenteditable");
            return "true" === e || "" === e;
        }(t)));
    }(e)) return !1;
    var l = $e444d6404c095fa5$var$Ls(e, !1).targetElementList;
    return !function(t, e) {
        if (!1 === t || $e444d6404c095fa5$var$K(t)) return !1;
        var i;
        if (!0 === t) i = $e444d6404c095fa5$var$Cs;
        else {
            if (!$e444d6404c095fa5$var$q(t)) return !1;
            if (t.length > 10) return $e444d6404c095fa5$var$mi.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
            i = t.map((t)=>t.toLowerCase());
        }
        return e.some((t)=>{
            var e = t.safeText, r = t.ariaLabel;
            return i.some((t)=>$e444d6404c095fa5$var$Ms(e, t) || $e444d6404c095fa5$var$Ms(r, t));
        });
    }(s, l.map((t)=>{
        var e;
        return {
            safeText: $e444d6404c095fa5$var$ks(t).toLowerCase(),
            ariaLabel: (null == (e = t.getAttribute("aria-label")) ? void 0 : e.toLowerCase().trim()) || ""
        };
    })) && !$e444d6404c095fa5$var$Ps(l, r);
}
var $e444d6404c095fa5$var$Us = (t)=>!t || $e444d6404c095fa5$var$ms(t, "html") || !$e444d6404c095fa5$var$gs(t), $e444d6404c095fa5$var$Ls = (e, i)=>{
    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Us(e)) return {
        parentIsUsefulElement: !1,
        targetElementList: []
    };
    for(var r = !1, s = [
        e
    ], n = e; n.parentNode && !$e444d6404c095fa5$var$ms(n, "body");)if ($e444d6404c095fa5$var$ys(n.parentNode)) s.push(n.parentNode.host), n = n.parentNode.host;
    else {
        var o = $e444d6404c095fa5$var$Os(n);
        if (!o) break;
        if (i || $e444d6404c095fa5$var$Rs.indexOf(o.tagName.toLowerCase()) > -1) r = !0;
        else try {
            var a = $e444d6404c095fa5$var$t.getComputedStyle(o);
            a && "pointer" === a.getPropertyValue("cursor") && (r = !0);
        } catch (t) {}
        s.push(o), n = o;
    }
    return {
        parentIsUsefulElement: r,
        targetElementList: s
    };
};
function $e444d6404c095fa5$var$js(t) {
    for(var e = new Set, i = 0, r = t; r.parentNode && !$e444d6404c095fa5$var$ms(r, "body"); r = r.parentNode){
        if (i++ >= $e444d6404c095fa5$var$ws || e.has(r)) return !1;
        e.add(r);
        var s = $e444d6404c095fa5$var$Ss(r);
        if ($e444d6404c095fa5$var$N(s, "ph-sensitive") || $e444d6404c095fa5$var$N(s, "ph-no-capture")) return !1;
    }
    if ($e444d6404c095fa5$var$N($e444d6404c095fa5$var$Ss(t), "ph-include")) return !0;
    var n = t.type || "";
    if ($e444d6404c095fa5$var$J(n)) switch(n.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var o = t.name || t.id || "";
    return !$e444d6404c095fa5$var$J(o) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(o.replace(/[^a-zA-Z0-9]/g, ""));
}
function $e444d6404c095fa5$var$Bs(t) {
    return !!($e444d6404c095fa5$var$ms(t, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(t.type) || $e444d6404c095fa5$var$ms(t, "select") || $e444d6404c095fa5$var$ms(t, "textarea") || "true" === t.getAttribute("contenteditable"));
}
var $e444d6404c095fa5$var$zs = new RegExp("^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$"), $e444d6404c095fa5$var$Hs = /(^|[^0-9A-Za-z_])([0-9][0-9 -]*[0-9])(?=$|[^0-9A-Za-z_])/g, $e444d6404c095fa5$var$qs = [
    16,
    15,
    14,
    13
], $e444d6404c095fa5$var$Vs = new RegExp("^(\\d{3}-?\\d{2}-?\\d{4})$"), $e444d6404c095fa5$var$Ws = new RegExp("(^|[^0-9])((?!000|666)[0-9]{3}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4})(?=$|([^0-9]))", "g"), $e444d6404c095fa5$var$Gs = /[0-9A-Za-z_]/;
function $e444d6404c095fa5$var$Ks(t) {
    for(var e = 0, i = !1, r = t.length - 1; r >= 0; r--){
        var s = t.charCodeAt(r) - 48;
        i && (s *= 2) > 9 && (s -= 9), e += s, i = !i;
    }
    return e % 10 == 0;
}
function $e444d6404c095fa5$var$Js(t, e) {
    if (void 0 === e && (e = !0), $e444d6404c095fa5$var$X(t)) return !1;
    if ($e444d6404c095fa5$var$J(t)) {
        t = $e444d6404c095fa5$var$U(t);
        var i = e ? $e444d6404c095fa5$var$zs.test((t || "").replace(/[- ]/g, "")) : function(t) {
            var e;
            for($e444d6404c095fa5$var$Hs.lastIndex = 0; e = $e444d6404c095fa5$var$Hs.exec(t);){
                var i = e[2];
                if (i) for(var r = i.replace(/[- ]/g, ""), s = 0; r.length > s; s++)for (var n of $e444d6404c095fa5$var$qs){
                    var o = s + n;
                    if (r.length >= o) {
                        var a = r.slice(s, o);
                        if ($e444d6404c095fa5$var$zs.test(a) && $e444d6404c095fa5$var$Ks(a)) return !0;
                    }
                }
            }
            return !1;
        }(t);
        if (i) return !1;
        var r = e ? $e444d6404c095fa5$var$Vs.test(t) : function(t) {
            var e;
            for($e444d6404c095fa5$var$Ws.lastIndex = 0; e = $e444d6404c095fa5$var$Ws.exec(t);){
                var i = e[1], r = e[3];
                if (!(i && r && $e444d6404c095fa5$var$Gs.test(i) && $e444d6404c095fa5$var$Gs.test(r))) return !0;
            }
            return !1;
        }(t);
        if (r) return !1;
    }
    return !0;
}
function $e444d6404c095fa5$var$Ys(t) {
    var e = $e444d6404c095fa5$var$ks(t);
    return $e444d6404c095fa5$var$Js(e = (e + " " + $e444d6404c095fa5$var$Qs(t)).trim()) ? e : "";
}
function $e444d6404c095fa5$var$Qs(t) {
    var e = "";
    return t && t.childNodes && t.childNodes.length && $e444d6404c095fa5$var$Dr(t.childNodes, function(t) {
        var i;
        if (t && "span" === (null == (i = t.tagName) ? void 0 : i.toLowerCase())) try {
            var r = $e444d6404c095fa5$var$ks(t);
            e = (e + " " + r).trim(), t.childNodes && t.childNodes.length && (e = (e + " " + $e444d6404c095fa5$var$Qs(t)).trim());
        } catch (t) {
            $e444d6404c095fa5$var$mi.error("[AutoCapture]", t);
        }
    }), e;
}
function $e444d6404c095fa5$var$Xs(t) {
    return t.replace(/"|\\"/g, '\\"');
}
function $e444d6404c095fa5$var$Zs(t) {
    var e = t.attr__class;
    if (e) return $e444d6404c095fa5$var$q(e) ? e : $e444d6404c095fa5$var$xs(e);
}
var $e444d6404c095fa5$var$tn = $e444d6404c095fa5$var$bi("[Dead Clicks]"), $e444d6404c095fa5$var$en = ()=>!0, $e444d6404c095fa5$var$rn = (t)=>{
    var e, i = !(null == (e = t.instance.persistence) || !e.get_property($e444d6404c095fa5$var$Ai)), r = t.instance.config.capture_dead_clicks;
    return $e444d6404c095fa5$var$et(r) ? r : !!$e444d6404c095fa5$var$W(r) || i;
};
class $e444d6404c095fa5$var$sn {
    get lazyLoadedDeadClicksAutocapture() {
        return this.si;
    }
    constructor(t, e, i){
        this.instance = t, this.isEnabled = e, this.onCapture = i, this.startIfEnabledOrStop();
    }
    onRemoteConfig(t) {
        if (t.ok) {
            var e = t.config;
            "captureDeadClicks" in e && (this.instance.persistence && this.instance.persistence.register({
                [$e444d6404c095fa5$var$Ai]: e.captureDeadClicks
            }), this.startIfEnabledOrStop());
        }
    }
    startIfEnabledOrStop() {
        this.isEnabled(this) ? this.ai(()=>{
            this.oi();
        }) : this.stop();
    }
    ai(t) {
        var e, i;
        null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.initDeadClicksAutocapture ? t() : null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this.instance, "dead-clicks-autocapture", (e)=>{
            e ? $e444d6404c095fa5$var$tn.error("failed to load script", e) : t();
        });
    }
    oi() {
        var t;
        if ($e444d6404c095fa5$var$r) {
            if (!this.si && null != (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) && t.initDeadClicksAutocapture) {
                var e = $e444d6404c095fa5$var$W(this.instance.config.capture_dead_clicks) ? $e444d6404c095fa5$var$_({}, this.instance.config.capture_dead_clicks) : {};
                e.__onCapture = this.onCapture, this.onCapture && (e.capture_dead_swipes = !1), this.si = $e444d6404c095fa5$var$v.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, e), this.si.start($e444d6404c095fa5$var$r), $e444d6404c095fa5$var$tn.info("starting...");
            }
        } else $e444d6404c095fa5$var$tn.error("`document` not found. Cannot start.");
    }
    stop() {
        this.si && (this.si.stop(), this.si = void 0, $e444d6404c095fa5$var$tn.info("stopping..."));
    }
}
var $e444d6404c095fa5$var$nn = $e444d6404c095fa5$var$bi("[SegmentIntegration]");
var $e444d6404c095fa5$var$on = "posthog-js";
function $e444d6404c095fa5$var$an(t, e) {
    var i = void 0 === e ? {} : e, r = i.organization, s = i.projectId, n = i.prefix, o = i.severityAllowList, a = void 0 === o ? [
        "error"
    ] : o, l = i.sendExceptionsToPostHog, u = void 0 === l || l;
    return (e)=>{
        var i, o, l, h, d;
        if ("*" !== a && !a.includes(e.level) || !t.__loaded) return e;
        e.tags || (e.tags = {});
        var v = t.requestRouter.endpointFor("ui", "/project/" + t.config.token + "/person/" + t.get_distinct_id());
        e.tags["PostHog Person URL"] = v, t.sessionRecordingStarted() && (e.tags["PostHog Recording URL"] = t.get_session_replay_url({
            withTimestamp: !0
        }));
        var c, f = (null == (i = e.exception) ? void 0 : i.values) || [], p = f.map((t)=>$e444d6404c095fa5$var$_({}, t, {
                stacktrace: t.stacktrace ? $e444d6404c095fa5$var$_({}, t.stacktrace, {
                    type: "raw",
                    frames: (t.stacktrace.frames || []).map((t)=>$e444d6404c095fa5$var$_({}, t, {
                            platform: "web:javascript"
                        }))
                }) : void 0
            })), g = {
            $exception_message: (null == (o = f[0]) ? void 0 : o.value) || e.message,
            $exception_type: null == (l = f[0]) ? void 0 : l.type,
            $exception_level: e.level,
            $exception_list: p,
            $sentry_event_id: e.event_id,
            $sentry_exception: e.exception,
            $sentry_exception_message: (null == (h = f[0]) ? void 0 : h.value) || e.message,
            $sentry_exception_type: null == (d = f[0]) ? void 0 : d.type,
            $sentry_tags: e.tags
        };
        return r && s && (g.$sentry_url = (n || "https://sentry.io/organizations/") + r + "/issues/?project=" + s + "&query=" + e.event_id), u && (null == (c = t.exceptions) || c.sendExceptionEvent(g)), e;
    };
}
class $e444d6404c095fa5$var$ln {
    constructor(t, e, i, r, s, n){
        this.name = $e444d6404c095fa5$var$on, this.setupOnce = function(o) {
            o($e444d6404c095fa5$var$an(t, {
                organization: e,
                projectId: i,
                prefix: r,
                severityAllowList: s,
                sendExceptionsToPostHog: null == n || n
            }));
        };
    }
}
class $e444d6404c095fa5$var$un {
    constructor(t){
        this.li = (t, e, i)=>{
            i && (i.noSessionId || i.activityTimeout || i.sessionPastMaximumLength || i.crossTabAdoption) && ($e444d6404c095fa5$var$mi.info("[PageViewManager] Session rotated, clearing pageview state", {
                sessionId: t,
                changeReason: i
            }), this.ui = void 0, this._instance.scrollManager.resetContext());
        }, this._instance = t, this.hi();
    }
    hi() {
        var t;
        this.di = null == (t = this._instance.sessionManager) ? void 0 : t.onSessionId(this.li);
    }
    destroy() {
        var t;
        null == (t = this.di) || t.call(this), this.di = void 0;
    }
    doPageView(e, i) {
        var r, s = this.vi(e, i);
        return this.ui = {
            pathname: null !== (r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.pathname) && void 0 !== r ? r : "",
            pageViewId: i,
            timestamp: e
        }, this._instance.scrollManager.resetContext(), s;
    }
    doPageLeave(t) {
        var e;
        return this.vi(t, null == (e = this.ui) ? void 0 : e.pageViewId);
    }
    doEvent() {
        var t;
        return {
            $pageview_id: null == (t = this.ui) ? void 0 : t.pageViewId
        };
    }
    vi(t, e) {
        var i = this.ui;
        if (!i) return {
            $pageview_id: e
        };
        var r = {
            $pageview_id: e,
            $prev_pageview_id: i.pageViewId
        }, s = this._instance.scrollManager.getContext();
        if (s && !this._instance.config.disable_scroll_properties) {
            var n = s.maxScrollHeight, o = s.lastScrollY, a = s.maxScrollY, l = s.maxContentHeight, u = s.lastContentY, h = s.maxContentY;
            if (!($e444d6404c095fa5$var$K(n) || $e444d6404c095fa5$var$K(o) || $e444d6404c095fa5$var$K(a) || $e444d6404c095fa5$var$K(l) || $e444d6404c095fa5$var$K(u) || $e444d6404c095fa5$var$K(h))) {
                n = Math.ceil(n), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), h = Math.ceil(h);
                var d = n > 1 ? $e444d6404c095fa5$var$vt(o / n, 0, 1, $e444d6404c095fa5$var$mi) : 1, v = n > 1 ? $e444d6404c095fa5$var$vt(a / n, 0, 1, $e444d6404c095fa5$var$mi) : 1, c = l > 1 ? $e444d6404c095fa5$var$vt(u / l, 0, 1, $e444d6404c095fa5$var$mi) : 1, f = l > 1 ? $e444d6404c095fa5$var$vt(h / l, 0, 1, $e444d6404c095fa5$var$mi) : 1;
                r = $e444d6404c095fa5$var$Nr(r, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: v,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: c,
                    $prev_pageview_max_content: h,
                    $prev_pageview_max_content_percentage: f
                });
            }
        }
        return i.pathname && (r.$prev_pageview_pathname = i.pathname), i.timestamp && (r.$prev_pageview_duration = (t.getTime() - i.timestamp.getTime()) / 1e3), r;
    }
}
var $e444d6404c095fa5$var$hn = [
    "flags",
    "surveys"
], $e444d6404c095fa5$var$dn = {
    [$e444d6404c095fa5$var$xi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$$i]: {
        exposure: "hidden"
    },
    __cmpns: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$ki]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Ti]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Ri]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Pi]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Oi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Ii]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Ci]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Ai]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Mi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Fi]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Di]: {
        exposure: "hidden"
    },
    $session_recording_enabled_server_side: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$zi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Hi]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Ni]: {
        exposure: "event",
        shouldSkipFromEventProperties: (t)=>$e444d6404c095fa5$var$Q(t)
    },
    $session_past_minimum_duration: {
        exposure: "event"
    },
    $session_recording_url_trigger_activated_session: {
        exposure: "event"
    },
    $session_recording_event_trigger_activated_session: {
        exposure: "event"
    },
    $debug_first_full_snapshot_timestamp: {
        exposure: "event"
    },
    $sess_rec_flush_size: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$qi]: {
        exposure: "derived",
        storageGroup: "flags",
        shouldSkipFromEventProperties: (t, e)=>e(),
        transformToEventProperties (t) {
            if (!$e444d6404c095fa5$var$W(t)) return {};
            for(var e = {}, i = Object.keys(t), r = 0; i.length > r; r++)e["$feature/" + i[r]] = t[i[r]];
            return e;
        }
    },
    [$e444d6404c095fa5$var$Vi]: {
        exposure: "event",
        storageGroup: "flags"
    },
    [$e444d6404c095fa5$var$Wi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Gi]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$e444d6404c095fa5$var$Ki]: {
        exposure: "event",
        storageGroup: "flags"
    },
    [$e444d6404c095fa5$var$Ji]: {
        exposure: "event",
        storageGroup: "flags",
        volatile: !0
    },
    [$e444d6404c095fa5$var$Yi]: {
        exposure: "hidden",
        storageGroup: "flags"
    },
    [$e444d6404c095fa5$var$Qi]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Xi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Zi]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$tr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$er]: {
        exposure: "hidden",
        storageGroup: "surveys"
    },
    [$e444d6404c095fa5$var$ir]: {
        exposure: "hidden",
        storageGroup: "surveys",
        volatile: !0
    },
    [$e444d6404c095fa5$var$rr]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$sr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$nr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$or]: {
        exposure: "hidden"
    },
    $product_tours_activated: {
        exposure: "hidden"
    },
    $product_tours_activated_session: {
        exposure: "hidden"
    },
    $conversations_widget_session_id: {
        exposure: "event"
    },
    $conversations_ticket_id: {
        exposure: "event"
    },
    $conversations_widget_state: {
        exposure: "event"
    },
    $conversations_user_traits: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$ar]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$lr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$ur]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$hr]: {
        exposure: "hidden",
        storageGroup: "flags",
        volatile: !0
    },
    [$e444d6404c095fa5$var$dr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$vr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$cr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$fr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$pr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$_r]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$gr]: {
        exposure: "hidden"
    },
    [$e444d6404c095fa5$var$Ui]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Li]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$ji]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$Bi]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$yr]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$wr]: {
        exposure: "event"
    },
    [$e444d6404c095fa5$var$xr]: {
        exposure: "event"
    },
    $sdk_debug_replay_event_trigger_status: {
        exposure: "event"
    },
    $sdk_debug_replay_linked_flag_trigger_status: {
        exposure: "event"
    },
    $sdk_debug_replay_matched_recording_trigger_groups: {
        exposure: "event"
    },
    $sdk_debug_replay_remote_trigger_matching_config: {
        exposure: "event"
    },
    $sdk_debug_replay_trigger_groups_count: {
        exposure: "event"
    },
    $sdk_debug_replay_url_trigger_status: {
        exposure: "event"
    },
    $session_recording_start_reason: {
        exposure: "event"
    }
}, $e444d6404c095fa5$var$vn = [
    [
        "$posthog_sr_group_event_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_url_trigger_",
        {
            exposure: "hidden"
        }
    ],
    [
        "$posthog_sr_group_sampling_",
        {
            exposure: "hidden"
        }
    ]
], $e444d6404c095fa5$var$cn = (t)=>{
    var e = $e444d6404c095fa5$var$dn[t];
    if (e) return e;
    for (var i of $e444d6404c095fa5$var$vn){
        var r = i[1];
        if (0 === t.indexOf(i[0])) return r;
    }
}, $e444d6404c095fa5$var$fn = (t, e)=>{
    try {
        return JSON.stringify(t, (t, e)=>"bigint" == typeof e ? e.toString() : e, e);
    } catch (e) {
        return $e444d6404c095fa5$var$j(t);
    }
}, $e444d6404c095fa5$var$pn = (t)=>{
    var e = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.createElement("a");
    return $e444d6404c095fa5$var$K(e) ? null : (e.href = t, e);
}, $e444d6404c095fa5$var$_n = function(t, e) {
    for(var i, r = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&"), s = 0; r.length > s; s++){
        var n = r[s].split("=");
        if (n[0] === e) {
            i = n;
            break;
        }
    }
    if (!$e444d6404c095fa5$var$q(i) || 2 > i.length) return "";
    var o = i[1];
    try {
        o = decodeURIComponent(o);
    } catch (t) {
        $e444d6404c095fa5$var$mi.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, $e444d6404c095fa5$var$gn = function(t, e, i) {
    if (!t || !e || !e.length) return t;
    for(var r = t.split("#"), s = r[1], n = (r[0] || "").split("?"), o = n[1], a = n[0], l = (o || "").split("&"), u = [], h = 0; l.length > h; h++){
        var d = l[h].split("=");
        $e444d6404c095fa5$var$q(d) && (e.includes(d[0]) ? u.push(d[0] + "=" + i) : u.push(l[h]));
    }
    var v = a;
    return null != o && (v += "?" + u.join("&")), null != s && (v += "#" + s), v;
}, $e444d6404c095fa5$var$mn = function(t, e) {
    var i = t.match(new RegExp(e + "=([^&]*)"));
    return i ? i[1] : null;
}, $e444d6404c095fa5$var$bn = (t, e)=>t >= e && $e444d6404c095fa5$var$h(), $e444d6404c095fa5$var$yn = (t, e, i, r)=>{
    if (0 === t) {
        if ($e444d6404c095fa5$var$h()) {
            var s = e + 1;
            return s === i && r(), s;
        }
        return e;
    }
    return 0;
}, $e444d6404c095fa5$var$wn = "https?://(.*)", $e444d6404c095fa5$var$xn = [
    "gclid",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "igshid",
    "ttclid",
    "rdt_cid",
    "epik",
    "qclid",
    "sccid",
    "irclid",
    "_kx"
], $e444d6404c095fa5$var$En = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gad_source",
    "mc_cid",
    ...$e444d6404c095fa5$var$xn
], $e444d6404c095fa5$var$Sn = "<masked>", $e444d6404c095fa5$var$$n = [
    "li_fat_id"
];
function $e444d6404c095fa5$var$kn(t, e, i) {
    if (!$e444d6404c095fa5$var$r) return {};
    var s, n = e ? [
        ...$e444d6404c095fa5$var$xn,
        ...i || []
    ] : [], o = $e444d6404c095fa5$var$Tn($e444d6404c095fa5$var$gn($e444d6404c095fa5$var$r.URL, n, $e444d6404c095fa5$var$Sn), t), a = (s = {}, $e444d6404c095fa5$var$Dr($e444d6404c095fa5$var$$n, function(t) {
        var e = $e444d6404c095fa5$var$Wr(t);
        s[t] = e || null;
    }), s);
    return $e444d6404c095fa5$var$Nr(a, o);
}
function $e444d6404c095fa5$var$Tn(t, e) {
    var i = $e444d6404c095fa5$var$En.concat(e || []), r = {};
    return $e444d6404c095fa5$var$Dr(i, function(e) {
        var i = $e444d6404c095fa5$var$_n(t, e);
        r[e] = i || null;
    }), r;
}
function $e444d6404c095fa5$var$Rn(t) {
    var e = function(t) {
        return t ? 0 === t.search($e444d6404c095fa5$var$wn + "google.([^/?]*)") ? "google" : 0 === t.search($e444d6404c095fa5$var$wn + "bing.com") ? "bing" : 0 === t.search($e444d6404c095fa5$var$wn + "yahoo.com") ? "yahoo" : 0 === t.search($e444d6404c095fa5$var$wn + "duckduckgo.com") ? "duckduckgo" : null : null;
    }(t), i = "yahoo" != e ? "q" : "p", s = {};
    if (!$e444d6404c095fa5$var$Q(e)) {
        s.$search_engine = e;
        var n = $e444d6404c095fa5$var$r ? $e444d6404c095fa5$var$_n($e444d6404c095fa5$var$r.referrer, i) : "";
        n.length && (s.ph_keyword = n);
    }
    return s;
}
function $e444d6404c095fa5$var$Pn() {
    return navigator.language || navigator.userLanguage;
}
var $e444d6404c095fa5$var$On = "$direct";
function $e444d6404c095fa5$var$In() {
    return (null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.referrer) || $e444d6404c095fa5$var$On;
}
function $e444d6404c095fa5$var$Cn(t, e, i) {
    void 0 === i && (i = !1);
    var r = t ? [
        ...$e444d6404c095fa5$var$xn,
        ...e || []
    ] : [], n = i ? $e444d6404c095fa5$var$ye(null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.href) : null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.href, o = null == n ? void 0 : n.substring(0, 1e3);
    return {
        r: $e444d6404c095fa5$var$In().substring(0, 1e3),
        u: o ? $e444d6404c095fa5$var$gn(o, r, $e444d6404c095fa5$var$Sn) : void 0
    };
}
function $e444d6404c095fa5$var$An(t, e) {
    var i;
    void 0 === e && (e = !1);
    var r = t.r, s = t.u, n = e ? $e444d6404c095fa5$var$ye(s) : s, o = {
        $referrer: r,
        $referring_domain: null == r ? void 0 : r == $e444d6404c095fa5$var$On ? $e444d6404c095fa5$var$On : null == (i = $e444d6404c095fa5$var$pn(r)) ? void 0 : i.host
    };
    if (n) {
        o.$current_url = n;
        var a = $e444d6404c095fa5$var$pn(n);
        o.$host = null == a ? void 0 : a.host, o.$pathname = null == a ? void 0 : a.pathname;
        var l = $e444d6404c095fa5$var$Tn(n);
        $e444d6404c095fa5$var$Nr(o, l);
    }
    if (r) {
        var u = $e444d6404c095fa5$var$Rn(r);
        $e444d6404c095fa5$var$Nr(o, u);
    }
    return o;
}
function $e444d6404c095fa5$var$Mn() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (t) {
        return;
    }
}
function $e444d6404c095fa5$var$Fn() {
    try {
        return (new Date).getTimezoneOffset();
    } catch (t) {
        return;
    }
}
var $e444d6404c095fa5$var$Dn = {
    flags: $e444d6404c095fa5$var$hr,
    surveys: $e444d6404c095fa5$var$ir
}, $e444d6404c095fa5$var$Nn = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
], $e444d6404c095fa5$var$Un = "main";
class $e444d6404c095fa5$var$Ln {
    constructor(e, i, r){
        if (void 0 === r && (r = !0), this.ci = {}, this.fi = !1, this.pi = !1, this.Ne = e, this.gi = r, this.props = {}, this.mi = void 0, this.yi = ((t)=>{
            var e = "";
            return t.token && (e = t.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), t.persistence_name ? "ph_" + t.persistence_name : "ph_" + e + "_posthog";
        })(e), this.ii = this.bi(e), this.pi = this.wi(e), this.load(), e.debug && $e444d6404c095fa5$var$mi.info("Persistence loaded", e.persistence, $e444d6404c095fa5$var$_({}, this.props)), this.update_config(e, e, i), this.save(), $e444d6404c095fa5$var$t) {
            var s = ()=>this.flush();
            $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "beforeunload", s, {
                capture: !1
            }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "pagehide", s, {
                capture: !1
            });
        }
    }
    ki() {
        var t, e = null == (t = this.Ne) ? void 0 : t.persistence_save_debounce_ms;
        return $e444d6404c095fa5$var$Z(e) && e > 0 ? e : 0;
    }
    isDisabled() {
        return !!this.xi;
    }
    bi(e) {
        -1 === $e444d6404c095fa5$var$Nn.indexOf(e.persistence.toLowerCase()) && ($e444d6404c095fa5$var$mi.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
        var i, r = function(e, i) {
            void 0 === e && (e = []), void 0 === i && (i = !1);
            var r = [
                ...$e444d6404c095fa5$var$ns,
                ...e
            ];
            return $e444d6404c095fa5$var$_({}, $e444d6404c095fa5$var$ss, {
                H (t) {
                    try {
                        var e = {};
                        try {
                            e = $e444d6404c095fa5$var$is.H(t) || {};
                        } catch (t) {}
                        var r, s = JSON.parse($e444d6404c095fa5$var$ss.P(t) || "{}");
                        if (i) {
                            var n = {};
                            for(var o in e){
                                var a = e[o];
                                $e444d6404c095fa5$var$Q(a) || "" === a || (n[o] = a);
                            }
                            r = $e444d6404c095fa5$var$Nr(s, n);
                        } else r = $e444d6404c095fa5$var$Nr(e, s);
                        return $e444d6404c095fa5$var$ss.F(t, r), r;
                    } catch (t) {}
                    return null;
                },
                F (t, e, i, s, n, o) {
                    var a = $e444d6404c095fa5$var$ss.F(t, e, void 0, void 0, o);
                    try {
                        var l = {};
                        r.forEach((t)=>{
                            e[t] && (l[t] = e[t]);
                        }), Object.keys(l).length && $e444d6404c095fa5$var$is.F(t, l, i, s, n, o);
                    } catch (t) {
                        $e444d6404c095fa5$var$ss.j(t);
                    }
                    return a;
                },
                q (e, i) {
                    try {
                        null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.localStorage.removeItem(e), $e444d6404c095fa5$var$is.q(e, i);
                    } catch (t) {
                        $e444d6404c095fa5$var$ss.j(t);
                    }
                }
            });
        }(e.cookie_persisted_properties || [], e.__preview_cookie_wins_on_conflict || !1), s = !1, n = e.persistence.toLowerCase();
        return "localstorage" === n && $e444d6404c095fa5$var$ss.N() ? (i = $e444d6404c095fa5$var$ss, s = !0) : "localstorage+cookie" === n && r.N() ? (i = r, s = !0) : "sessionstorage" === n && $e444d6404c095fa5$var$us.N() ? i = $e444d6404c095fa5$var$us : "memory" === n ? i = $e444d6404c095fa5$var$as : "cookie" === n ? i = $e444d6404c095fa5$var$is : r.N() ? (i = r, s = !0) : i = $e444d6404c095fa5$var$is, this.fi = s, i;
    }
    Si(t) {
        return this.yi + "__" + t;
    }
    wi(t) {
        return this.fi && !!t.split_storage;
    }
    Ci(t) {
        var e = null != t ? t : this.Ne.feature_flag_cache_ttl_ms;
        if (!e || 0 >= e) return !1;
        var i = this.props[$e444d6404c095fa5$var$hr];
        return !i || "number" != typeof i || Date.now() - i > e;
    }
    properties() {
        var t = {};
        return $e444d6404c095fa5$var$Dr(this.props, (e, i)=>{
            var r = $e444d6404c095fa5$var$cn(i);
            if ("derived" === (null == r ? void 0 : r.exposure)) {
                if (null != r.shouldSkipFromEventProperties && r.shouldSkipFromEventProperties(e, i === $e444d6404c095fa5$var$qi ? ()=>this.Ci() : ()=>!1)) return;
                r.transformToEventProperties && $e444d6404c095fa5$var$Nr(t, r.transformToEventProperties(e));
            } else if (!r || "event" === r.exposure) {
                if (null != r && null != r.shouldSkipFromEventProperties && r.shouldSkipFromEventProperties(e, ()=>!1)) return;
                t[i] = e;
            }
        }), t;
    }
    load() {
        if (!this.xi) {
            var t = this.ii.H(this.yi);
            t && (this.props = $e444d6404c095fa5$var$Nr({}, t)), this.pi && this.Mi();
        }
    }
    Mi() {
        for (var t of $e444d6404c095fa5$var$hn){
            var e = $e444d6404c095fa5$var$ss.H(this.Si(t));
            if (e && !$e444d6404c095fa5$var$G(e)) {
                var i = this.Ti(t);
                i.persisted = !0, this.Ei(t) || (i.fingerprint = this.Ii(e, t)), this.Pi(t, e) || $e444d6404c095fa5$var$Nr(this.props, e);
            }
        }
    }
    Ei(t) {
        return Object.keys(this.props).some((e)=>{
            var i;
            return (null == (i = $e444d6404c095fa5$var$cn(e)) ? void 0 : i.storageGroup) === t;
        });
    }
    Pi(t, e) {
        var i = $e444d6404c095fa5$var$Dn[t];
        if (!i) return !1;
        var r = e[i], s = this.props[i];
        return $e444d6404c095fa5$var$Z(r) && $e444d6404c095fa5$var$Z(s) && s > r;
    }
    refreshKey(t) {
        var e;
        if (!this.xi) {
            var i = this.pi ? null == (e = $e444d6404c095fa5$var$cn(t)) ? void 0 : e.storageGroup : void 0, r = i ? $e444d6404c095fa5$var$ss.H(this.Si(i)) : this.ii.H(this.yi);
            if (r && t in r) this.Ri(t, r[t]);
            else {
                if (i) {
                    var s = this.ii.H(this.yi);
                    if (s && t in s) return void this.Ri(t, s[t]);
                }
                this.Ai(t);
            }
        }
    }
    save() {
        if (!this.xi) {
            var t = this.ki();
            t > 0 ? $e444d6404c095fa5$var$K(this.Fi) && (this.Fi = setTimeout(()=>{
                this.Fi = void 0, this.Li();
            }, t)) : this.Li();
        }
    }
    flush() {
        $e444d6404c095fa5$var$K(this.Fi) || (clearTimeout(this.Fi), this.Fi = void 0, this.Li());
    }
    Li() {
        this.xi || (this.pi ? this.Oi() : this.Di(this.ii, this.yi, this.props, $e444d6404c095fa5$var$Un));
    }
    Oi() {
        var t = this.$i(), e = t.main, i = t.groups;
        for (var r of (this.Di(this.ii, this.yi, e, $e444d6404c095fa5$var$Un), $e444d6404c095fa5$var$hn)){
            var s, n = i[r];
            (!$e444d6404c095fa5$var$G(n) || null != (s = this.ci[r]) && s.persisted) && this.Di($e444d6404c095fa5$var$ss, this.Si(r), n, r);
        }
    }
    $i() {
        var t = {}, e = {
            flags: {},
            surveys: {}
        };
        return $e444d6404c095fa5$var$Dr(this.props, (i, r)=>{
            var s, n = null == (s = $e444d6404c095fa5$var$cn(r)) ? void 0 : s.storageGroup;
            n ? e[n][r] = i : t[r] = i;
        }), {
            main: t,
            groups: e
        };
    }
    Ii(t, e) {
        if (e === $e444d6404c095fa5$var$Un) return JSON.stringify(t) + "|" + this.Ni + "|" + this.qi + "|" + this.ji;
        var i = {};
        return $e444d6404c095fa5$var$Dr(t, (t, e)=>{
            var r;
            i[e] = null != (r = $e444d6404c095fa5$var$cn(e)) && r.volatile ? "__volatile__" : t;
        }), JSON.stringify(i);
    }
    Di(t, e, i, r) {
        var s = this.Ti(r);
        if (r === $e444d6404c095fa5$var$Un || s.dirty || $e444d6404c095fa5$var$K(s.fingerprint)) {
            var n;
            try {
                if ((n = this.Ii(i, r)) === s.fingerprint) return void (s.dirty = !1);
            } catch (t) {
                n = void 0;
            }
            t.F(e, i, this.Ni, this.qi, this.ji, this.Ne.debug) ? (s.dirty = !1, r !== $e444d6404c095fa5$var$Un && (s.persisted = !0), $e444d6404c095fa5$var$K(n) || (s.fingerprint = n)) : this.Ne.debug && $e444d6404c095fa5$var$mi.warn('failed to persist storage entry "' + e + '"; will retry on next save');
        }
    }
    remove(t) {
        var e = (void 0 === t ? {} : t).keepGroupEntries, i = void 0 !== e && e;
        if ($e444d6404c095fa5$var$K(this.Fi) || (clearTimeout(this.Fi), this.Fi = void 0), this.ii.q(this.yi, !1), this.ii.q(this.yi, !0), !i && this.gi) for (var r of $e444d6404c095fa5$var$hn)$e444d6404c095fa5$var$ss.q(this.Si(r));
        i ? delete this.ci[$e444d6404c095fa5$var$Un] : this.ci = {};
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(t, e, i) {
        if ($e444d6404c095fa5$var$W(t)) {
            $e444d6404c095fa5$var$K(e) && (e = "None"), this.Ni = $e444d6404c095fa5$var$K(i) ? this.Bi : i;
            var r = !1;
            if ($e444d6404c095fa5$var$Dr(t, (t, i)=>{
                this.props.hasOwnProperty(i) && this.props[i] !== e || (this.Ri(i, t), r = !0);
            }), r) return this.save(), !0;
        }
        return !1;
    }
    register(t, e) {
        if ($e444d6404c095fa5$var$W(t)) {
            this.Ni = $e444d6404c095fa5$var$K(e) ? this.Bi : e;
            var i = !1;
            if ($e444d6404c095fa5$var$Dr(t, (e, r)=>{
                t.hasOwnProperty(r) && (this.props[r] !== e || $e444d6404c095fa5$var$W(e) || $e444d6404c095fa5$var$q(e)) && (this.Ri(r, e), i = !0);
            }), i) return this.save(), !0;
        }
        return !1;
    }
    unregister(t) {
        t in this.props && (this.Ai(t), this.save());
    }
    update_campaign_params() {
        var t = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.URL;
        if (t !== this.mi) {
            var e = $e444d6404c095fa5$var$kn(this.Ne.custom_campaign_params, this.Ne.mask_personal_data_properties, this.Ne.custom_personal_data_properties);
            $e444d6404c095fa5$var$G($e444d6404c095fa5$var$Br(e)) || this.register(e), this.mi = t;
        }
    }
    update_search_keyword() {
        var t;
        this.register((t = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.referrer) ? $e444d6404c095fa5$var$Rn(t) : {});
    }
    update_referrer_info() {
        var t;
        this.register_once({
            $referrer: $e444d6404c095fa5$var$In(),
            $referring_domain: null != $e444d6404c095fa5$var$r && $e444d6404c095fa5$var$r.referrer && (null == (t = $e444d6404c095fa5$var$pn($e444d6404c095fa5$var$r.referrer)) ? void 0 : t.host) || $e444d6404c095fa5$var$On
        }, void 0);
    }
    set_initial_person_info() {
        this.props[$e444d6404c095fa5$var$fr] || this.props[$e444d6404c095fa5$var$pr] || this.register_once({
            [$e444d6404c095fa5$var$_r]: $e444d6404c095fa5$var$Cn(this.Ne.mask_personal_data_properties, this.Ne.custom_personal_data_properties, this.Ne.disable_capture_url_hashes)
        }, void 0);
    }
    get_initial_props() {
        var t = {};
        $e444d6404c095fa5$var$Dr([
            $e444d6404c095fa5$var$pr,
            $e444d6404c095fa5$var$fr
        ], (e)=>{
            var i = this.props[e];
            i && $e444d6404c095fa5$var$Dr(i, function(e, i) {
                t["$initial_" + $e444d6404c095fa5$var$L(i)] = e;
            });
        });
        var e = this.props[$e444d6404c095fa5$var$_r];
        if (e) {
            var i = function(t, e) {
                void 0 === e && (e = !1);
                var i = $e444d6404c095fa5$var$An(t, e), r = {};
                return $e444d6404c095fa5$var$Dr(i, function(t, e) {
                    r["$initial_" + $e444d6404c095fa5$var$L(e)] = t;
                }), r;
            }(e, this.Ne.disable_capture_url_hashes);
            $e444d6404c095fa5$var$Nr(t, i);
        }
        return t;
    }
    safe_merge(t) {
        return $e444d6404c095fa5$var$Dr(this.props, function(e, i) {
            i in t || (t[i] = e);
        }), t;
    }
    update_config(t, e, i) {
        this.Bi = this.Ni = t.cookie_expiration, this.set_disabled(t.disable_persistence || !!i), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie);
        var r = t.persistence !== e.persistence || !((t, e)=>{
            if (t.length !== e.length) return !1;
            var i = [
                ...t
            ].sort(), r = [
                ...e
            ].sort();
            return i.every((t, e)=>t === r[e]);
        })(t.cookie_persisted_properties || [], e.cookie_persisted_properties || []), s = r ? this.bi(t) : this.ii, n = this.wi(t);
        if (r || n !== this.pi) {
            var o = this.props;
            this.clear(), this.ii = s, this.pi = n, this.props = o, this.save();
        }
    }
    set_disabled(t) {
        this.xi = t, this.xi ? this.remove() : this.save();
    }
    set_cross_subdomain(t) {
        t !== this.qi && (this.qi = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_secure(t) {
        t !== this.ji && (this.ji = t, this.remove({
            keepGroupEntries: !0
        }), this.save());
    }
    set_event_timer(t, e) {
        var i = this.props[$e444d6404c095fa5$var$ki] || {};
        i[t] = e, this.Ri($e444d6404c095fa5$var$ki, i), this.save();
    }
    remove_event_timer(t) {
        var e = this.props[$e444d6404c095fa5$var$ki] || {}, i = e[t];
        return $e444d6404c095fa5$var$K(i) || (delete e[t], this.Ri($e444d6404c095fa5$var$ki, e), this.save()), i;
    }
    get_property(t) {
        return this.props[t];
    }
    set_property(t, e) {
        this.Ri(t, e), this.save();
    }
    Ri(t, e) {
        var i;
        this.props[t] = e, null != (i = $e444d6404c095fa5$var$cn(t)) && i.volatile || this.Hi(t);
    }
    Ai(t) {
        delete this.props[t], this.Hi(t);
    }
    Hi(t) {
        var e, i = null == (e = $e444d6404c095fa5$var$cn(t)) ? void 0 : e.storageGroup;
        i && (this.Ti(i).dirty = !0);
    }
    Ti(t) {
        return this.ci[t] || (this.ci[t] = {});
    }
}
function $e444d6404c095fa5$var$jn(t) {
    var e = !0;
    return {
        dispose () {
            if (e) {
                e = !1;
                var i = t();
                i && $e444d6404c095fa5$var$V(i.then) && i.then(void 0, ()=>{});
            }
        }
    };
}
var $e444d6404c095fa5$export$6a00d17b5aff0af = {
    GZipJS: "gzip-js",
    Base64: "base64"
}, $e444d6404c095fa5$export$352273f853caad57 = {
    Activation: "events",
    Cancellation: "cancelEvents"
}, $e444d6404c095fa5$export$87f1e68f1b904cbb = {
    Button: "button",
    Tab: "tab",
    Selector: "selector"
}, $e444d6404c095fa5$export$8c0ce98316e43193 = {
    TopLeft: "top_left",
    TopRight: "top_right",
    TopCenter: "top_center",
    MiddleLeft: "middle_left",
    MiddleRight: "middle_right",
    MiddleCenter: "middle_center",
    Left: "left",
    Center: "center",
    Right: "right",
    NextToTrigger: "next_to_trigger"
}, $e444d6404c095fa5$export$3693bed37a847924 = {
    Top: "top",
    Left: "left",
    Right: "right",
    Bottom: "bottom"
}, $e444d6404c095fa5$export$22779822dd24228f = {
    Popover: "popover",
    API: "api",
    Widget: "widget",
    ExternalSurvey: "external_survey"
}, $e444d6404c095fa5$export$9c2ac61661d417f8 = {
    Open: "open",
    MultipleChoice: "multiple_choice",
    SingleChoice: "single_choice",
    Rating: "rating",
    Link: "link"
}, $e444d6404c095fa5$export$bbed2da3bd3bb001 = {
    NextQuestion: "next_question",
    End: "end",
    ResponseBased: "response_based",
    SpecificQuestion: "specific_question"
}, $e444d6404c095fa5$export$407ee791fe918359 = {
    Once: "once",
    Recurring: "recurring",
    Always: "always"
}, $e444d6404c095fa5$export$9d7ec1793ca1658e = {
    SHOWN: "survey shown",
    DISMISSED: "survey dismissed",
    SENT: "survey sent",
    ABANDONED: "survey abandoned"
}, $e444d6404c095fa5$export$fe4c9af525341543 = {
    SURVEY_ID: "$survey_id",
    SURVEY_NAME: "$survey_name",
    SURVEY_RESPONSE: "$survey_response",
    SURVEY_ITERATION: "$survey_iteration",
    SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date",
    SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed",
    SURVEY_SUBMISSION_ID: "$survey_submission_id",
    SURVEY_QUESTIONS: "$survey_questions",
    SURVEY_COMPLETED: "$survey_completed",
    PRODUCT_TOUR_ID: "$product_tour_id",
    SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date",
    SURVEY_LANGUAGE: "$survey_language"
}, $e444d6404c095fa5$export$a8a66d9d1b857494 = {
    Popover: "popover",
    Inline: "inline"
}, $e444d6404c095fa5$export$8f14e1a0dc415d5d = {
    backgroundColor: "#ffffff",
    textColor: "#1d1f27",
    buttonColor: "#1d1f27",
    borderRadius: 8,
    buttonBorderRadius: 6,
    borderColor: "#e5e7eb",
    fontFamily: "system-ui",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    showOverlay: !0,
    whiteLabel: !1,
    dismissOnClickOutside: !0,
    zIndex: 2147483646
}, $e444d6404c095fa5$export$e5d0052c1e47bfda = {
    SHOWN: "product tour shown",
    DISMISSED: "product tour dismissed",
    COMPLETED: "product tour completed",
    STEP_SHOWN: "product tour step shown",
    STEP_COMPLETED: "product tour step completed",
    BUTTON_CLICKED: "product tour button clicked",
    STEP_SELECTOR_FAILED: "product tour step selector failed",
    BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed",
    BANNER_ACTION_CLICKED: "product tour banner action clicked"
}, $e444d6404c095fa5$export$eedf6d13bc23d767 = {
    TOUR_ID: "$product_tour_id",
    TOUR_NAME: "$product_tour_name",
    TOUR_ITERATION: "$product_tour_iteration",
    TOUR_RENDER_REASON: "$product_tour_render_reason",
    TOUR_STEP_ID: "$product_tour_step_id",
    TOUR_STEP_ORDER: "$product_tour_step_order",
    TOUR_STEP_TYPE: "$product_tour_step_type",
    TOUR_DISMISS_REASON: "$product_tour_dismiss_reason",
    TOUR_BUTTON_TEXT: "$product_tour_button_text",
    TOUR_BUTTON_ACTION: "$product_tour_button_action",
    TOUR_BUTTON_LINK: "$product_tour_button_link",
    TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id",
    TOUR_STEPS_COUNT: "$product_tour_steps_count",
    TOUR_STEP_SELECTOR: "$product_tour_step_selector",
    TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found",
    TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag",
    TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id",
    TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes",
    TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text",
    TOUR_ERROR: "$product_tour_error",
    TOUR_MATCHES_COUNT: "$product_tour_matches_count",
    TOUR_FAILURE_PHASE: "$product_tour_failure_phase",
    TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element",
    TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms",
    TOUR_BANNER_SELECTOR: "$product_tour_banner_selector",
    TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id",
    USE_MANUAL_SELECTOR: "$use_manual_selector",
    INFERENCE_DATA_PRESENT: "$inference_data_present",
    TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date",
    TOUR_TYPE: "$product_tour_type"
}, $e444d6404c095fa5$var$io = $e444d6404c095fa5$var$bi("[RateLimiter]");
class $e444d6404c095fa5$var$ro {
    constructor(t){
        this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (t)=>{
            var e = t.text;
            if (e && e.length) try {
                (JSON.parse(e).quota_limited || []).forEach((t)=>{
                    $e444d6404c095fa5$var$io.info((t || "events") + " is quota limited."), this.serverLimits[t] = (new Date).getTime() + 6e4;
                });
            } catch (t) {
                return void $e444d6404c095fa5$var$io.warn('could not rate limit - continuing. Error: "' + (null == t ? void 0 : t.message) + '"', {
                    text: e
                });
            }
        }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    get captureEventsPerSecond() {
        var t;
        return (null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_per_second) || 10;
    }
    get captureEventsBurstLimit() {
        var t;
        return Math.max((null == (t = this.instance.config.rate_limiting) ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
    }
    clientRateLimitContext(t) {
        var e, i, r;
        void 0 === t && (t = !1);
        var s = this.captureEventsBurstLimit, n = this.captureEventsPerSecond, o = (new Date).getTime(), a = null !== (e = null == (i = this.instance.persistence) ? void 0 : i.get_property($e444d6404c095fa5$var$cr)) && void 0 !== e ? e : {
            tokens: s,
            last: o
        };
        a.tokens += (o - a.last) / 1e3 * n, a.last = o, a.tokens > s && (a.tokens = s);
        var l = 1 > a.tokens;
        if (l || t || (a.tokens = Math.max(0, a.tokens - 1)), l && !t) {
            var u = ($e444d6404c095fa5$var$Z(a.dropped) ? a.dropped : 0) + 1;
            a.dropped = u, !this.lastEventRateLimited && this.Ui(u) && (a.dropped = 0);
        }
        return this.lastEventRateLimited = l, null == (r = this.instance.persistence) || r.set_property($e444d6404c095fa5$var$cr, a), {
            isRateLimited: l,
            remainingTokens: a.tokens
        };
    }
    zi(t) {
        var e = this.instance.config.property_denylist;
        return !$e444d6404c095fa5$var$q(e) || !e.includes(t);
    }
    Wi() {
        var t;
        if (this.zi("$current_url") && this.zi("$pathname") && null != $e444d6404c095fa5$var$s && $e444d6404c095fa5$var$s.pathname) return "" + (null !== (t = $e444d6404c095fa5$var$s.origin) && void 0 !== t ? t : "") + $e444d6404c095fa5$var$s.pathname;
    }
    Ui(t) {
        var e, i, r = this.captureEventsBurstLimit, s = this.captureEventsPerSecond, n = this.Wi(), o = this.zi("$session_id") ? null == (e = (i = this.instance).get_session_id) ? void 0 : e.call(i) : void 0, a = [
            t + " event(s) dropped since the last warning",
            n ? "triggered on " + n : void 0,
            o ? "session " + o : void 0
        ].filter(Boolean).join(", ");
        return !!this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited: " + a + ". Config is set to " + s + " events per second and " + r + " events burst limit."
        }, {
            skip_client_rate_limiting: !0
        });
    }
    isServerRateLimited(t) {
        var e = this.serverLimits[t || "events"] || !1;
        return !1 !== e && (new Date).getTime() < e;
    }
}
var $e444d6404c095fa5$var$so = $e444d6404c095fa5$var$bi("[RemoteConfig]");
class $e444d6404c095fa5$var$no {
    constructor(t){
        this._instance = t;
    }
    get remoteConfig() {
        var t;
        return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.config;
    }
    Vi(t) {
        var e, i;
        null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.loadExternalDependency ? null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "remote-config", ()=>t(this.remoteConfig)) : t();
    }
    Zi(t) {
        this._instance._send_request({
            method: "GET",
            url: this._instance.requestRouter.endpointFor("assets", "/array/" + this._instance.config.token + "/config"),
            callback: t
        });
    }
    load() {
        try {
            if (this.remoteConfig) return $e444d6404c095fa5$var$so.info("Using preloaded remote config", this.remoteConfig), this.Gi(this.remoteConfig), void this.Qi();
            if (this._instance.Ki()) return void $e444d6404c095fa5$var$so.warn("Remote config is disabled. Falling back to local config.");
            this.Vi((t)=>{
                if (!t) return $e444d6404c095fa5$var$so.info("No config found after loading remote JS config. Falling back to JSON."), void this.Zi((t)=>{
                    this.Gi(t.json, t), this.Qi();
                });
                this.Gi(t), this.Qi();
            });
        } catch (t) {
            $e444d6404c095fa5$var$so.error("Error loading remote config", t), this.Gi();
        }
    }
    stop() {
        this.Ji && (clearInterval(this.Ji), this.Ji = void 0);
    }
    refresh() {
        !this._instance.Ki() && $e444d6404c095fa5$var$r && "hidden" !== $e444d6404c095fa5$var$r.visibilityState && this._instance.reloadFeatureFlags();
    }
    Qi() {
        var t;
        if (!this.Ji) {
            var e = null !== (t = this._instance.config.remote_config_refresh_interval_ms) && void 0 !== t ? t : 3e5;
            0 !== e && (this.Ji = setInterval(()=>{
                this.refresh();
            }, e));
        }
    }
    Gi(t, e) {
        !t && e && (0 === e.statusCode ? e.error || $e444d6404c095fa5$var$so.warn("Failed to fetch remote config from PostHog.") : $e444d6404c095fa5$var$so.error("Failed to fetch remote config from PostHog."));
        try {
            this._instance.Gi(t ? {
                ok: !0,
                config: t
            } : {
                ok: !1
            });
        } catch (t) {
            $e444d6404c095fa5$var$so.error("Error applying remote config", t);
        }
        if (!1 !== (null == t ? void 0 : t.hasFeatureFlags) && !this._instance.config.advanced_disable_feature_flags_on_first_load) try {
            var i;
            null == (i = this._instance.featureFlags) || i.ensureFlagsLoaded();
        } catch (t) {
            $e444d6404c095fa5$var$so.error("Error loading feature flags", t);
        }
    }
}
var $e444d6404c095fa5$export$9dd8f6ec3b5e6004 = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
], $e444d6404c095fa5$var$ao = Uint8Array, $e444d6404c095fa5$var$lo = Uint16Array, $e444d6404c095fa5$var$uo = Uint32Array, $e444d6404c095fa5$var$ho = new $e444d6404c095fa5$var$ao([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $e444d6404c095fa5$var$vo = new $e444d6404c095fa5$var$ao([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $e444d6404c095fa5$var$co = new $e444d6404c095fa5$var$ao([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $e444d6404c095fa5$var$fo = function(t, e) {
    for(var i = new $e444d6404c095fa5$var$lo(31), r = 0; 31 > r; ++r)i[r] = e += 1 << t[r - 1];
    var s = new $e444d6404c095fa5$var$uo(i[30]);
    for(r = 1; 30 > r; ++r)for(var n = i[r]; i[r + 1] > n; ++n)s[n] = n - i[r] << 5 | r;
    return [
        i,
        s
    ];
}, $e444d6404c095fa5$var$po = $e444d6404c095fa5$var$fo($e444d6404c095fa5$var$ho, 2), $e444d6404c095fa5$var$_o = $e444d6404c095fa5$var$po[1];
$e444d6404c095fa5$var$po[0][28] = 258, $e444d6404c095fa5$var$_o[258] = 28;
for(var $e444d6404c095fa5$var$go = $e444d6404c095fa5$var$fo($e444d6404c095fa5$var$vo, 0)[1], $e444d6404c095fa5$var$mo = new $e444d6404c095fa5$var$lo(32768), $e444d6404c095fa5$var$bo = 0; 32768 > $e444d6404c095fa5$var$bo; ++$e444d6404c095fa5$var$bo){
    var $e444d6404c095fa5$var$yo = (43690 & $e444d6404c095fa5$var$bo) >>> 1 | (21845 & $e444d6404c095fa5$var$bo) << 1;
    $e444d6404c095fa5$var$mo[$e444d6404c095fa5$var$bo] = ((65280 & ($e444d6404c095fa5$var$yo = (61680 & ($e444d6404c095fa5$var$yo = (52428 & $e444d6404c095fa5$var$yo) >>> 2 | (13107 & $e444d6404c095fa5$var$yo) << 2)) >>> 4 | (3855 & $e444d6404c095fa5$var$yo) << 4)) >>> 8 | (255 & $e444d6404c095fa5$var$yo) << 8) >>> 1;
}
var $e444d6404c095fa5$var$wo = function(t, e, i) {
    for(var r = t.length, s = 0, n = new $e444d6404c095fa5$var$lo(e); r > s; ++s)++n[t[s] - 1];
    var o, a = new $e444d6404c095fa5$var$lo(e);
    for(s = 0; e > s; ++s)a[s] = a[s - 1] + n[s - 1] << 1;
    if (i) {
        o = new $e444d6404c095fa5$var$lo(1 << e);
        var l = 15 - e;
        for(s = 0; r > s; ++s)if (t[s]) for(var u = s << 4 | t[s], h = e - t[s], d = a[t[s] - 1]++ << h, v = d | (1 << h) - 1; v >= d; ++d)o[$e444d6404c095fa5$var$mo[d] >>> l] = u;
    } else for(o = new $e444d6404c095fa5$var$lo(r), s = 0; r > s; ++s)o[s] = $e444d6404c095fa5$var$mo[a[t[s] - 1]++] >>> 15 - t[s];
    return o;
}, $e444d6404c095fa5$var$xo = new $e444d6404c095fa5$var$ao(288);
for($e444d6404c095fa5$var$bo = 0; 144 > $e444d6404c095fa5$var$bo; ++$e444d6404c095fa5$var$bo)$e444d6404c095fa5$var$xo[$e444d6404c095fa5$var$bo] = 8;
for($e444d6404c095fa5$var$bo = 144; 256 > $e444d6404c095fa5$var$bo; ++$e444d6404c095fa5$var$bo)$e444d6404c095fa5$var$xo[$e444d6404c095fa5$var$bo] = 9;
for($e444d6404c095fa5$var$bo = 256; 280 > $e444d6404c095fa5$var$bo; ++$e444d6404c095fa5$var$bo)$e444d6404c095fa5$var$xo[$e444d6404c095fa5$var$bo] = 7;
for($e444d6404c095fa5$var$bo = 280; 288 > $e444d6404c095fa5$var$bo; ++$e444d6404c095fa5$var$bo)$e444d6404c095fa5$var$xo[$e444d6404c095fa5$var$bo] = 8;
var $e444d6404c095fa5$var$Eo = new $e444d6404c095fa5$var$ao(32);
for($e444d6404c095fa5$var$bo = 0; 32 > $e444d6404c095fa5$var$bo; ++$e444d6404c095fa5$var$bo)$e444d6404c095fa5$var$Eo[$e444d6404c095fa5$var$bo] = 5;
var $e444d6404c095fa5$var$So = $e444d6404c095fa5$var$wo($e444d6404c095fa5$var$xo, 9, 0), $e444d6404c095fa5$var$$o = $e444d6404c095fa5$var$wo($e444d6404c095fa5$var$Eo, 5, 0), $e444d6404c095fa5$var$ko = function(t) {
    return (t / 8 >> 0) + (7 & t && 1);
}, $e444d6404c095fa5$var$To = function(t, e, i) {
    (null == i || i > t.length) && (i = t.length);
    var r = new (t instanceof $e444d6404c095fa5$var$lo ? $e444d6404c095fa5$var$lo : t instanceof $e444d6404c095fa5$var$uo ? $e444d6404c095fa5$var$uo : $e444d6404c095fa5$var$ao)(i - e);
    return r.set(t.subarray(e, i)), r;
}, $e444d6404c095fa5$var$Ro = function(t, e, i) {
    var r = e / 8 >> 0;
    t[r] |= i <<= 7 & e, t[r + 1] |= i >>> 8;
}, $e444d6404c095fa5$var$Po = function(t, e, i) {
    var r = e / 8 >> 0;
    t[r] |= i <<= 7 & e, t[r + 1] |= i >>> 8, t[r + 2] |= i >>> 16;
}, $e444d6404c095fa5$var$Oo = function(t, e) {
    for(var i = [], r = 0; t.length > r; ++r)t[r] && i.push({
        s: r,
        f: t[r]
    });
    var s = i.length, n = i.slice();
    if (!s) return [
        new $e444d6404c095fa5$var$ao(0),
        0
    ];
    if (1 == s) {
        var o = new $e444d6404c095fa5$var$ao(i[0].s + 1);
        return o[i[0].s] = 1, [
            o,
            1
        ];
    }
    i.sort(function(t, e) {
        return t.f - e.f;
    }), i.push({
        s: -1,
        f: 25001
    });
    var a = i[0], l = i[1], u = 0, h = 1, d = 2;
    for(i[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; h != s - 1;)a = i[i[d].f > i[u].f ? u++ : d++], l = i[u != h && i[d].f > i[u].f ? u++ : d++], i[h++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var v = n[0].s;
    for(r = 1; s > r; ++r)n[r].s > v && (v = n[r].s);
    var c = new $e444d6404c095fa5$var$lo(v + 1), f = $e444d6404c095fa5$var$Io(i[h - 1], c, 0);
    if (f > e) {
        r = 0;
        var p = 0, _ = f - e, g = 1 << _;
        for(n.sort(function(t, e) {
            return c[e.s] - c[t.s] || t.f - e.f;
        }); s > r; ++r){
            var m = n[r].s;
            if (e >= c[m]) break;
            p += g - (1 << f - c[m]), c[m] = e;
        }
        for(p >>>= _; p > 0;){
            var b = n[r].s;
            e > c[b] ? p -= 1 << e - c[b]++ - 1 : ++r;
        }
        for(; r >= 0 && p; --r){
            var y = n[r].s;
            c[y] == e && (--c[y], ++p);
        }
        f = e;
    }
    return [
        new $e444d6404c095fa5$var$ao(c),
        f
    ];
}, $e444d6404c095fa5$var$Io = function(t, e, i) {
    return -1 == t.s ? Math.max($e444d6404c095fa5$var$Io(t.l, e, i + 1), $e444d6404c095fa5$var$Io(t.r, e, i + 1)) : e[t.s] = i;
}, $e444d6404c095fa5$var$Co = function(t) {
    for(var e = t.length; e && !t[--e];);
    for(var i = new $e444d6404c095fa5$var$lo(++e), r = 0, s = t[0], n = 1, o = function(t) {
        i[r++] = t;
    }, a = 1; e >= a; ++a)if (t[a] == s && a != e) ++n;
    else {
        if (!s && n > 2) {
            for(; n > 138; n -= 138)o(32754);
            n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
        } else if (n > 3) {
            for(o(s), --n; n > 6; n -= 6)o(8304);
            n > 2 && (o(n - 3 << 5 | 8208), n = 0);
        }
        for(; n--;)o(s);
        n = 1, s = t[a];
    }
    return [
        i.subarray(0, r),
        e
    ];
}, $e444d6404c095fa5$var$Ao = function(t, e) {
    for(var i = 0, r = 0; e.length > r; ++r)i += t[r] * e[r];
    return i;
}, $e444d6404c095fa5$var$Mo = function(t, e, i) {
    var r = i.length, s = $e444d6404c095fa5$var$ko(e + 2);
    t[s] = 255 & r, t[s + 1] = r >>> 8, t[s + 2] = 255 ^ t[s], t[s + 3] = 255 ^ t[s + 1];
    for(var n = 0; r > n; ++n)t[s + n + 4] = i[n];
    return 8 * (s + 4 + r);
}, $e444d6404c095fa5$var$Fo = function(t, e, i, r, s, n, o, a, l, u, h) {
    $e444d6404c095fa5$var$Ro(e, h++, i), ++s[256];
    for(var d = $e444d6404c095fa5$var$Oo(s, 15), v = d[0], c = d[1], f = $e444d6404c095fa5$var$Oo(n, 15), p = f[0], _ = f[1], g = $e444d6404c095fa5$var$Co(v), m = g[0], b = g[1], y = $e444d6404c095fa5$var$Co(p), w = y[0], x = y[1], E = new $e444d6404c095fa5$var$lo(19), S = 0; m.length > S; ++S)E[31 & m[S]]++;
    for(S = 0; w.length > S; ++S)E[31 & w[S]]++;
    for(var k = $e444d6404c095fa5$var$Oo(E, 7), T = k[0], R = k[1], P = 19; P > 4 && !T[$e444d6404c095fa5$var$co[P - 1]]; --P);
    var O, I, C, A, M = u + 5 << 3, F = $e444d6404c095fa5$var$Ao(s, $e444d6404c095fa5$var$xo) + $e444d6404c095fa5$var$Ao(n, $e444d6404c095fa5$var$Eo) + o, D = $e444d6404c095fa5$var$Ao(s, v) + $e444d6404c095fa5$var$Ao(n, p) + o + 14 + 3 * P + $e444d6404c095fa5$var$Ao(E, T) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (F >= M && D >= M) return $e444d6404c095fa5$var$Mo(e, h, t.subarray(l, l + u));
    if ($e444d6404c095fa5$var$Ro(e, h, 1 + (F > D)), h += 2, F > D) {
        O = $e444d6404c095fa5$var$wo(v, c, 0), I = v, C = $e444d6404c095fa5$var$wo(p, _, 0), A = p;
        var N = $e444d6404c095fa5$var$wo(T, R, 0);
        for($e444d6404c095fa5$var$Ro(e, h, b - 257), $e444d6404c095fa5$var$Ro(e, h + 5, x - 1), $e444d6404c095fa5$var$Ro(e, h + 10, P - 4), h += 14, S = 0; P > S; ++S)$e444d6404c095fa5$var$Ro(e, h + 3 * S, T[$e444d6404c095fa5$var$co[S]]);
        h += 3 * P;
        for(var U = [
            m,
            w
        ], L = 0; 2 > L; ++L){
            var j = U[L];
            for(S = 0; j.length > S; ++S)$e444d6404c095fa5$var$Ro(e, h, N[B = 31 & j[S]]), h += T[B], B > 15 && ($e444d6404c095fa5$var$Ro(e, h, j[S] >>> 5 & 127), h += j[S] >>> 12);
        }
    } else O = $e444d6404c095fa5$var$So, I = $e444d6404c095fa5$var$xo, C = $e444d6404c095fa5$var$$o, A = $e444d6404c095fa5$var$Eo;
    for(S = 0; a > S; ++S)if (r[S] > 255) {
        var B;
        $e444d6404c095fa5$var$Po(e, h, O[257 + (B = r[S] >>> 18 & 31)]), h += I[B + 257], B > 7 && ($e444d6404c095fa5$var$Ro(e, h, r[S] >>> 23 & 31), h += $e444d6404c095fa5$var$ho[B]);
        var z = 31 & r[S];
        $e444d6404c095fa5$var$Po(e, h, C[z]), h += A[z], z > 3 && ($e444d6404c095fa5$var$Po(e, h, r[S] >>> 5 & 8191), h += $e444d6404c095fa5$var$vo[z]);
    } else $e444d6404c095fa5$var$Po(e, h, O[r[S]]), h += I[r[S]];
    return $e444d6404c095fa5$var$Po(e, h, O[256]), h + I[256];
}, $e444d6404c095fa5$var$Do = new $e444d6404c095fa5$var$uo([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), $e444d6404c095fa5$var$No = function() {
    for(var t = new $e444d6404c095fa5$var$uo(256), e = 0; 256 > e; ++e){
        for(var i = e, r = 9; --r;)i = (1 & i && 3988292384) ^ i >>> 1;
        t[e] = i;
    }
    return t;
}(), $e444d6404c095fa5$var$Uo = function(t, e, i) {
    for(; i; ++e)t[e] = i, i >>>= 8;
};
function $e444d6404c095fa5$var$Lo(t, e) {
    void 0 === e && (e = {});
    var i = function() {
        var t = 4294967295;
        return {
            p (e) {
                for(var i = t, r = 0; e.length > r; ++r)i = $e444d6404c095fa5$var$No[255 & i ^ e[r]] ^ i >>> 8;
                t = i;
            },
            d () {
                return 4294967295 ^ t;
            }
        };
    }(), r = t.length;
    i.p(t);
    var s, n, o, a, l, u = (a = 10 + ((s = e).filename && s.filename.length + 1 || 0), l = 8, function(t, e, i, r, s, n) {
        var o = t.length, a = new $e444d6404c095fa5$var$ao(r + o + 5 * (1 + Math.floor(o / 7e3)) + s), l = a.subarray(r, a.length - s), u = 0;
        if (!e || 8 > o) for(var h = 0; o >= h; h += 65535){
            var d = h + 65535;
            o > d ? u = $e444d6404c095fa5$var$Mo(l, u, t.subarray(h, d)) : (l[h] = !0, u = $e444d6404c095fa5$var$Mo(l, u, t.subarray(h, o)));
        }
        else {
            for(var v = $e444d6404c095fa5$var$Do[e - 1], c = v >>> 13, f = 8191 & v, p = (1 << i) - 1, _ = new $e444d6404c095fa5$var$lo(32768), g = new $e444d6404c095fa5$var$lo(p + 1), m = Math.ceil(i / 3), b = 2 * m, y = function(e) {
                return (t[e] ^ t[e + 1] << m ^ t[e + 2] << b) & p;
            }, w = new $e444d6404c095fa5$var$uo(25e3), x = new $e444d6404c095fa5$var$lo(288), E = new $e444d6404c095fa5$var$lo(32), S = 0, k = 0, T = (h = 0, 0), R = 0, P = 0; o > h; ++h){
                var O = y(h), I = 32767 & h, C = g[O];
                if (_[I] = C, g[O] = I, h >= R) {
                    var A = o - h;
                    if ((S > 7e3 || T > 24576) && A > 423) {
                        u = $e444d6404c095fa5$var$Fo(t, l, 0, w, x, E, k, T, P, h - P, u), T = S = k = 0, P = h;
                        for(var M = 0; 286 > M; ++M)x[M] = 0;
                        for(M = 0; 30 > M; ++M)E[M] = 0;
                    }
                    var F = 2, D = 0, N = f, U = I - C & 32767;
                    if (A > 2 && O == y(h - U)) for(var L = Math.min(c, A) - 1, j = Math.min(32767, h), B = Math.min(258, A); j >= U && --N && I != C;){
                        if (t[h + F] == t[h + F - U]) {
                            for(var z = 0; B > z && t[h + z] == t[h + z - U]; ++z);
                            if (z > F) {
                                if (F = z, D = U, z > L) break;
                                var H = Math.min(U, z - 2), q = 0;
                                for(M = 0; H > M; ++M){
                                    var V = h - U + M + 32768 & 32767, W = V - _[V] + 32768 & 32767;
                                    W > q && (q = W, C = V);
                                }
                            }
                        }
                        U += (I = C) - (C = _[I]) + 32768 & 32767;
                    }
                    if (D) {
                        w[T++] = 268435456 | $e444d6404c095fa5$var$_o[F] << 18 | $e444d6404c095fa5$var$go[D];
                        var G = 31 & $e444d6404c095fa5$var$_o[F], K = 31 & $e444d6404c095fa5$var$go[D];
                        k += $e444d6404c095fa5$var$ho[G] + $e444d6404c095fa5$var$vo[K], ++x[257 + G], ++E[K], R = h + F, ++S;
                    } else w[T++] = t[h], ++x[t[h]];
                }
            }
            u = $e444d6404c095fa5$var$Fo(t, l, !0, w, x, E, k, T, P, h - P, u);
        }
        return $e444d6404c095fa5$var$To(a, 0, r + $e444d6404c095fa5$var$ko(u) + s);
    }(n = t, null == (o = e).level ? 6 : o.level, null == o.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(n.length)))) : 12 + o.mem, a, l)), h = u.length;
    return function(t, e) {
        var i = e.filename;
        if (t[0] = 31, t[1] = 139, t[2] = 8, t[8] = 2 > e.level ? 4 : 9 == e.level ? 2 : 0, t[9] = 3, 0 != e.mtime && $e444d6404c095fa5$var$Uo(t, 4, Math.floor(new Date(e.mtime || Date.now()) / 1e3)), i) {
            t[3] = 8;
            for(var r = 0; i.length >= r; ++r)t[r + 10] = i.charCodeAt(r);
        }
    }(u, e), $e444d6404c095fa5$var$Uo(u, h - 8, i.d()), $e444d6404c095fa5$var$Uo(u, h - 4, r), u;
}
var $e444d6404c095fa5$var$jo = !!$e444d6404c095fa5$var$o || !!$e444d6404c095fa5$var$n, $e444d6404c095fa5$var$Bo = "text/plain", $e444d6404c095fa5$var$zo = !1, $e444d6404c095fa5$var$Ho = (t, e)=>{
    var i = t.split("#"), r = i[1], s = i[0].split("?"), n = s[0], o = s[1];
    if (!o) return t;
    var a = o.split("&").filter((t)=>t.split("=")[0] !== e).join("&");
    return n + (a ? "?" + a : "") + (r ? "#" + r : "");
}, $e444d6404c095fa5$var$qo = function(t, e, i) {
    var r;
    void 0 === i && (i = !0);
    var s = t.split("?"), n = s[0], o = s[1], a = $e444d6404c095fa5$var$_({}, e), l = null !== (r = null == o ? void 0 : o.split("&").map((t)=>{
        var e, r = t.split("="), s = r[0], n = i && null !== (e = a[s]) && void 0 !== e ? e : r[1];
        return delete a[s], s + "=" + n;
    })) && void 0 !== r ? r : [], u = function(t, e) {
        var i, r;
        void 0 === e && (e = "&");
        var s = [];
        return $e444d6404c095fa5$var$Dr(t, function(t, e) {
            $e444d6404c095fa5$var$K(t) || $e444d6404c095fa5$var$K(e) || "undefined" === e || (i = encodeURIComponent(((t)=>t instanceof File)(t) ? t.name : t.toString()), r = encodeURIComponent(e), s[s.length] = r + "=" + i);
        }), s.join(e);
    }(a);
    return u && l.push(u), l.length > 0 ? n + "?" + l.join("&") : n;
}, $e444d6404c095fa5$var$Vo = (t)=>{
    if (t.Yi) return t.Yi;
    var e = t.data, i = t.compression;
    if (e) {
        if (i === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) {
            var r = $e444d6404c095fa5$var$Lo(function(t, e) {
                var i = t.length;
                if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(t);
                for(var r = new $e444d6404c095fa5$var$ao(t.length + (t.length >>> 1)), s = 0, n = function(t) {
                    r[s++] = t;
                }, o = 0; i > o; ++o){
                    if (s + 5 > r.length) {
                        var a = new $e444d6404c095fa5$var$ao(s + 8 + (i - o << 1));
                        a.set(r), r = a;
                    }
                    var l = t.charCodeAt(o);
                    128 > l ? n(l) : 2048 > l ? (n(192 | l >>> 6), n(128 | 63 & l)) : l > 55295 && 57344 > l ? (n(240 | (l = 65536 + (1047552 & l) | 1023 & t.charCodeAt(++o)) >>> 18), n(128 | l >>> 12 & 63), n(128 | l >>> 6 & 63), n(128 | 63 & l)) : (n(224 | l >>> 12), n(128 | l >>> 6 & 63), n(128 | 63 & l));
                }
                return $e444d6404c095fa5$var$To(r, 0, s);
            }($e444d6404c095fa5$var$fn(e)), {
                mtime: 0
            });
            return {
                contentType: $e444d6404c095fa5$var$Bo,
                body: r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength),
                estimatedSize: r.byteLength
            };
        }
        if (i === $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) {
            var s = function(t) {
                return t ? btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, (t, e)=>String.fromCharCode(parseInt(e, 16)))) : t;
            }($e444d6404c095fa5$var$fn(e)), n = ((t)=>"data=" + encodeURIComponent("string" == typeof t ? t : $e444d6404c095fa5$var$fn(t)))(s);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: n,
                estimatedSize: new Blob([
                    n
                ]).size
            };
        }
        var o = $e444d6404c095fa5$var$fn(e);
        return {
            contentType: "application/json",
            body: o,
            estimatedSize: new Blob([
                o
            ]).size
        };
    }
}, $e444d6404c095fa5$var$Wo = (t)=>{
    var e, i, r = ()=>"sendBeacon" === t.transport ? {
            url: $e444d6404c095fa5$var$qo(t.url, {
                compression: $e444d6404c095fa5$export$6a00d17b5aff0af.Base64
            }),
            encodedBody: $e444d6404c095fa5$var$Vo($e444d6404c095fa5$var$_({}, t, {
                compression: $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                Yi: void 0
            }))
        } : {
            url: $e444d6404c095fa5$var$Ho(t.url, "compression"),
            encodedBody: $e444d6404c095fa5$var$Vo($e444d6404c095fa5$var$_({}, t, {
                compression: void 0,
                Yi: void 0
            }))
        };
    try {
        e = $e444d6404c095fa5$var$Vo(t);
    } catch (e) {
        if ($e444d6404c095fa5$var$O(t.compression, $e444d6404c095fa5$var$_n(t.url, "compression"))) return $e444d6404c095fa5$var$mi.error("Failed to gzip request body, sending uncompressed payload", e), r();
        throw e;
    }
    return e && $e444d6404c095fa5$var$O(t.compression, $e444d6404c095fa5$var$_n(t.url, "compression")) && !((i = e.body) instanceof ArrayBuffer ? $e444d6404c095fa5$var$P(new Uint8Array(i)) : ArrayBuffer.isView(i) && $e444d6404c095fa5$var$P(new Uint8Array(i.buffer, i.byteOffset, i.byteLength))) ? ($e444d6404c095fa5$var$zo = !0, r()) : {
        url: t.url,
        encodedBody: e
    };
}, $e444d6404c095fa5$var$Go = (t)=>{
    try {
        return $e444d6404c095fa5$var$Wo(t);
    } catch (e) {
        return $e444d6404c095fa5$var$mi.error(e), void (null == t.callback || t.callback({
            statusCode: 0,
            error: e
        }));
    }
}, $e444d6404c095fa5$var$Ko = function() {
    var t = $e444d6404c095fa5$var$p(function*(t) {
        var e = $e444d6404c095fa5$var$fn(t.data), i = yield function(t, e, i) {
            return $e444d6404c095fa5$var$M.apply(this, arguments);
        }(e, $e444d6404c095fa5$var$c.DEBUG, {
            rethrow: !0
        });
        if (!i) return t;
        var r = yield i.arrayBuffer();
        return $e444d6404c095fa5$var$_({}, t, {
            Yi: {
                contentType: $e444d6404c095fa5$var$Bo,
                body: r,
                estimatedSize: r.byteLength
            }
        });
    });
    return function(e) {
        return t.apply(this, arguments);
    };
}(), $e444d6404c095fa5$var$Jo = /Failed to fetch|NetworkError|Load failed/i, $e444d6404c095fa5$var$Yo = (t)=>"TypeError" === (null == t ? void 0 : t.name) && $e444d6404c095fa5$var$Jo.test((null == t ? void 0 : t.message) || ""), $e444d6404c095fa5$var$Qo = (t)=>{
    var e = $e444d6404c095fa5$var$Go(t);
    if (e) {
        var i = e.url, r = e.encodedBody, s = null != r ? r : {}, o = s.contentType, l = s.body, u = s.estimatedSize, h = new Headers;
        $e444d6404c095fa5$var$Dr(t.headers, function(t, e) {
            h.append(e, t);
        }), o && h.append("Content-Type", o);
        var d = null, v = !1;
        if ($e444d6404c095fa5$var$a) {
            var c = new $e444d6404c095fa5$var$a;
            d = {
                signal: c.signal,
                timeout: setTimeout(()=>{
                    var e, i;
                    v = !0, c.abort((e = t.timeout, (i = new Error("PostHog request timed out" + (e ? " after " + e + "ms" : ""))).name = "AbortError", i));
                }, t.timeout)
            };
        }
        var f = (e)=>{
            v && "AbortError" === (null == e ? void 0 : e.name) || $e444d6404c095fa5$var$Yo(e) ? $e444d6404c095fa5$var$mi.warn(e) : $e444d6404c095fa5$var$mi.error(e), null == t.callback || t.callback({
                statusCode: 0,
                error: e
            });
        };
        try {
            var p;
            $e444d6404c095fa5$var$n(i, $e444d6404c095fa5$var$_({
                method: (null == t ? void 0 : t.method) || "GET",
                headers: h,
                keepalive: "POST" === t.method && !t.Xi && 52428.8 > (u || 0),
                body: l,
                signal: null == (p = d) ? void 0 : p.signal
            }, t.fetchOptions)).then((e)=>e.text().then((i)=>{
                    var r = {
                        statusCode: e.status,
                        text: i
                    };
                    if (200 === e.status) try {
                        r.json = JSON.parse(i);
                    } catch (t) {
                        $e444d6404c095fa5$var$mi.error(t);
                    }
                    null == t.callback || t.callback(r);
                })).catch(f).finally(()=>d ? clearTimeout(d.timeout) : null);
        } catch (t) {
            d && clearTimeout(d.timeout), f(t);
        }
    }
}, $e444d6404c095fa5$var$Xo = (t)=>{
    try {
        var e, r = $e444d6404c095fa5$var$Wo(t), s = r.url, n = r.encodedBody, o = null != n ? n : {}, a = o.body, l = o.estimatedSize;
        if (!a) return;
        var u = a instanceof Blob ? a : new Blob([
            a
        ], {
            type: o.contentType
        });
        if ($e444d6404c095fa5$var$i.sendBeacon(s, u)) return;
        var h = $e444d6404c095fa5$var$q(t.data) ? t.data : null == (e = t.data) ? void 0 : e.batch;
        if ($e444d6404c095fa5$var$q(h) && h.length > 1 && (null != l ? l : 0) > 16384) {
            var d = Math.ceil(h.length / 2), v = (e)=>$e444d6404c095fa5$var$q(t.data) ? e : $e444d6404c095fa5$var$_({}, t.data, {
                    batch: e
                });
            return $e444d6404c095fa5$var$Xo($e444d6404c095fa5$var$_({}, t, {
                data: v(h.slice(0, d))
            })), void $e444d6404c095fa5$var$Xo($e444d6404c095fa5$var$_({}, t, {
                data: v(h.slice(d))
            }));
        }
        $e444d6404c095fa5$var$mi.warn("Beacon of ~" + (null != l ? l : 0) + " bytes was rejected by the browser, falling back to fetch"), $e444d6404c095fa5$var$Qo($e444d6404c095fa5$var$_({}, t, {
            Xi: !0
        }));
    } catch (t) {
        $e444d6404c095fa5$var$mi.warn("Beacon send failed", t);
    }
}, $e444d6404c095fa5$var$Zo = (t, e, i, r)=>{
    var s = "query" === r ? "POST" === e ? "sent_at" : "_" : void 0;
    return $e444d6404c095fa5$var$qo(i === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS ? $e444d6404c095fa5$var$Ho(t, "compression") : t, $e444d6404c095fa5$var$_({}, s ? {
        [s]: Date.now().toString()
    } : {}, i === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS ? {} : {
        compression: i
    }));
}, $e444d6404c095fa5$var$ta = [];
$e444d6404c095fa5$var$n && $e444d6404c095fa5$var$ta.push({
    transport: "fetch",
    method: $e444d6404c095fa5$var$Qo
}), $e444d6404c095fa5$var$o && $e444d6404c095fa5$var$ta.push({
    transport: "XHR",
    method (t) {
        var e = $e444d6404c095fa5$var$Go(t);
        if (e) {
            var i = new $e444d6404c095fa5$var$o, r = e.encodedBody;
            i.open(t.method || "GET", e.url, !0);
            var s = null != r ? r : {}, n = s.contentType, a = s.body;
            $e444d6404c095fa5$var$Dr(t.headers, function(t, e) {
                i.setRequestHeader(e, t);
            }), n && i.setRequestHeader("Content-Type", n), t.timeout && (i.timeout = t.timeout), i.onreadystatechange = ()=>{
                if (4 === i.readyState) {
                    var e = {
                        statusCode: i.status,
                        text: i.responseText
                    };
                    if (200 === i.status) try {
                        e.json = JSON.parse(i.responseText);
                    } catch (t) {}
                    null == t.callback || t.callback(e);
                }
            }, i.send(a);
        }
    }
}), null != $e444d6404c095fa5$var$i && $e444d6404c095fa5$var$i.sendBeacon && $e444d6404c095fa5$var$ta.push({
    transport: "sendBeacon",
    method: $e444d6404c095fa5$var$Xo
});
var $e444d6404c095fa5$var$ea = 3e3;
class $e444d6404c095fa5$var$ia {
    constructor(t, e){
        this.tr = !0, this.er = [], this.ir = $e444d6404c095fa5$var$vt((null == e ? void 0 : e.flush_interval_ms) || $e444d6404c095fa5$var$ea, 250, 5e3, $e444d6404c095fa5$var$mi.createLogger("flush interval"), $e444d6404c095fa5$var$ea), this.rr = t;
    }
    enqueue(t) {
        this.er.push(t), this.nr || this.sr();
    }
    unload() {
        this.ar();
        var t = this.er.length > 0 ? this.lr() : {}, e = Object.values(t);
        [
            ...e.filter((t)=>0 === t.url.indexOf("/e")),
            ...e.filter((t)=>0 !== t.url.indexOf("/e"))
        ].map((t)=>{
            this.ur($e444d6404c095fa5$var$_({}, t, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.tr = !1, this.sr();
    }
    sr() {
        var t = this;
        this.tr || (this.nr = setTimeout(()=>{
            if (this.ar(), this.er.length > 0) {
                var e = this.lr(), i = function() {
                    var i = e[r], s = (new Date).getTime();
                    i.data && $e444d6404c095fa5$var$q(i.data) && $e444d6404c095fa5$var$Dr(i.data, (t)=>{
                        t.offset = Math.abs(t.timestamp - s), delete t.timestamp;
                    }), t.ur(i);
                };
                for(var r in e)i();
            }
        }, this.ir));
    }
    ur(t) {
        try {
            this.rr(t);
        } catch (t) {
            $e444d6404c095fa5$var$mi.error(t);
        }
    }
    ar() {
        clearTimeout(this.nr), this.nr = void 0;
    }
    lr() {
        var t = {};
        return $e444d6404c095fa5$var$Dr(this.er, (e)=>{
            var i, r = e, s = (r ? r.batchKey : null) || r.url;
            $e444d6404c095fa5$var$K(t[s]) && (t[s] = $e444d6404c095fa5$var$_({}, r, {
                data: []
            })), null == (i = t[s].data) || i.push(r.data);
        }), this.er = [], t;
    }
}
var $e444d6404c095fa5$var$ra = [
    "retriesPerformedSoFar"
];
class $e444d6404c095fa5$var$sa {
    constructor(e){
        this.hr = !1, this.dr = 3e3, this.er = [], this._instance = e, this.er = [], this.vr = !0, !$e444d6404c095fa5$var$K($e444d6404c095fa5$var$t) && "onLine" in $e444d6404c095fa5$var$t.navigator && (this.vr = $e444d6404c095fa5$var$t.navigator.onLine, this.cr = ()=>{
            this.vr = !0, this.pr();
        }, this.gr = ()=>{
            this.vr = !1;
        }, $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "online", this.cr), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "offline", this.gr));
    }
    get length() {
        return this.er.length;
    }
    retriableRequest(t) {
        var e = t.retriesPerformedSoFar, i = $e444d6404c095fa5$var$g(t, $e444d6404c095fa5$var$ra);
        $e444d6404c095fa5$var$tt(e) && (i.url = $e444d6404c095fa5$var$qo(i.url, {
            retry_count: e
        })), this._instance._send_request($e444d6404c095fa5$var$_({}, i, {
            callback: (t)=>{
                if (200 !== t.statusCode && (400 > t.statusCode || t.statusCode >= 500)) {
                    if ((0 === t.statusCode ? 3 : 10) > (null != e ? e : 0)) return void this.At($e444d6404c095fa5$var$_({
                        retriesPerformedSoFar: e
                    }, i));
                    0 === t.statusCode && $e444d6404c095fa5$var$mi.warn("Request failed before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped retrying after " + (null != e ? e : 0) + " retries.");
                }
                null == i.callback || i.callback(t);
            }
        }));
    }
    At(t) {
        var e = t.retriesPerformedSoFar || 0;
        t.retriesPerformedSoFar = e + 1;
        var i = function(t) {
            var e = 3e3 * Math.pow(2, t), i = e / 2, r = Math.min(18e5, e), s = Math.random() - .5;
            return Math.ceil(r + s * (r - i));
        }(e), r = Date.now() + i;
        this.er.push({
            retryAt: r,
            requestOptions: t
        });
        var s = "Enqueued failed request for retry in " + i;
        navigator.onLine || (s += " (Browser is offline)"), $e444d6404c095fa5$var$mi.warn(s), this.hr || (this.hr = !0, this.mr());
    }
    mr() {
        if (this.yr && clearTimeout(this.yr), 0 === this.er.length) return this.hr = !1, void (this.yr = void 0);
        this.yr = setTimeout(()=>{
            this.vr && this.er.length > 0 && this.pr(), this.mr();
        }, this.dr);
    }
    pr() {
        var t = Date.now(), e = [], i = this.er.filter((i)=>t > i.retryAt || (e.push(i), !1));
        if (this.er = e, i.length > 0) for (var r of i)this.retriableRequest(r.requestOptions);
    }
    unload() {
        for (var e of (this.yr && (clearTimeout(this.yr), this.yr = void 0), this.hr = !1, $e444d6404c095fa5$var$K($e444d6404c095fa5$var$t) || (this.cr && ($e444d6404c095fa5$var$t.removeEventListener("online", this.cr), this.cr = void 0), this.gr && ($e444d6404c095fa5$var$t.removeEventListener("offline", this.gr), this.gr = void 0)), this.er)){
            var i = e.requestOptions;
            try {
                this._instance._send_request($e444d6404c095fa5$var$_({}, i, {
                    transport: "sendBeacon"
                }));
            } catch (t) {
                $e444d6404c095fa5$var$mi.error(t);
            }
        }
        this.er = [];
    }
}
class $e444d6404c095fa5$var$na {
    constructor(t){
        this.br = ()=>{
            var t, e, i, r;
            this._r || (this._r = {});
            var s = this.scrollElement(), n = this.scrollY(), o = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, a = n + ((null == s ? void 0 : s.clientHeight) || 0), l = (null == s ? void 0 : s.scrollHeight) || 0;
            this._r.lastScrollY = Math.ceil(n), this._r.maxScrollY = Math.max(n, null !== (t = this._r.maxScrollY) && void 0 !== t ? t : 0), this._r.maxScrollHeight = Math.max(o, null !== (e = this._r.maxScrollHeight) && void 0 !== e ? e : 0), this._r.lastContentY = a, this._r.maxContentY = Math.max(a, null !== (i = this._r.maxContentY) && void 0 !== i ? i : 0), this._r.maxContentHeight = Math.max(l, null !== (r = this._r.maxContentHeight) && void 0 !== r ? r : 0);
        }, this._instance = t;
    }
    get wr() {
        return this._instance.config.scroll_root_selector;
    }
    getContext() {
        return this._r;
    }
    resetContext() {
        var t = this._r;
        return setTimeout(this.br, 0), t;
    }
    startMeasuringScrollPosition() {
        $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "scroll", this.br, {
            capture: !0
        }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "scrollend", this.br, {
            capture: !0
        }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "resize", this.br);
    }
    scrollElement() {
        if (!this.wr) return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.documentElement;
        var e = $e444d6404c095fa5$var$q(this.wr) ? this.wr : [
            this.wr
        ];
        for (var i of e){
            var r = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.document.querySelector(i);
            if (r) return r;
        }
    }
    kr(e) {
        var i = "y" === e ? "scrollTop" : "scrollLeft";
        if (this.wr) {
            var r = this.scrollElement();
            return r && r[i] || 0;
        }
        return $e444d6404c095fa5$var$t ? "y" === e ? $e444d6404c095fa5$var$t.scrollY || $e444d6404c095fa5$var$t.pageYOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollTop || 0 : $e444d6404c095fa5$var$t.scrollX || $e444d6404c095fa5$var$t.pageXOffset || $e444d6404c095fa5$var$t.document.documentElement.scrollLeft || 0 : 0;
    }
    scrollY() {
        return this.kr("y");
    }
    scrollX() {
        return this.kr("x");
    }
}
var $e444d6404c095fa5$var$oa = (t)=>$e444d6404c095fa5$var$Cn(null == t ? void 0 : t.config.mask_personal_data_properties, null == t ? void 0 : t.config.custom_personal_data_properties, null == t ? void 0 : t.config.disable_capture_url_hashes);
class $e444d6404c095fa5$var$aa {
    constructor(t, e, i, r){
        this.Sr = (t)=>{
            var e = this.Cr();
            if (!e || e.sessionId !== t) {
                var i = {
                    sessionId: t,
                    props: this.Mr(this._instance)
                };
                this.Tr.register({
                    [$e444d6404c095fa5$var$vr]: i
                });
            }
        }, this._instance = t, this.Er = e, this.Tr = i, this.Mr = r || $e444d6404c095fa5$var$oa, this.Er.onSessionId(this.Sr);
    }
    Cr() {
        return this.Tr.props[$e444d6404c095fa5$var$vr];
    }
    getSetOnceProps() {
        var t, e = null == (t = this.Cr()) ? void 0 : t.props;
        return e ? "r" in e ? $e444d6404c095fa5$var$An(e, this._instance.config.disable_capture_url_hashes) : {
            $referring_domain: e.referringDomain,
            $pathname: e.initialPathName,
            utm_source: e.utm_source,
            utm_campaign: e.utm_campaign,
            utm_medium: e.utm_medium,
            utm_content: e.utm_content,
            utm_term: e.utm_term
        } : {};
    }
    getSessionProps() {
        var t = {};
        return $e444d6404c095fa5$var$Dr($e444d6404c095fa5$var$Br(this.getSetOnceProps()), (e, i)=>{
            "$current_url" === i && (i = "url"), t["$session_entry_" + $e444d6404c095fa5$var$L(i)] = e;
        }), t;
    }
}
class $e444d6404c095fa5$var$la {
    on(t, e) {
        return this.Ir[t] || (this.Ir[t] = []), this.Ir[t].push(e), ()=>{
            this.Ir[t] = this.Ir[t].filter((t)=>t !== e);
        };
    }
    emit(t, e) {
        for (var i of this.Ir[t] || [])i(e);
        for (var r of this.Ir["*"] || [])r(t, e);
    }
    constructor(){
        this.Ir = {};
    }
}
var $e444d6404c095fa5$var$ua = $e444d6404c095fa5$var$bi("[SessionId]");
class $e444d6404c095fa5$var$ha {
    on(t, e) {
        return this.Pr.on(t, e);
    }
    constructor(t, e, i){
        var r;
        if (this.Rr = null, this.Ar = [], this.Fr = void 0, this.Lr = !1, this.Pr = new $e444d6404c095fa5$var$la, this.Or = (t, e)=>!(!$e444d6404c095fa5$var$tt(t) || !$e444d6404c095fa5$var$tt(e)) && Math.abs(t - e) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (t.config.cookieless_mode === $e444d6404c095fa5$var$$r) throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
        this.Ne = t.config, this.Tr = t.persistence, this.Dr = void 0, this.$r = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this.Nr = e || $e444d6404c095fa5$var$Xr, this.qr = i || $e444d6404c095fa5$var$Xr;
        var s = this.Ne.persistence_name || this.Ne.token;
        if (this._sessionTimeoutMs = 1e3 * $e444d6404c095fa5$var$vt(this.Ne.session_idle_timeout_seconds || 1800, 60, 36e3, $e444d6404c095fa5$var$ua.createLogger("session_idle_timeout_seconds"), 1800), t.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.jr(), this.Br = "ph_" + s + "_window_id", this.Hr = "ph_" + s + "_primary_window_exists", this.Ur()) {
            var n = $e444d6404c095fa5$var$us.H(this.Br), o = $e444d6404c095fa5$var$us.H(this.Hr);
            n && !o ? this.Dr = n : $e444d6404c095fa5$var$us.q(this.Br), $e444d6404c095fa5$var$us.F(this.Hr, !0);
        }
        if (null != (r = this.Ne.bootstrap) && r.sessionID) try {
            var a = ((t)=>{
                var e = this.Ne.bootstrap.sessionID.replace(/-/g, "");
                if (32 !== e.length) throw new Error("Not a valid UUID");
                if ("7" !== e[12]) throw new Error("Not a UUIDv7");
                return parseInt(e.substring(0, 12), 16);
            })();
            this.zr(this.Ne.bootstrap.sessionID, (new Date).getTime(), a);
        } catch (t) {
            $e444d6404c095fa5$var$ua.error("Invalid sessionID in bootstrap", t);
        }
        this.Wr();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(t) {
        return $e444d6404c095fa5$var$K(this.Ar) && (this.Ar = []), this.Ar.push(t), this.$r && t(this.$r, this.Dr), ()=>{
            this.Ar = this.Ar.filter((e)=>e !== t);
        };
    }
    Ur() {
        return "memory" !== this.Ne.persistence && !this.Tr.xi && $e444d6404c095fa5$var$us.N();
    }
    Vr(t) {
        t !== this.Dr && (this.Dr = t, this.Ur() && $e444d6404c095fa5$var$us.F(this.Br, t));
    }
    Zr() {
        return this.Dr ? this.Dr : this.Ur() ? $e444d6404c095fa5$var$us.H(this.Br) : null;
    }
    Gr(t) {
        var e = this.Rr;
        return !$e444d6404c095fa5$var$Q(e) && !$e444d6404c095fa5$var$Q(t) && 5e3 > Math.abs(t - e);
    }
    zr(t, e, i) {
        var r = e !== this._sessionActivityTimestamp, s = !(t !== this.$r || i !== this._sessionStartTimestamp);
        this._sessionStartTimestamp = i, this._sessionActivityTimestamp = e, this.$r = t, s && !r || s && this.Gr(e) || (this.Rr = e, this.Tr.register({
            [$e444d6404c095fa5$var$zi]: [
                e,
                t,
                i
            ]
        }));
    }
    Qr() {
        var t, e = null == (t = this.Ne) ? void 0 : t.persistence_save_debounce_ms;
        return $e444d6404c095fa5$var$tt(e) && e > 0;
    }
    Kr() {
        this.Qr() ? this.Tr.refreshKey($e444d6404c095fa5$var$zi) : (this.Tr.flush(), this.Tr.load());
    }
    Jr() {
        var t;
        if (!$e444d6404c095fa5$var$Q(this._sessionActivityTimestamp) && this._sessionActivityTimestamp !== this.Rr) {
            this.Kr();
            var e = this.Yr();
            e[1] === this.$r && e[2] === this._sessionStartTimestamp && (this.Rr = this._sessionActivityTimestamp, this.Tr.register({
                [$e444d6404c095fa5$var$zi]: [
                    this._sessionActivityTimestamp,
                    null !== (t = this.$r) && void 0 !== t ? t : null,
                    this._sessionStartTimestamp
                ]
            }), this.Tr.flush());
        }
    }
    Xr() {
        var t = this.Yr()[0], e = $e444d6404c095fa5$var$tt(t) ? t : 0, i = $e444d6404c095fa5$var$tt(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
        return Math.max(e, i);
    }
    tn(t) {
        return this.Kr(), this.Or(t, this.Xr());
    }
    Yr() {
        var t = this.Tr.props[$e444d6404c095fa5$var$zi];
        return $e444d6404c095fa5$var$q(t) && 2 === t.length && t.push(t[0]), t || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this.Rr = null, clearTimeout(this.en), this.en = void 0, this.zr(null, null, null);
    }
    destroy() {
        this.Lr = !0, this.Jr(), clearTimeout(this.en), this.en = void 0, this.Fr && $e444d6404c095fa5$var$t && ($e444d6404c095fa5$var$t.removeEventListener($e444d6404c095fa5$var$Or, this.Fr, {
            capture: !1
        }), this.Fr = void 0), this.Ar = [];
    }
    Wr() {
        this.Fr = ()=>{
            this.Jr(), this.Ur() && $e444d6404c095fa5$var$us.q(this.Hr);
        }, $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, $e444d6404c095fa5$var$Or, this.Fr, {
            capture: !1
        });
    }
    checkAndGetSessionAndWindowId(t, e) {
        if (void 0 === t && (t = !1), void 0 === e && (e = null), this.Ne.cookieless_mode === $e444d6404c095fa5$var$$r) throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
        var i = e || (new Date).getTime(), r = this.Yr(), s = r[1], n = r[2], o = this.Xr(), a = this.Zr(), l = $e444d6404c095fa5$var$tt(n) && Math.abs(i - n) > 864e5, u = !1, h = !1, d = !s, v = s, c = !d && !t && this.Or(i, o);
        if (c) {
            (c = this.tn(i)) || $e444d6404c095fa5$var$ua.info("cross-tab refresh kept the session alive", {
                sessionId: s
            });
            var f = this.Yr();
            s = f[1], n = f[2];
        }
        d || c || l ? (s = this.Nr(), a = this.qr(), $e444d6404c095fa5$var$ua.info("new session ID generated", {
            sessionId: s,
            windowId: a,
            changeReason: {
                noSessionId: d,
                activityTimeout: c,
                sessionPastMaximumLength: l
            }
        }), n = i, u = !0) : (a || (a = this.qr(), u = !0), (h = s !== v) && ($e444d6404c095fa5$var$ua.info("adopted cross-tab session id", {
            sessionId: s,
            windowId: a
        }), u = !0));
        var p = $e444d6404c095fa5$var$tt(o) && t && !l ? o : i, _ = $e444d6404c095fa5$var$tt(n) ? n : (new Date).getTime();
        this.Vr(a), this.zr(s, p, _), t || this.jr();
        var g = {
            noSessionId: d,
            activityTimeout: c,
            sessionPastMaximumLength: l,
            crossTabAdoption: h
        };
        return u && this.Ar.forEach((t)=>t(s, a, g)), {
            sessionId: s,
            windowId: a,
            sessionStartTimestamp: _,
            changeReason: u ? g : void 0,
            lastActivityTimestamp: o
        };
    }
    jr() {
        this.Lr || (clearTimeout(this.en), this.en = setTimeout(()=>{
            if (!this.Lr) {
                if (this.tn((new Date).getTime())) {
                    var t = this.$r;
                    this.resetSessionId(), this.Pr.emit("forcedIdleReset", {
                        idleSessionId: t
                    });
                } else this.jr();
            }
        }, 1.1 * this.sessionTimeoutMs));
    }
}
var $e444d6404c095fa5$var$da = function(t, e) {
    if (!t) return !1;
    var i = t.userAgent;
    if (i && $e444d6404c095fa5$var$D(i, e)) return !0;
    try {
        var r = null == t ? void 0 : t.userAgentData;
        if (null != r && r.brands && r.brands.some((t)=>$e444d6404c095fa5$var$D(null == t ? void 0 : t.brand, e))) return !0;
    } catch (t) {}
    return !!t.webdriver;
};
function $e444d6404c095fa5$var$va() {
    return ($e444d6404c095fa5$var$va = $e444d6404c095fa5$var$p(function*() {
        var t = null == $e444d6404c095fa5$var$i ? void 0 : $e444d6404c095fa5$var$i.userAgentData;
        if (null != t && t.getHighEntropyValues) try {
            var e = yield t.getHighEntropyValues([
                "model"
            ]), r = null == e ? void 0 : e.model;
            return $e444d6404c095fa5$var$J(r) && r.length > 0 ? r : void 0;
        } catch (t) {
            return void $e444d6404c095fa5$var$mi.info("Unable to resolve $device_model from userAgentData.getHighEntropyValues", t);
        }
    })).apply(this, arguments);
}
var $e444d6404c095fa5$var$ca = function(t, e) {
    if (!function(t) {
        try {
            new RegExp(t);
        } catch (t) {
            return !1;
        }
        return !0;
    }(e)) return !1;
    try {
        return new RegExp(e).test(t);
    } catch (t) {
        return !1;
    }
};
function $e444d6404c095fa5$var$fa(t, e, i) {
    return $e444d6404c095fa5$var$fn({
        distinct_id: t,
        userPropertiesToSet: e,
        userPropertiesToSetOnce: i
    });
}
var $e444d6404c095fa5$var$pa = {
    exact: (t, e)=>e.some((e)=>t.some((t)=>e === t)),
    is_not: (t, e)=>e.every((e)=>t.every((t)=>e !== t)),
    regex: (t, e)=>e.some((e)=>t.some((t)=>$e444d6404c095fa5$var$ca(e, t))),
    not_regex: (t, e)=>e.every((e)=>t.every((t)=>!$e444d6404c095fa5$var$ca(e, t))),
    icontains: (t, e)=>e.map($e444d6404c095fa5$var$_a).some((e)=>t.map($e444d6404c095fa5$var$_a).some((t)=>e.includes(t))),
    not_icontains: (t, e)=>e.map($e444d6404c095fa5$var$_a).every((e)=>t.map($e444d6404c095fa5$var$_a).every((t)=>!e.includes(t))),
    gt: (t, e)=>e.some((e)=>{
            var i = parseFloat(e);
            return !isNaN(i) && t.some((t)=>i > parseFloat(t));
        }),
    lt: (t, e)=>e.some((e)=>{
            var i = parseFloat(e);
            return !isNaN(i) && t.some((t)=>i < parseFloat(t));
        })
}, $e444d6404c095fa5$var$_a = (t)=>t.toLowerCase();
function $e444d6404c095fa5$var$ga(t, e) {
    return !t || Object.entries(t).every((t)=>{
        var i = t[1], r = null == e ? void 0 : e[t[0]];
        if ($e444d6404c095fa5$var$K(r) || $e444d6404c095fa5$var$Q(r)) return !1;
        var s = [
            String(r)
        ], n = $e444d6404c095fa5$var$pa[i.operator];
        return !!n && n(i.values, s);
    });
}
var $e444d6404c095fa5$var$ma = "custom", $e444d6404c095fa5$var$ba = "i.posthog.com", $e444d6404c095fa5$var$ya = /^\/static\//;
class $e444d6404c095fa5$var$wa {
    constructor(t){
        this.rn = {}, this.instance = t;
    }
    get apiHost() {
        var t = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === t ? "https://us.i.posthog.com" : t;
    }
    get flagsApiHost() {
        var t = this.instance.config.flags_api_host;
        return t ? t.trim().replace(/\/$/, "") : this.apiHost;
    }
    get uiHost() {
        var t, e = null == (t = this.instance.config.ui_host) ? void 0 : t.replace(/\/$/, "");
        return e || (e = this.apiHost.replace("." + $e444d6404c095fa5$var$ba, ".posthog.com")), "https://app.posthog.com" === e ? "https://us.posthog.com" : e;
    }
    get region() {
        return this.rn[this.apiHost] || (this.rn[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : $e444d6404c095fa5$var$ma), this.rn[this.apiHost];
    }
    nn(t) {
        if ($e444d6404c095fa5$var$ya.test(t)) {
            var e = this.instance.config.asset_host;
            if ("string" == typeof e) return e.trim().replace(/\/$/, "") || void 0;
        }
    }
    endpointFor(t, e) {
        if (void 0 === e && (e = ""), e && (e = "/" === e[0] ? e : "/" + e), "ui" === t) return this.uiHost + e;
        if ("flags" === t) return this.flagsApiHost + e;
        if ("assets" === t) {
            var i = this.nn(e);
            if (i) return "" + i + e;
        }
        if (this.region === $e444d6404c095fa5$var$ma) return this.apiHost + e;
        var r = $e444d6404c095fa5$var$ba + e;
        switch(t){
            case "assets":
                return "https://" + this.region + "-assets." + r;
            case "api":
                return "https://" + this.region + "." + r;
        }
    }
}
function $e444d6404c095fa5$var$xa(t) {
    var e;
    return !(null == (e = t.conditions) || null == (e = e.events) || null == (e = e.values) || !e.length);
}
var $e444d6404c095fa5$var$Ea = $e444d6404c095fa5$var$bi("[Surveys]"), $e444d6404c095fa5$var$Sa = "seenSurvey_", $e444d6404c095fa5$var$$a = (t)=>{
    try {
        var e = ((t)=>((t, e)=>"" + $e444d6404c095fa5$var$Sa + function(t) {
                    return t.current_iteration && t.current_iteration > 0 ? t.id + "_" + t.current_iteration : t.id;
                }(e))(0, t))(t);
        if (localStorage.getItem(e)) return;
        localStorage.setItem(e, "true");
    } catch (t) {
        $e444d6404c095fa5$var$Ea.error("Failed to persist survey seen state", t);
    }
}, $e444d6404c095fa5$var$ka = [
    $e444d6404c095fa5$export$22779822dd24228f.Popover,
    $e444d6404c095fa5$export$22779822dd24228f.Widget,
    $e444d6404c095fa5$export$22779822dd24228f.API
], $e444d6404c095fa5$var$Ta = {
    ignoreConditions: !1,
    ignoreDelay: !1,
    displayType: $e444d6404c095fa5$export$a8a66d9d1b857494.Popover
}, $e444d6404c095fa5$var$Ra = $e444d6404c095fa5$var$bi("[PostHog ExternalIntegrations]"), $e444d6404c095fa5$var$Pa = {
    intercom: "intercom-integration",
    crispChat: "crisp-chat-integration"
};
class $e444d6404c095fa5$var$Oa {
    constructor(t){
        this._instance = t;
    }
    ai(t, e) {
        var i;
        null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, t, (t)=>{
            if (t) return $e444d6404c095fa5$var$Ra.error("failed to load script", t);
            e();
        });
    }
    startIfEnabledOrStop() {
        var t = this, e = function() {
            var e, r, s, n = i[0], o = i[1];
            !o || null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (e = e.integrations) && e[n] || t.ai($e444d6404c095fa5$var$Pa[n], ()=>{
                var e;
                null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (e = e.integrations) || null == (e = e[n]) || e.start(t._instance);
            }), !o && null != (r = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (r = r.integrations) && r[n] && (null == (s = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (s = s.integrations) || null == (s = s[n]) || s.stop());
        };
        for (var i of Object.entries(null !== (r = this._instance.config.integrations) && void 0 !== r ? r : {})){
            var r;
            e();
        }
    }
}
class $e444d6404c095fa5$var$Ia {
    constructor(t, e){
        this.rt = t, this.sn = e, this.an = new Map, this.ln = !1;
    }
    add(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            if (e.ln) throw new Error("Cannot add an extension to a disposed ExtensionRuntime");
            if (e.an.has(t.name)) throw new Error('Browser extension "' + t.name + '" is already registered');
            e.an.set(t.name, t);
            try {
                var i = t.setup(e.sn);
                i && (yield i);
            } catch (i) {
                var r = e.an.get(t.name) === t;
                r && e.an.delete(t.name), e.rt.error('Failed to set up browser extension "' + t.name + '"', i), r && e.un(t);
            }
        })();
    }
    dispose() {
        if (!this.ln) {
            this.ln = !0;
            var t = Array.from(this.an.values()).reverse();
            for (var e of (this.an.clear(), t))this.un(e);
        }
    }
    un(t) {
        try {
            var e = null == t.dispose ? void 0 : t.dispose();
            e && $e444d6404c095fa5$var$V(e.then) && e.then(void 0, (e)=>{
                this.rt.error('Failed to dispose browser extension "' + t.name + '"', e);
            });
        } catch (e) {
            this.rt.error('Failed to dispose browser extension "' + t.name + '"', e);
        }
    }
}
class $e444d6404c095fa5$var$Ca {
    constructor(t){
        this._instance = t;
    }
    get(t) {
        var e;
        return null == (e = this._instance.persistence) ? void 0 : e.get_property(t);
    }
    set(t, e) {
        var i;
        null == (i = this._instance.persistence) || i.set_property(t, e);
    }
    remove(t) {
        var e;
        null == (e = this._instance.persistence) || e.unregister(t);
    }
}
var $e444d6404c095fa5$var$Aa = "extensionsRemoteConfig";
class $e444d6404c095fa5$var$Ma {
    constructor(t){
        this.ln = !1, this.instance = t, this.rt = $e444d6404c095fa5$var$mi.createLogger("[BrowserExtensions]"), this.hn = t.dn, this.kv = new $e444d6404c095fa5$var$Ca(t), this.onEvent = (t)=>$e444d6404c095fa5$var$jn(this.instance.on("eventCaptured", (e)=>{
                try {
                    t({
                        event: e.event,
                        properties: e.properties
                    });
                } catch (t) {
                    this.rt.error("Browser extension event listener failed", t);
                }
            })), this.onRemoteConfig = (t)=>{
            if (this.ln) return $e444d6404c095fa5$var$jn(()=>{});
            var e = (e)=>{
                try {
                    t(e);
                } catch (t) {
                    this.rt.error("Browser extension remote config listener failed", t);
                }
            }, i = this.instance.vn.on($e444d6404c095fa5$var$Aa, e);
            return this.hn && e(this.hn), $e444d6404c095fa5$var$jn(i);
        }, this.cn = new $e444d6404c095fa5$var$Ia(this.rt, this);
    }
    get logger() {
        return this.rt;
    }
    get distinctId() {
        return this.instance.get_distinct_id();
    }
    get anonymousId() {
        var t;
        return null !== (t = this.instance.get_property($e444d6404c095fa5$var$Ei)) && void 0 !== t ? t : this.distinctId;
    }
    get groups() {
        return this.instance.getGroups();
    }
    get session() {
        try {
            var t, e, i, r, s = null == (t = this.instance.sessionManager) ? void 0 : t.checkAndGetSessionAndWindowId(!0);
            return {
                sessionId: null !== (e = null == s ? void 0 : s.sessionId) && void 0 !== e ? e : "",
                windowId: null !== (i = null == s ? void 0 : s.windowId) && void 0 !== i ? i : "",
                sessionStartTimestamp: null !== (r = null == s ? void 0 : s.sessionStartTimestamp) && void 0 !== r ? r : 0
            };
        } catch (t) {
            return {
                sessionId: "",
                windowId: "",
                sessionStartTimestamp: 0
            };
        }
    }
    get projectToken() {
        return this.instance.config.token;
    }
    add(t) {
        return this.cn.add(t);
    }
    capture(t, e, i) {
        var r = this;
        return $e444d6404c095fa5$var$p(function*() {
            i ? r.instance.capture(t, e, {
                timestamp: i.timestamp,
                uuid: i.uuid,
                $set: i.set,
                $set_once: i.setOnce
            }) : r.instance.capture(t, e);
        })();
    }
    registerDynamicEventProperties(t) {
        return $e444d6404c095fa5$var$jn(this.instance.fn(t));
    }
    handleRemoteConfig(t) {
        this.ln || (this.hn = t, this.instance.vn.emit($e444d6404c095fa5$var$Aa, t));
    }
    sendRequest(t, e) {
        var i = this;
        return $e444d6404c095fa5$var$p(function*() {
            var r;
            void 0 === e && (e = {});
            var s = i.instance.requestRouter.endpointFor(null !== (r = e.target) && void 0 !== r ? r : "api", t), n = {
                method: e.method,
                url: e.query ? $e444d6404c095fa5$var$qo(s, e.query) : s,
                data: e.body,
                headers: e.headers,
                timeout: e.timeoutMs,
                fireCallbackOnDrop: !0,
                transport: e.transport
            };
            return "sendBeacon" === e.transport ? (i.instance._send_request(n), {
                statusCode: 202
            }) : new Promise((t)=>{
                n.callback = t, i.instance._send_request(n);
            });
        })();
    }
    dispose() {
        this.ln || (this.ln = !0, this.cn.dispose());
    }
}
var $e444d6404c095fa5$var$Fa = {}, $e444d6404c095fa5$var$Da = 0, $e444d6404c095fa5$var$Na = ()=>{}, $e444d6404c095fa5$var$Ua = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', $e444d6404c095fa5$var$La = "Surveys module not available", $e444d6404c095fa5$var$ja = "sanitize_properties is deprecated. Use before_send instead", $e444d6404c095fa5$var$Ba = "Invalid value for property_denylist config: ", $e444d6404c095fa5$var$za = [
    "token",
    "distinct_id",
    $e444d6404c095fa5$var$br
], $e444d6404c095fa5$var$Ha = "posthog", $e444d6404c095fa5$var$qa = !$e444d6404c095fa5$var$jo && -1 === (null == $e444d6404c095fa5$var$u ? void 0 : $e444d6404c095fa5$var$u.indexOf("MSIE")) && -1 === (null == $e444d6404c095fa5$var$u ? void 0 : $e444d6404c095fa5$var$u.indexOf("Mozilla")), $e444d6404c095fa5$var$Va = (e)=>{
    var i;
    return $e444d6404c095fa5$var$_({
        api_host: "https://us.i.posthog.com",
        flags_api_host: null,
        ui_host: null,
        asset_host: null,
        token: "",
        autocapture: !0,
        cross_subdomain_cookie: $e444d6404c095fa5$var$Hr(null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.location),
        persistence: "localStorage+cookie",
        persistence_name: "",
        cookie_persisted_properties: [],
        loaded: $e444d6404c095fa5$var$Na,
        save_campaign_params: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageleave: "if_capture_pageview",
        defaults: null != e ? e : "unset",
        __preview_deferred_init_extensions: !1,
        __preview_external_dependency_versioned_paths: !1,
        __preview_cookie_wins_on_conflict: !1,
        debug: $e444d6404c095fa5$var$s && $e444d6404c095fa5$var$J(null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.search) && -1 !== $e444d6404c095fa5$var$s.search.indexOf("__posthog_debug=true") || !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        disable_surveys_automatic_display: !1,
        disable_conversations: !1,
        disable_product_tours: !1,
        disableDeviceModel: !1,
        disable_external_dependency_loading: !1,
        strict_script_versioning: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == $e444d6404c095fa5$var$t || null == (i = $e444d6404c095fa5$var$t.location) ? void 0 : i.protocol),
        ip: !1,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        consent_persistence_name: null,
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        request_batching: !0,
        properties_string_max_length: 65535,
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        mask_personal_data_properties: !1,
        custom_personal_data_properties: [],
        advanced_disable_flags: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_only_evaluate_survey_feature_flags: !1,
        advanced_feature_flags_dedup_per_session: !1,
        advanced_enable_surveys: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        surveys_request_timeout_ms: 1e4,
        on_request_error (t) {
            $e444d6404c095fa5$var$mi.error("Bad HTTP status: " + t.statusCode + " " + t.text);
        },
        get_device_id: (t)=>t,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: $e444d6404c095fa5$var$Rr,
        before_send: void 0,
        get_current_url: void 0,
        request_queue_config: {
            flush_interval_ms: $e444d6404c095fa5$var$ea
        },
        error_tracking: {},
        _onCapture: $e444d6404c095fa5$var$Na
    }, ((t)=>({
            rageclick: t && t >= "2026-05-30" ? {
                content_ignorelist: $e444d6404c095fa5$var$As,
                ignore_text_selection: !0
            } : !t || "2025-11-30" > t || {
                content_ignorelist: !0
            },
            capture_pageview: !t || "2025-05-24" > t || "history_change",
            session_recording: t && t >= "2026-06-25" ? {
                strictMinimumDuration: !0,
                canvasCapture: {
                    resolutionScale: .6
                },
                streamNetworkBody: !0
            } : t && t >= "2026-05-30" ? {
                strictMinimumDuration: !0,
                canvasCapture: {
                    resolutionScale: .6
                }
            } : t && t >= "2025-11-30" ? {
                strictMinimumDuration: !0
            } : {},
            external_scripts_inject_target: t && t >= "2026-01-30" ? "head" : "body",
            internal_or_test_user_hostname: t && t >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0,
            persistence_save_debounce_ms: t && t >= "2026-05-30" ? 250 : 0,
            split_storage: !(!t || "2026-05-30" > t),
            detect_google_search_app: !(!t || "2026-05-30" > t),
            disable_capture_url_hashes: !(!t || "2026-06-25" > t)
        }))(e));
}, $e444d6404c095fa5$var$Wa = [
    [
        "process_person",
        "person_profiles"
    ],
    [
        "xhr_headers",
        "request_headers"
    ],
    [
        "cookie_name",
        "persistence_name"
    ],
    [
        "disable_cookie",
        "disable_persistence"
    ],
    [
        "__preview_disable_beacon",
        "disable_beacon"
    ],
    [
        "store_google",
        "save_campaign_params"
    ],
    [
        "verbose",
        "debug"
    ]
], $e444d6404c095fa5$var$Ga = (t)=>{
    var e = {};
    for (var i of $e444d6404c095fa5$var$Wa){
        var r = i[0], s = i[1];
        $e444d6404c095fa5$var$K(t[r]) || (e[s] = t[r]);
    }
    var n = $e444d6404c095fa5$var$Nr({}, e, t), o = t.__preview_external_dependency_versioned_paths;
    return $e444d6404c095fa5$var$K(o) || ($e444d6404c095fa5$var$K(t.strict_script_versioning) && (n.strict_script_versioning = !!o), $e444d6404c095fa5$var$J(o) && $e444d6404c095fa5$var$K(t.asset_host) && (n.asset_host = o)), $e444d6404c095fa5$var$q(t.property_blacklist) && ($e444d6404c095fa5$var$K(t.property_denylist) ? n.property_denylist = t.property_blacklist : $e444d6404c095fa5$var$q(t.property_denylist) ? n.property_denylist = [
        ...t.property_blacklist,
        ...t.property_denylist
    ] : $e444d6404c095fa5$var$mi.error($e444d6404c095fa5$var$Ba + t.property_denylist)), n;
};
class $e444d6404c095fa5$var$Ka {
    constructor(){
        this.__forceAllowLocalhost = !1;
    }
    get pn() {
        return this.__forceAllowLocalhost;
    }
    set pn(t) {
        $e444d6404c095fa5$var$mi.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
    }
}
class $e444d6404c095fa5$export$a9d6b9cbf49b8241 {
    gn(t, e) {
        if (t) {
            var i = this.an.indexOf(t);
            -1 !== i && this.an.splice(i, 1);
        }
        return this.an.push(e), null == e.initialize || e.initialize(), e;
    }
    mn() {
        return this.config.cookieless_mode === $e444d6404c095fa5$var$$r || this.config.cookieless_mode === $e444d6404c095fa5$var$Sr && this.consent.isRejected();
    }
    get decideEndpointWasHit() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.hasLoadedFlags) && void 0 !== t && t;
    }
    get flagsEndpointWasHit() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.hasLoadedFlags) && void 0 !== t && t;
    }
    constructor(){
        var t;
        this.webPerformance = new $e444d6404c095fa5$var$Ka, this.yn = !1, this.version = $e444d6404c095fa5$var$c.LIB_VERSION, this.bn = new Set, this._n = "", this.vn = new $e444d6404c095fa5$var$la, this.an = [], this.wn = [], this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = $e444d6404c095fa5$var$Va(), this.SentryIntegration = $e444d6404c095fa5$var$ln, this.sentryIntegration = (t)=>(function(t, e) {
                var i = $e444d6404c095fa5$var$an(t, e);
                return {
                    name: $e444d6404c095fa5$var$on,
                    processEvent: (t)=>i(t)
                };
            })(this, t), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.kn = !1, this.xn = null, this.Sn = null, this.Cn = null, this.scrollManager = new $e444d6404c095fa5$var$na(this), this.pageViewManager = new $e444d6404c095fa5$var$un(this), this.rateLimiter = new $e444d6404c095fa5$var$ro(this), this.requestRouter = new $e444d6404c095fa5$var$wa(this), this.consent = new $e444d6404c095fa5$var$hs(this), this.externalIntegrations = new $e444d6404c095fa5$var$Oa(this);
        var e = null !== (t = $e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses) && void 0 !== t ? t : {};
        this.featureFlags = e.featureFlags && new e.featureFlags(this), this.toolbar = e.toolbar && new e.toolbar(this), this.surveys = e.surveys && new e.surveys(this), this.conversations = e.conversations && new e.conversations(this), this.logs = e.logs && new e.logs(this), this.metrics = e.metrics && new e.metrics(this), this.experiments = e.experiments && new e.experiments(this), this.exceptions = e.exceptions && new e.exceptions(this), this.people = {
            set: (t, e, i)=>{
                var r = $e444d6404c095fa5$var$J(t) ? {
                    [t]: e
                } : t;
                this.setPersonProperties(r), null == i || i({});
            },
            set_once: (t, e, i)=>{
                var r = $e444d6404c095fa5$var$J(t) ? {
                    [t]: e
                } : t;
                this.setPersonProperties(void 0, r), null == i || i({});
            }
        }, this.on("eventCaptured", (t)=>$e444d6404c095fa5$var$mi.info('send "' + (null == t ? void 0 : t.event) + '"', t));
    }
    init(t, e, i) {
        if (i && i !== $e444d6404c095fa5$var$Ha) {
            var r, s = null !== (r = $e444d6404c095fa5$var$Fa[i]) && void 0 !== r ? r : new $e444d6404c095fa5$export$a9d6b9cbf49b8241;
            return s._init(t, e, i), $e444d6404c095fa5$var$Fa[i] = s, $e444d6404c095fa5$var$Fa[$e444d6404c095fa5$var$Ha][i] = s, s;
        }
        return this._init(t, e, i);
    }
    _init(e, i, r) {
        var s, n;
        void 0 === i && (i = {});
        var o, a = $e444d6404c095fa5$var$J(e) ? e.trim() : "";
        if (!a) return $e444d6404c095fa5$var$mi.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return a !== (null == (o = this.config) ? void 0 : o.token) ? console.warn("[PostHog.js]", "You have already initialized PostHog with a different project token! Re-initializing is a no-op, so events will keep going to the project this instance was initialized with. To capture into a second project, load PostHog once, then initialize a named instance after the SDK has loaded, e.g. posthog.init('" + a + "', { ... }, 'project2')") : console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = $e444d6404c095fa5$var$Va(i.defaults), i.debug = this.Mn(i.debug), this.Tn = i, this.En = [], i.person_profiles ? this.Sn = i.person_profiles : i.process_person && (this.Sn = i.process_person);
        var l = $e444d6404c095fa5$var$Va(i.defaults), u = $e444d6404c095fa5$var$Ga(i), h = $e444d6404c095fa5$var$Nr({}, l, u, {
            name: r,
            token: a
        });
        $e444d6404c095fa5$var$W(l.rageclick) && $e444d6404c095fa5$var$W(u.rageclick) && (h.rageclick = $e444d6404c095fa5$var$Nr({}, l.rageclick, u.rageclick)), $e444d6404c095fa5$var$W(l.session_recording) && $e444d6404c095fa5$var$W(u.session_recording) && (h.session_recording = $e444d6404c095fa5$var$Nr({}, l.session_recording, u.session_recording)), this.set_config(h), this.config.on_xhr_error && $e444d6404c095fa5$var$mi.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = i.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS;
        var d = this.In();
        if (this.persistence = new $e444d6404c095fa5$var$Ln(this.config, d), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Ln($e444d6404c095fa5$var$_({}, this.config, {
            persistence: "sessionStorage"
        }), d, !1), this._n = "ph_" + (this.config.persistence_name || this.config.token) + "_session_registered_properties", "memory" !== this.config.persistence && !d && $e444d6404c095fa5$var$us.N()) {
            var v = $e444d6404c095fa5$var$us.H(this._n);
            $e444d6404c095fa5$var$q(v) && v.forEach((t)=>{
                $e444d6404c095fa5$var$J(t) && this.bn.add(t);
            });
        } else $e444d6404c095fa5$var$us.q(this._n);
        var f = $e444d6404c095fa5$var$_({}, this.persistence.props), p = $e444d6404c095fa5$var$_({}, this.sessionPersistence.props);
        this.register({
            $initialization_time: (new Date).toISOString()
        }), this.Pn = new $e444d6404c095fa5$var$ia((t)=>this.Rn(t), this.config.request_queue_config), this.An = new $e444d6404c095fa5$var$sa(this), this.__request_queue = [];
        var g = this.mn();
        if (g || (this.sessionManager = new $e444d6404c095fa5$var$ha(this), this.sessionPropsManager = new $e444d6404c095fa5$var$aa(this, this.sessionManager, this.persistence), this.sessionManager.onSessionId((t, e, i)=>{
            (null != i && i.activityTimeout || null != i && i.sessionPastMaximumLength || null != i && i.crossTabAdoption) && this.Fn();
        })), this.config.__preview_deferred_init_extensions ? ($e444d6404c095fa5$var$mi.info("Deferring extension initialization to improve startup performance"), setTimeout(()=>{
            this.Ln(g);
        }, 0)) : ($e444d6404c095fa5$var$mi.info("Initializing extensions synchronously"), this.Ln(g)), $e444d6404c095fa5$var$c.DEBUG = $e444d6404c095fa5$var$c.DEBUG || this.config.debug, $e444d6404c095fa5$var$c.DEBUG && $e444d6404c095fa5$var$mi.info("Starting in debug mode", {
            this: this,
            config: i,
            thisC: $e444d6404c095fa5$var$_({}, this.config),
            p: f,
            s: p
        }), !this.config.identity_distinct_id || null != (s = i.bootstrap) && s.distinctID || (i.bootstrap = $e444d6404c095fa5$var$_({}, i.bootstrap, {
            distinctID: this.config.identity_distinct_id,
            isIdentifiedID: !0
        })), void 0 !== (null == (n = i.bootstrap) ? void 0 : n.distinctID)) {
            var m = i.bootstrap.distinctID, b = this.get_distinct_id(), y = this.persistence.get_property($e444d6404c095fa5$var$dr);
            if (i.bootstrap.isIdentifiedID && null != b && b !== m && y === $e444d6404c095fa5$var$kr) this.identify(m);
            else if (i.bootstrap.isIdentifiedID && null != b && b !== m && y === $e444d6404c095fa5$var$Tr) $e444d6404c095fa5$var$mi.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
            else {
                var w = this.config.get_device_id($e444d6404c095fa5$var$Xr()), x = i.bootstrap.isIdentifiedID ? w : m;
                this.persistence.set_property($e444d6404c095fa5$var$dr, i.bootstrap.isIdentifiedID ? $e444d6404c095fa5$var$Tr : $e444d6404c095fa5$var$kr), this.register({
                    distinct_id: m,
                    $device_id: x
                });
            }
        }
        if (g) this.register_once({
            distinct_id: $e444d6404c095fa5$var$mr,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var E = this.config.get_device_id($e444d6404c095fa5$var$Xr());
            this.register_once({
                distinct_id: E,
                $device_id: E
            }, ""), this.persistence.set_property($e444d6404c095fa5$var$dr, $e444d6404c095fa5$var$kr);
        }
        return $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), {
            passive: !1
        }), i.segment ? function(t, e) {
            var i = t.config.segment;
            if (!i) return e();
            !function(t, e) {
                var i = t.config.segment;
                if (!i) return e();
                var r = (i)=>{
                    var r = ()=>i.anonymousId() || $e444d6404c095fa5$var$Xr();
                    t.config.get_device_id = r, i.id() && (t.register({
                        distinct_id: i.id(),
                        $device_id: r()
                    }), t.persistence.set_property($e444d6404c095fa5$var$dr, $e444d6404c095fa5$var$Tr)), e();
                }, s = i.user();
                "then" in s && $e444d6404c095fa5$var$V(s.then) ? s.then(r) : r(s);
            }(t, ()=>{
                i.register(((t)=>{
                    "undefined" != typeof Promise && Promise.resolve || $e444d6404c095fa5$var$nn.warn("This browser does not have Promise support, and can not use the segment integration");
                    var e = (e, i)=>{
                        if (!i) return e;
                        e.event.userId || e.event.anonymousId === t.get_distinct_id() || ($e444d6404c095fa5$var$nn.info("No userId set, resetting PostHog"), t.reset()), e.event.userId && e.event.userId !== t.get_distinct_id() && ($e444d6404c095fa5$var$nn.info("UserId set, identifying with PostHog"), t.identify(e.event.userId));
                        var r = t.calculateEventProperties(i, e.event.properties);
                        return e.event.properties = Object.assign({}, r, e.event.properties), e;
                    };
                    return {
                        name: "PostHog JS",
                        type: "enrichment",
                        version: "1.0.0",
                        isLoaded: ()=>!0,
                        load: ()=>Promise.resolve(),
                        track: (t)=>e(t, t.event.event),
                        page: (t)=>e(t, $e444d6404c095fa5$var$Ir),
                        identify: (t)=>e(t, $e444d6404c095fa5$var$Ar),
                        screen: (t)=>e(t, "$screen")
                    };
                })(t)).then(()=>{
                    e();
                });
            });
        }(this, ()=>this.On()) : this.On(), $e444d6404c095fa5$var$V(this.config._onCapture) && this.config._onCapture !== $e444d6404c095fa5$var$Na && ($e444d6404c095fa5$var$mi.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (t)=>this.config._onCapture(t.event, t))), this.config.ip && $e444d6404c095fa5$var$mi.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this.config.disableDeviceModel || (function() {
            return $e444d6404c095fa5$var$va.apply(this, arguments);
        })().then((t)=>{
            t && this.register({
                [$e444d6404c095fa5$var$Si]: t
            });
        }).catch($e444d6404c095fa5$var$Na), this;
    }
    Ln(t) {
        var e, i, r, s, n, o, a, l, u = performance.now(), h = $e444d6404c095fa5$var$_({}, $e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses, this.config.__extensionClasses), d = [];
        h.featureFlags && this.an.push(this.featureFlags = null !== (e = this.featureFlags) && void 0 !== e ? e : new h.featureFlags(this)), h.exceptions && this.an.push(this.exceptions = null !== (i = this.exceptions) && void 0 !== i ? i : new h.exceptions(this)), h.historyAutocapture && this.an.push(this.historyAutocapture = new h.historyAutocapture(this)), h.tracingHeaders && this.an.push(this.tracingHeaders = new h.tracingHeaders(this)), h.siteApps && this.an.push(this.siteApps = new h.siteApps(this)), h.sessionRecording && !t && this.an.push(this.sessionRecording = new h.sessionRecording(this)), this.config.disable_scroll_properties || d.push(()=>{
            this.scrollManager.startMeasuringScrollPosition();
        }), h.autocapture && this.an.push(this.autocapture = new h.autocapture(this)), h.surveys && this.an.push(this.surveys = null !== (r = this.surveys) && void 0 !== r ? r : new h.surveys(this)), h.logs && this.an.push(this.logs = null !== (s = this.logs) && void 0 !== s ? s : new h.logs(this)), h.metrics && this.an.push(this.metrics = null !== (n = this.metrics) && void 0 !== n ? n : new h.metrics(this)), h.conversations && this.an.push(this.conversations = null !== (o = this.conversations) && void 0 !== o ? o : new h.conversations(this)), h.productTours && this.an.push(this.productTours = new h.productTours(this)), h.heatmaps && this.an.push(this.heatmaps = new h.heatmaps(this)), h.webVitalsAutocapture && this.an.push(this.webVitalsAutocapture = new h.webVitalsAutocapture(this)), h.exceptionObserver && this.an.push(this.exceptionObserver = new h.exceptionObserver(this)), h.deadClicksAutocapture && this.an.push(this.deadClicksAutocapture = new h.deadClicksAutocapture(this, $e444d6404c095fa5$var$rn)), h.toolbar && this.an.push(this.toolbar = null !== (a = this.toolbar) && void 0 !== a ? a : new h.toolbar(this)), h.experiments && this.an.push(this.experiments = null !== (l = this.experiments) && void 0 !== l ? l : new h.experiments(this)), this.an.forEach((t)=>{
            t.initialize && d.push(()=>{
                null == t.initialize || t.initialize();
            });
        }), d.push(()=>{
            if (this.Dn) {
                var t = this.Dn;
                this.Dn = void 0, this.an.forEach((e)=>null == e.onRemoteConfig ? void 0 : e.onRemoteConfig(t));
            }
        }), this.$n(d, u);
    }
    $n(t, e) {
        for(; t.length > 0;){
            if (this.config.__preview_deferred_init_extensions && performance.now() - e >= 30 && t.length > 0) return void setTimeout(()=>{
                this.$n(t, e);
            }, 0);
            var i = t.shift();
            if (i) try {
                i();
            } catch (t) {
                $e444d6404c095fa5$var$mi.error("Error initializing extension:", t);
            }
        }
        var r = Math.round(performance.now() - e);
        this.register_for_session({
            [$e444d6404c095fa5$var$yr]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous",
            [$e444d6404c095fa5$var$wr]: r
        }), this.config.__preview_deferred_init_extensions && $e444d6404c095fa5$var$mi.info("PostHog extensions initialized (" + r + "ms)");
    }
    Gi(t) {
        var e;
        if (!$e444d6404c095fa5$var$r || !$e444d6404c095fa5$var$r.body) return $e444d6404c095fa5$var$mi.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this.Gi(t);
        }, 500);
        if (this.config.__preview_deferred_init_extensions && (this.Dn = t), this.dn = t, this.compression = void 0, t.ok) {
            var i, s = t.config;
            s.supportedCompression && !this.config.disable_compression && (this.compression = $e444d6404c095fa5$var$N(s.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS) ? $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS : $e444d6404c095fa5$var$N(s.supportedCompression, $e444d6404c095fa5$export$6a00d17b5aff0af.Base64) ? $e444d6404c095fa5$export$6a00d17b5aff0af.Base64 : void 0), null != (i = s.analytics) && i.endpoint && (this.analyticsDefaultEndpoint = s.analytics.endpoint);
        }
        this.set_config({
            person_profiles: this.Sn ? this.Sn : $e444d6404c095fa5$var$Rr
        }), null == (e = this.Nn) || e.handleRemoteConfig(t), this.an.forEach((e)=>null == e.onRemoteConfig ? void 0 : e.onRemoteConfig(t));
    }
    On() {
        try {
            this.config.loaded(this);
        } catch (t) {
            $e444d6404c095fa5$var$mi.critical("`loaded` function failed", t);
        }
        if (this.qn(), this.config.internal_or_test_user_hostname && null != $e444d6404c095fa5$var$s && $e444d6404c095fa5$var$s.hostname) {
            var t = $e444d6404c095fa5$var$s.hostname, e = this.config.internal_or_test_user_hostname;
            ("string" == typeof e ? t === e : e.test(t)) && this.setInternalOrTestUser();
        }
        this.config.capture_pageview && setTimeout(()=>{
            (this.consent.isOptedIn() || this.mn()) && this.jn();
        }, 1), this.Bn = new $e444d6404c095fa5$var$no(this), this.Bn.load();
    }
    qn() {
        var t;
        this.is_capturing() && this.config.request_batching && (null == (t = this.Pn) || t.enable());
    }
    _dom_loaded() {
        this.is_capturing() && $e444d6404c095fa5$var$Fr(this.__request_queue, (t)=>this.Rn(t)), this.__request_queue = [], this.qn();
    }
    _handle_unload() {
        var t, e, i, r, s;
        null == (t = this.surveys) || null == t.handlePageUnload || t.handlePageUnload(), null == (e = this.metrics) || e.flush("sendBeacon"), this.config.request_batching ? (this.Hn() && this.capture($e444d6404c095fa5$var$Cr), null == (i = this.logs) || i.flushLogs("sendBeacon"), null == (r = this.Pn) || r.unload(), null == (s = this.An) || s.unload()) : this.Hn() && this.capture($e444d6404c095fa5$var$Cr, null, {
            transport: "sendBeacon"
        });
    }
    _send_request(t) {
        this.__loaded ? $e444d6404c095fa5$var$qa ? this.__request_queue.push(t) : this.rateLimiter.isServerRateLimited(t.batchKey) ? t.fireCallbackOnDrop && (null == t.callback || t.callback({
            statusCode: 429
        })) : (t.transport = t.transport || this.config.api_transport, t.headers = $e444d6404c095fa5$var$_({}, this.config.request_headers, t.headers), t.compression = "best-available" === t.compression ? this.compression : t.compression, ($e444d6404c095fa5$var$K(this.config.disable_beacon) ? this.config.__preview_disable_beacon : this.config.disable_beacon) && (t.disableTransport = [
            "sendBeacon"
        ]), t.fetchOptions = t.fetchOptions || this.config.fetch_options, ((t)=>{
            var e, i, r, s = $e444d6404c095fa5$var$_({}, t);
            s.timeout = s.timeout || 6e4;
            var n, o, a, u, h, d = null !== (e = s.transport) && void 0 !== e ? e : "fetch";
            "sendBeacon" === d && $e444d6404c095fa5$var$K(s.compression) && s.data && (s.compression = $e444d6404c095fa5$export$6a00d17b5aff0af.Base64), "POST" === s.method && s.data && ("capture-body" === s.timestampMode ? s.data = {
                api_key: null !== (o = null == (h = (u = $e444d6404c095fa5$var$q(n = s.data) ? n : [
                    n
                ])[0]) || null == (a = h.properties) ? void 0 : a.token) && void 0 !== o ? o : null == h ? void 0 : h.token,
                batch: u,
                sent_at: (new Date).toISOString()
            } : "body" === s.timestampMode && (s.data = function(t, e) {
                return void 0 === e && (e = (new Date).toISOString()), $e444d6404c095fa5$var$q(t) ? t.map((t)=>$e444d6404c095fa5$var$_({}, t, {
                        sent_at: e
                    })) : $e444d6404c095fa5$var$_({}, t, {
                    sent_at: e
                });
            }(s.data))), s.url = $e444d6404c095fa5$var$Zo(s.url, s.method, s.compression, s.timestampMode);
            var v = $e444d6404c095fa5$var$ta.filter((t)=>!s.disableTransport || !t.transport || !s.disableTransport.includes(t.transport)), c = null !== (i = null == (r = function(t, e) {
                for(var i = 0; t.length > i; i++)if (t[i].transport === d) return t[i];
            }(v)) ? void 0 : r.method) && void 0 !== i ? i : v[0].method;
            if (!c) throw new Error("No available transport method");
            var f = (t)=>{
                try {
                    c(t);
                } catch (t) {
                    $e444d6404c095fa5$var$Yo(t) ? $e444d6404c095fa5$var$mi.warn(t) : $e444d6404c095fa5$var$mi.error(t), null == s.callback || s.callback({
                        statusCode: 0,
                        error: t
                    });
                }
            };
            "sendBeacon" !== d && s.data && s.compression === $e444d6404c095fa5$export$6a00d17b5aff0af.GZipJS && $e444d6404c095fa5$var$l && "undefined" != typeof Promise && !$e444d6404c095fa5$var$zo ? $e444d6404c095fa5$var$Ko(s).then((t)=>{
                f(t);
            }).catch((e)=>{
                if ($e444d6404c095fa5$var$I(e)) return $e444d6404c095fa5$var$zo = !0, void f($e444d6404c095fa5$var$_({}, s, {
                    compression: void 0,
                    url: $e444d6404c095fa5$var$Zo(t.url, t.method, void 0, t.timestampMode)
                }));
                ((t)=>{
                    if (!t || "object" != typeof t) return !1;
                    var e = "name" in t ? String(t.name) : "";
                    return $e444d6404c095fa5$var$I(t) || e === $e444d6404c095fa5$var$R;
                })(e) && ($e444d6404c095fa5$var$zo = !0), f(s);
            }) : c(s);
        })($e444d6404c095fa5$var$_({}, t, {
            callback: (e)=>{
                var i, r;
                this.rateLimiter.checkForLimiting(e), 400 > e.statusCode || null == (i = (r = this.config).on_request_error) || i.call(r, e), null == t.callback || t.callback(e);
            }
        }))) : t.fireCallbackOnDrop && (null == t.callback || t.callback({
            statusCode: 0
        }));
    }
    Rn(t) {
        this.An ? this.An.retriableRequest(t) : this._send_request(t);
    }
    _execute_array(t) {
        $e444d6404c095fa5$var$Da++;
        try {
            var e, i = [], r = [], s = [];
            $e444d6404c095fa5$var$Fr(t, (t)=>{
                if (t) {
                    if ($e444d6404c095fa5$var$q(e = t[0])) s.push(t);
                    else if ($e444d6404c095fa5$var$V(t)) try {
                        t.call(this);
                    } catch (e) {
                        $e444d6404c095fa5$var$mi.error("Error executing queued PostHog call", t, e);
                    }
                    else $e444d6404c095fa5$var$q(t) && "alias" === e ? i.push(t) : $e444d6404c095fa5$var$q(t) && -1 !== e.indexOf("capture") && $e444d6404c095fa5$var$V(this[e]) ? s.push(t) : r.push(t);
                }
            });
            var n = function(t, e) {
                $e444d6404c095fa5$var$Fr(t, function(t) {
                    try {
                        if ($e444d6404c095fa5$var$q(t[0])) {
                            var i = e;
                            $e444d6404c095fa5$var$Dr(t, function(t) {
                                i = i[t[0]].apply(i, t.slice(1));
                            });
                        } else e[t[0]].apply(e, t.slice(1));
                    } catch (e) {
                        $e444d6404c095fa5$var$mi.error("Error executing queued PostHog call", t, e);
                    }
                });
            };
            n(i, this), n(r, this), n(s, this);
        } finally{
            $e444d6404c095fa5$var$Da--;
        }
    }
    push(t) {
        if ($e444d6404c095fa5$var$Da > 0 && $e444d6404c095fa5$var$q(t) && $e444d6404c095fa5$var$J(t[0])) {
            var e = $e444d6404c095fa5$export$a9d6b9cbf49b8241.prototype[t[0]];
            $e444d6404c095fa5$var$V(e) && e.apply(this, t.slice(1));
        } else this._execute_array([
            t
        ]);
    }
    capture(t, e, i) {
        var r, s, n, o, a, l, u;
        if (this.__loaded && this.persistence && this.sessionPersistence && this.Pn) {
            if (this.is_capturing()) {
                if (!$e444d6404c095fa5$var$K(t) && $e444d6404c095fa5$var$J(t)) {
                    var h = !this.config.opt_out_useragent_filter && this._is_bot();
                    if (!h || this.config.__preview_capture_bot_pageviews) {
                        var d = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == d || !d.isRateLimited) {
                            if (this.wn.length > 0) {
                                var v = {};
                                for (var c of this.wn.slice())try {
                                    $e444d6404c095fa5$var$Nr(v, c());
                                } catch (t) {
                                    $e444d6404c095fa5$var$mi.error("Failed to produce browser extension event properties", t);
                                }
                                e = $e444d6404c095fa5$var$_({}, v, null != e ? e : {});
                            }
                            var f;
                            null != (r = e) && r.$current_url && !$e444d6404c095fa5$var$J(null == (s = e) ? void 0 : s.$current_url) && ($e444d6404c095fa5$var$mi.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), null == (f = e) || delete f.$current_url), "$exception" !== t || null != i && i.Un || $e444d6404c095fa5$var$mi.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var p = new Date, g = (null == i ? void 0 : i.timestamp) || p, m = $e444d6404c095fa5$var$be(null == i ? void 0 : i.uuid, $e444d6404c095fa5$var$Xr), b = {
                                uuid: m,
                                event: t,
                                properties: this.calculateEventProperties(t, e || {}, g, m)
                            };
                            t === $e444d6404c095fa5$var$Ir && this.config.__preview_capture_bot_pageviews && h && (b.event = "$bot_pageview", b.properties.$browser_type = "bot"), d && (b.properties.$lib_rate_limit_remaining_tokens = d.remainingTokens);
                            var y = "$feature_flag_called" === t && !1 === b.properties.$feature_flag_has_experiment && !0 === this.get_property($e444d6404c095fa5$var$Yi);
                            (null == i ? void 0 : i.$set) && !y && (b.$set = null == i ? void 0 : i.$set);
                            var w = null == i ? void 0 : i.$unset;
                            w && (b.$unset = w);
                            var E, S, k, T = y ? void 0 : this.zn(null == i ? void 0 : i.$set_once, t !== $e444d6404c095fa5$var$Mr, t === $e444d6404c095fa5$var$Ar);
                            if (T && (b.$set_once = T), null != i && i._noTruncate || (o = this.config.properties_string_max_length, a = b, l = (t)=>$e444d6404c095fa5$var$J(t) ? t.slice(0, o) : t, u = new Set, b = function t(e, i) {
                                if (e !== Object(e)) return l ? l(e) : e;
                                if (!u.has(e)) {
                                    var r;
                                    if (u.add(e), $e444d6404c095fa5$var$q(e)) r = [], $e444d6404c095fa5$var$Fr(e, (e)=>{
                                        r.push(t(e));
                                    });
                                    else {
                                        var s = {};
                                        $e444d6404c095fa5$var$Dr(e, (e, i)=>{
                                            u.has(e) || (s[i] = t(e, i));
                                        }), r = s;
                                    }
                                    return r;
                                }
                            }(a)), b.timestamp = g, $e444d6404c095fa5$var$K(null == i ? void 0 : i.timestamp) || (b.properties.$event_time_override_provided = !0, b.properties.$event_time_override_system_time = p), y && (b.properties = function(t, e) {
                                void 0 === e && (e = []);
                                var i = {}, r = (e)=>{
                                    void 0 !== t[e] && (i[e] = t[e]);
                                };
                                return $e444d6404c095fa5$var$x.forEach(r), e.forEach(r), i;
                            }(b.properties, $e444d6404c095fa5$var$za)), t === $e444d6404c095fa5$export$9d7ec1793ca1658e.DISMISSED || t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT) {
                                var R, P, O = null == (R = e) ? void 0 : R[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ID], I = null == (P = e) ? void 0 : P[$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_ITERATION];
                                $e444d6404c095fa5$var$$a({
                                    id: O,
                                    current_iteration: I
                                }), b.$set = $e444d6404c095fa5$var$_({}, b.$set, {
                                    [(E = {
                                        id: O,
                                        current_iteration: I
                                    }, S = t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT ? "responded" : "dismissed", k = "$survey_" + S + "/" + E.id, E.current_iteration && E.current_iteration > 0 && (k = "$survey_" + S + "/" + E.id + "/" + E.current_iteration), k)]: !0
                                });
                            } else t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN && (b.$set = $e444d6404c095fa5$var$_({}, b.$set, {
                                [$e444d6404c095fa5$export$fe4c9af525341543.SURVEY_LAST_SEEN_DATE]: (new Date).toISOString()
                            }));
                            if (t === $e444d6404c095fa5$export$e5d0052c1e47bfda.SHOWN) {
                                var C, A = null == (C = e) ? void 0 : C[$e444d6404c095fa5$export$eedf6d13bc23d767.TOUR_TYPE];
                                A && (b.$set = $e444d6404c095fa5$var$_({}, b.$set, {
                                    [$e444d6404c095fa5$export$eedf6d13bc23d767.TOUR_LAST_SEEN_DATE + "/" + A]: (new Date).toISOString()
                                }));
                            }
                            var M = $e444d6404c095fa5$var$_({}, b.properties.$set, b.$set);
                            if ($e444d6404c095fa5$var$G(M) || this.setPersonPropertiesForFlags(M), !$e444d6404c095fa5$var$X(this.config.before_send)) {
                                var F = this.Pt(b);
                                if (!F) return;
                                (b = F).uuid = $e444d6404c095fa5$var$be(b.uuid, $e444d6404c095fa5$var$Xr);
                            }
                            this.vn.emit("eventCaptured", b);
                            var D = null !== (n = null == i ? void 0 : i._url) && void 0 !== n ? n : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), N = {
                                method: "POST",
                                url: D,
                                data: b,
                                compression: "best-available",
                                timestampMode: "recordings" === (null == i ? void 0 : i._batchKey) || /\/s\/(?:\?|$)/.test(D) ? "body" : "capture-body",
                                batchKey: null == i ? void 0 : i._batchKey,
                                transport: null == i ? void 0 : i.transport
                            };
                            return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this.Rn(N) : this.Pn.enqueue(N), b;
                        }
                        $e444d6404c095fa5$var$mi.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else $e444d6404c095fa5$var$mi.error("No event name provided to posthog.capture");
            }
        } else $e444d6404c095fa5$var$mi.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(t) {
        return this.on("eventCaptured", (e)=>t(e.event, e));
    }
    Wn() {
        var t;
        return null !== (t = this.Nn) && void 0 !== t ? t : this.Nn = new $e444d6404c095fa5$var$Ma(this);
    }
    fn(t) {
        this.wn.push(t);
        var e = !0;
        return ()=>{
            if (e) {
                e = !1;
                var i = this.wn.indexOf(t);
                -1 !== i && this.wn.splice(i, 1);
            }
        };
    }
    calculateEventProperties(e, i, n, o, a) {
        if (n = n || new Date, !this.persistence || !this.sessionPersistence) return i;
        var l = a ? void 0 : this.persistence.remove_event_timer(e), h = $e444d6404c095fa5$var$_({}, i);
        if (h.token = this.config.token, h.$config_defaults = this.config.defaults, this.mn() && (h[$e444d6404c095fa5$var$br] = !0), "$snapshot" === e) {
            var d = $e444d6404c095fa5$var$_({}, this.persistence.properties(), this.sessionPersistence.properties());
            return h.distinct_id = d.distinct_id, (!$e444d6404c095fa5$var$J(h.distinct_id) && !$e444d6404c095fa5$var$Z(h.distinct_id) || $e444d6404c095fa5$var$Y(h.distinct_id)) && $e444d6404c095fa5$var$mi.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), h;
        }
        var v, f = function(e, i, r, n) {
            var o, a, l, h;
            if (void 0 === n && (n = !1), !$e444d6404c095fa5$var$u) return {};
            var d, v = e ? [
                ...$e444d6404c095fa5$var$xn,
                ...i || []
            ] : [], f = function(t) {
                for(var e = 0; $e444d6404c095fa5$var$_e.length > e; e++){
                    var i = $e444d6404c095fa5$var$_e[e], r = i[1], s = i[0].exec(t), n = s && ($e444d6404c095fa5$var$V(r) ? r(s, t) : r);
                    if (n) return n;
                }
                return [
                    "",
                    ""
                ];
            }($e444d6404c095fa5$var$u), p = f[0], _ = f[1], g = null != (d = "undefined" != typeof navigator ? navigator : void 0) && d.brave ? {
                brave: !0
            } : {}, m = {};
            $e444d6404c095fa5$var$K(r) || (m.detectGoogleSearchApp = r);
            var b = {}, y = null == (o = navigator) || null == (o = o.userAgentData) ? void 0 : o.platform, w = null == (a = navigator) ? void 0 : a.maxTouchPoints, x = null == $e444d6404c095fa5$var$t || null == (l = $e444d6404c095fa5$var$t.screen) ? void 0 : l.width, E = null == $e444d6404c095fa5$var$t || null == (h = $e444d6404c095fa5$var$t.screen) ? void 0 : h.height, S = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.devicePixelRatio;
            $e444d6404c095fa5$var$K(y) || (b.userAgentDataPlatform = y), $e444d6404c095fa5$var$K(w) || (b.maxTouchPoints = w), $e444d6404c095fa5$var$K(x) || (b.screenWidth = x), $e444d6404c095fa5$var$K(E) || (b.screenHeight = E), $e444d6404c095fa5$var$K(S) || (b.devicePixelRatio = S);
            var k, T, R, P, O, I, C, A, M = $e444d6404c095fa5$var$Nr($e444d6404c095fa5$var$Br({
                $os: p,
                $os_version: _,
                $browser: $e444d6404c095fa5$var$ce($e444d6404c095fa5$var$u, navigator.vendor, g, m),
                $device: $e444d6404c095fa5$var$ge($e444d6404c095fa5$var$u),
                $device_type: (T = $e444d6404c095fa5$var$u, R = b, A = $e444d6404c095fa5$var$ge(T), A === $e444d6404c095fa5$var$bt || A === $e444d6404c095fa5$var$mt || "Kobo" === A || "Kindle Fire" === A || A === $e444d6404c095fa5$var$Jt ? $e444d6404c095fa5$var$gt : A === $e444d6404c095fa5$var$Ut || A === $e444d6404c095fa5$var$jt || A === $e444d6404c095fa5$var$Lt || A === $e444d6404c095fa5$var$Wt ? "Console" : A === $e444d6404c095fa5$var$wt ? "Wearable" : A ? $e444d6404c095fa5$var$ft : "Android" === (null == R ? void 0 : R.userAgentDataPlatform) && (null !== (P = null == R ? void 0 : R.maxTouchPoints) && void 0 !== P ? P : 0) > 0 ? 600 > Math.min(null !== (O = null == R ? void 0 : R.screenWidth) && void 0 !== O ? O : 0, null !== (I = null == R ? void 0 : R.screenHeight) && void 0 !== I ? I : 0) / (null !== (C = null == R ? void 0 : R.devicePixelRatio) && void 0 !== C ? C : 1) ? $e444d6404c095fa5$var$ft : $e444d6404c095fa5$var$gt : "Desktop"),
                $timezone: $e444d6404c095fa5$var$Mn(),
                $timezone_offset: $e444d6404c095fa5$var$Fn()
            }), {
                $current_url: $e444d6404c095fa5$var$gn(n ? $e444d6404c095fa5$var$ye(null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.href) : null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.href, v, $e444d6404c095fa5$var$Sn),
                $host: null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.host,
                $pathname: null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.pathname,
                $raw_user_agent: $e444d6404c095fa5$var$u.length > 1e3 ? $e444d6404c095fa5$var$u.substring(0, 997) + "..." : $e444d6404c095fa5$var$u,
                $browser_version: $e444d6404c095fa5$var$pe($e444d6404c095fa5$var$u, navigator.vendor, g, m),
                $browser_language: $e444d6404c095fa5$var$Pn(),
                $browser_language_prefix: (k = $e444d6404c095fa5$var$Pn(), "string" == typeof k ? k.split("-")[0] : void 0),
                $screen_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.height,
                $screen_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.screen.width,
                $viewport_height: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerHeight,
                $viewport_width: null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.innerWidth,
                $lib: $e444d6404c095fa5$var$c.LIB_NAME,
                $lib_version: $e444d6404c095fa5$var$c.LIB_VERSION,
                $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
                $time: Date.now() / 1e3
            });
            return $e444d6404c095fa5$var$c.SDK_DIST_CHANNEL && (M.$sdk_dist_channel = $e444d6404c095fa5$var$c.SDK_DIST_CHANNEL), M;
        }(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app, this.config.disable_capture_url_hashes);
        if (this.sessionManager) {
            var p = this.sessionManager.checkAndGetSessionAndWindowId(a, n.getTime()), g = p.windowId;
            h.$session_id = p.sessionId, h.$window_id = g;
        }
        this.sessionPropsManager && $e444d6404c095fa5$var$Nr(h, this.sessionPropsManager.getSessionProps());
        try {
            var m;
            this.sessionRecording && $e444d6404c095fa5$var$Nr(h, this.sessionRecording.sdkDebugProperties), h.$sdk_debug_retry_queue_size = null == (m = this.An) ? void 0 : m.length;
        } catch (t) {
            h.$sdk_debug_error_capturing_properties = String(t);
        }
        if (this.requestRouter.region === $e444d6404c095fa5$var$ma && (h.$lib_custom_api_host = this.config.api_host), v = e !== $e444d6404c095fa5$var$Ir || a ? e !== $e444d6404c095fa5$var$Cr || a ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(n) : this.pageViewManager.doPageView(n, o), h = $e444d6404c095fa5$var$Nr(h, v), e === $e444d6404c095fa5$var$Ir && $e444d6404c095fa5$var$r && (h.title = $e444d6404c095fa5$var$r.title), !$e444d6404c095fa5$var$K(l)) {
            var b = n.getTime() - l;
            h.$duration = parseFloat((b / 1e3).toFixed(3));
        }
        $e444d6404c095fa5$var$u && this.config.opt_out_useragent_filter && (h.$browser_type = this._is_bot() ? "bot" : "browser");
        var y = this.persistence.properties(), w = this.sessionPersistence.properties();
        $e444d6404c095fa5$var$Dr([
            "$referrer",
            "$referring_domain"
        ], (t)=>{
            t in y && delete w[t];
        }), (h = $e444d6404c095fa5$var$Nr({}, f, y, w, h)).$is_identified = this._isIdentified(), $e444d6404c095fa5$var$q(this.config.property_denylist) ? $e444d6404c095fa5$var$Dr(this.config.property_denylist, function(t) {
            delete h[t];
        }) : $e444d6404c095fa5$var$mi.error($e444d6404c095fa5$var$Ba + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var x = this.config.sanitize_properties;
        x && ($e444d6404c095fa5$var$mi.error($e444d6404c095fa5$var$ja), h = x(h, e));
        var E = this.Vn();
        return h.$process_person_profile = E, E && !a && this.Zn("_calculate_event_properties"), h;
    }
    zn(t, e, i) {
        var r;
        if (void 0 === e && (e = !0), void 0 === i && (i = !1), !this.persistence || !this.Vn()) return t;
        if (this.yn && !i) return t;
        var s = this.persistence.get_initial_props(), n = null == (r = this.sessionPropsManager) ? void 0 : r.getSetOnceProps(), o = $e444d6404c095fa5$var$Nr({}, s, n || {}, t || {}), a = this.config.sanitize_properties;
        return a && ($e444d6404c095fa5$var$mi.error($e444d6404c095fa5$var$ja), o = a(o, "$set_once")), e && (this.yn = !0), $e444d6404c095fa5$var$G(o) ? void 0 : o;
    }
    register(t, e) {
        var i;
        null == (i = this.persistence) || i.register(t, e);
    }
    register_once(t, e, i) {
        var r;
        null == (r = this.persistence) || r.register_once(t, e, i);
    }
    register_for_session(t) {
        var e;
        null == (e = this.sessionPersistence) || e.register(t), Object.keys(t).forEach((t)=>this.bn.add(t)), this.Gn();
    }
    unregister(t) {
        var e;
        null == (e = this.persistence) || e.unregister(t);
    }
    unregister_for_session(t) {
        var e;
        null == (e = this.sessionPersistence) || e.unregister(t), this.bn.delete(t), this.Gn();
    }
    Qn(t, e) {
        this.register({
            [t]: e
        });
    }
    Fn() {
        this.bn.forEach((t)=>{
            var e;
            null == (e = this.sessionPersistence) || e.unregister(t);
        }), this.bn.clear(), this.Gn();
    }
    Gn() {
        var t;
        if (this._n) {
            if ("memory" === this.config.persistence || null != (t = this.sessionPersistence) && t.xi || !$e444d6404c095fa5$var$us.N()) $e444d6404c095fa5$var$us.q(this._n);
            else {
                var e = [];
                this.bn.forEach((t)=>e.push(t)), e.length > 0 ? $e444d6404c095fa5$var$us.F(this._n, e) : $e444d6404c095fa5$var$us.q(this._n);
            }
        }
    }
    getFeatureFlag(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlag(t, e);
    }
    getFeatureFlagPayload(t) {
        var e;
        return null == (e = this.featureFlags) ? void 0 : e.getFeatureFlagPayload(t);
    }
    getFeatureFlagResult(t, e) {
        var i;
        return null == (i = this.featureFlags) ? void 0 : i.getFeatureFlagResult(t, e);
    }
    getAllFeatureFlags() {
        var t, e;
        return null !== (t = null == (e = this.featureFlags) ? void 0 : e.getAllFeatureFlags()) && void 0 !== t ? t : [];
    }
    isFeatureEnabled(t, e) {
        var i, r;
        return null !== (i = null == (r = this.featureFlags) ? void 0 : r.isFeatureEnabled(t, e)) && void 0 !== i ? i : null == e ? void 0 : e.defaultValue;
    }
    reloadFeatureFlags() {
        var t;
        null == (t = this.featureFlags) || t.reloadFeatureFlags();
    }
    updateFlags(t, e, i) {
        var r;
        null == (r = this.featureFlags) || r.updateFlags(t, e, i);
    }
    updateEarlyAccessFeatureEnrollment(t, e, i) {
        var r;
        null == (r = this.featureFlags) || r.updateEarlyAccessFeatureEnrollment(t, e, i);
    }
    getEarlyAccessFeatures(t, e, i) {
        var r;
        return void 0 === e && (e = !1), null == (r = this.featureFlags) ? void 0 : r.getEarlyAccessFeatures(t, e, i);
    }
    on(t, e) {
        return this.vn.on(t, e);
    }
    onFeatureFlags(t) {
        return this.featureFlags ? this.featureFlags.onFeatureFlags(t) : (t([], {}, {
            errorsLoading: !0
        }), ()=>{});
    }
    onSurveysLoaded(t) {
        return this.surveys ? this.surveys.onSurveysLoaded(t) : (t([], {
            isLoaded: !1,
            error: $e444d6404c095fa5$var$La
        }), ()=>{});
    }
    onSessionId(t) {
        var e, i;
        return null !== (e = null == (i = this.sessionManager) ? void 0 : i.onSessionId(t)) && void 0 !== e ? e : ()=>{};
    }
    getSurveys(t, e) {
        void 0 === e && (e = !1), this.surveys ? this.surveys.getSurveys(t, e) : t([], {
            isLoaded: !1,
            error: $e444d6404c095fa5$var$La
        });
    }
    getActiveMatchingSurveys(t, e) {
        void 0 === e && (e = !1), this.surveys ? this.surveys.getActiveMatchingSurveys(t, e) : t([], {
            isLoaded: !1,
            error: $e444d6404c095fa5$var$La
        });
    }
    renderSurvey(t, e) {
        var i;
        null == (i = this.surveys) || i.renderSurvey(t, e);
    }
    displaySurvey(t, e) {
        var i;
        void 0 === e && (e = $e444d6404c095fa5$var$Ta), null == (i = this.surveys) || i.displaySurvey(t, e);
    }
    cancelPendingSurvey(t) {
        var e;
        null == (e = this.surveys) || e.cancelPendingSurvey(t);
    }
    canRenderSurvey(t) {
        var e, i;
        return null !== (e = null == (i = this.surveys) ? void 0 : i.canRenderSurvey(t)) && void 0 !== e ? e : {
            visible: !1,
            disabledReason: $e444d6404c095fa5$var$La
        };
    }
    canRenderSurveyAsync(t, e) {
        var i, r;
        return void 0 === e && (e = !1), null !== (i = null == (r = this.surveys) ? void 0 : r.canRenderSurveyAsync(t, e)) && void 0 !== i ? i : Promise.resolve({
            visible: !1,
            disabledReason: $e444d6404c095fa5$var$La
        });
    }
    Kn(t) {
        return !t || $e444d6404c095fa5$var$Y(t) ? ($e444d6404c095fa5$var$mi.critical("Unique user id has not been set in posthog.identify"), !1) : t === $e444d6404c095fa5$var$mr ? ($e444d6404c095fa5$var$mi.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.'), !1) : ![
            "distinct_id",
            "distinctid"
        ].includes(t.toLowerCase()) && ![
            "undefined",
            "null"
        ].includes(t.toLowerCase()) || ($e444d6404c095fa5$var$mi.critical('The string "' + t + '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'), !1);
    }
    identify(t, e, i) {
        if (!this.__loaded || !this.persistence) return $e444d6404c095fa5$var$mi.uninitializedWarning("posthog.identify");
        if ($e444d6404c095fa5$var$Z(t) && (t = t.toString(), $e444d6404c095fa5$var$mi.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), this.Kn(t) && this.Zn("posthog.identify")) {
            var r = this.get_distinct_id();
            this.register({
                $user_id: t
            }), this.get_property($e444d6404c095fa5$var$Ei) || this.register_once({
                $had_persisted_distinct_id: !0,
                $device_id: r
            }, ""), t !== r && t !== this.get_property($e444d6404c095fa5$var$$i) && (this.unregister($e444d6404c095fa5$var$$i), this.register({
                distinct_id: t
            }));
            var s, n = (this.persistence.get_property($e444d6404c095fa5$var$dr) || $e444d6404c095fa5$var$kr) === $e444d6404c095fa5$var$kr, o = t !== r, a = !o && n;
            if (o && n) this.persistence.set_property($e444d6404c095fa5$var$dr, $e444d6404c095fa5$var$Tr), this.setPersonPropertiesForFlags({
                $set: e || {},
                $set_once: i || {}
            }, !1), this.capture($e444d6404c095fa5$var$Ar, {
                distinct_id: t,
                $anon_distinct_id: r
            }, {
                $set: e || {},
                $set_once: i || {}
            }), this.Cn = $e444d6404c095fa5$var$fa(t, e, i), null == (s = this.featureFlags) || s.setAnonymousDistinctId(r);
            else if (a) {
                this.persistence.set_property($e444d6404c095fa5$var$dr, $e444d6404c095fa5$var$Tr);
                var l = e || {}, u = i || {};
                this.setPersonPropertiesForFlags({
                    $set: l,
                    $set_once: u
                }, !1), this.capture("$set", {
                    $set: l,
                    $set_once: u
                }), this.Cn = $e444d6404c095fa5$var$fa(t, e, i);
            } else (e || i) && this.setPersonProperties(e, i);
            o ? (this.reloadFeatureFlags(), this.unregister($e444d6404c095fa5$var$ar)) : a && (e || i) && this.reloadFeatureFlags();
        }
    }
    setPersonProperties(t, e) {
        if ((t || e) && this.Zn("posthog.setPersonProperties")) {
            var i = $e444d6404c095fa5$var$fa(this.get_distinct_id(), t, e);
            this.Cn !== i ? (this.setPersonPropertiesForFlags({
                $set: t || {},
                $set_once: e || {}
            }, !0), this.capture("$set", {
                $set: t || {},
                $set_once: e || {}
            }), this.Cn = i) : $e444d6404c095fa5$var$mi.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
        }
    }
    unsetPersonProperties(t) {
        var e, i = ($e444d6404c095fa5$var$q(t) ? t : [
            t
        ]).filter((t)=>$e444d6404c095fa5$var$J(t) && t.length > 0);
        0 !== i.length && this.Zn("posthog.unsetPersonProperties") && (null == (e = this.featureFlags) || e.unsetPersonPropertiesForFlags(i, !0), this.capture("$set", {
            $unset: i
        }), this.Cn = null);
    }
    group(t, e, i) {
        if (t && e) {
            var r = this.getGroups(), s = r[t] !== e;
            if (s && this.resetGroupPropertiesForFlags(t), this.register({
                $groups: $e444d6404c095fa5$var$_({}, r, {
                    [t]: e
                })
            }), s || i) {
                var n = {
                    $group_type: t,
                    $group_key: e
                };
                i && (n.$group_set = i), this.capture($e444d6404c095fa5$var$Mr, n);
            }
            i && this.setGroupPropertiesForFlags({
                [t]: i
            }), s && !i && this.reloadFeatureFlags();
        } else $e444d6404c095fa5$var$mi.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(t, e) {
        var i;
        void 0 === e && (e = !0), null == (i = this.featureFlags) || i.setPersonPropertiesForFlags(t, e);
    }
    resetPersonPropertiesForFlags(t) {
        var e;
        void 0 === t && (t = !0), null == (e = this.featureFlags) || e.resetPersonPropertiesForFlags(t);
    }
    setGroupPropertiesForFlags(t, e) {
        var i;
        void 0 === e && (e = !0), this.Zn("posthog.setGroupPropertiesForFlags") && (null == (i = this.featureFlags) || i.setGroupPropertiesForFlags(t, e));
    }
    resetGroupPropertiesForFlags(t) {
        var e;
        null == (e = this.featureFlags) || e.resetGroupPropertiesForFlags(t);
    }
    reset(t) {
        this.Jn(t);
    }
    Jn(t, e) {
        var i, r, s, n, o, a, l, u, h, d;
        if (void 0 === e && (e = !1), $e444d6404c095fa5$var$mi.info("reset"), !this.__loaded) return $e444d6404c095fa5$var$mi.uninitializedWarning("posthog.reset");
        var v, c = this.get_property($e444d6404c095fa5$var$Ei), f = this.get_property($e444d6404c095fa5$var$Si), p = this.get_property($e444d6404c095fa5$var$Di), _ = this.is_capturing();
        if (this.consent.reset(), e || !_ || this.is_capturing() || console.warn("[PostHog.js]", "reset() cleared the stored consent, and capturing is now off because of `opt_out_capturing_by_default`. Call opt_in_capturing() again, and prefer calling reset() before opting in rather than after."), null == (i = this.persistence) || i.clear(), null == (r = this.sessionPersistence) || r.clear(), this.bn.clear(), this.Gn(), $e444d6404c095fa5$var$K(p) || null == (v = this.persistence) || v.register({
            [$e444d6404c095fa5$var$Di]: p
        }), null == (s = this.surveys) || s.reset(), null == (n = this.Bn) || n.stop(), null == (o = this.featureFlags) || o.reset(), null == (a = this.conversations) || a.reset(), null == (l = this.logs) || l.reset(), null == (u = this.metrics) || u.reset(), null == (h = this.persistence) || h.set_property($e444d6404c095fa5$var$dr, $e444d6404c095fa5$var$kr), null == (d = this.sessionManager) || d.resetSessionId(), this.Cn = null, this.config.cookieless_mode === $e444d6404c095fa5$var$$r) this.register_once({
            distinct_id: $e444d6404c095fa5$var$mr,
            $device_id: null
        }, "");
        else {
            var g = this.config.get_device_id($e444d6404c095fa5$var$Xr());
            this.register_once({
                distinct_id: g,
                $device_id: t ? g : c
            }, ""), t || $e444d6404c095fa5$var$K(f) || this.register({
                [$e444d6404c095fa5$var$Si]: f
            });
        }
        this.register({
            $last_posthog_reset: (new Date).toISOString()
        }, 1), delete this.config.identity_distinct_id, delete this.config.identity_hash, this.reloadFeatureFlags();
    }
    shutdown(t) {
        var e = this;
        return $e444d6404c095fa5$var$p(function*() {
            var t, i, r, s, n, o, a, l;
            e.__loaded ? (null == (t = e.Bn) || t.stop(), null == (i = e.Nn) || i.dispose(), null == (r = e.sessionRecording) || r.dispose(), null == (s = e.logs) || s.flushLogs("sendBeacon"), null == (n = e.metrics) || n.flush("sendBeacon"), null == (o = e.Pn) || o.unload(), null == (a = e.An) || a.unload(), null == (l = e.featureFlags) || l.destroy()) : $e444d6404c095fa5$var$mi.uninitializedWarning("posthog.shutdown");
        })();
    }
    setIdentity(t, e) {
        var i;
        this.config.identity_distinct_id = t, this.config.identity_hash = e, this.alias(t), null == (i = this.conversations) || i.Yn();
    }
    clearIdentity() {
        var t;
        delete this.config.identity_distinct_id, delete this.config.identity_hash, null == (t = this.conversations) || t.Xn();
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var t, e;
        return null !== (t = null == (e = this.sessionManager) ? void 0 : e.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== t ? t : "";
    }
    get_session_replay_url(t) {
        if (!this.sessionManager) return "";
        var e = this.sessionManager.checkAndGetSessionAndWindowId(!0), i = e.sessionStartTimestamp, r = this.requestRouter.endpointFor("ui", "/project/" + this.config.token + "/replay/" + e.sessionId);
        if (null != t && t.withTimestamp && i) {
            var s, n = null !== (s = t.timestampLookBack) && void 0 !== s ? s : 10;
            if (!i) return r;
            r += "?t=" + Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - n, 0);
        }
        return r;
    }
    alias(t, e) {
        return t === this.get_property($e444d6404c095fa5$var$xi) ? ($e444d6404c095fa5$var$mi.critical("Attempting to create alias for existing People user - aborting."), -2) : this.Zn("posthog.alias") ? ($e444d6404c095fa5$var$K(e) && (e = this.get_distinct_id()), t !== e ? (this.Qn($e444d6404c095fa5$var$$i, t), this.capture("$create_alias", {
            alias: t,
            distinct_id: e
        })) : ($e444d6404c095fa5$var$mi.warn("alias matches current distinct_id - skipping api call."), this.identify(t), -1)) : void 0;
    }
    set_config(t) {
        var e = $e444d6404c095fa5$var$_({}, this.config);
        if ($e444d6404c095fa5$var$W(t)) {
            var i, r, s, n, o, a, l, u, h, d, v;
            $e444d6404c095fa5$var$Nr(this.config, $e444d6404c095fa5$var$Ga(t));
            var f = this.In();
            null == (i = this.persistence) || i.update_config(this.config, e, f), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new $e444d6404c095fa5$var$Ln($e444d6404c095fa5$var$_({}, this.config, {
                persistence: "sessionStorage"
            }), f, !1);
            var p = this.Mn(this.config.debug);
            $e444d6404c095fa5$var$et(p) && (this.config.debug = p), $e444d6404c095fa5$var$et(this.config.debug) && (this.config.debug ? ($e444d6404c095fa5$var$c.DEBUG = !0, $e444d6404c095fa5$var$ss.N() && $e444d6404c095fa5$var$ss.F("ph_debug", !0), $e444d6404c095fa5$var$mi.info("set_config", {
                config: t,
                oldConfig: e,
                newConfig: $e444d6404c095fa5$var$_({}, this.config)
            })) : ($e444d6404c095fa5$var$c.DEBUG = !1, $e444d6404c095fa5$var$ss.N() && $e444d6404c095fa5$var$ss.q("ph_debug"))), null == (r = this.exceptionObserver) || r.onConfigChange(), null == (s = this.exceptions) || s.onConfigChange(), null == (n = this.sessionRecording) || n.startIfEnabledOrStop(), null == (o = this.tracingHeaders) || o.startIfEnabledOrStop(), null == (a = this.autocapture) || a.startIfEnabled(), null == (l = this.heatmaps) || l.startIfEnabled(), null == (u = this.exceptionObserver) || u.startIfEnabledOrStop(), null == (h = this.deadClicksAutocapture) || h.startIfEnabledOrStop(), null == (d = this.surveys) || d.loadIfEnabled(), this.ts(), null == (v = this.externalIntegrations) || v.startIfEnabledOrStop();
        }
    }
    _overrideSDKInfo(t, e) {
        $e444d6404c095fa5$var$c.LIB_NAME = t, $e444d6404c095fa5$var$c.LIB_VERSION = e;
    }
    startSessionRecording(t) {
        var e, i, r, s, n, o = !0 === t, a = {
            sampling: o || !(null == t || !t.sampling),
            linked_flag: o || !(null == t || !t.linked_flag),
            url_trigger: o || !(null == t || !t.url_trigger),
            event_trigger: o || !(null == t || !t.event_trigger)
        };
        Object.values(a).some(Boolean) && (null == (e = this.sessionManager) || e.checkAndGetSessionAndWindowId(), a.sampling && (null == (i = this.sessionRecording) || i.overrideSampling()), a.linked_flag && (null == (r = this.sessionRecording) || r.overrideLinkedFlag()), a.url_trigger && (null == (s = this.sessionRecording) || s.overrideTrigger("url")), a.event_trigger && (null == (n = this.sessionRecording) || n.overrideTrigger("event")));
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var t;
        return !(null == (t = this.sessionRecording) || !t.started);
    }
    captureException(t, e) {
        if (this.exceptions) {
            var i = new Error("PostHog syntheticException"), r = this.exceptions.buildProperties(t, {
                handled: !0,
                syntheticException: i
            });
            return this.exceptions.sendExceptionEvent($e444d6404c095fa5$var$_({}, r, e));
        }
    }
    addExceptionStep(t, e) {
        var i;
        null == (i = this.exceptions) || i.addExceptionStep(t, e);
    }
    captureLog(t) {
        var e;
        null == (e = this.logs) || e.captureLog(t);
    }
    get logger() {
        var t, e;
        return null !== (t = null == (e = this.logs) ? void 0 : e.logger) && void 0 !== t ? t : $e444d6404c095fa5$export$a9d6b9cbf49b8241.es;
    }
    startExceptionAutocapture(t) {
        this.set_config({
            capture_exceptions: null == t || t
        });
    }
    stopExceptionAutocapture() {
        this.set_config({
            capture_exceptions: !1
        });
    }
    loadToolbar(t) {
        var e, i;
        return null !== (e = null == (i = this.toolbar) ? void 0 : i.loadToolbar(t)) && void 0 !== e && e;
    }
    get_property(t) {
        var e;
        return null == (e = this.persistence) ? void 0 : e.props[t];
    }
    getSessionProperty(t) {
        var e;
        return null == (e = this.sessionPersistence) ? void 0 : e.props[t];
    }
    toString() {
        var t, e = null !== (t = this.config.name) && void 0 !== t ? t : $e444d6404c095fa5$var$Ha;
        return e !== $e444d6404c095fa5$var$Ha && (e = $e444d6404c095fa5$var$Ha + "." + e), e;
    }
    _isIdentified() {
        var t, e;
        return (null == (t = this.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$dr)) === $e444d6404c095fa5$var$Tr || (null == (e = this.sessionPersistence) ? void 0 : e.get_property($e444d6404c095fa5$var$dr)) === $e444d6404c095fa5$var$Tr;
    }
    Vn() {
        var t, e;
        return !("never" === this.config.person_profiles || this.config.person_profiles === $e444d6404c095fa5$var$Rr && !this._isIdentified() && $e444d6404c095fa5$var$G(this.getGroups()) && (null == (t = this.persistence) || null == (t = t.props) || !t[$e444d6404c095fa5$var$$i]) && (null == (e = this.persistence) || null == (e = e.props) || !e[$e444d6404c095fa5$var$gr]));
    }
    Hn() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && (!0 === this.config.capture_pageview || "history_change" === this.config.capture_pageview);
    }
    createPersonProfile() {
        this.Vn() || this.Zn("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    setInternalOrTestUser() {
        this.Zn("posthog.setInternalOrTestUser") && this.setPersonProperties({
            $internal_or_test_user: !0
        });
    }
    Zn(t) {
        return "never" === this.config.person_profiles ? ($e444d6404c095fa5$var$mi.error(t + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this.Qn($e444d6404c095fa5$var$gr, !0), !0);
    }
    In() {
        if ("always" === this.config.cookieless_mode) return !0;
        var t = this.consent.isOptedOut();
        return this.config.disable_persistence || t && !(!this.config.opt_out_persistence_by_default && this.config.cookieless_mode !== $e444d6404c095fa5$var$Sr);
    }
    ts() {
        var t, e, i, r, s = this.In();
        return (null == (t = this.persistence) ? void 0 : t.xi) !== s && (null == (i = this.persistence) || i.set_disabled(s)), (null == (e = this.sessionPersistence) ? void 0 : e.xi) !== s && (null == (r = this.sessionPersistence) || r.set_disabled(s)), s && (this.bn.clear(), this.Gn()), s;
    }
    opt_in_capturing(t) {
        var e;
        if (this.config.cookieless_mode !== $e444d6404c095fa5$var$$r) {
            if (this.mn()) {
                var i, r, s, n, o;
                this.Jn(!0, !0), null == (i = this.sessionManager) || i.destroy(), null == (r = this.pageViewManager) || r.destroy(), this.sessionManager = new $e444d6404c095fa5$var$ha(this), this.pageViewManager = new $e444d6404c095fa5$var$un(this), this.persistence && (this.sessionPropsManager = new $e444d6404c095fa5$var$aa(this, this.sessionManager, this.persistence));
                var a, l = null !== (s = null == (n = this.config.__extensionClasses) ? void 0 : n.sessionRecording) && void 0 !== s ? s : null == (o = $e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses) ? void 0 : o.sessionRecording;
                l && (this.sessionRecording = this.gn(this.sessionRecording, new l(this)), this.dn && (null == (a = this.sessionRecording) || null == a.onRemoteConfig || a.onRemoteConfig(this.dn)));
            }
            var u, h;
            this.consent.optInOut(!0), this.ts(), this.qn(), null == (e = this.sessionRecording) || e.startIfEnabledOrStop(), this.config.cookieless_mode == $e444d6404c095fa5$var$Sr && (null == (u = this.surveys) || u.loadIfEnabled()), ($e444d6404c095fa5$var$K(null == t ? void 0 : t.captureEventName) || null != t && t.captureEventName) && this.capture(null !== (h = null == t ? void 0 : t.captureEventName) && void 0 !== h ? h : "$opt_in", null == t ? void 0 : t.captureProperties, {
                send_instantly: !0
            }), this.config.capture_pageview && this.jn();
        } else $e444d6404c095fa5$var$mi.warn($e444d6404c095fa5$var$Ua);
    }
    opt_out_capturing() {
        var t, e, i;
        this.config.cookieless_mode !== $e444d6404c095fa5$var$$r ? (this.config.cookieless_mode === $e444d6404c095fa5$var$Sr && this.consent.isOptedIn() && this.Jn(!0, !0), this.consent.optInOut(!1), this.ts(), this.config.cookieless_mode === $e444d6404c095fa5$var$Sr && (this.register({
            distinct_id: $e444d6404c095fa5$var$mr,
            $device_id: null
        }), null == (t = this.sessionRecording) || t.stopRecording(), this.sessionRecording = void 0, null == (e = this.sessionManager) || e.destroy(), null == (i = this.pageViewManager) || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.jn(), this.qn())) : $e444d6404c095fa5$var$mi.warn($e444d6404c095fa5$var$Ua);
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    get_explicit_consent_status() {
        var t = this.consent.consent;
        return 1 === t ? "granted" : 0 === t ? "denied" : "pending";
    }
    is_capturing() {
        return this.config.cookieless_mode === $e444d6404c095fa5$var$$r || (this.config.cookieless_mode === $e444d6404c095fa5$var$Sr ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this.ts();
    }
    _is_bot() {
        return $e444d6404c095fa5$var$i ? $e444d6404c095fa5$var$da($e444d6404c095fa5$var$i, this.config.custom_blocked_useragents) : void 0;
    }
    jn() {
        $e444d6404c095fa5$var$r && ("visible" === $e444d6404c095fa5$var$r.visibilityState ? this.kn || (this.kn = !0, this.capture($e444d6404c095fa5$var$Ir, {
            title: $e444d6404c095fa5$var$r.title
        }, {
            send_instantly: !0
        }), this.xn && ($e444d6404c095fa5$var$r.removeEventListener($e444d6404c095fa5$var$Pr, this.xn), this.xn = null)) : this.xn || (this.xn = this.jn.bind(this), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, $e444d6404c095fa5$var$Pr, this.xn)));
    }
    debug(e) {
        !1 === e ? (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You've disabled debug mode."), this.set_config({
            debug: !1
        })) : (null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({
            debug: !0
        }));
    }
    Ki() {
        var t = this.Tn || {};
        return "advanced_disable_flags" in t ? !!t.advanced_disable_flags : !1 !== this.config.advanced_disable_flags ? !!this.config.advanced_disable_flags : !0 === this.config.advanced_disable_decide ? ($e444d6404c095fa5$var$mi.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : function(t, e, i, r, s) {
            var n = e in t && !$e444d6404c095fa5$var$X(t[e]), o = i in t && !$e444d6404c095fa5$var$X(t[i]);
            return n ? t[e] : !!o && (s && s.warn("Config field '" + i + "' is deprecated. Please use '" + e + "' instead. The old field will be removed in a future major version."), t[i]);
        }(t, "advanced_disable_flags", "advanced_disable_decide", 0, $e444d6404c095fa5$var$mi);
    }
    Pt(t) {
        var e;
        if ($e444d6404c095fa5$var$X(this.config.before_send)) return t;
        var i = Object.keys(null !== (e = t.properties) && void 0 !== e ? e : {}).filter($e444d6404c095fa5$var$st), r = $e444d6404c095fa5$var$q(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], s = t;
        for (var n of r){
            if (s = n(s), $e444d6404c095fa5$var$X(s)) {
                var o = "Event '" + t.event + "' was rejected in beforeSend function";
                return $e444d6404c095fa5$var$rt(t.event) ? $e444d6404c095fa5$var$mi.warn(o + ". This can cause unexpected behavior.") : $e444d6404c095fa5$var$mi.info(o), null;
            }
            s.properties && !$e444d6404c095fa5$var$G(s.properties) || $e444d6404c095fa5$var$mi.warn("Event '" + t.event + "' has no properties after beforeSend function, this is likely an error.");
        }
        for (var a of i)if (s.properties && $e444d6404c095fa5$var$X(s.properties[a])) return $e444d6404c095fa5$var$mi.warn("Event '" + t.event + "' had its '" + a + "' property removed in a beforeSend function. This property is required for ingestion, so the event will be dropped."), null;
        return s;
    }
    getPageViewId() {
        var t;
        return null == (t = this.pageViewManager.ui) ? void 0 : t.pageViewId;
    }
    captureTraceFeedback(t, e) {
        this.capture("$ai_feedback", {
            $ai_trace_id: String(t),
            $ai_feedback_text: e
        });
    }
    captureTraceMetric(t, e, i) {
        this.capture("$ai_metric", {
            $ai_trace_id: String(t),
            $ai_metric_name: e,
            $ai_metric_value: String(i)
        });
    }
    Mn(t) {
        var e = $e444d6404c095fa5$var$et(t) && !t, i = $e444d6404c095fa5$var$ss.N() && "true" === $e444d6404c095fa5$var$ss.P("ph_debug");
        return !e && (!!i || t);
    }
}
$e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses = {}, $e444d6404c095fa5$export$a9d6b9cbf49b8241.es = (()=>{
    var t = ()=>{};
    return {
        trace: t,
        debug: t,
        info: t,
        warn: t,
        error: t,
        fatal: t
    };
})(), function(t, e) {
    for(var i = 0; e.length > i; i++)t.prototype[e[i]] = $e444d6404c095fa5$var$jr(t.prototype[e[i]]);
}($e444d6404c095fa5$export$a9d6b9cbf49b8241, [
    "identify"
]);
class $e444d6404c095fa5$var$Ya {
    constructor(t){
        this.disabled = !1 === t;
        var e = $e444d6404c095fa5$var$W(t) ? t : {};
        this.thresholdPx = e.threshold_px || 30, this.timeoutMs = e.timeout_ms || 1e3, this.clickCount = e.click_count || 3, this.clicks = [];
    }
    isRageClick(t, e, i) {
        if (this.disabled) return !1;
        var r = this.clicks[this.clicks.length - 1];
        if (r && Math.abs(t - r.x) + Math.abs(e - r.y) < this.thresholdPx && this.timeoutMs > i - r.timestamp) {
            if (this.clicks.push({
                x: t,
                y: e,
                timestamp: i
            }), this.clicks.length === this.clickCount) return !0;
        } else this.clicks = [
            {
                x: t,
                y: e,
                timestamp: i
            }
        ];
        return !1;
    }
}
var $e444d6404c095fa5$var$Qa = "$copy_autocapture", $e444d6404c095fa5$var$Xa = $e444d6404c095fa5$var$bi("[AutoCapture]");
function $e444d6404c095fa5$var$Za(t, e) {
    return e.length > t ? e.slice(0, t) + "..." : e;
}
function $e444d6404c095fa5$var$tl(t) {
    if (t.previousElementSibling) return t.previousElementSibling;
    var e = t;
    do e = e.previousSibling;
    while (e && !$e444d6404c095fa5$var$gs(e));
    return e;
}
function $e444d6404c095fa5$var$el(e, i) {
    var r, s, n = i.e, o = i.maskAllElementAttributes, a = i.maskAllText, l = i.elementAttributeIgnoreList, u = i.elementsChainAsString, h = i.disableCaptureUrlHashes;
    if (!$e444d6404c095fa5$var$gs(e)) return {
        props: {}
    };
    for(var d = [
        e
    ], v = new Set([
        e
    ]), c = e; c.parentNode && !$e444d6404c095fa5$var$ms(c, "body") && $e444d6404c095fa5$var$ws > d.length;)if ($e444d6404c095fa5$var$ys(c.parentNode)) {
        var f = c.parentNode.host;
        if (v.has(f)) break;
        v.add(f), d.push(f), c = f;
    } else {
        if (!$e444d6404c095fa5$var$gs(c.parentNode)) break;
        if (v.has(c.parentNode)) break;
        v.add(c.parentNode), d.push(c.parentNode), c = c.parentNode;
    }
    var p, g, m = [], b = {}, y = !1, w = !1;
    if ($e444d6404c095fa5$var$Dr(d, (t)=>{
        var e = $e444d6404c095fa5$var$js(t);
        if ($e444d6404c095fa5$var$ms(t, "a")) {
            var i = t.getAttribute("href");
            y = !!(e && i && $e444d6404c095fa5$var$Js(i)) && (h ? $e444d6404c095fa5$var$ye(i) : i);
        }
        $e444d6404c095fa5$var$N($e444d6404c095fa5$var$Ss(t), "ph-no-capture") && (w = !0), m.push(function(t, e, i, r, s) {
            void 0 === s && (s = !1);
            var n = t.tagName.toLowerCase(), o = {
                tag_name: n
            };
            $e444d6404c095fa5$var$Rs.indexOf(n) > -1 && !i && (o.$el_text = "a" === n.toLowerCase() || "button" === n.toLowerCase() ? $e444d6404c095fa5$var$Za(1024, $e444d6404c095fa5$var$Ys(t)) : $e444d6404c095fa5$var$Za(1024, $e444d6404c095fa5$var$ks(t)));
            var a = $e444d6404c095fa5$var$Ss(t);
            a.length > 0 && (o.classes = a.filter(function(t) {
                return "" !== t;
            })), $e444d6404c095fa5$var$Dr(t.attributes, function(i) {
                var n;
                if ((!$e444d6404c095fa5$var$Bs(t) || -1 !== [
                    "name",
                    "id",
                    "class",
                    "aria-label"
                ].indexOf(i.name)) && (null == r || !r.includes(i.name)) && !e && $e444d6404c095fa5$var$Js(i.value) && (!$e444d6404c095fa5$var$J(n = i.name) || "_ngcontent" !== n.substring(0, 10) && "_nghost" !== n.substring(0, 7))) {
                    var a = i.value;
                    "class" === i.name && (a = $e444d6404c095fa5$var$xs(a).join(" ")), o["attr__" + i.name] = $e444d6404c095fa5$var$Za(1024, "href" === i.name && s ? $e444d6404c095fa5$var$ye(a) : a);
                }
            });
            for(var l = 1, u = 1, h = t; h = $e444d6404c095fa5$var$tl(h);)l++, h.tagName === t.tagName && u++;
            return o.nth_child = l, o.nth_of_type = u, o;
        }(t, o, a, l, h));
        var r = function(t) {
            if (!$e444d6404c095fa5$var$js(t)) return {};
            var e = {};
            return $e444d6404c095fa5$var$Dr(t.attributes, function(t) {
                if (t.name && 0 === t.name.indexOf("data-ph-capture-attribute")) {
                    var i = t.name.replace("data-ph-capture-attribute-", ""), r = t.value;
                    i && r && $e444d6404c095fa5$var$Js(r) && (e[i] = r);
                }
            }), e;
        }(t);
        $e444d6404c095fa5$var$Nr(b, r);
    }), w) return {
        props: {},
        explicitNoCapture: w
    };
    if (a || (m[0].$el_text = $e444d6404c095fa5$var$ms(e, "a") || $e444d6404c095fa5$var$ms(e, "button") ? $e444d6404c095fa5$var$Ys(e) : $e444d6404c095fa5$var$ks(e)), y) {
        var x, E;
        m[0].attr__href = y;
        var S = null == (x = $e444d6404c095fa5$var$pn(y)) ? void 0 : x.host, k = null == $e444d6404c095fa5$var$t || null == (E = $e444d6404c095fa5$var$t.location) ? void 0 : E.host;
        S && k && S !== k && (p = y);
    }
    return {
        props: $e444d6404c095fa5$var$Nr({
            $event_type: n.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: m
        }, {
            $elements_chain: (g = m, function(t) {
                return t.map((t)=>{
                    var e, i, r = "";
                    if (t.tag_name && (r += t.tag_name), t.attr_class) for (var s of (t.attr_class.sort(), t.attr_class))r += "." + s.replace(/"/g, "");
                    var n = $e444d6404c095fa5$var$_({}, t.text ? {
                        text: t.text
                    } : {}, {
                        "nth-child": null !== (e = t.nth_child) && void 0 !== e ? e : 0,
                        "nth-of-type": null !== (i = t.nth_of_type) && void 0 !== i ? i : 0
                    }, t.href ? {
                        href: t.href
                    } : {}, t.attr_id ? {
                        attr_id: t.attr_id
                    } : {}, t.attributes), o = {};
                    return $e444d6404c095fa5$var$Ur(n).sort((t, e)=>t[0].localeCompare(e[0])).forEach((t)=>{
                        var e = t[1];
                        return o[$e444d6404c095fa5$var$Xs(t[0].toString())] = $e444d6404c095fa5$var$Xs(e.toString());
                    }), (r += ":") + $e444d6404c095fa5$var$Ur(o).map((t)=>t[0] + '="' + t[1] + '"').join("");
                }).join(";");
            }(function(t) {
                return t.map((t)=>{
                    var e, i, r = {
                        text: null == (e = t.$el_text) ? void 0 : e.slice(0, 400),
                        tag_name: t.tag_name,
                        href: null == (i = t.attr__href) ? void 0 : i.slice(0, 2048),
                        attr_class: $e444d6404c095fa5$var$Zs(t),
                        attr_id: t.attr__id,
                        nth_child: t.nth_child,
                        nth_of_type: t.nth_of_type,
                        attributes: {}
                    };
                    return $e444d6404c095fa5$var$Ur(t).filter((t)=>0 === t[0].indexOf("attr__")).forEach((t)=>r.attributes[t[0]] = t[1]), r;
                });
            }(g)))
        }, null != (r = m[0]) && r.$el_text ? {
            $el_text: null == (s = m[0]) ? void 0 : s.$el_text
        } : {}, p && "click" === n.type ? {
            $external_click_url: p
        } : {}, b)
    };
}
var $e444d6404c095fa5$var$il = $e444d6404c095fa5$var$bi("[ExceptionAutocapture]"), $e444d6404c095fa5$var$rl = ()=>{}, $e444d6404c095fa5$var$sl = $e444d6404c095fa5$var$bi("[TracingHeaders]"), $e444d6404c095fa5$var$nl = $e444d6404c095fa5$var$bi("[Web Vitals]"), $e444d6404c095fa5$var$ol = 9e5, $e444d6404c095fa5$var$al = "disabled", $e444d6404c095fa5$var$ll = "lazy_loading", $e444d6404c095fa5$var$ul = "awaiting_config", $e444d6404c095fa5$var$hl = "missing_config";
$e444d6404c095fa5$var$bi("[SessionRecording]"), $e444d6404c095fa5$var$bi("[SessionRecording]");
var $e444d6404c095fa5$var$dl = "[SessionRecording]", $e444d6404c095fa5$var$vl = $e444d6404c095fa5$var$bi($e444d6404c095fa5$var$dl), $e444d6404c095fa5$var$cl = $e444d6404c095fa5$var$bi("[Heatmaps]");
function $e444d6404c095fa5$var$fl(t) {
    return $e444d6404c095fa5$var$W(t) && "clientX" in t && "clientY" in t && $e444d6404c095fa5$var$Z(t.clientX) && $e444d6404c095fa5$var$Z(t.clientY);
}
var $e444d6404c095fa5$var$pl = $e444d6404c095fa5$var$bi("[Product Tours]"), $e444d6404c095fa5$var$_l = (t)=>{
    var e;
    return !t.config.disable_product_tours && !(null == (e = t.persistence) || !e.get_property($e444d6404c095fa5$var$Mi));
}, $e444d6404c095fa5$var$gl = [
    "$set_once",
    "$set"
], $e444d6404c095fa5$var$ml = $e444d6404c095fa5$var$bi("[SiteApps]"), $e444d6404c095fa5$var$bl = "Error while initializing PostHog app with config id ";
function $e444d6404c095fa5$var$yl(t, e, i) {
    if ($e444d6404c095fa5$var$X(t)) return !1;
    switch(i){
        case "exact":
            return t === e;
        case "contains":
            var r = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
            return new RegExp(r, "i").test(t);
        case "regex":
            try {
                return new RegExp(e).test(t);
            } catch (t) {
                return !1;
            }
        default:
            return !1;
    }
}
class $e444d6404c095fa5$var$wl {
    constructor(t){
        this.rs = new $e444d6404c095fa5$var$la, this.ns = (t, e)=>this.ss(t, e) && this.os(t, e) && this.ls(t, e) && this.us(t, e), this.ss = (t, e)=>null == e || !e.event || (null == t ? void 0 : t.event) === (null == e ? void 0 : e.event), this._instance = t, this.hs = new Set, this.ds = new Set;
    }
    init() {
        var t, e;
        $e444d6404c095fa5$var$K(null == (t = this._instance) ? void 0 : t._addCaptureHook) || null == (e = this._instance) || e._addCaptureHook((t, e)=>{
            this.on(t, e);
        });
    }
    register(t) {
        var e, i;
        if (!$e444d6404c095fa5$var$K(null == (e = this._instance) ? void 0 : e._addCaptureHook) && (t.forEach((t)=>{
            var e, i;
            null == (e = this.ds) || e.add(t), null == (i = t.steps) || i.forEach((t)=>{
                var e;
                null == (e = this.hs) || e.add((null == t ? void 0 : t.event) || "");
            });
        }), null != (i = this._instance) && i.autocapture)) {
            var r, s = new Set;
            t.forEach((t)=>{
                var e;
                null == (e = t.steps) || e.forEach((t)=>{
                    null != t && t.selector && s.add(null == t ? void 0 : t.selector);
                });
            }), null == (r = this._instance) || r.autocapture.setElementSelectors(s);
        }
    }
    on(t, e) {
        var i;
        null != e && 0 != t.length && (this.hs.has(t) || this.hs.has(e.event)) && this.ds && (null == (i = this.ds) ? void 0 : i.size) > 0 && this.ds.forEach((t)=>{
            this.vs(e, t) && this.rs.emit("actionCaptured", t.name);
        });
    }
    cs(t) {
        this.onAction("actionCaptured", (e)=>t(e));
    }
    vs(t, e) {
        if (null == (null == e ? void 0 : e.steps)) return !1;
        for (var i of e.steps)if (this.ns(t, i)) return !0;
        return !1;
    }
    onAction(t, e) {
        return this.rs.on(t, e);
    }
    os(t, e) {
        if (null != e && e.url) {
            var i, r = null == t || null == (i = t.properties) ? void 0 : i.$current_url;
            if (!r || "string" != typeof r) return !1;
            if (!$e444d6404c095fa5$var$yl(r, e.url, e.url_matching || "contains")) return !1;
        }
        return !0;
    }
    ls(t, e) {
        return !!this.fs(t, e) && !!this.ps(t, e) && !!this.gs(t, e);
    }
    fs(t, e) {
        var i;
        if (null == e || !e.href) return !0;
        var r = this.ys(t);
        if (r.length > 0) return r.some((t)=>$e444d6404c095fa5$var$yl(t.href, e.href, e.href_matching || "exact"));
        var s, n = (null == t || null == (i = t.properties) ? void 0 : i.$elements_chain) || "";
        return !!n && $e444d6404c095fa5$var$yl((s = n.match(/(?::|")href="(.*?)"/)) ? s[1] : "", e.href, e.href_matching || "exact");
    }
    ps(t, e) {
        var i;
        if (null == e || !e.text) return !0;
        var r = this.ys(t);
        if (r.length > 0) return r.some((t)=>$e444d6404c095fa5$var$yl(t.text, e.text, e.text_matching || "exact") || $e444d6404c095fa5$var$yl(t.$el_text, e.text, e.text_matching || "exact"));
        var s, n, o, a = (null == t || null == (i = t.properties) ? void 0 : i.$elements_chain) || "";
        return !!a && (s = function(t) {
            for(var e, i = [], r = /(?::|")text="(.*?)"/g; !$e444d6404c095fa5$var$X(e = r.exec(t));)i.includes(e[1]) || i.push(e[1]);
            return i;
        }(a), n = e.text, o = e.text_matching || "exact", s.some((t)=>$e444d6404c095fa5$var$yl(t, n, o)));
    }
    gs(t, e) {
        var i, r;
        if (null == e || !e.selector) return !0;
        var s = null == t || null == (i = t.properties) ? void 0 : i.$element_selectors;
        if (null != s && s.includes(e.selector)) return !0;
        var n = (null == t || null == (r = t.properties) ? void 0 : r.$elements_chain) || "";
        if (e.selector_regex && n) try {
            return new RegExp(e.selector_regex).test(n);
        } catch (t) {
            return !1;
        }
        return !1;
    }
    ys(t) {
        var e;
        return null == (null == t || null == (e = t.properties) ? void 0 : e.$elements) ? [] : null == t ? void 0 : t.properties.$elements;
    }
    us(t, e) {
        return null == e || !e.properties || 0 === e.properties.length || $e444d6404c095fa5$var$ga(e.properties.reduce((t, e)=>{
            var i = $e444d6404c095fa5$var$q(e.value) ? e.value.map(String) : null != e.value ? [
                String(e.value)
            ] : [];
            return t[e.key] = {
                values: i,
                operator: e.operator || "exact"
            }, t;
        }, {}), null == t ? void 0 : t.properties);
    }
}
class $e444d6404c095fa5$var$xl {
    constructor(t){
        var e;
        this.bs = [], this._instance = t, this._s = new Map, this.ws = new Map, this.ks = new Map, null == (e = this._instance) || null == e.onSessionId || e.onSessionId((t)=>this.xs(t));
    }
    Ss(t) {
        return !1;
    }
    Cs() {
        return null;
    }
    Ms(t) {}
    Ts() {}
    Es(t, e) {
        return !!t && $e444d6404c095fa5$var$ga(t.propertyFilters, null == e ? void 0 : e.properties);
    }
    Is(t, e) {
        var i = new Map;
        return t.forEach((t)=>{
            var r;
            null == (r = t.conditions) || null == (r = r[e]) || null == (r = r.values) || r.forEach((e)=>{
                if (null != e && e.name) {
                    var r = i.get(e.name) || [];
                    r.push(t.id), i.set(e.name, r);
                }
            });
        }), i;
    }
    Ps(t, e, i) {
        var r = (i === $e444d6404c095fa5$export$352273f853caad57.Activation ? this._s : this.ws).get(t), s = [];
        return this.Rs((t)=>{
            s = t.filter((t)=>null == r ? void 0 : r.includes(t.id));
        }), s.filter((r)=>{
            var s, n = null == (s = r.conditions) || null == (s = s[i]) || null == (s = s.values) ? void 0 : s.find((e)=>e.name === t);
            return this.Es(n, e);
        });
    }
    register(t) {
        var e;
        $e444d6404c095fa5$var$K(null == (e = this._instance) ? void 0 : e._addCaptureHook) || (this.As(t), this.Fs(t));
    }
    Fs(t) {
        var e = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.actions) && (null == (i = t.conditions) || null == (i = i.actions) || null == (i = i.values) ? void 0 : i.length) > 0;
        });
        0 !== e.length && (null == this.Ls && (this.Ls = new $e444d6404c095fa5$var$wl(this._instance), this.Ls.init(), this.Ls.cs((t)=>{
            this.onAction(t);
        })), e.forEach((t)=>{
            var e, i, r, s, n;
            t.conditions && null != (e = t.conditions) && e.actions && null != (i = t.conditions) && null != (i = i.actions) && i.values && (null == (r = t.conditions) || null == (r = r.actions) || null == (r = r.values) ? void 0 : r.length) > 0 && (null == (s = this.Ls) || s.register(t.conditions.actions.values), null == (n = t.conditions) || null == (n = n.actions) || null == (n = n.values) || n.forEach((e)=>{
                if (e && e.name) {
                    var i = this.ks.get(e.name);
                    i && i.push(t.id), this.ks.set(e.name, i || [
                        t.id
                    ]);
                }
            }));
        }));
    }
    As(t) {
        var e, i = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.events) && (null == (i = t.conditions) || null == (i = i.events) || null == (i = i.values) ? void 0 : i.length) > 0;
        }), r = t.filter((t)=>{
            var e, i;
            return (null == (e = t.conditions) ? void 0 : e.cancelEvents) && (null == (i = t.conditions) || null == (i = i.cancelEvents) || null == (i = i.values) ? void 0 : i.length) > 0;
        });
        0 === i.length && 0 === r.length || (null == (e = this._instance) || e._addCaptureHook((t, e)=>{
            this.onEvent(t, e);
        }), this._s = this.Is(t, $e444d6404c095fa5$export$352273f853caad57.Activation), this.ws = this.Is(t, $e444d6404c095fa5$export$352273f853caad57.Cancellation));
    }
    onEvent(t, e) {
        var i, r, s = this.Os(), n = (null == e || null == (i = e.properties) ? void 0 : i.$survey_id) || (null == e || null == (r = e.properties) ? void 0 : r.$product_tour_id);
        if (n && this.getActivatedIds().includes(n)) {
            var o = this.Ds(t, n);
            if ("consume" === o) return s.info("event consumed activated item, removing it", {
                event: t,
                itemId: n
            }), void this.$s([
                n
            ]);
            if ("persist" === o) return s.info("shown item promoted to persisted activation", {
                event: t,
                itemId: n
            }), this.Ns(n), void this.qs([
                n
            ]);
        }
        if (this.ws.has(t)) {
            var a = this.Ps(t, e, $e444d6404c095fa5$export$352273f853caad57.Cancellation);
            a.length > 0 && (s.info("cancel event matched, cancelling items", {
                event: t,
                itemsToCancel: a.map((t)=>t.id)
            }), this.$s(a.map((t)=>t.id)), a.forEach((t)=>this.js(t.id)));
        }
        if (this._s.has(t)) {
            s.info("event name matched", {
                event: t,
                eventPayload: e,
                items: this._s.get(t)
            });
            var l = this.Ps(t, e, $e444d6404c095fa5$export$352273f853caad57.Activation);
            this.Bs(l.map((t)=>t.id));
        }
    }
    onAction(t) {
        this.ks.has(t) && this.Bs(this.ks.get(t) || []);
    }
    Bs(t) {
        var e;
        if (0 !== t.length) {
            var i = !(null == (e = this._instance) || null == e.get_session_id || !e.get_session_id()), r = [];
            for (var s of t)i && this.Ss(s) ? this.Ns(s) && this.Hs(s) : r.push(s);
            r.length > 0 && (this.bs = [
                ...new Set([
                    ...this.bs,
                    ...r
                ])
            ]), this.Os().info("updating activated items", {
                activatedItems: this.getActivatedIds()
            });
        }
    }
    Ns(t) {
        this.bs = this.bs.filter((e)=>e !== t);
        var e = this.Us();
        return !e.includes(t) && (this.zs([
            ...e,
            t
        ]), this.Ws(), !0);
    }
    $s(t) {
        var e = new Set(t);
        this.bs = this.bs.filter((t)=>!e.has(t));
        var i = this.Vs(), r = i.filter((t)=>!e.has(t));
        r.length !== i.length && (this.zs(r), 0 === r.length && this.Zs()), this.qs(t);
    }
    Gs() {
        var t, e = this.Cs();
        if (!e) return {};
        var i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[e];
        return i && "object" == typeof i ? i : {};
    }
    Hs(t) {
        if (this.Cs()) {
            var e = this.Gs();
            this.Ms($e444d6404c095fa5$var$_({}, e, {
                [t]: Date.now()
            }));
        }
    }
    qs(t) {
        if (this.Cs()) {
            var e = this.Gs(), i = {}, r = !1;
            for (var s of Object.entries(e)){
                var n = s[0], o = s[1];
                t.includes(n) ? r = !0 : i[n] = o;
            }
            r && ($e444d6404c095fa5$var$G(i) ? this.Ts() : this.Ms(i));
        }
    }
    Qs() {
        this.Cs() && this.Ts();
    }
    getActivationTimestamp(t) {
        if (this.Us().includes(t)) {
            var e = this.Gs()[t];
            return $e444d6404c095fa5$var$Z(e) ? e : void 0;
        }
    }
    Vs() {
        var t, e = this.Ks();
        return (null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[e]) || [];
    }
    Us() {
        var t, e, i = this.Vs();
        if (0 === i.length) return [];
        var r = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.props[this.Js()], s = null == (e = this._instance) || null == e.get_session_id ? void 0 : e.get_session_id();
        return s && r === s ? i : [];
    }
    Ws() {
        var t, e = null == (t = this._instance) || null == t.get_session_id ? void 0 : t.get_session_id();
        e && this.Ys(e);
    }
    Zs() {
        this.Xs();
    }
    xs(t) {
        var e, i = null == (e = this._instance) || null == (e = e.persistence) ? void 0 : e.props[this.Js()];
        if (i && i !== t) {
            var r = this.Vs(), s = this.Gs();
            r.length > 0 && (this.zs([]), r.filter((t)=>$e444d6404c095fa5$var$Z(s[t])).forEach((t)=>this.js(t))), this.Zs(), this.Qs();
        }
    }
    getActivatedIds() {
        return [
            ...new Set([
                ...this.Us(),
                ...this.bs
            ])
        ].filter((t)=>!this.ta(t));
    }
    reset() {
        this.bs = [], this.Vs().length > 0 && this.zs([]), this.Zs(), this.Qs();
    }
    getEventToItemsMap() {
        return this._s;
    }
    ea() {
        return this.Ls;
    }
}
class $e444d6404c095fa5$var$El extends $e444d6404c095fa5$var$xl {
    constructor(t){
        super(t);
    }
    Ks() {
        return $e444d6404c095fa5$var$rr;
    }
    Js() {
        return $e444d6404c095fa5$var$sr;
    }
    Cs() {
        return $e444d6404c095fa5$var$nr;
    }
    Ms(t) {
        var e;
        null == (e = this._instance) || null == (e = e.persistence) || e.register({
            [$e444d6404c095fa5$var$nr]: t
        });
    }
    Ts() {
        var t;
        null == (t = this._instance) || null == (t = t.persistence) || t.unregister($e444d6404c095fa5$var$nr);
    }
    Ss(t) {
        var e, i;
        this.Rs((e)=>{
            i = e.find((e)=>e.id === t);
        });
        var r = null == (e = i) || null == (e = e.appearance) ? void 0 : e.surveyPopupDelaySeconds;
        return $e444d6404c095fa5$var$Z(r) && r > 0;
    }
    ia() {
        return $e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN;
    }
    Rs(t) {
        var e;
        null == (e = this._instance) || e.getSurveys(t);
    }
    js(t) {
        var e;
        null == (e = this._instance) || e.cancelPendingSurvey(t);
    }
    Os() {
        return $e444d6404c095fa5$var$Ea;
    }
    zs(t) {
        var e;
        null == (e = this._instance) || null == (e = e.persistence) || e.register({
            [$e444d6404c095fa5$var$rr]: t
        });
    }
    Ys(t) {
        var e;
        null == (e = this._instance) || null == (e = e.persistence) || e.register({
            [$e444d6404c095fa5$var$sr]: t
        });
    }
    Xs() {
        var t;
        null == (t = this._instance) || null == (t = t.persistence) || t.unregister($e444d6404c095fa5$var$sr);
    }
    ta() {
        return !1;
    }
    Ds(t, e) {
        var i;
        this.Rs((t)=>{
            i = t.find((t)=>t.id === e);
        });
        var r = !i || function(t) {
            var e;
            return $e444d6404c095fa5$var$xa(t) && !(null == (e = t.conditions) || null == (e = e.events) || !e.repeatedActivation) || "always" === t.schedule;
        }(i);
        return r ? t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN ? "consume" : "ignore" : t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SHOWN ? "persist" : t === $e444d6404c095fa5$export$9d7ec1793ca1658e.DISMISSED || t === $e444d6404c095fa5$export$9d7ec1793ca1658e.SENT ? "consume" : "ignore";
    }
    getSurveys() {
        return this.getActivatedIds();
    }
    getEventToSurveys() {
        return this.getEventToItemsMap();
    }
}
var $e444d6404c095fa5$var$Sl = "SDK is not enabled or survey functionality is not yet loaded", $e444d6404c095fa5$var$$l = "Disabled. Not loading surveys.", $e444d6404c095fa5$var$kl = null != $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.location ? $e444d6404c095fa5$var$mn($e444d6404c095fa5$var$t.location.hash, "__posthog") || $e444d6404c095fa5$var$mn(location.hash, "state") : null, $e444d6404c095fa5$var$Tl = "_postHogToolbarParams", $e444d6404c095fa5$var$Rl = $e444d6404c095fa5$var$bi("[Toolbar]"), $e444d6404c095fa5$var$Pl = $e444d6404c095fa5$var$bi("[FeatureFlags]"), $e444d6404c095fa5$var$Ol = $e444d6404c095fa5$var$bi("[FeatureFlags]", {
    debugEnabled: !0
}), $e444d6404c095fa5$var$Il = "\" failed. Feature flags didn't load in time.", $e444d6404c095fa5$var$Cl = (t)=>{
    for(var e = {}, i = 0; t.length > i; i++)e[t[i]] = !0;
    return e;
}, $e444d6404c095fa5$var$Al = (t)=>{
    var e = {};
    for (var i of $e444d6404c095fa5$var$Ur(t || {})){
        var r = i[1];
        r && (e[i[0]] = r);
    }
    return e;
}, $e444d6404c095fa5$var$Ml = $e444d6404c095fa5$var$bi("[Error tracking]"), $e444d6404c095fa5$var$Fl = "Refusing to render web experiment since the viewer is a likely bot", $e444d6404c095fa5$var$Dl = {
    icontains: (t, e)=>e.toLowerCase().indexOf(t.toLowerCase()) > -1,
    not_icontains: (t, e)=>-1 === e.toLowerCase().indexOf(t.toLowerCase()),
    regex: (t, e)=>$e444d6404c095fa5$var$ca(e, t),
    not_regex: (t, e)=>!$e444d6404c095fa5$var$ca(e, t),
    exact: (t, e)=>e === t,
    is_not: (t, e)=>e !== t
};
class $e444d6404c095fa5$var$Nl {
    get Ne() {
        return this._instance.config;
    }
    constructor(t){
        var e = this;
        this.getWebExperimentsAndEvaluateDisplayLogic = function(t) {
            void 0 === t && (t = !1), e.getWebExperiments((t)=>{
                $e444d6404c095fa5$var$Nl.ra("retrieved web experiments from the server"), e.na = new Map, t.forEach((t)=>{
                    if (t.feature_flag_key) {
                        var i;
                        e.na && ($e444d6404c095fa5$var$Nl.ra("setting flag key ", t.feature_flag_key, " to web experiment ", t), null == (i = e.na) || i.set(t.feature_flag_key, t));
                        var r = e._instance.getFeatureFlag(t.feature_flag_key);
                        $e444d6404c095fa5$var$J(r) && t.variants[r] && e.sa(t.name, r, t.variants[r].transforms);
                    } else if (t.variants) for(var s in t.variants){
                        var n = t.variants[s];
                        $e444d6404c095fa5$var$Nl.aa(n, e._instance) && e.sa(t.name, s, n.transforms);
                    }
                });
            }, t);
        }, this._instance = t, this._instance.onFeatureFlags((t)=>{
            this.onFeatureFlags(t);
        });
    }
    initialize() {}
    onFeatureFlags(t) {
        if (this._is_bot()) $e444d6404c095fa5$var$Nl.ra($e444d6404c095fa5$var$Fl);
        else if (!this.Ne.disable_web_experiments) {
            if ($e444d6404c095fa5$var$X(this.na)) return this.na = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            $e444d6404c095fa5$var$Nl.ra("applying feature flags", t), t.forEach((t)=>{
                var e;
                if (this.na && null != (e = this.na) && e.has(t)) {
                    var i, r = this._instance.getFeatureFlag(t), s = null == (i = this.na) ? void 0 : i.get(t);
                    r && null != s && s.variants[r] && this.sa(s.name, r, s.variants[r].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var t = $e444d6404c095fa5$var$Nl.getWindowLocation();
        if (null != t && t.search) {
            var e = $e444d6404c095fa5$var$_n(null == t ? void 0 : t.search, "__experiment_id"), i = $e444d6404c095fa5$var$_n(null == t ? void 0 : t.search, "__experiment_variant");
            e && i && ($e444d6404c095fa5$var$Nl.ra("previewing web experiments " + e + " && " + i), this.getWebExperiments((t)=>{
                this.oa(parseInt(e), i, t);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.Ne.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(t, e, i) {
        if (this.Ne.disable_web_experiments && !i) return t([]);
        var r = this._instance.get_property("$web_experiments");
        if (r && !e) return t(r);
        this._instance._send_request({
            url: this._instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=" + this.Ne.token),
            method: "GET",
            timestampMode: "query",
            callback: (e)=>t(200 === e.statusCode && e.json && e.json.experiments || [])
        });
    }
    oa(t, e, i) {
        var r = i.filter((e)=>e.id === t);
        r && r.length > 0 && ($e444d6404c095fa5$var$Nl.ra("Previewing web experiment [" + r[0].name + "] with variant [" + e + "]"), this.sa(r[0].name, e, r[0].variants[e].transforms));
    }
    static aa(t, e) {
        return !$e444d6404c095fa5$var$X(t.conditions) && $e444d6404c095fa5$var$Nl.la(t, e) && $e444d6404c095fa5$var$Nl.ua(t);
    }
    static la(t, e) {
        var i;
        if ($e444d6404c095fa5$var$X(t.conditions) || $e444d6404c095fa5$var$X(null == (i = t.conditions) ? void 0 : i.url)) return !0;
        var r = $e444d6404c095fa5$var$Nl.getWindowLocation();
        if (r) {
            var s, n, o, a = $e444d6404c095fa5$var$ds(e, r.href);
            return null == (s = t.conditions) || !s.url || $e444d6404c095fa5$var$Dl[null !== (n = null == (o = t.conditions) ? void 0 : o.urlMatchType) && void 0 !== n ? n : "icontains"](t.conditions.url, a);
        }
        return !1;
    }
    static getWindowLocation() {
        return null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location;
    }
    static ua(t) {
        var e;
        if ($e444d6404c095fa5$var$X(t.conditions) || $e444d6404c095fa5$var$X(null == (e = t.conditions) ? void 0 : e.utm)) return !0;
        var i = $e444d6404c095fa5$var$kn();
        if (i.utm_source) {
            var r, s, n, o, a, l, u, h, d = null == (r = t.conditions) || null == (r = r.utm) || !r.utm_campaign || (null == (s = t.conditions) || null == (s = s.utm) ? void 0 : s.utm_campaign) == i.utm_campaign, v = null == (n = t.conditions) || null == (n = n.utm) || !n.utm_source || (null == (o = t.conditions) || null == (o = o.utm) ? void 0 : o.utm_source) == i.utm_source, c = null == (a = t.conditions) || null == (a = a.utm) || !a.utm_medium || (null == (l = t.conditions) || null == (l = l.utm) ? void 0 : l.utm_medium) == i.utm_medium, f = null == (u = t.conditions) || null == (u = u.utm) || !u.utm_term || (null == (h = t.conditions) || null == (h = h.utm) ? void 0 : h.utm_term) == i.utm_term;
            return d && c && f && v;
        }
        return !1;
    }
    static ra(t) {
        for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
        $e444d6404c095fa5$var$mi.info("[WebExperiments] " + t, i);
    }
    sa(t, e, i) {
        this._is_bot() ? $e444d6404c095fa5$var$Nl.ra($e444d6404c095fa5$var$Fl) : "control" !== e ? i.forEach((i)=>{
            if (i.selector) {
                var r;
                $e444d6404c095fa5$var$Nl.ra("applying transform of variant " + e + " for experiment " + t + " ", i);
                var s = null == (r = document) ? void 0 : r.querySelectorAll(i.selector);
                null == s || s.forEach((t)=>{
                    var e = t;
                    i.html && (e.innerHTML = i.html), i.css && e.setAttribute("style", i.css);
                });
            }
        }) : $e444d6404c095fa5$var$Nl.ra("Control variants leave the page unmodified.");
    }
    _is_bot() {
        return $e444d6404c095fa5$var$i && this._instance ? $e444d6404c095fa5$var$da($e444d6404c095fa5$var$i, this.Ne.custom_blocked_useragents) : void 0;
    }
}
var $e444d6404c095fa5$var$Ul = $e444d6404c095fa5$var$bi("[Conversations]"), $e444d6404c095fa5$var$Ll = "Conversations not available yet.", $e444d6404c095fa5$var$jl = "console", $e444d6404c095fa5$var$Bl = "__posthogHandledLogsRequestError", $e444d6404c095fa5$var$zl = (t, e)=>{
    var i = t instanceof Error ? t : new Error(e);
    return i[$e444d6404c095fa5$var$Bl] = !0, i;
}, $e444d6404c095fa5$var$Hl = (t)=>!!t && "object" == typeof t && !0 === t[$e444d6404c095fa5$var$Bl], $e444d6404c095fa5$var$ql = {
    featureFlags: class {
        constructor(e){
            this.ha = !1, this.da = !1, this.va = !1, this.ca = !1, this.fa = !1, this.pa = !1, this.ga = !1, this.ma = !1, this.ya = 0, this.ba = ()=>{
                var t = this._a();
                this.ya = 0, t && this.reloadFeatureFlags();
            }, this._instance = e, this.featureFlagEventHandlers = [], $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "online", this.ba);
        }
        destroy() {
            null == $e444d6404c095fa5$var$t || $e444d6404c095fa5$var$t.removeEventListener("online", this.ba);
        }
        get Ne() {
            return this._instance.config;
        }
        get Tr() {
            return this._instance.persistence;
        }
        wa(t) {
            return this._instance.get_property(t);
        }
        ka() {
            var t, e;
            return null !== (t = null == (e = this.Tr) ? void 0 : e.Ci(this.Ne.feature_flag_cache_ttl_ms)) && void 0 !== t && t;
        }
        xa() {
            return !!this.ka() && (this.ma || this.va || (this.ma = !0, $e444d6404c095fa5$var$Pl.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
        }
        Sa() {
            var t, e = null !== (t = this.Ne.evaluation_contexts) && void 0 !== t ? t : this.Ne.evaluation_environments;
            return !this.Ne.evaluation_environments || this.Ne.evaluation_contexts || this.ga || ($e444d6404c095fa5$var$Pl.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.ga = !0), null != e && e.length ? e.filter((t)=>{
                var e = t && "string" == typeof t && t.trim().length > 0;
                return e || $e444d6404c095fa5$var$Pl.error("Invalid evaluation context found:", t, "Expected non-empty string"), e;
            }) : [];
        }
        Ca() {
            return this.Sa().length > 0;
        }
        Ma() {
            var t = this.Ne.flag_keys;
            if (!$e444d6404c095fa5$var$K(t)) {
                if ($e444d6404c095fa5$var$q(t)) return t.filter((t)=>{
                    var e = t && "string" == typeof t && t.trim().length > 0;
                    return e || $e444d6404c095fa5$var$Pl.error("Invalid flag key found:", t, "Expected non-empty string"), e;
                });
                $e444d6404c095fa5$var$Pl.error("Invalid flag_keys found:", t, "Expected array of non-empty strings");
            }
        }
        initialize() {
            var t, e, i = this._instance.config, r = null !== (t = null == (e = i.bootstrap) ? void 0 : e.featureFlags) && void 0 !== t ? t : {};
            if (Object.keys(r).length) {
                var s, n, o = null !== (s = null == (n = i.bootstrap) ? void 0 : n.featureFlagPayloads) && void 0 !== s ? s : {}, a = Object.keys(r).filter((t)=>!!r[t]).reduce((t, e)=>(t[e] = r[e] || !1, t), {}), l = Object.keys(o).filter((t)=>a[t]).reduce((t, e)=>(o[e] && (t[e] = o[e]), t), {});
                this.receivedFeatureFlags({
                    featureFlags: a,
                    featureFlagPayloads: l
                });
            }
        }
        updateFlags(t, e, i) {
            var r, s, n = null != i && i.merge && null !== (r = this.wa($e444d6404c095fa5$var$qi)) && void 0 !== r ? r : {}, o = null != i && i.merge && null !== (s = this.wa($e444d6404c095fa5$var$Ki)) && void 0 !== s ? s : {}, a = $e444d6404c095fa5$var$_({}, n, t), l = $e444d6404c095fa5$var$_({}, o, e), u = {};
            for (var h of Object.entries(a)){
                var d = h[0], v = h[1];
                u[d] = {
                    key: d,
                    enabled: $e444d6404c095fa5$var$b(v),
                    variant: $e444d6404c095fa5$var$y(v),
                    reason: void 0,
                    metadata: $e444d6404c095fa5$var$K(null == l ? void 0 : l[d]) ? void 0 : {
                        id: 0,
                        version: void 0,
                        description: void 0,
                        payload: l[d]
                    }
                };
            }
            this.receivedFeatureFlags({
                flags: u
            });
        }
        get hasLoadedFlags() {
            return this.da;
        }
        getFlags() {
            return Object.keys(this.getFlagVariants());
        }
        getFlagsWithDetails() {
            var t = this.wa($e444d6404c095fa5$var$Gi), e = this.wa($e444d6404c095fa5$var$Qi), i = this.wa($e444d6404c095fa5$var$Xi);
            if (!i && !e) return t || {};
            var r = $e444d6404c095fa5$var$Nr({}, t || {}), s = [
                ...new Set([
                    ...Object.keys(i || {}),
                    ...Object.keys(e || {})
                ])
            ];
            for (var n of s){
                var o, a, l = r[n], u = null == e ? void 0 : e[n], h = $e444d6404c095fa5$var$K(u) ? null !== (o = null == l ? void 0 : l.enabled) && void 0 !== o && o : !!u, d = $e444d6404c095fa5$var$K(u) ? l.variant : "string" == typeof u ? u : void 0, v = null == i ? void 0 : i[n], c = $e444d6404c095fa5$var$_({}, l, {
                    enabled: h,
                    variant: h ? null != d ? d : null == l ? void 0 : l.variant : void 0
                });
                h !== (null == l ? void 0 : l.enabled) && (c.original_enabled = null == l ? void 0 : l.enabled), d !== (null == l ? void 0 : l.variant) && (c.original_variant = null == l ? void 0 : l.variant), v && (c.metadata = $e444d6404c095fa5$var$_({}, null == l ? void 0 : l.metadata, {
                    payload: v,
                    original_payload: null == l || null == (a = l.metadata) ? void 0 : a.payload
                })), r[n] = c;
            }
            return this.ha || ($e444d6404c095fa5$var$Pl.warn(" Overriding feature flag details!", {
                flagDetails: t,
                overriddenPayloads: i,
                finalDetails: r
            }), this.ha = !0), r;
        }
        getAllFeatureFlags() {
            var t = this.getFlagVariants(), e = this.getFlagPayloads();
            return Object.keys(t).map((i)=>{
                var r = t[i];
                return {
                    key: i,
                    enabled: $e444d6404c095fa5$var$b(r),
                    variant: $e444d6404c095fa5$var$y(r),
                    payload: $e444d6404c095fa5$var$m(e[i])
                };
            });
        }
        getFlagVariants() {
            var t = this.wa($e444d6404c095fa5$var$qi), e = this.wa($e444d6404c095fa5$var$Qi);
            if (!e) return t || {};
            for(var i = $e444d6404c095fa5$var$Nr({}, t), r = Object.keys(e), s = 0; r.length > s; s++)i[r[s]] = e[r[s]];
            return this.ha || ($e444d6404c095fa5$var$Pl.warn(" Overriding feature flags!", {
                enabledFlags: t,
                overriddenFlags: e,
                finalFlags: i
            }), this.ha = !0), i;
        }
        getFlagPayloads() {
            var t = this.wa($e444d6404c095fa5$var$Ki), e = this.wa($e444d6404c095fa5$var$Xi);
            if (!e) return t || {};
            for(var i = $e444d6404c095fa5$var$Nr({}, t || {}), r = Object.keys(e), s = 0; r.length > s; s++)i[r[s]] = e[r[s]];
            return this.ha || ($e444d6404c095fa5$var$Pl.warn(" Overriding feature flag payloads!", {
                flagPayloads: t,
                overriddenPayloads: e,
                finalPayloads: i
            }), this.ha = !0), i;
        }
        reloadFeatureFlags() {
            this.ca || this.Ne.advanced_disable_feature_flags || this._a() || this.Ta || (this._instance.vn.emit("featureFlagsReloading", !0), this.Ta = setTimeout(()=>{
                this.Ea();
            }, 5));
        }
        Ia() {
            clearTimeout(this.Ta), this.Ta = void 0;
        }
        ensureFlagsLoaded() {
            this.da || this.va || this.Ta || this.reloadFeatureFlags();
        }
        setAnonymousDistinctId(t) {
            this.$anon_distinct_id = t;
        }
        setReloadingPaused(t) {
            this.ca = t;
        }
        Ea(t) {
            var e;
            if (this.Ia(), !this._instance.Ki() && !this._a()) {
                if (this.va) this.fa = !0;
                else {
                    var i = this.Ne.token, r = this.wa($e444d6404c095fa5$var$Ei), s = {
                        token: i,
                        distinct_id: this._instance.get_distinct_id(),
                        groups: this._instance.getGroups(),
                        $anon_distinct_id: this.$anon_distinct_id,
                        person_properties: $e444d6404c095fa5$var$_({}, (null == (e = this.Tr) ? void 0 : e.get_initial_props()) || {}, this.wa($e444d6404c095fa5$var$Zi) || {}, {
                            $lib: $e444d6404c095fa5$var$c.LIB_NAME,
                            $lib_version: $e444d6404c095fa5$var$c.LIB_VERSION
                        }),
                        group_properties: this.wa($e444d6404c095fa5$var$tr),
                        timezone: $e444d6404c095fa5$var$Mn()
                    };
                    $e444d6404c095fa5$var$Q(r) || $e444d6404c095fa5$var$K(r) || (s.$device_id = r), (null != t && t.disableFlags || this.Ne.advanced_disable_feature_flags) && (s.disable_flags = !0), this.Ca() && (s.evaluation_contexts = this.Sa());
                    var n = this.Ma();
                    $e444d6404c095fa5$var$K(n) || (s.flag_keys = n);
                    var o = !!this.Ne.advanced_only_evaluate_survey_feature_flags, a = this._instance.requestRouter.endpointFor("flags", "/flags/?v=2" + (this.Ne.advanced_only_evaluate_survey_feature_flags ? "&only_evaluate_survey_feature_flags=true" : ""));
                    this.va = !0, this._instance._send_request({
                        method: "POST",
                        url: a,
                        data: s,
                        compression: this.Ne.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                        timestampMode: "body",
                        timeout: this.Ne.feature_flag_request_timeout_ms,
                        callback: (t)=>{
                            var e, i, r, n = !0;
                            if (this.Pa(t.statusCode), 200 === t.statusCode && (this.fa || (this.$anon_distinct_id = void 0), n = !1), this.va = !1, !s.disable_flags || this.fa) {
                                this.pa = !n;
                                var a = [];
                                t.error ? t.error instanceof Error ? a.push("AbortError" === t.error.name ? "timeout" : "connection_error") : a.push("unknown_error") : 200 !== t.statusCode && a.push("api_error_" + t.statusCode), null != (e = t.json) && e.errorsWhileComputingFlags && a.push("errors_while_computing_flags");
                                var l, u = !(null == (i = t.json) || null == (i = i.quotaLimited) || !i.includes("feature_flags"));
                                if (u && a.push("quota_limited"), null == (r = this.Tr) || r.register({
                                    [$e444d6404c095fa5$var$ur]: a
                                }), u) $e444d6404c095fa5$var$Pl.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.");
                                else s.disable_flags || this.receivedFeatureFlags(null !== (l = t.json) && void 0 !== l ? l : {}, n, {
                                    partialResponse: o
                                }), this.fa && (this.fa = !1, this.Ea());
                            }
                        }
                    });
                }
            }
        }
        _a() {
            return $e444d6404c095fa5$var$bn(this.ya, 3);
        }
        Pa(t) {
            this.ya = $e444d6404c095fa5$var$yn(t, this.ya, 3, ()=>$e444d6404c095fa5$var$Pl.warn("Feature flag requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped refreshing feature flags; will try again when connectivity changes."));
        }
        getFeatureFlag(t, e) {
            var i;
            if (void 0 === e && (e = {}), !e.fresh || this.pa) {
                if (this.da || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.xa()) {
                        var r = this.getFeatureFlagResult(t, e);
                        return null !== (i = null == r ? void 0 : r.variant) && void 0 !== i ? i : null == r ? void 0 : r.enabled;
                    }
                } else $e444d6404c095fa5$var$Pl.warn('getFeatureFlag for key "' + t + $e444d6404c095fa5$var$Il);
            }
        }
        getFeatureFlagDetails(t) {
            return this.getFlagsWithDetails()[t];
        }
        getFeatureFlagPayload(t) {
            var e = this.getFeatureFlagResult(t, {
                send_event: !1
            });
            return null == e ? void 0 : e.payload;
        }
        getFeatureFlagResult(t, e) {
            if (void 0 === e && (e = {}), !e.fresh || this.pa) {
                if (this.da || this.getFlags() && this.getFlags().length > 0) {
                    if (!this.xa()) {
                        var i = this.getFlagVariants(), r = t in i, s = i[t], n = this.getFlagPayloads()[t], o = String(s), a = this.wa($e444d6404c095fa5$var$Ji) || void 0, l = this.wa($e444d6404c095fa5$var$hr) || void 0, u = this.wa($e444d6404c095fa5$var$ar) || {};
                        if (this.Ne.advanced_feature_flags_dedup_per_session) {
                            var h, d = this._instance.get_session_id(), v = this.wa($e444d6404c095fa5$var$lr);
                            d && d !== v && (u = {}, null == (h = this.Tr) || h.register({
                                [$e444d6404c095fa5$var$ar]: u,
                                [$e444d6404c095fa5$var$lr]: d
                            }));
                        }
                        if ((e.send_event || !("send_event" in e)) && (!(t in u) || !u[t].includes(o))) {
                            var c, f, p, _, g, b, y, w, x, E, S;
                            $e444d6404c095fa5$var$q(u[t]) ? u[t].push(o) : u[t] = [
                                o
                            ], null == (c = this.Tr) || c.register({
                                [$e444d6404c095fa5$var$ar]: u
                            });
                            var k = this.getFeatureFlagDetails(t), T = [
                                ...null !== (f = this.wa($e444d6404c095fa5$var$ur)) && void 0 !== f ? f : []
                            ];
                            $e444d6404c095fa5$var$K(s) && T.push("flag_missing");
                            var R = {
                                $feature_flag: t,
                                $feature_flag_response: s,
                                $feature_flag_payload: n || null,
                                $feature_flag_request_id: a,
                                $feature_flag_evaluated_at: l,
                                $feature_flag_bootstrapped_response: (null == (p = this.Ne.bootstrap) || null == (p = p.featureFlags) ? void 0 : p[t]) || null,
                                $feature_flag_bootstrapped_payload: (null == (_ = this.Ne.bootstrap) || null == (_ = _.featureFlagPayloads) ? void 0 : _[t]) || null,
                                $used_bootstrap_value: !this.pa
                            };
                            $e444d6404c095fa5$var$K(null == k || null == (g = k.metadata) ? void 0 : g.has_experiment) || (R.$feature_flag_has_experiment = k.metadata.has_experiment), $e444d6404c095fa5$var$K(null == k || null == (b = k.metadata) ? void 0 : b.version) || (R.$feature_flag_version = k.metadata.version);
                            var P, O = null !== (y = null == k || null == (w = k.reason) ? void 0 : w.description) && void 0 !== y ? y : null == k || null == (x = k.reason) ? void 0 : x.code;
                            O && (R.$feature_flag_reason = O), null != k && null != (E = k.metadata) && E.id && (R.$feature_flag_id = k.metadata.id), $e444d6404c095fa5$var$K(null == k ? void 0 : k.original_variant) && $e444d6404c095fa5$var$K(null == k ? void 0 : k.original_enabled) || (R.$feature_flag_original_response = $e444d6404c095fa5$var$K(k.original_variant) ? k.original_enabled : k.original_variant), null != k && null != (S = k.metadata) && S.original_payload && (R.$feature_flag_original_payload = null == k || null == (P = k.metadata) ? void 0 : P.original_payload), T.length && (R.$feature_flag_error = T.join(",")), this._instance.capture("$feature_flag_called", R);
                        }
                        if (r) return {
                            key: t,
                            enabled: !!s,
                            variant: "string" == typeof s ? s : void 0,
                            payload: $e444d6404c095fa5$var$m(n)
                        };
                    }
                } else $e444d6404c095fa5$var$Pl.warn('getFeatureFlagResult for key "' + t + $e444d6404c095fa5$var$Il);
            }
        }
        getRemoteConfigPayload(t, e) {
            var i = this.Ne.token, r = {
                distinct_id: this._instance.get_distinct_id(),
                token: i,
                person_properties: {
                    $lib: $e444d6404c095fa5$var$c.LIB_NAME,
                    $lib_version: $e444d6404c095fa5$var$c.LIB_VERSION
                }
            };
            this.Ca() && (r.evaluation_contexts = this.Sa());
            var s = this.Ma();
            $e444d6404c095fa5$var$K(s) || (r.flag_keys = s), this._instance._send_request({
                method: "POST",
                url: this._instance.requestRouter.endpointFor("flags", "/flags/?v=2"),
                data: r,
                compression: this.Ne.disable_compression ? void 0 : $e444d6404c095fa5$export$6a00d17b5aff0af.Base64,
                timestampMode: "body",
                timeout: this.Ne.feature_flag_request_timeout_ms,
                callback (i) {
                    var r, s = null == (r = i.json) ? void 0 : r.featureFlagPayloads;
                    e((null == s ? void 0 : s[t]) || void 0);
                }
            });
        }
        isFeatureEnabled(t, e) {
            if (void 0 === e && (e = {}), e.fresh && !this.pa) return e.defaultValue;
            if (!(this.da || this.getFlags() && this.getFlags().length > 0)) return $e444d6404c095fa5$var$Pl.warn('isFeatureEnabled for key "' + t + $e444d6404c095fa5$var$Il), e.defaultValue;
            var i = this.getFeatureFlag(t, e);
            return $e444d6404c095fa5$var$K(i) ? e.defaultValue : !!i;
        }
        addFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers.push(t);
        }
        removeFeatureFlagsHandler(t) {
            this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((e)=>e !== t);
        }
        receivedFeatureFlags(t, e, i) {
            if (this.Tr) {
                this.da = !0;
                var r = this.getFlagVariants(), s = this.getFlagPayloads(), n = this.getFlagsWithDetails();
                !function(t, e, i, r, s, n) {
                    void 0 === i && (i = {}), void 0 === r && (r = {}), void 0 === s && (s = {});
                    var o = ((t)=>{
                        var e = t.flags;
                        return e ? (t.featureFlags = Object.fromEntries(Object.keys(e).map((t)=>{
                            var i;
                            return [
                                t,
                                null !== (i = e[t].variant) && void 0 !== i ? i : e[t].enabled
                            ];
                        })), t.featureFlagPayloads = Object.fromEntries(Object.keys(e).filter((t)=>e[t].enabled).filter((t)=>{
                            var i;
                            return null == (i = e[t].metadata) ? void 0 : i.payload;
                        }).map((t)=>{
                            var i;
                            return [
                                t,
                                null == (i = e[t].metadata) ? void 0 : i.payload
                            ];
                        }))) : t.featureFlags && $e444d6404c095fa5$var$Pl.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), t;
                    })(t), a = o.flags, l = o.featureFlags, u = o.featureFlagPayloads;
                    if (l) {
                        var h = t.requestId, d = t.evaluatedAt;
                        if ($e444d6404c095fa5$var$q(l)) {
                            $e444d6404c095fa5$var$Pl.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
                            var v = {};
                            if (l) for(var c = 0; l.length > c; c++)v[l[c]] = !0;
                            e && e.register({
                                [$e444d6404c095fa5$var$Vi]: l,
                                [$e444d6404c095fa5$var$qi]: v,
                                [$e444d6404c095fa5$var$Yi]: !1
                            });
                        } else {
                            var f = l, p = u, g = a;
                            if (null != n && n.partialResponse) f = $e444d6404c095fa5$var$_({}, i, f), p = $e444d6404c095fa5$var$_({}, r, p), g = $e444d6404c095fa5$var$_({}, s, g);
                            else if (t.errorsWhileComputingFlags) {
                                if (a) {
                                    var m = new Set(Object.keys(a).filter((t)=>{
                                        var e;
                                        return !(null != (e = a[t]) && e.failed);
                                    }));
                                    f = $e444d6404c095fa5$var$_({}, i, Object.fromEntries(Object.entries(f).filter((t)=>m.has(t[0])))), p = $e444d6404c095fa5$var$_({}, r, Object.fromEntries(Object.entries(p || {}).filter((t)=>m.has(t[0])))), g = $e444d6404c095fa5$var$_({}, s, Object.fromEntries(Object.entries(g || {}).filter((t)=>m.has(t[0]))));
                                } else f = $e444d6404c095fa5$var$_({}, i, f), p = $e444d6404c095fa5$var$_({}, r, p), g = $e444d6404c095fa5$var$_({}, s, g);
                            }
                            e && e.register($e444d6404c095fa5$var$_({
                                [$e444d6404c095fa5$var$Vi]: Object.keys($e444d6404c095fa5$var$Al(f)),
                                [$e444d6404c095fa5$var$qi]: f || {},
                                [$e444d6404c095fa5$var$Ki]: p || {},
                                [$e444d6404c095fa5$var$Gi]: g || {},
                                [$e444d6404c095fa5$var$Yi]: !0 === t.minimalFlagCalledEvents
                            }, h ? {
                                [$e444d6404c095fa5$var$Ji]: h
                            } : {}, d ? {
                                [$e444d6404c095fa5$var$hr]: d
                            } : {}));
                        }
                    }
                }(t, this.Tr, r, s, n, i), e || (this.ma = !1), this.Ra(e);
            }
        }
        override(t, e) {
            void 0 === e && (e = !1), $e444d6404c095fa5$var$Pl.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({
                flags: t,
                suppressWarning: e
            });
        }
        overrideFeatureFlags(t) {
            if (!this._instance.__loaded || !this.Tr) return $e444d6404c095fa5$var$Pl.uninitializedWarning("posthog.featureFlags.overrideFeatureFlags");
            if (!1 === t) return this.Tr.unregister($e444d6404c095fa5$var$Qi), this.Tr.unregister($e444d6404c095fa5$var$Xi), this.Ra(), $e444d6404c095fa5$var$Ol.info("All overrides cleared");
            if ($e444d6404c095fa5$var$q(t)) {
                var e = $e444d6404c095fa5$var$Cl(t);
                return this.Tr.register({
                    [$e444d6404c095fa5$var$Qi]: e
                }), this.Ra(), $e444d6404c095fa5$var$Ol.info("Flag overrides set", {
                    flags: t
                });
            }
            if (t && "object" == typeof t && ("flags" in t || "payloads" in t)) {
                var i, r = t;
                if (this.ha = Boolean(null !== (i = r.suppressWarning) && void 0 !== i && i), "flags" in r) {
                    if (!1 === r.flags) this.Tr.unregister($e444d6404c095fa5$var$Qi), $e444d6404c095fa5$var$Ol.info("Flag overrides cleared");
                    else if (r.flags) {
                        if ($e444d6404c095fa5$var$q(r.flags)) {
                            var s = $e444d6404c095fa5$var$Cl(r.flags);
                            this.Tr.register({
                                [$e444d6404c095fa5$var$Qi]: s
                            });
                        } else this.Tr.register({
                            [$e444d6404c095fa5$var$Qi]: r.flags
                        });
                        $e444d6404c095fa5$var$Ol.info("Flag overrides set", {
                            flags: r.flags
                        });
                    }
                }
                return "payloads" in r && (!1 === r.payloads ? (this.Tr.unregister($e444d6404c095fa5$var$Xi), $e444d6404c095fa5$var$Ol.info("Payload overrides cleared")) : r.payloads && (this.Tr.register({
                    [$e444d6404c095fa5$var$Xi]: r.payloads
                }), $e444d6404c095fa5$var$Ol.info("Payload overrides set", {
                    payloads: r.payloads
                }))), void this.Ra();
            }
            if (t && "object" == typeof t) return this.Tr.register({
                [$e444d6404c095fa5$var$Qi]: t
            }), this.Ra(), $e444d6404c095fa5$var$Ol.info("Flag overrides set", {
                flags: t
            });
            $e444d6404c095fa5$var$Pl.warn("Invalid overrideOptions provided to overrideFeatureFlags", {
                overrideOptions: t
            });
        }
        onFeatureFlags(t) {
            if (this.addFeatureFlagsHandler(t), this.da) {
                var e = this.Aa(), i = e.flags, r = e.flagVariants;
                try {
                    t(i, r);
                } catch (t) {
                    $e444d6404c095fa5$var$Pl.error("Error while running feature flags callback", t);
                }
            }
            return ()=>this.removeFeatureFlagsHandler(t);
        }
        updateEarlyAccessFeatureEnrollment(t, e, i) {
            var r, s = (this.wa($e444d6404c095fa5$var$Wi) || []).find((e)=>e.flagKey === t), n = {
                ["$feature_enrollment/" + t]: e
            }, o = {
                $feature_flag: t,
                $feature_enrollment: e,
                $set: n
            };
            s && (o.$early_access_feature_name = s.name), i && (o.$feature_enrollment_stage = i), this._instance.capture("$feature_enrollment_update", o), this.setPersonPropertiesForFlags(n, !1);
            var a = $e444d6404c095fa5$var$_({}, this.getFlagVariants(), {
                [t]: e
            });
            null == (r = this.Tr) || r.register({
                [$e444d6404c095fa5$var$Vi]: Object.keys($e444d6404c095fa5$var$Al(a)),
                [$e444d6404c095fa5$var$qi]: a
            }), this.Ra();
        }
        getEarlyAccessFeatures(t, e, i) {
            void 0 === e && (e = !1);
            var r = this.wa($e444d6404c095fa5$var$Wi), s = i ? "&" + i.map((t)=>"stage=" + t).join("&") : "";
            if (r && !e) return t(r);
            this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=" + this.Ne.token + s),
                method: "GET",
                timestampMode: "query",
                callback: (e)=>{
                    var i, r;
                    if (e.json) {
                        var s = e.json.earlyAccessFeatures;
                        return null == (i = this.Tr) || i.unregister($e444d6404c095fa5$var$Wi), null == (r = this.Tr) || r.register({
                            [$e444d6404c095fa5$var$Wi]: s
                        }), t(s);
                    }
                }
            });
        }
        Aa() {
            var t = this.getFlags(), e = this.getFlagVariants();
            return {
                flags: t.filter((t)=>e[t]),
                flagVariants: Object.keys(e).filter((t)=>e[t]).reduce((t, i)=>(t[i] = e[i], t), {})
            };
        }
        Ra(t) {
            var e = this.Aa(), i = e.flags, r = e.flagVariants;
            this.featureFlagEventHandlers.forEach((e)=>{
                try {
                    e(i, r, {
                        errorsLoading: t
                    });
                } catch (t) {
                    $e444d6404c095fa5$var$Pl.error("Error while running feature flags callback", t);
                }
            });
        }
        setPersonPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = this.wa($e444d6404c095fa5$var$Zi) || {}, r = (null == t ? void 0 : t.$set) || (null != t && t.$set_once ? {} : t), s = null == t ? void 0 : t.$set_once, n = {};
            if (s) for(var o in s)({}).hasOwnProperty.call(s, o) && (o in i || (n[o] = s[o]));
            this._instance.register({
                [$e444d6404c095fa5$var$Zi]: $e444d6404c095fa5$var$_({}, i, n, r)
            }), e && this._instance.reloadFeatureFlags();
        }
        unsetPersonPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = $e444d6404c095fa5$var$_({}, this.wa($e444d6404c095fa5$var$Zi) || {});
            t.forEach((t)=>{
                delete i[t];
            }), this._instance.register({
                [$e444d6404c095fa5$var$Zi]: i
            }), e && this._instance.reloadFeatureFlags();
        }
        resetPersonPropertiesForFlags(t) {
            void 0 === t && (t = !0), this._instance.unregister($e444d6404c095fa5$var$Zi), t && this._instance.reloadFeatureFlags();
        }
        setGroupPropertiesForFlags(t, e) {
            void 0 === e && (e = !0);
            var i = this.wa($e444d6404c095fa5$var$tr) || {};
            0 !== Object.keys(i).length && Object.keys(i).forEach((e)=>{
                i[e] = $e444d6404c095fa5$var$_({}, i[e], t[e]), delete t[e];
            }), this._instance.register({
                [$e444d6404c095fa5$var$tr]: $e444d6404c095fa5$var$_({}, i, t)
            }), e && this._instance.reloadFeatureFlags();
        }
        resetGroupPropertiesForFlags(t) {
            if (t) {
                var e = this.wa($e444d6404c095fa5$var$tr) || {};
                this._instance.register({
                    [$e444d6404c095fa5$var$tr]: $e444d6404c095fa5$var$_({}, e, {
                        [t]: {}
                    })
                });
            } else this._instance.unregister($e444d6404c095fa5$var$tr);
        }
        reset() {
            this.da = !1, this.va = !1, this.ca = !1, this.fa = !1, this.pa = !1, this.$anon_distinct_id = void 0, this.Ia(), this.ha = !1, this.ya = 0;
        }
    }
}, $e444d6404c095fa5$var$Vl = {
    sessionRecording: class {
        get Ne() {
            return this._instance.config;
        }
        get Tr() {
            return this._instance.persistence;
        }
        get started() {
            var t;
            return !(null == (t = this.Fa) || !t.isStarted);
        }
        get status() {
            var t, e;
            return this.La === $e444d6404c095fa5$var$ul || this.La === $e444d6404c095fa5$var$hl ? this.La : null !== (t = null == (e = this.Fa) ? void 0 : e.status) && void 0 !== t ? t : this.La;
        }
        constructor(e){
            if (this._forceAllowLocalhostNetworkCapture = !1, this.La = $e444d6404c095fa5$var$al, this.Oa = void 0, this.Da = !1, this.$a = (()=>{
                var e;
                if (null == $e444d6404c095fa5$var$r || !$e444d6404c095fa5$var$r.visibilityState || "visible" === $e444d6404c095fa5$var$r.visibilityState) return !0;
                var i = null == $e444d6404c095fa5$var$t || null == (e = $e444d6404c095fa5$var$t.performance) || null == e.getEntriesByType ? void 0 : e.getEntriesByType("visibility-state");
                return !(null != i && i.length) || i.some((t)=>"visible" === t.name);
            })(), this.Ie = ()=>{
                var t;
                "visible" === (null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.visibilityState) && (this.$a = !0, null == (t = this.Fa) || null == t.setDocumentWasEverVisible || t.setDocumentWasEverVisible(!0));
            }, this._instance = e, !this._instance.sessionManager) throw $e444d6404c095fa5$var$vl.error("started without valid sessionManager"), new Error($e444d6404c095fa5$var$dl + " started without valid sessionManager. This is a bug.");
            if (this.Ne.cookieless_mode === $e444d6404c095fa5$var$$r) throw new Error($e444d6404c095fa5$var$dl + ' cannot be used with cookieless_mode="always"');
            null != $e444d6404c095fa5$var$r && $e444d6404c095fa5$var$r.addEventListener && $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "visibilitychange", this.Ie);
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        dispose() {
            this.Da = !0, null == $e444d6404c095fa5$var$r || null == $e444d6404c095fa5$var$r.removeEventListener || $e444d6404c095fa5$var$r.removeEventListener("visibilitychange", this.Ie), this.stopRecording();
        }
        get Na() {
            var e, i = !(null == (e = this._instance.get_property($e444d6404c095fa5$var$Di)) || !e.enabled), r = !this.Ne.disable_session_recording, s = this.Ne.disable_session_recording || this._instance.consent.isOptedOut();
            return $e444d6404c095fa5$var$t && i && r && !s;
        }
        startIfEnabledOrStop(t) {
            var e;
            if (!(this.Da || this.Na && null != (e = this.Fa) && e.isStarted)) {
                var i = !$e444d6404c095fa5$var$K(Object.assign) && !$e444d6404c095fa5$var$K(Array.from);
                this.Na && i ? (this.qa(t), $e444d6404c095fa5$var$vl.info("starting")) : (this.La = $e444d6404c095fa5$var$al, this.stopRecording());
            }
        }
        qa(t) {
            var e, i, r;
            this.Na && (this.La !== $e444d6404c095fa5$var$ul && this.La !== $e444d6404c095fa5$var$hl && (this.La = $e444d6404c095fa5$var$ll), null != $e444d6404c095fa5$var$v && null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && null != (e = e.rrweb) && e.record && null != (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) && i.initSessionRecording ? this.ja(t) : null == (r = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == r.loadExternalDependency || r.loadExternalDependency(this._instance, this.Ba, (e)=>{
                if (e) return $e444d6404c095fa5$var$vl.error("could not load recorder", e);
                this.ja(t);
            }));
        }
        stopRecording() {
            var t, e;
            null == (t = this.Oa) || t.call(this), this.Oa = void 0, null == (e = this.Fa) || e.stop();
        }
        Ha() {
            var t, e;
            null == (t = this.Oa) || t.call(this), this.Oa = void 0, null == (e = this.Fa) || e.discard();
        }
        Ua() {
            var t, e;
            null == (t = this.Tr) || t.unregister($e444d6404c095fa5$var$Hi), null == (e = this.Tr) || e.unregister($e444d6404c095fa5$var$Ni);
        }
        za(t, e) {
            if ($e444d6404c095fa5$var$X(t)) return null;
            var i, r = $e444d6404c095fa5$var$Z(t) ? t : parseFloat(t);
            return "number" != typeof (i = r) || !Number.isFinite(i) || 0 > i || i > 1 ? ($e444d6404c095fa5$var$vl.warn(e + " must be between 0 and 1. Ignoring invalid value:", t), null) : r;
        }
        Wa(t) {
            if (this.Tr) {
                var e, i, r = this.Tr, s = ()=>{
                    var e, i = !1 === t.sessionRecording ? void 0 : t.sessionRecording, s = this.za(null == (e = this.Ne.session_recording) ? void 0 : e.sampleRate, "session_recording.sampleRate"), n = this.za(null == i ? void 0 : i.sampleRate, "remote config sampleRate"), o = null != s ? s : n;
                    $e444d6404c095fa5$var$X(o) && this.Ua();
                    var a = null == i ? void 0 : i.minimumDurationMilliseconds;
                    r.register({
                        [$e444d6404c095fa5$var$Di]: $e444d6404c095fa5$var$_({
                            cache_timestamp: Date.now(),
                            enabled: !!i
                        }, i, {
                            networkPayloadCapture: $e444d6404c095fa5$var$_({
                                capturePerformance: t.capturePerformance
                            }, null == i ? void 0 : i.networkPayloadCapture),
                            canvasRecording: {
                                enabled: null == i ? void 0 : i.recordCanvas,
                                fps: null == i ? void 0 : i.canvasFps,
                                quality: null == i ? void 0 : i.canvasQuality
                            },
                            sampleRate: o,
                            minimumDurationMilliseconds: $e444d6404c095fa5$var$K(a) ? null : a,
                            endpoint: null == i ? void 0 : i.endpoint,
                            triggerMatchType: null == i ? void 0 : i.triggerMatchType,
                            masking: null == i ? void 0 : i.masking,
                            urlTriggers: null == i ? void 0 : i.urlTriggers,
                            version: null == i ? void 0 : i.version,
                            triggerGroups: null == i ? void 0 : i.triggerGroups
                        })
                    });
                };
                s(), null == (e = this.Oa) || e.call(this), this.Oa = null == (i = this._instance.sessionManager) ? void 0 : i.onSessionId(s);
            }
        }
        onRemoteConfig(t) {
            var e = t.ok ? t.config : void 0;
            return e && "sessionRecording" in e ? !1 === e.sessionRecording ? (this.Wa(e), void this.Ha()) : (this.Wa(e), void this.startIfEnabledOrStop()) : (this.La === $e444d6404c095fa5$var$ul && (this.La = $e444d6404c095fa5$var$hl, $e444d6404c095fa5$var$vl.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
        }
        log(t, e) {
            var i;
            void 0 === e && (e = "log"), null != (i = this.Fa) && i.log ? this.Fa.log(t, e) : $e444d6404c095fa5$var$vl.warn("log called before recorder was ready");
        }
        get Ba() {
            var t, e, i = null == (t = this._instance) || null == (t = t.persistence) ? void 0 : t.get_property($e444d6404c095fa5$var$Di);
            return (null == i || null == (e = i.scriptConfig) ? void 0 : e.script) || "lazy-recorder";
        }
        Va() {
            var t, e, i = this._instance.get_property($e444d6404c095fa5$var$Di);
            if (!i) return !1;
            try {
                e = "object" == typeof i ? i : JSON.parse(i);
            } catch (t) {
                return $e444d6404c095fa5$var$vl.warn("persisted remote config for session recording is invalid and will be ignored", t), !1;
            }
            var r = null !== (t = e.cache_timestamp) && void 0 !== t ? t : Date.now();
            return 36e5 >= Date.now() - r;
        }
        ja(t) {
            var e, i, r;
            if (!this.Da) {
                if (null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || !e.initSessionRecording) return $e444d6404c095fa5$var$vl.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({
                    [$e444d6404c095fa5$var$xr]: !0
                });
                var s;
                if (this.Fa || (this.Fa = null == (s = $e444d6404c095fa5$var$v.__PosthogExtensions__) ? void 0 : s.initSessionRecording(this._instance, this.$a), this.Fa._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.Va()) {
                    if (this.La === $e444d6404c095fa5$var$hl || this.La === $e444d6404c095fa5$var$ul) return;
                    return this.La = $e444d6404c095fa5$var$ul, $e444d6404c095fa5$var$vl.info("persisted remote config is stale, requesting fresh config before starting"), void new $e444d6404c095fa5$var$no(this._instance).load();
                }
                this.La = $e444d6404c095fa5$var$ll, null == (i = (r = this.Fa).setDocumentWasEverVisible) || i.call(r, this.$a), this.Fa.start(t);
            }
        }
        onRRwebEmit(t) {
            var e;
            null == (e = this.Fa) || null == e.onRRwebEmit || e.onRRwebEmit(t);
        }
        overrideLinkedFlag() {
            var t, e;
            this.Fa || null == (e = this.Tr) || e.register({
                [$e444d6404c095fa5$var$Li]: !0
            }), null == (t = this.Fa) || t.overrideLinkedFlag();
        }
        overrideSampling() {
            var t, e;
            this.Fa || null == (e = this.Tr) || e.register({
                [$e444d6404c095fa5$var$Ui]: !0
            }), null == (t = this.Fa) || t.overrideSampling();
        }
        overrideTrigger(t) {
            var e, i;
            this.Fa || null == (i = this.Tr) || i.register({
                ["url" === t ? $e444d6404c095fa5$var$ji : $e444d6404c095fa5$var$Bi]: !0
            }), null == (e = this.Fa) || e.overrideTrigger(t);
        }
        get sdkDebugProperties() {
            var t;
            return (null == (t = this.Fa) ? void 0 : t.sdkDebugProperties) || {
                $recording_status: this.status
            };
        }
        tryAddCustomEvent(t, e) {
            var i;
            return !(null == (i = this.Fa) || !i.tryAddCustomEvent(t, e));
        }
    }
}, $e444d6404c095fa5$var$Wl = {
    autocapture: class {
        constructor(t){
            this.Za = !1, this.Ga = null, this.Qa = !1, this.Ka = !1, this.instance = t, this.rageclicks = new $e444d6404c095fa5$var$Ya(t.config.rageclick), this.Ja = null;
        }
        initialize() {
            this.startIfEnabled();
        }
        get Ne() {
            var t, e, i = $e444d6404c095fa5$var$W(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
            return i.url_allowlist = null == (t = i.url_allowlist) ? void 0 : t.map((t)=>new RegExp(t)), i.url_ignorelist = null == (e = i.url_ignorelist) ? void 0 : e.map((t)=>new RegExp(t)), i;
        }
        Ya() {
            if (this.isBrowserSupported()) {
                if ($e444d6404c095fa5$var$t && $e444d6404c095fa5$var$r) {
                    var e = (e)=>{
                        e = e || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event);
                        try {
                            this.Xa(e);
                        } catch (t) {
                            $e444d6404c095fa5$var$Xa.error("Failed to capture event", t);
                        }
                    };
                    if ($e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "submit", e, {
                        capture: !0
                    }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "change", e, {
                        capture: !0
                    }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "click", e, {
                        capture: !0
                    }), this.Ne.capture_copied_text) {
                        var i = (e)=>{
                            e = e || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event);
                            try {
                                this.Xa(e, $e444d6404c095fa5$var$Qa);
                            } catch (t) {
                                $e444d6404c095fa5$var$Xa.error("Failed to capture copy/cut event", t);
                            }
                        };
                        $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "copy", i, {
                            capture: !0
                        }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "cut", i, {
                            capture: !0
                        });
                    }
                }
            } else $e444d6404c095fa5$var$Xa.info("Disabling Automatic Event Collection because this browser is not supported");
        }
        startIfEnabled() {
            this.isEnabled && !this.Za && (this.Ya(), this.Za = !0);
        }
        onRemoteConfig(t) {
            if (this.Qa = !0, t.ok) {
                var e = t.config;
                e.elementsChainAsString && (this.Ka = e.elementsChainAsString);
                var i = e.autocapture_opt_out;
                $e444d6404c095fa5$var$et(i) && (this.instance.persistence && this.instance.persistence.register({
                    [$e444d6404c095fa5$var$Ti]: i
                }), this.Ga = i), this.startIfEnabled();
            } else this.startIfEnabled();
        }
        setElementSelectors(t) {
            this.Ja = t;
        }
        getElementSelectors(t) {
            var e, i = [];
            return null == (e = this.Ja) || e.forEach((e)=>{
                var s = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.querySelectorAll(e);
                null == s || s.forEach((r)=>{
                    t === r && i.push(e);
                });
            }), i;
        }
        get isEnabled() {
            var t, e, i = null == (t = this.instance.persistence) ? void 0 : t.props[$e444d6404c095fa5$var$Ti], r = this.Ga, s = this.instance.Ki() && !this.Qa;
            if ($e444d6404c095fa5$var$Q(r) && !$e444d6404c095fa5$var$et(i) && !s) return !1;
            var n = null !== (e = this.Ga) && void 0 !== e ? e : !!i;
            return !!this.instance.config.autocapture && !n;
        }
        Xa(e, i) {
            if (void 0 === i && (i = "$autocapture"), this.isEnabled) {
                var r, s = $e444d6404c095fa5$var$Ts(e);
                $e444d6404c095fa5$var$bs(s) && (s = s.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent && this.instance.config.rageclick && null != (r = this.rageclicks) && r.isRageClick(e.clientX, e.clientY, e.timeStamp || (new Date).getTime()) && $e444d6404c095fa5$var$Ns(s, this.instance.config.rageclick) && this.Xa(e, "$rageclick");
                var n = i === $e444d6404c095fa5$var$Qa;
                if (s && function(e, i, r, s, n, o) {
                    var a;
                    if (!$e444d6404c095fa5$var$t || $e444d6404c095fa5$var$Us(e)) return !1;
                    if (null != r && r.url_allowlist && !$e444d6404c095fa5$var$Es(r.url_allowlist, o)) return !1;
                    if (null != r && r.url_ignorelist && $e444d6404c095fa5$var$Es(r.url_ignorelist, o)) return !1;
                    if (null != r && r.dom_event_allowlist) {
                        var l = r.dom_event_allowlist;
                        if (l && !l.some((t)=>i.type === t)) return !1;
                    }
                    var u = $e444d6404c095fa5$var$Ls(e, s), h = u.parentIsUsefulElement, d = u.targetElementList;
                    if (!function(t, e) {
                        var i = null == e ? void 0 : e.element_allowlist;
                        if ($e444d6404c095fa5$var$K(i)) return !0;
                        var r, s = function(t) {
                            if (i.some((e)=>t.tagName.toLowerCase() === e)) return {
                                v: !0
                            };
                        };
                        for (var n of t)if (r = s(n)) return r.v;
                        return !1;
                    }(d, r)) return !1;
                    if (!$e444d6404c095fa5$var$Ps(d, null == r ? void 0 : r.css_selector_allowlist)) return !1;
                    if ($e444d6404c095fa5$var$Ps(d, null !== (a = null == r ? void 0 : r.css_selector_ignorelist) && void 0 !== a ? a : $e444d6404c095fa5$var$Is)) return !1;
                    try {
                        var v = $e444d6404c095fa5$var$t.getComputedStyle(e);
                        if (v && "pointer" === v.getPropertyValue("cursor") && "click" === i.type) return !0;
                    } catch (t) {}
                    var c = e.tagName.toLowerCase();
                    switch(c){
                        case "html":
                            return !1;
                        case "form":
                            return (n || [
                                "submit"
                            ]).indexOf(i.type) >= 0;
                        case "input":
                        case "select":
                        case "textarea":
                            return (n || [
                                "change",
                                "click"
                            ]).indexOf(i.type) >= 0;
                        default:
                            return h ? (n || [
                                "click"
                            ]).indexOf(i.type) >= 0 : (n || [
                                "click"
                            ]).indexOf(i.type) >= 0 && ($e444d6404c095fa5$var$Rs.indexOf(c) > -1 || "true" === e.getAttribute("contenteditable"));
                    }
                }(s, e, this.Ne, n, n ? [
                    "copy",
                    "cut"
                ] : void 0, this.instance)) {
                    var o = $e444d6404c095fa5$var$el(s, {
                        e: e,
                        maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                        maskAllText: this.instance.config.mask_all_text,
                        elementAttributeIgnoreList: this.Ne.element_attribute_ignorelist,
                        elementsChainAsString: this.Ka,
                        disableCaptureUrlHashes: this.instance.config.disable_capture_url_hashes
                    }), a = o.props;
                    if (o.explicitNoCapture) return !1;
                    var l = this.getElementSelectors(s);
                    if (l && l.length > 0 && (a.$element_selectors = l), i === $e444d6404c095fa5$var$Qa) {
                        var u, h = $e444d6404c095fa5$var$$s(null == $e444d6404c095fa5$var$t || null == (u = $e444d6404c095fa5$var$t.getSelection()) ? void 0 : u.toString()), d = e.type || "clipboard";
                        if (!h) return !1;
                        a.$selected_content = h, a.$copy_type = d;
                    }
                    return this.instance.capture(i, a), !0;
                }
            }
        }
        isBrowserSupported() {
            return $e444d6404c095fa5$var$V(null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.querySelectorAll);
        }
    },
    historyAutocapture: class {
        constructor(e){
            var i;
            this._instance = e, this.eo = (null == $e444d6404c095fa5$var$t || null == (i = $e444d6404c095fa5$var$t.location) ? void 0 : i.pathname) || "";
        }
        initialize() {
            this.startIfEnabled();
        }
        get isEnabled() {
            return "history_change" === this._instance.config.capture_pageview;
        }
        startIfEnabled() {
            this.isEnabled && ($e444d6404c095fa5$var$mi.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
        }
        stop() {
            this.io && this.io(), this.io = void 0, $e444d6404c095fa5$var$mi.info("History API monitoring stopped");
        }
        monitorHistoryChanges() {
            $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.history && (this.ro("pushState"), this.ro("replaceState"), this.no());
        }
        ro(e) {
            var i;
            if ($e444d6404c095fa5$var$t && (null == (i = $e444d6404c095fa5$var$t.history[e]) || !i.__posthog_wrapped__)) {
                var r = this;
                !function(t, e, i) {
                    try {
                        if (!(e in t)) return $e444d6404c095fa5$var$rl;
                        var r = {
                            next: t[e]
                        }, s = i(function() {
                            for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
                            return r.next.apply(this, e);
                        });
                        return $e444d6404c095fa5$var$V(s) && (s.prototype = s.prototype || {}, Object.defineProperties(s, {
                            __posthog_wrapped__: {
                                enumerable: !1,
                                value: !0
                            },
                            __posthog_layer__: {
                                enumerable: !1,
                                value: r
                            }
                        })), t[e] = s, ()=>{
                            if (t[e] !== s) for(var i = t[e]; $e444d6404c095fa5$var$V(i) && i.__posthog_layer__;){
                                var n = i.__posthog_layer__;
                                if (n.next === s) return void (n.next = r.next);
                                i = n.next;
                            }
                            else t[e] = r.next;
                        };
                    } catch (t) {
                        return $e444d6404c095fa5$var$rl;
                    }
                }($e444d6404c095fa5$var$t.history, e, (t)=>function(i, s, n) {
                        t.call(this, i, s, n), r.so(e);
                    });
            }
        }
        so(e) {
            try {
                var i, r = null == $e444d6404c095fa5$var$t || null == (i = $e444d6404c095fa5$var$t.location) ? void 0 : i.pathname;
                if (!r) return;
                r !== this.eo && this.isEnabled && this._instance.capture($e444d6404c095fa5$var$Ir, {
                    navigation_type: e
                }), this.eo = r;
            } catch (t) {
                $e444d6404c095fa5$var$mi.error("Error capturing " + e + " pageview", t);
            }
        }
        no() {
            if (!this.io) {
                var e = ()=>{
                    this.so("popstate");
                };
                $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "popstate", e), this.io = ()=>{
                    $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$t.removeEventListener("popstate", e);
                };
            }
        }
    },
    heatmaps: class {
        get Ne() {
            return this.instance.config;
        }
        constructor(t){
            var e;
            this.ao = !1, this.Za = !1, this.oo = null, this.instance = t, this.ao = !(null == (e = this.instance.persistence) || !e.props[$e444d6404c095fa5$var$Ri]), this.rageclicks = new $e444d6404c095fa5$var$Ya(t.config.rageclick);
        }
        initialize() {
            this.startIfEnabled();
        }
        get flushIntervalMilliseconds() {
            var t = 5e3;
            return $e444d6404c095fa5$var$W(this.Ne.capture_heatmaps) && this.Ne.capture_heatmaps.flush_interval_milliseconds && (t = this.Ne.capture_heatmaps.flush_interval_milliseconds), t;
        }
        get isEnabled() {
            return $e444d6404c095fa5$var$X(this.Ne.capture_heatmaps) ? $e444d6404c095fa5$var$X(this.Ne.enable_heatmaps) ? this.ao : this.Ne.enable_heatmaps : !1 !== this.Ne.capture_heatmaps;
        }
        startIfEnabled() {
            if (this.isEnabled) {
                if (this.Za) return;
                $e444d6404c095fa5$var$cl.info("starting..."), this.lo(), this.Ie();
            } else {
                var t;
                clearInterval(null !== (t = this.oo) && void 0 !== t ? t : void 0), this.uo(), this.getAndClearBuffer();
            }
        }
        onRemoteConfig(t) {
            if (t.ok) {
                var e = t.config;
                if ("heatmaps" in e) {
                    var i = !!e.heatmaps;
                    this.instance.persistence && this.instance.persistence.register({
                        [$e444d6404c095fa5$var$Ri]: i
                    }), this.ao = i, this.startIfEnabled();
                }
            }
        }
        getAndClearBuffer() {
            var t = this.R;
            return this.R = void 0, t;
        }
        ho(t) {
            $e444d6404c095fa5$var$fl(t.originalEvent) && this.ke(t.originalEvent, "deadclick");
        }
        Ie() {
            this.oo && clearInterval(this.oo), this.oo = "visible" === (null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.visibilityState) ? setInterval(this.pr.bind(this), this.flushIntervalMilliseconds) : null;
        }
        lo() {
            $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$r && (this.do = this.pr.bind(this), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, $e444d6404c095fa5$var$Or, this.do), this.vo = (e)=>this.ke(e || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "click", this.vo, {
                capture: !0
            }), this.co = (e)=>this.fo(e || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.event)), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "mousemove", this.co, {
                capture: !0
            }), this.po = new $e444d6404c095fa5$var$sn(this.instance, $e444d6404c095fa5$var$en, this.ho.bind(this)), this.po.startIfEnabledOrStop(), this.mo = this.Ie.bind(this), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, $e444d6404c095fa5$var$Pr, this.mo), this.Za = !0);
        }
        uo() {
            var e;
            $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$r && (this.do && $e444d6404c095fa5$var$t.removeEventListener($e444d6404c095fa5$var$Or, this.do), this.vo && $e444d6404c095fa5$var$r.removeEventListener("click", this.vo, {
                capture: !0
            }), this.co && $e444d6404c095fa5$var$r.removeEventListener("mousemove", this.co, {
                capture: !0
            }), this.mo && $e444d6404c095fa5$var$r.removeEventListener($e444d6404c095fa5$var$Pr, this.mo), clearTimeout(this.yo), null == (e = this.po) || e.stop(), this.Za = !1);
        }
        bo(e, i) {
            var r = this.instance.scrollManager.scrollY(), s = this.instance.scrollManager.scrollX(), n = this.instance.scrollManager.scrollElement(), o = function(e, i, r) {
                for(var s = e; s && $e444d6404c095fa5$var$gs(s) && !$e444d6404c095fa5$var$ms(s, "body");){
                    if (s === r) return !1;
                    var n = void 0;
                    try {
                        var o, a, l;
                        n = null == (o = null !== (a = null == (l = s.ownerDocument) ? void 0 : l.defaultView) && void 0 !== a ? a : $e444d6404c095fa5$var$t) ? void 0 : o.getComputedStyle(s).position;
                    } catch (t) {
                        return !1;
                    }
                    if ($e444d6404c095fa5$var$N(i, n)) return !0;
                    s = $e444d6404c095fa5$var$Os(s);
                }
                return !1;
            }($e444d6404c095fa5$var$Ts(e), [
                "fixed",
                "sticky"
            ], n);
            return {
                x: e.clientX + (o ? 0 : s),
                y: e.clientY + (o ? 0 : r),
                target_fixed: o,
                type: i
            };
        }
        ke(t, e) {
            var i;
            if (void 0 === e && (e = "click"), !$e444d6404c095fa5$var$_s(t.target) && $e444d6404c095fa5$var$fl(t)) {
                var r = this.bo(t, e);
                null != (i = this.rageclicks) && i.isRageClick(t.clientX, t.clientY, (new Date).getTime()) && $e444d6404c095fa5$var$Ns($e444d6404c095fa5$var$Ts(t), this.instance.config.rageclick) && this.Vt($e444d6404c095fa5$var$_({}, r, {
                    type: "rageclick"
                })), this.Vt(r);
            }
        }
        fo(t) {
            !$e444d6404c095fa5$var$_s(t.target) && $e444d6404c095fa5$var$fl(t) && (clearTimeout(this.yo), this.yo = setTimeout(()=>{
                this.Vt(this.bo(t, "mousemove"));
            }, 500));
        }
        Vt(e) {
            if ($e444d6404c095fa5$var$t) {
                var i = this.Ne.disable_capture_url_hashes ? $e444d6404c095fa5$var$ye($e444d6404c095fa5$var$t.location.href) : $e444d6404c095fa5$var$t.location.href, r = this.Ne.custom_personal_data_properties, s = this.Ne.mask_personal_data_properties ? [
                    ...$e444d6404c095fa5$var$xn,
                    ...r || []
                ] : [], n = $e444d6404c095fa5$var$gn(i, s, $e444d6404c095fa5$var$Sn);
                this.R = this.R || {}, this.R[n] || (this.R[n] = []), this.R[n].push(e);
            }
        }
        pr() {
            this.R && !$e444d6404c095fa5$var$G(this.R) && this.instance.capture("$$heatmap", {
                $heatmap_data: this.getAndClearBuffer()
            });
        }
    },
    deadClicksAutocapture: $e444d6404c095fa5$var$sn,
    webVitalsAutocapture: class {
        constructor(t){
            var e;
            this.ao = !1, this.Za = !1, this.R = {
                navigationKey: void 0,
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            }, this._o = ()=>{
                clearTimeout(this.wo), this.wo = void 0, 0 !== this.R.metrics.length && (this._instance.capture("$web_vitals", $e444d6404c095fa5$var$_({
                    $current_url: this.R.url
                }, this.R.metrics.reduce((t, e)=>$e444d6404c095fa5$var$_({}, t, {
                        ["$web_vitals_" + e.name + "_event"]: $e444d6404c095fa5$var$_({}, e),
                        ["$web_vitals_" + e.name + "_value"]: e.value
                    }), {}))), this.R = {
                    navigationKey: void 0,
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                });
            }, this.ko = (t)=>{
                var e;
                if (this.R = this.R || {
                    navigationKey: void 0,
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                }, $e444d6404c095fa5$var$X(null == t ? void 0 : t.name) || $e444d6404c095fa5$var$X(null == t ? void 0 : t.value)) $e444d6404c095fa5$var$nl.error("Invalid metric received", t);
                else {
                    var i = "string" == typeof t.navigationURL ? t.navigationURL : void 0, r = this.xo(i);
                    if (!$e444d6404c095fa5$var$K(r)) {
                        var s = $e444d6404c095fa5$var$Z(t.navigationId) || "string" == typeof t.navigationId ? "navigation:" + t.navigationId : "url:" + r;
                        if (!this.So || this.So > t.value) {
                            this.R.navigationKey !== s && (this._o(), this.wo = setTimeout(this._o, this.flushToCaptureTimeoutMs)), $e444d6404c095fa5$var$K(this.R.navigationKey) && (this.R.navigationKey = s, this.R.url = r), this.R.firstMetricTimestamp = $e444d6404c095fa5$var$K(this.R.firstMetricTimestamp) ? Date.now() : this.R.firstMetricTimestamp, t.attribution && t.attribution.interactionTargetElement && (t.attribution.interactionTargetElement = void 0);
                            var n = null == (e = this._instance.sessionManager) ? void 0 : e.checkAndGetSessionAndWindowId(!0), o = $e444d6404c095fa5$var$_({}, t, i ? {
                                navigationURL: r
                            } : {}, {
                                $current_url: r,
                                timestamp: Date.now()
                            });
                            $e444d6404c095fa5$var$K(n) || (o.$session_id = n.sessionId, o.$window_id = n.windowId), this.R.metrics.push(o), this.R.metrics.length === this.allowedMetrics.length && this._o();
                        } else $e444d6404c095fa5$var$nl.error("Ignoring metric with value >= " + this.So, t);
                    }
                }
            }, this.Co = ()=>{
                if (!this.Za) {
                    var t, e, i, r, s = $e444d6404c095fa5$var$v.__PosthogExtensions__, n = null == s ? void 0 : s.postHogWebVitalsCallbacksByFlavor, o = (null == n ? void 0 : n[this.Mo]) || ("web-vitals" === this.Mo && $e444d6404c095fa5$var$K(n) ? null == s ? void 0 : s.postHogWebVitalsCallbacks : void 0);
                    if ($e444d6404c095fa5$var$K(o) || (t = o.onLCP, e = o.onCLS, i = o.onFCP, r = o.onINP), t && e && i && r) {
                        var a = {
                            reportSoftNavs: this.useSoftNavs
                        };
                        this.allowedMetrics.indexOf("LCP") > -1 && t(this.ko.bind(this), a), this.allowedMetrics.indexOf("CLS") > -1 && e(this.ko.bind(this), a), this.allowedMetrics.indexOf("FCP") > -1 && i(this.ko.bind(this), a), this.allowedMetrics.indexOf("INP") > -1 && r(this.ko.bind(this), a), this.Za = !0;
                    } else $e444d6404c095fa5$var$nl.error("web vitals callbacks not loaded - not starting");
                }
            }, this._instance = t, this.ao = !(null == (e = this._instance.persistence) || !e.props[$e444d6404c095fa5$var$Ci]), this.startIfEnabled();
        }
        get To() {
            return this._instance.config.capture_performance;
        }
        get allowedMetrics() {
            var t, e, i = $e444d6404c095fa5$var$W(this.To) ? null == (t = this.To) ? void 0 : t.web_vitals_allowed_metrics : void 0;
            return $e444d6404c095fa5$var$X(i) ? (null == (e = this._instance.persistence) ? void 0 : e.props[$e444d6404c095fa5$var$Fi]) || [
                "CLS",
                "FCP",
                "INP",
                "LCP"
            ] : i;
        }
        get flushToCaptureTimeoutMs() {
            return ($e444d6404c095fa5$var$W(this.To) ? this.To.web_vitals_delayed_flush_ms : void 0) || 5e3;
        }
        get useAttribution() {
            var t = $e444d6404c095fa5$var$W(this.To) ? this.To.web_vitals_attribution : void 0;
            return null != t && t;
        }
        get useSoftNavs() {
            var t = $e444d6404c095fa5$var$W(this.To) ? this.To.__preview_web_vitals_soft_navs : void 0;
            return null != t && t;
        }
        get So() {
            var t = $e444d6404c095fa5$var$W(this.To) && $e444d6404c095fa5$var$Z(this.To.__web_vitals_max_value) ? this.To.__web_vitals_max_value : $e444d6404c095fa5$var$ol;
            return t > 0 && 6e4 >= t ? $e444d6404c095fa5$var$ol : t;
        }
        get isEnabled() {
            var t = null == $e444d6404c095fa5$var$s ? void 0 : $e444d6404c095fa5$var$s.protocol;
            if ("http:" !== t && "https:" !== t) return $e444d6404c095fa5$var$nl.info("Web Vitals are disabled on non-http/https protocols"), !1;
            var e = $e444d6404c095fa5$var$W(this.To) ? this.To.web_vitals : $e444d6404c095fa5$var$et(this.To) ? this.To : void 0;
            return $e444d6404c095fa5$var$et(e) ? e : this.ao;
        }
        startIfEnabled() {
            this.isEnabled && !this.Za && ($e444d6404c095fa5$var$nl.info("enabled, starting..."), this.ai(this.Co));
        }
        onRemoteConfig(t) {
            if (t.ok) {
                var e = t.config;
                if ("capturePerformance" in e) {
                    var i = $e444d6404c095fa5$var$W(e.capturePerformance) && !!e.capturePerformance.web_vitals, r = $e444d6404c095fa5$var$W(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
                    this._instance.persistence && (this._instance.persistence.register({
                        [$e444d6404c095fa5$var$Ci]: i
                    }), this._instance.persistence.register({
                        [$e444d6404c095fa5$var$Fi]: r
                    })), this.ao = i, this.startIfEnabled();
                }
            }
        }
        get Mo() {
            return this.useSoftNavs ? this.useAttribution ? "web-vitals-with-attribution-soft-navs" : "web-vitals-soft-navs" : this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
        }
        ai(t) {
            var e = $e444d6404c095fa5$var$v.__PosthogExtensions__, i = this.Mo, r = null == e ? void 0 : e.postHogWebVitalsCallbacksByFlavor;
            null != r && r[i] || "web-vitals" === i && $e444d6404c095fa5$var$K(r) && null != e && e.postHogWebVitalsCallbacks ? t() : null == e || null == e.loadExternalDependency || e.loadExternalDependency(this._instance, i, (e)=>{
                e ? $e444d6404c095fa5$var$nl.error("failed to load script", e) : t();
            });
        }
        xo(e) {
            var i = e || (null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.location.href);
            if (i) {
                var r = this._instance.config.disable_capture_url_hashes ? $e444d6404c095fa5$var$ye(i) : i, s = this._instance.config.custom_personal_data_properties, n = this._instance.config.mask_personal_data_properties ? [
                    ...$e444d6404c095fa5$var$xn,
                    ...s || []
                ] : [];
                return $e444d6404c095fa5$var$gn(r, n, $e444d6404c095fa5$var$Sn);
            }
            $e444d6404c095fa5$var$nl.error("Could not determine current URL");
        }
    }
}, $e444d6404c095fa5$var$Gl = {
    exceptionObserver: class {
        constructor(e){
            var i;
            this.Co = ()=>{
                var e;
                if ($e444d6404c095fa5$var$t && this.isEnabled && null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.errorWrappingFunctions) {
                    var i = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = $e444d6404c095fa5$var$v.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
                    try {
                        !this.Eo && this.Ne.capture_unhandled_errors && (this.Eo = i(this.captureException.bind(this))), !this.Io && this.Ne.capture_unhandled_rejections && (this.Io = r(this.captureException.bind(this))), !this.Po && this.Ne.capture_console_errors && (this.Po = s(this.captureException.bind(this)));
                    } catch (t) {
                        $e444d6404c095fa5$var$il.error("failed to start", t), this.Ro();
                    }
                }
            }, this._instance = e, this.Ao = !(null == (i = this._instance.persistence) || !i.props[$e444d6404c095fa5$var$Pi]), this.Fo = new $e444d6404c095fa5$var$ct($e444d6404c095fa5$var$_({}, function(t) {
                var e, i, r, s;
                return void 0 === t && (t = {}), {
                    refillRate: null !== (e = null !== (i = t.exceptionRateLimiterRefillRate) && void 0 !== i ? i : t.__exceptionRateLimiterRefillRate) && void 0 !== e ? e : 1,
                    bucketSize: null !== (r = null !== (s = t.exceptionRateLimiterBucketSize) && void 0 !== s ? s : t.__exceptionRateLimiterBucketSize) && void 0 !== r ? r : 10
                };
            }(this._instance.config.error_tracking), {
                refillInterval: 1e4,
                rt: $e444d6404c095fa5$var$il
            })), this.Ne = this.Lo(), this.startIfEnabledOrStop();
        }
        Lo() {
            var t = this._instance.config.capture_exceptions, e = {
                capture_unhandled_errors: !1,
                capture_unhandled_rejections: !1,
                capture_console_errors: !1
            };
            return $e444d6404c095fa5$var$W(t) ? e = $e444d6404c095fa5$var$_({}, e, t) : ($e444d6404c095fa5$var$K(t) ? this.Ao : t) && (e = $e444d6404c095fa5$var$_({}, e, {
                capture_unhandled_errors: !0,
                capture_unhandled_rejections: !0
            })), e;
        }
        get isEnabled() {
            return this.Ne.capture_console_errors || this.Ne.capture_unhandled_errors || this.Ne.capture_unhandled_rejections;
        }
        startIfEnabledOrStop() {
            this.isEnabled ? ($e444d6404c095fa5$var$il.info("enabled"), this.Ro(), this.ai(this.Co)) : this.Ro();
        }
        ai(t) {
            var e, i;
            null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.errorWrappingFunctions ? t() : null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "exception-autocapture", (e)=>{
                if (e) return $e444d6404c095fa5$var$il.error("failed to load script", e);
                t();
            });
        }
        Ro() {
            var t, e, i;
            null == (t = this.Eo) || t.call(this), this.Eo = void 0, null == (e = this.Io) || e.call(this), this.Io = void 0, null == (i = this.Po) || i.call(this), this.Po = void 0;
        }
        onRemoteConfig(t) {
            if (t.ok) {
                var e = t.config;
                "autocaptureExceptions" in e && (this.Ao = !!e.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({
                    [$e444d6404c095fa5$var$Pi]: this.Ao
                }), this.Ne = this.Lo(), this.startIfEnabledOrStop());
            }
        }
        onConfigChange() {
            this.Ne = this.Lo();
        }
        captureException(t) {
            var e, i, r, s = null !== (e = null == t || null == (i = t.$exception_list) || null == (i = i[0]) ? void 0 : i.type) && void 0 !== e ? e : "Exception";
            this.Fo.consumeRateLimit(s) ? $e444d6404c095fa5$var$il.info("Skipping exception capture because of client rate limiting.", {
                exception: s
            }) : null == (r = this._instance.exceptions) || r.sendExceptionEvent(t);
        }
    },
    exceptions: class {
        constructor(t){
            var e, i;
            this.Oo = [], this.Do = new $e444d6404c095fa5$var$Be([
                new $e444d6404c095fa5$var$Ze,
                new $e444d6404c095fa5$var$ui,
                new $e444d6404c095fa5$var$ei,
                new $e444d6404c095fa5$var$ti,
                new $e444d6404c095fa5$var$ai,
                new $e444d6404c095fa5$var$oi,
                new $e444d6404c095fa5$var$ri,
                new $e444d6404c095fa5$var$li
            ], function(t) {
                for(var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), r = 1; e > r; r++)i[r - 1] = arguments[r];
                return function(e, r) {
                    void 0 === r && (r = 0);
                    for(var s = [], n = e.split("\n"), o = r; n.length > o; o++){
                        var a = n[o];
                        if (1024 >= a.length) {
                            var l = $e444d6404c095fa5$var$Xe.test(a) ? a.replace($e444d6404c095fa5$var$Xe, "$1") : a;
                            if (!l.match(/\S*Error: /)) {
                                for (var u of i){
                                    var h = u(l, t);
                                    if (h) {
                                        s.push(h);
                                        break;
                                    }
                                }
                                if (s.length >= 50) break;
                            }
                        }
                    }
                    return function(t) {
                        if (!t.length) return [];
                        var e = Array.from(t);
                        return e.reverse(), e.slice(0, 50).map((t)=>{
                            var i;
                            return $e444d6404c095fa5$var$_({}, t, {
                                filename: t.filename || (i = e, i[i.length - 1] || {}).filename,
                                function: t.function || $e444d6404c095fa5$var$ze
                            });
                        });
                    }(s);
                };
            }("web:javascript", $e444d6404c095fa5$var$Ke, $e444d6404c095fa5$var$Qe)), this._instance = t, this.Oo = null !== (e = null == (i = this._instance.persistence) ? void 0 : i.get_property($e444d6404c095fa5$var$Oi)) && void 0 !== e ? e : [], this.$o = $e444d6404c095fa5$var$fi(this.No()), this.qo = new $e444d6404c095fa5$var$pi(this.$o);
        }
        onConfigChange() {
            this.$o = $e444d6404c095fa5$var$fi(this.No()), this.qo.setConfig(this.$o);
        }
        onRemoteConfig(t) {
            var e, i, r;
            if (t.ok) {
                var s = t.config;
                if ("errorTracking" in s) {
                    var n = null !== (e = null == (i = s.errorTracking) ? void 0 : i.suppressionRules) && void 0 !== e ? e : [], o = null == (r = s.errorTracking) ? void 0 : r.captureExtensionExceptions;
                    this.Oo = n, this._instance.persistence && this._instance.persistence.register({
                        [$e444d6404c095fa5$var$Oi]: this.Oo,
                        [$e444d6404c095fa5$var$Ii]: o
                    });
                }
            }
        }
        get jo() {
            var t, e = !!this._instance.get_property($e444d6404c095fa5$var$Ii), i = this._instance.config.error_tracking.captureExtensionExceptions;
            return null !== (t = null != i ? i : e) && void 0 !== t && t;
        }
        buildProperties(t, e) {
            return this.Do.buildFromUnknown(t, {
                syntheticException: null == e ? void 0 : e.syntheticException,
                mechanism: {
                    handled: null == e ? void 0 : e.handled
                }
            });
        }
        addExceptionStep(t, e) {
            if (this.$o.enabled) try {
                if (!$e444d6404c095fa5$var$J(t) || 0 === t.trim().length) return void $e444d6404c095fa5$var$Ml.warn("Ignoring exception step because message must be a non-empty string");
                var i = function(t) {
                    if (!t) return {
                        sanitizedProperties: {},
                        droppedKeys: []
                    };
                    var e = [];
                    return {
                        sanitizedProperties: Object.keys(t).reduce((i, r)=>$e444d6404c095fa5$var$vi.has(r) ? (e.push(r), i) : (i[r] = t[r], i), {}),
                        droppedKeys: e
                    };
                }(this.Bo(e)), r = i.sanitizedProperties, s = i.droppedKeys;
                s.length > 0 && $e444d6404c095fa5$var$Ml.warn("Ignoring reserved exception step fields", {
                    droppedKeys: s
                }), this.qo.add($e444d6404c095fa5$var$_({
                    [$e444d6404c095fa5$var$hi]: t,
                    [$e444d6404c095fa5$var$di]: (new Date).toISOString()
                }, r));
            } catch (t) {
                $e444d6404c095fa5$var$Ml.error("Failed to add exception step. Ignoring breadcrumb.", t);
            }
        }
        sendExceptionEvent(t) {
            try {
                var e = t.$exception_list;
                if (this.Ho(e)) {
                    if (this.Uo(e)) return this.zo("Exception dropped: matched a suppression rule"), void $e444d6404c095fa5$var$Ml.info("Skipping exception capture because a suppression rule matched");
                    if (!this.jo && this.Wo(e)) return this.zo("Exception dropped: thrown by a browser extension"), void $e444d6404c095fa5$var$Ml.info("Skipping exception capture because it was thrown by an extension");
                    if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.Vo(e)) return this.zo("Exception dropped: thrown by the PostHog SDK"), void $e444d6404c095fa5$var$Ml.info("Skipping exception capture because it was thrown by the PostHog SDK");
                }
                var i = this.$o.enabled && $e444d6404c095fa5$var$X(t.$exception_steps) ? this.Zo(t) : t, r = "string" == typeof (n = globalThis._posthogReleaseId) && n.length > 0 ? n : void 0;
                r && (i.$release_id = r);
                try {
                    var s = this._instance.capture("$exception", i, {
                        _noTruncate: !0,
                        _batchKey: "exceptionEvent",
                        Un: !0
                    });
                    return s && this.qo.clear(), s;
                } catch (t) {
                    return $e444d6404c095fa5$var$Ml.error("Failed to capture exception event. Dropping this exception.", t), void this.qo.clear();
                }
            } catch (t) {
                return void $e444d6404c095fa5$var$Ml.error("Failed to process exception event. Ignoring this exception.", t);
            }
            var n;
        }
        Zo(t) {
            try {
                var e = this.qo.getAttachable();
                return 0 === e.length ? t : $e444d6404c095fa5$var$_({}, t, {
                    $exception_steps: e
                });
            } catch (e) {
                return $e444d6404c095fa5$var$Ml.error("Failed to read buffered exception steps. Capturing exception without steps.", e), t;
            }
        }
        zo(t) {
            this.$o.enabled && this.qo.add({
                [$e444d6404c095fa5$var$hi]: t,
                [$e444d6404c095fa5$var$di]: (new Date).toISOString()
            });
        }
        Bo(t) {
            return $e444d6404c095fa5$var$W(t) ? $e444d6404c095fa5$var$_({}, t) : {};
        }
        No() {
            var t, e;
            return null !== (t = null == (e = this._instance.config.error_tracking) ? void 0 : e.exception_steps) && void 0 !== t ? t : {};
        }
        Uo(t) {
            if (0 === t.length) return !1;
            try {
                var e = t.reduce((t, e)=>{
                    var i = e.type, r = e.value;
                    return $e444d6404c095fa5$var$J(i) && i.length > 0 && t.$exception_types.push(i), $e444d6404c095fa5$var$J(r) && r.length > 0 && t.$exception_values.push(r), t;
                }, {
                    $exception_types: [],
                    $exception_values: []
                });
                return this.Oo.some((t)=>{
                    var i = t.values.map((t)=>{
                        var i = $e444d6404c095fa5$var$pa[t.operator], r = e[t.key];
                        if (!i || !r) return !1;
                        var s = $e444d6404c095fa5$var$q(t.value) ? t.value : [
                            t.value
                        ];
                        return s.length > 0 && i(s, r);
                    });
                    return "OR" === t.type ? i.some(Boolean) : i.every(Boolean);
                });
            } catch (t) {
                return $e444d6404c095fa5$var$Ml.warn("Failed to evaluate suppression rules. Capturing the exception.", t), !1;
            }
        }
        Wo(t) {
            return t.flatMap((t)=>{
                var e, i;
                return null !== (e = null == (i = t.stacktrace) ? void 0 : i.frames) && void 0 !== e ? e : [];
            }).some((t)=>t.filename && t.filename.startsWith("chrome-extension://"));
        }
        Vo(t) {
            if (t.length > 0) {
                var e, i, r, s, n = null !== (e = null == (i = t[0].stacktrace) ? void 0 : i.frames) && void 0 !== e ? e : [], o = n[n.length - 1];
                return null !== (r = null == o || null == (s = o.filename) ? void 0 : s.includes("posthog.com/static")) && void 0 !== r && r;
            }
            return !1;
        }
        Ho(t) {
            return !$e444d6404c095fa5$var$X(t) && $e444d6404c095fa5$var$q(t);
        }
    }
}, $e444d6404c095fa5$var$Kl = $e444d6404c095fa5$var$_({
    productTours: class {
        get Tr() {
            return this._instance.persistence;
        }
        constructor(t){
            this.Go = null, this.Qo = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (t.ok) {
                var e = t.config;
                if ("productTours" in e) {
                    var i, r;
                    if (this.Tr && this.Tr.register({
                        [$e444d6404c095fa5$var$Mi]: !!e.productTours
                    }), !$e444d6404c095fa5$var$_l(this._instance)) return !this.Go && $e444d6404c095fa5$var$X(null == (i = this.Tr) ? void 0 : i.props[$e444d6404c095fa5$var$or]) || $e444d6404c095fa5$var$pl.info("product tours disabled; stopping and clearing cached tours"), null == (r = this.Go) || r.stop(), this.Go = null, void this.clearCache();
                    this.loadIfEnabled();
                }
            }
        }
        loadIfEnabled() {
            !this.Go && $e444d6404c095fa5$var$_l(this._instance) && this.ai(()=>this.Ko());
        }
        ai(t) {
            var e, i;
            null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.generateProductTours ? t() : null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "product-tours", (e)=>{
                e ? $e444d6404c095fa5$var$pl.error("Could not load product tours script", e) : t();
            });
        }
        Ko() {
            var t;
            !this.Go && null != (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) && t.generateProductTours && (this.Go = $e444d6404c095fa5$var$v.__PosthogExtensions__.generateProductTours(this._instance, !0));
        }
        getProductTours(t, e) {
            if (void 0 === e && (e = !1), !$e444d6404c095fa5$var$q(this.Qo) || e) {
                var i = this.Tr;
                if (i) {
                    var r = i.props[$e444d6404c095fa5$var$or];
                    if ($e444d6404c095fa5$var$q(r) && !e) return this.Qo = r, void t(r, {
                        isLoaded: !0
                    });
                }
                this._instance._send_request({
                    url: this._instance.requestRouter.endpointFor("api", "/api/product_tours/?token=" + this._instance.config.token),
                    method: "GET",
                    timestampMode: "query",
                    callback: (e)=>{
                        if ($e444d6404c095fa5$var$_l(this._instance)) {
                            var r = e.statusCode;
                            if (200 !== r || !e.json) {
                                var s = "Product Tours API could not be loaded, status: " + r;
                                return 0 === r ? e.error || $e444d6404c095fa5$var$pl.warn(s) : $e444d6404c095fa5$var$pl.error(s), void t([], {
                                    isLoaded: !1,
                                    error: s
                                });
                            }
                            var n = $e444d6404c095fa5$var$q(e.json.product_tours) ? e.json.product_tours : [];
                            this.Qo = n, i && i.register({
                                [$e444d6404c095fa5$var$or]: n
                            }), t(n, {
                                isLoaded: !0
                            });
                        } else t([], {
                            isLoaded: !0
                        });
                    }
                });
            } else t(this.Qo, {
                isLoaded: !0
            });
        }
        getActiveProductTours(t) {
            $e444d6404c095fa5$var$X(this.Go) ? t([], {
                isLoaded: !1,
                error: "Product tours not loaded"
            }) : this.Go.getActiveProductTours(t);
        }
        showProductTour(t) {
            var e;
            null == (e = this.Go) || e.showTourById(t);
        }
        previewTour(t) {
            this.Go ? this.Go.previewTour(t) : this.ai(()=>{
                var e;
                this.Ko(), null == (e = this.Go) || e.previewTour(t);
            });
        }
        dismissProductTour() {
            var t;
            null == (t = this.Go) || t.dismissTour("user_clicked_skip");
        }
        nextStep() {
            var t;
            null == (t = this.Go) || t.nextStep();
        }
        previousStep() {
            var t;
            null == (t = this.Go) || t.previousStep();
        }
        clearCache() {
            var t;
            this.Qo = null, null == (t = this.Tr) || t.unregister($e444d6404c095fa5$var$or);
        }
        resetTour(t) {
            var e;
            null == (e = this.Go) || e.resetTour(t);
        }
        resetAllTours() {
            var t;
            null == (t = this.Go) || t.resetAllTours();
        }
        cancelPendingTour(t) {
            var e;
            null == (e = this.Go) || e.cancelPendingTour(t);
        }
    }
}, $e444d6404c095fa5$var$ql), $e444d6404c095fa5$var$Jl = {
    siteApps: class {
        constructor(t){
            this.Jo = 0, this._instance = t, this.Yo = [], this.apps = {};
        }
        get isEnabled() {
            return !!this._instance.config.opt_in_site_apps;
        }
        Xo(t, e) {
            if (e) {
                var i = this.globalsForEvent(e);
                this.Yo.push(i), this.Yo.length > 1e3 && (this.Yo = this.Yo.slice(10));
            }
        }
        get siteAppLoaders() {
            var t;
            return null == (t = $e444d6404c095fa5$var$v._POSTHOG_REMOTE_CONFIG) || null == (t = t[this._instance.config.token]) ? void 0 : t.siteApps;
        }
        initialize() {
            if (this.isEnabled) {
                var t = this._instance._addCaptureHook(this.Xo.bind(this));
                this.tl = ()=>{
                    t(), this.Yo = [], this.tl = void 0;
                };
            }
        }
        globalsForEvent(t) {
            var e, i, r, s, n, o, a;
            if (!t) throw new Error("Event payload is required");
            var l = {}, u = this._instance.get_property("$groups") || [], h = this._instance.get_property("$stored_group_properties") || {};
            for (var d of Object.entries(h)){
                var v = d[0];
                l[v] = {
                    id: u[v],
                    type: v,
                    properties: d[1]
                };
            }
            var c = t.$set_once, f = t.$set;
            return {
                event: $e444d6404c095fa5$var$_({}, $e444d6404c095fa5$var$g(t, $e444d6404c095fa5$var$gl), {
                    properties: $e444d6404c095fa5$var$_({}, t.properties, f ? {
                        $set: $e444d6404c095fa5$var$_({}, null !== (e = null == (i = t.properties) ? void 0 : i.$set) && void 0 !== e ? e : {}, f)
                    } : {}, c ? {
                        $set_once: $e444d6404c095fa5$var$_({}, null !== (r = null == (s = t.properties) ? void 0 : s.$set_once) && void 0 !== r ? r : {}, c)
                    } : {}),
                    elements_chain: null !== (n = null == (o = t.properties) ? void 0 : o.$elements_chain) && void 0 !== n ? n : "",
                    distinct_id: null == (a = t.properties) ? void 0 : a.distinct_id
                }),
                person: {
                    properties: this._instance.get_property("$stored_person_properties")
                },
                groups: l
            };
        }
        el(t) {
            var e, i = null == (e = t.tagName) ? void 0 : e.toLowerCase();
            return "style" === i && this._instance.config.prepare_external_dependency_stylesheet ? this._instance.config.prepare_external_dependency_stylesheet(t) || ($e444d6404c095fa5$var$ml.error("prepare_external_dependency_stylesheet returned null"), null) : "script" === i && this._instance.config.prepare_external_dependency_script ? this._instance.config.prepare_external_dependency_script(t) || ($e444d6404c095fa5$var$ml.error("prepare_external_dependency_script returned null"), null) : t;
        }
        il() {
            var t, e, i, s, n, o, a, l;
            if (!this._instance.config.prepare_external_dependency_stylesheet && !this._instance.config.prepare_external_dependency_script) return ()=>{};
            var u = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.defaultView, h = null == u || null == (t = u.Node) ? void 0 : t.prototype;
            if (!u || !h) return ()=>{};
            if (this.Jo++, this.rl) return this.nl();
            var d = [], v = this, c = new WeakSet, f = (t, e, i)=>{
                if (null != t && t[e]) {
                    var r = t[e];
                    t[e] = i(r), d.push(()=>{
                        t[e] = r;
                    });
                }
            }, p = (t)=>{
                if (c.has(t)) return t;
                var e = v.el(t);
                return e && c.add(e), e;
            }, _ = (t)=>t.map((t)=>"string" == typeof t ? t : p(t)).filter((t)=>!$e444d6404c095fa5$var$Q(t));
            return f(h, "appendChild", (t)=>function(e) {
                    var i = p(e);
                    return i ? t.call(this, i) : e;
                }), f(h, "insertBefore", (t)=>function(e, i) {
                    var r = p(e);
                    return r ? t.call(this, r, i) : e;
                }), f(h, "replaceChild", (t)=>function(e, i) {
                    var r = p(e);
                    return r ? t.call(this, r, i) : i;
                }), [
                null == (e = u.Element) ? void 0 : e.prototype,
                null == (i = u.Document) ? void 0 : i.prototype,
                null == (s = u.DocumentFragment) ? void 0 : s.prototype
            ].forEach((t)=>{
                f(t, "append", (t)=>function() {
                        for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
                        return t.apply(this, _(i));
                    }), f(t, "prepend", (t)=>function() {
                        for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
                        return t.apply(this, _(i));
                    });
            }), [
                null == (n = u.Element) ? void 0 : n.prototype,
                null == (o = u.CharacterData) ? void 0 : o.prototype,
                null == (a = u.DocumentType) ? void 0 : a.prototype
            ].forEach((t)=>{
                f(t, "before", (t)=>function() {
                        for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
                        return t.apply(this, _(i));
                    }), f(t, "after", (t)=>function() {
                        for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
                        return t.apply(this, _(i));
                    }), f(t, "replaceWith", (t)=>function() {
                        for(var e = arguments.length, i = new Array(e), r = 0; e > r; r++)i[r] = arguments[r];
                        var s = _(i);
                        return i.length && !s.length ? void 0 : t.apply(this, s);
                    });
            }), f(null == (l = u.Element) ? void 0 : l.prototype, "insertAdjacentElement", (t)=>function(e, i) {
                    var r = p(i);
                    return r ? t.call(this, e, r) : null;
                }), this.rl = ()=>{
                d.forEach((t)=>t()), this.rl = void 0;
            }, this.nl();
        }
        nl() {
            var t = !1;
            return ()=>{
                var e;
                t || (t = !0, this.Jo--, 0 === this.Jo && (null == (e = this.rl) || e.call(this)));
            };
        }
        sl(t, e) {
            void 0 === e && (e = !0);
            var i = this.il();
            try {
                var r = t(i);
                return e && i(), r;
            } catch (t) {
                throw i(), t;
            }
        }
        setupSiteApp(t) {
            var e = this.apps[t.id], i = ()=>{
                var i;
                !e.errored && this.Yo.length && ($e444d6404c095fa5$var$ml.info("Processing " + this.Yo.length + " events for site app with id " + t.id), this.Yo.forEach((t)=>this.sl(()=>null == e.processEvent ? void 0 : e.processEvent(t))), e.processedBuffer = !0), Object.values(this.apps).every((t)=>t.processedBuffer || t.errored) && (null == (i = this.tl) || i.call(this));
            }, r = !1, s = (s)=>{
                e.errored = !s, e.loaded = !0, $e444d6404c095fa5$var$ml.info("Site app with id " + t.id + " " + (s ? "loaded" : "errored")), r && i();
            };
            try {
                var n = this.sl((e)=>t.init({
                        posthog: this._instance,
                        callback (t) {
                            e(), s(t);
                        }
                    }), !1).processEvent;
                n && (e.processEvent = n), r = !0;
            } catch (e) {
                $e444d6404c095fa5$var$ml.error($e444d6404c095fa5$var$bl + t.id, e), s(!1);
            }
            if (r && e.loaded) try {
                i();
            } catch (i) {
                $e444d6404c095fa5$var$ml.error("Error while processing buffered events PostHog app with config id " + t.id, i), e.errored = !0;
            }
        }
        al() {
            var t = this.siteAppLoaders || [];
            for (var e of t)this.apps[e.id] = {
                id: e.id,
                loaded: !1,
                errored: !1,
                processedBuffer: !1
            };
            for (var i of t)this.setupSiteApp(i);
        }
        ol(t) {
            var e = this;
            if (0 !== Object.keys(this.apps).length) {
                var i = this.globalsForEvent(t), r = function(r) {
                    try {
                        e.sl(()=>null == r.processEvent ? void 0 : r.processEvent(i));
                    } catch (e) {
                        $e444d6404c095fa5$var$ml.error("Error while processing event " + t.event + " for site app " + r.id, e);
                    }
                };
                for (var s of Object.values(this.apps))r(s);
            }
        }
        onRemoteConfig(t) {
            var e, i, r, s = this;
            if (null != (e = this.siteAppLoaders) && e.length) return this.isEnabled ? (this.al(), void this._instance.on("eventCaptured", (t)=>this.ol(t))) : void $e444d6404c095fa5$var$ml.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            if (null == (i = this.tl) || i.call(this), t.ok) {
                var n = t.config;
                if (null != (r = n.siteApps) && r.length) {
                    if (this.isEnabled) {
                        var o = function() {
                            var t, e = a.id, i = a.url;
                            $e444d6404c095fa5$var$v["__$$ph_site_app_" + e] = s._instance, null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == t.loadSiteApp || t.loadSiteApp(s._instance, i, (t)=>{
                                if (t) return $e444d6404c095fa5$var$ml.error($e444d6404c095fa5$var$bl + e, t);
                            });
                        };
                        for (var a of n.siteApps)o();
                    } else $e444d6404c095fa5$var$ml.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
                }
            }
        }
    }
}, $e444d6404c095fa5$var$Yl = {
    tracingHeaders: class {
        constructor(t){
            this.ll = void 0, this.ul = void 0, this.hl = void 0, this.Co = ()=>{
                var t, e, i = this.dl();
                i ? ($e444d6404c095fa5$var$K(this.ll) && (this.ll = null == (t = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (t = t.tracingHeadersPatchFns) ? void 0 : t._patchXHR(i, ()=>this._instance.get_distinct_id(), this._instance.sessionManager)), $e444d6404c095fa5$var$K(this.ul) && (this.ul = null == (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == (e = e.tracingHeadersPatchFns) ? void 0 : e._patchFetch(i, ()=>this._instance.get_distinct_id(), this._instance.sessionManager))) : this.Ro();
            }, this._instance = t;
        }
        initialize() {
            this.startIfEnabledOrStop();
        }
        ai(t) {
            var e, i;
            null != (e = $e444d6404c095fa5$var$v.__PosthogExtensions__) && e.tracingHeadersPatchFns ? t() : null == (i = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == i.loadExternalDependency || i.loadExternalDependency(this._instance, "tracing-headers", (e)=>{
                if (e) return $e444d6404c095fa5$var$sl.error("failed to load script", e);
                t();
            });
        }
        vl() {
            var t, e;
            return null !== (t = null !== (e = this._instance.config.tracing_headers) && void 0 !== e ? e : this._instance.config.addTracingHeaders) && void 0 !== t ? t : this._instance.config.__add_tracing_headers;
        }
        dl() {
            var t = this.vl();
            return $e444d6404c095fa5$var$q(t) ? ($e444d6404c095fa5$var$q(this.hl) ? this.hl.splice(0, this.hl.length, ...t) : this.hl = [
                ...t
            ], t.length > 0 ? this.hl : void 0) : ($e444d6404c095fa5$var$q(this.hl) && this.hl.splice(0), this.hl = t || void 0, this.hl);
        }
        Ro() {
            var t, e;
            null == (t = this.ll) || t.call(this), null == (e = this.ul) || e.call(this), this.ll = void 0, this.ul = void 0;
        }
        startIfEnabledOrStop() {
            this.dl() ? this.ai(this.Co) : this.Ro();
        }
    }
}, $e444d6404c095fa5$var$Ql = $e444d6404c095fa5$var$_({
    surveys: class {
        get Ne() {
            return this._instance.config;
        }
        constructor(t){
            this.cl = void 0, this._surveyManager = null, this.fl = !1, this.pl = [], this.gl = null, this.ml = null, this._instance = t, this._surveyEventReceiver = null;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this.Ne.disable_surveys) {
                if (!t.ok) return $e444d6404c095fa5$var$Ea.warn("Remote config unavailable. Not loading surveys.");
                var e = t.config.surveys;
                if ($e444d6404c095fa5$var$X(e)) return $e444d6404c095fa5$var$Ea.warn("Flags not loaded yet. Not loading surveys.");
                var i = $e444d6404c095fa5$var$q(e);
                this.cl = i ? e.length > 0 : e, $e444d6404c095fa5$var$Ea.info("flags response received, isSurveysEnabled: " + this.cl), this.loadIfEnabled();
            }
        }
        reset() {
            try {
                var t;
                null == (t = this._surveyEventReceiver) || t.reset(), localStorage.removeItem("lastSeenSurveyDate");
                for(var e = [], i = 0; i < localStorage.length; i++){
                    var r = localStorage.key(i);
                    (null != r && r.startsWith($e444d6404c095fa5$var$Sa) || null != r && r.startsWith("inProgressSurvey_")) && e.push(r);
                }
                e.forEach((t)=>localStorage.removeItem(t));
            } catch (t) {}
        }
        loadIfEnabled() {
            if (!this._surveyManager) {
                if (this.fl) $e444d6404c095fa5$var$Ea.info("Already initializing surveys, skipping...");
                else if (this.Ne.disable_surveys) $e444d6404c095fa5$var$Ea.info($e444d6404c095fa5$var$$l);
                else if (this.Ne.cookieless_mode && this._instance.consent.isOptedOut()) $e444d6404c095fa5$var$Ea.info("Not loading surveys in cookieless mode without consent.");
                else {
                    var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                    if (t) {
                        if (!$e444d6404c095fa5$var$K(this.cl) || this.Ne.advanced_enable_surveys) {
                            var e = this.cl || this.Ne.advanced_enable_surveys;
                            this.fl = !0;
                            try {
                                var i = t.generateSurveys;
                                if (i) return void this.yl(i, e);
                                var r = t.loadExternalDependency;
                                if (!r) return void this.bl($e444d6404c095fa5$var$Er);
                                r(this._instance, "surveys", (i)=>{
                                    i || !t.generateSurveys ? this.bl("Could not load surveys script", i) : this.yl(t.generateSurveys, e);
                                });
                            } catch (t) {
                                throw this.bl("Error initializing surveys", t), t;
                            } finally{
                                this.fl = !1;
                            }
                        }
                    } else $e444d6404c095fa5$var$Ea.error("PostHog Extensions not found.");
                }
            }
        }
        yl(t, e) {
            this._surveyManager = t(this._instance, e), this._surveyEventReceiver = new $e444d6404c095fa5$var$El(this._instance), $e444d6404c095fa5$var$Ea.info("Surveys loaded successfully"), this._l({
                isLoaded: !0
            });
        }
        bl(t, e) {
            $e444d6404c095fa5$var$Ea.error(t, e), this._l({
                isLoaded: !1,
                error: t
            });
        }
        onSurveysLoaded(t) {
            return this.pl.push(t), this._surveyManager && this._l({
                isLoaded: !0
            }), ()=>{
                this.pl = this.pl.filter((e)=>e !== t);
            };
        }
        getSurveys(t, e) {
            if (void 0 === e && (e = !1), this.Ne.disable_surveys) return $e444d6404c095fa5$var$Ea.info($e444d6404c095fa5$var$$l), t([]);
            var i, r = this._instance.get_property($e444d6404c095fa5$var$er);
            if (r && !e) return t(r, {
                isLoaded: !0
            }), void (this.wl() && this.getSurveys(()=>{}, !0));
            "undefined" != typeof Promise && this.gl ? this.gl.then((e)=>t(e.surveys, e.context)) : ("undefined" != typeof Promise && (this.gl = new Promise((t)=>{
                i = t;
            })), this._instance._send_request({
                url: this._instance.requestRouter.endpointFor("api", "/api/surveys/?token=" + this.Ne.token),
                method: "GET",
                timestampMode: "query",
                timeout: this.Ne.surveys_request_timeout_ms,
                callback: (e)=>{
                    var r;
                    this.gl = null;
                    var s = e.statusCode;
                    if (200 !== s || !e.json) {
                        var n = "Surveys API could not be loaded, status: " + s;
                        0 !== s ? $e444d6404c095fa5$var$Ea.error(n) : e.error || $e444d6404c095fa5$var$Ea.warn(n), this.ml = Date.now();
                        var o = {
                            isLoaded: !1,
                            error: n
                        };
                        return t([], o), void (null == i || i({
                            surveys: [],
                            context: o
                        }));
                    }
                    this.ml = null;
                    var a, l = e.json.surveys || [], u = l.filter((t)=>(function(t) {
                            return !(!t.start_date || t.end_date);
                        })(t) && ($e444d6404c095fa5$var$xa(t) || function(t) {
                            var e;
                            return !(null == (e = t.conditions) || null == (e = e.actions) || null == (e = e.values) || !e.length);
                        }(t)));
                    u.length > 0 && (null == (a = this._surveyEventReceiver) || a.register(u)), null == (r = this._instance.persistence) || r.register({
                        [$e444d6404c095fa5$var$er]: l,
                        [$e444d6404c095fa5$var$ir]: Date.now()
                    });
                    var h = {
                        isLoaded: !0
                    };
                    t(l, h), null == i || i({
                        surveys: l,
                        context: h
                    });
                }
            }));
        }
        wl() {
            return this.kl() && !this.gl && !this.xl();
        }
        kl() {
            var t = this._instance.get_property($e444d6404c095fa5$var$ir);
            return $e444d6404c095fa5$var$Z(t) && Date.now() - t > 3e5;
        }
        xl() {
            return $e444d6404c095fa5$var$Z(this.ml) && 3e5 > Date.now() - this.ml;
        }
        markSurveyAsSeen(t, e) {
            var i, r = {
                id: t,
                current_iteration: null !== (i = null == e ? void 0 : e.iteration) && void 0 !== i ? i : null
            };
            $e444d6404c095fa5$var$$a(r);
            try {
                localStorage.setItem("lastSeenSurveyDate", (new Date).toISOString());
            } catch (t) {}
        }
        _l(t) {
            for (var e of this.pl)try {
                if (!t.isLoaded) return e([], t);
                this.getSurveys(e);
            } catch (t) {
                $e444d6404c095fa5$var$Ea.error("Error in survey callback", t);
            }
        }
        getActiveMatchingSurveys(t, e) {
            if (void 0 === e && (e = !1), !$e444d6404c095fa5$var$X(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, e);
            $e444d6404c095fa5$var$Ea.warn("init was not called");
        }
        Sl(t) {
            var e = null;
            return this.getSurveys((i)=>{
                var r;
                e = null !== (r = i.find((e)=>e.id === t)) && void 0 !== r ? r : null;
            }), e;
        }
        Cl(t) {
            if ($e444d6404c095fa5$var$X(this._surveyManager)) return {
                eligible: !1,
                reason: $e444d6404c095fa5$var$Sl
            };
            var e = "string" == typeof t ? this.Sl(t) : t;
            return e ? this._surveyManager.checkSurveyEligibility(e) : {
                eligible: !1,
                reason: "Survey not found"
            };
        }
        Ml(t) {
            if ($e444d6404c095fa5$var$X(this._surveyManager)) return {
                eligible: !1,
                reason: $e444d6404c095fa5$var$Sl
            };
            var e = "string" == typeof t ? this.Sl(t) : t;
            return e ? this._surveyManager.checkSurveyRenderability(e) : {
                eligible: !1,
                reason: "Survey not found"
            };
        }
        canRenderSurvey(t) {
            if ($e444d6404c095fa5$var$X(this._surveyManager)) return $e444d6404c095fa5$var$Ea.warn("init was not called"), {
                visible: !1,
                disabledReason: $e444d6404c095fa5$var$Sl
            };
            var e = this.Ml(t);
            return {
                visible: e.eligible,
                disabledReason: e.reason
            };
        }
        canRenderSurveyAsync(t, e) {
            return $e444d6404c095fa5$var$X(this._surveyManager) ? ($e444d6404c095fa5$var$Ea.warn("init was not called"), Promise.resolve({
                visible: !1,
                disabledReason: $e444d6404c095fa5$var$Sl
            })) : new Promise((i)=>{
                this.getSurveys((e)=>{
                    var r, s = null !== (r = e.find((e)=>e.id === t)) && void 0 !== r ? r : null;
                    if (s) {
                        var n = this.Ml(s);
                        i({
                            visible: n.eligible,
                            disabledReason: n.reason
                        });
                    } else i({
                        visible: !1,
                        disabledReason: "Survey not found"
                    });
                }, e);
            });
        }
        renderSurvey(t, e, i) {
            var s;
            if ($e444d6404c095fa5$var$X(this._surveyManager)) $e444d6404c095fa5$var$Ea.warn("init was not called");
            else {
                var n = "string" == typeof t ? this.Sl(t) : t;
                if (null != n && n.id) {
                    if ($e444d6404c095fa5$var$ka.includes(n.type)) {
                        var o = null == $e444d6404c095fa5$var$r ? void 0 : $e444d6404c095fa5$var$r.querySelector(e);
                        if (o) return null != (s = n.appearance) && s.surveyPopupDelaySeconds ? ($e444d6404c095fa5$var$Ea.info("Rendering survey " + n.id + " with delay of " + n.appearance.surveyPopupDelaySeconds + " seconds"), void setTimeout(()=>{
                            var t, e;
                            $e444d6404c095fa5$var$Ea.info("Rendering survey " + n.id + " with delay of " + (null == (t = n.appearance) ? void 0 : t.surveyPopupDelaySeconds) + " seconds"), null == (e = this._surveyManager) || e.renderSurvey(n, o, i), $e444d6404c095fa5$var$Ea.info("Survey " + n.id + " rendered");
                        }, 1e3 * n.appearance.surveyPopupDelaySeconds)) : void this._surveyManager.renderSurvey(n, o, i);
                        $e444d6404c095fa5$var$Ea.warn("Survey element not found");
                    } else $e444d6404c095fa5$var$Ea.warn("Surveys of type " + n.type + " cannot be rendered in the app");
                } else $e444d6404c095fa5$var$Ea.warn("Survey not found");
            }
        }
        displaySurvey(t, e) {
            var i;
            if ($e444d6404c095fa5$var$X(this._surveyManager)) $e444d6404c095fa5$var$Ea.warn("init was not called");
            else {
                var r = this.Sl(t);
                if (r) {
                    var s = r;
                    if (null != (i = r.appearance) && i.surveyPopupDelaySeconds && e.ignoreDelay && (s = $e444d6404c095fa5$var$_({}, r, {
                        appearance: $e444d6404c095fa5$var$_({}, r.appearance, {
                            surveyPopupDelaySeconds: 0
                        })
                    })), e.displayType !== $e444d6404c095fa5$export$a8a66d9d1b857494.Popover && e.initialResponses && $e444d6404c095fa5$var$Ea.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), !1 === e.ignoreConditions) {
                        var n = this.Cl(r);
                        if (!n.eligible) return void $e444d6404c095fa5$var$Ea.warn("Survey is not eligible to be displayed: ", n.reason);
                    }
                    e.displayType !== $e444d6404c095fa5$export$a8a66d9d1b857494.Inline ? this._surveyManager.handlePopoverSurvey(s, e) : this.renderSurvey(s, e.selector, e.properties);
                } else $e444d6404c095fa5$var$Ea.warn("Survey not found");
            }
        }
        cancelPendingSurvey(t) {
            $e444d6404c095fa5$var$X(this._surveyManager) ? $e444d6404c095fa5$var$Ea.warn("init was not called") : this._surveyManager.cancelSurvey(t);
        }
        handlePageUnload() {
            var t;
            null == (t = this._surveyManager) || null == t.handlePageUnload || t.handlePageUnload();
        }
    }
}, $e444d6404c095fa5$var$ql), $e444d6404c095fa5$var$Xl = {
    toolbar: class {
        constructor(t){
            this.instance = t;
        }
        Tl(t) {
            $e444d6404c095fa5$var$v.ph_toolbar_state = t;
        }
        El() {
            var t;
            return null !== (t = $e444d6404c095fa5$var$v.ph_toolbar_state) && void 0 !== t ? t : 0;
        }
        initialize() {
            return this.maybeLoadToolbar();
        }
        maybeLoadToolbar(e, i, s) {
            if (void 0 === e && (e = void 0), void 0 === i && (i = void 0), void 0 === s && (s = void 0), $e444d6404c095fa5$var$Vr(this.instance.config)) return !1;
            if (!$e444d6404c095fa5$var$t || !$e444d6404c095fa5$var$r) return !1;
            e = null != e ? e : $e444d6404c095fa5$var$t.location, s = null != s ? s : $e444d6404c095fa5$var$t.history;
            try {
                if (!i) {
                    try {
                        $e444d6404c095fa5$var$t.localStorage.setItem("test", "test"), $e444d6404c095fa5$var$t.localStorage.removeItem("test");
                    } catch (t) {
                        return !1;
                    }
                    i = null == $e444d6404c095fa5$var$t ? void 0 : $e444d6404c095fa5$var$t.localStorage;
                }
                var n, o = $e444d6404c095fa5$var$kl || $e444d6404c095fa5$var$mn(e.hash, "__posthog") || $e444d6404c095fa5$var$mn(e.hash, "state"), a = o ? $e444d6404c095fa5$var$Lr(()=>JSON.parse(atob(decodeURIComponent(o)))) || $e444d6404c095fa5$var$Lr(()=>JSON.parse(decodeURIComponent(o))) : null;
                return a && "ph_authorize" === a.action ? ((n = a).source = "url", n && Object.keys(n).length > 0 && (a.desiredHash ? e.hash = a.desiredHash : s ? s.replaceState(s.state, "", e.pathname + e.search) : e.hash = "")) : ((n = JSON.parse(i.getItem($e444d6404c095fa5$var$Tl) || "{}")).source = "localstorage", delete n.userIntent), !(!n.token || this.instance.config.token !== n.token || (this.loadToolbar(n), 0));
            } catch (t) {
                return !1;
            }
        }
        Il(t) {
            var e = $e444d6404c095fa5$var$v.ph_load_toolbar || $e444d6404c095fa5$var$v.ph_load_editor;
            !$e444d6404c095fa5$var$X(e) && $e444d6404c095fa5$var$V(e) ? e(t, this.instance) : $e444d6404c095fa5$var$Rl.warn("No toolbar load function found");
        }
        loadToolbar(e) {
            var i = !(null == $e444d6404c095fa5$var$r || !$e444d6404c095fa5$var$r.getElementById($e444d6404c095fa5$var$vs));
            if (!$e444d6404c095fa5$var$t || i) return !1;
            var s = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, n = $e444d6404c095fa5$var$_({
                token: this.instance.config.token
            }, e, {
                apiURL: this.instance.requestRouter.endpointFor("ui")
            }, s ? {
                instrument: !1
            } : {});
            if ($e444d6404c095fa5$var$t.localStorage.setItem($e444d6404c095fa5$var$Tl, JSON.stringify($e444d6404c095fa5$var$_({}, n, {
                source: void 0
            }))), 2 === this.El()) this.Il(n);
            else if (0 === this.El()) {
                var o;
                this.Tl(1), null == (o = $e444d6404c095fa5$var$v.__PosthogExtensions__) || null == o.loadExternalDependency || o.loadExternalDependency(this.instance, "toolbar", (t)=>{
                    if (t) return $e444d6404c095fa5$var$Rl.error("[Toolbar] Failed to load", t), void this.Tl(0);
                    this.Tl(2), this.Il(n);
                }), $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "turbolinks:load", ()=>{
                    this.Tl(0), this.loadToolbar(n);
                });
            }
            return !0;
        }
        Pl(t) {
            return this.loadToolbar(t);
        }
        maybeLoadEditor(t, e, i) {
            return void 0 === t && (t = void 0), void 0 === e && (e = void 0), void 0 === i && (i = void 0), this.maybeLoadToolbar(t, e, i);
        }
    }
}, $e444d6404c095fa5$var$Zl = $e444d6404c095fa5$var$_({
    experiments: $e444d6404c095fa5$var$Nl
}, $e444d6404c095fa5$var$ql), $e444d6404c095fa5$var$tu = {
    conversations: class {
        constructor(t){
            this.Rl = void 0, this._conversationsManager = null, this.Al = !1, this.Fl = null, this._instance = t;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            if (!this._instance.config.disable_conversations && t.ok) {
                var e = t.config.conversations;
                $e444d6404c095fa5$var$X(e) || ($e444d6404c095fa5$var$et(e) ? this.Rl = e : (this.Rl = e.enabled, this.Fl = e), this.loadIfEnabled());
            }
        }
        reset() {
            var t;
            null == (t = this._conversationsManager) || t.reset(), this._conversationsManager = null, this.Rl = void 0, this.Fl = null;
        }
        loadIfEnabled() {
            if (!(this._conversationsManager || this.Al || this._instance.config.disable_conversations || $e444d6404c095fa5$var$Vr(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut())) {
                var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                if (t && !$e444d6404c095fa5$var$K(this.Rl) && this.Rl) {
                    if (this.Fl && this.Fl.token) {
                        this.Al = !0;
                        try {
                            var e = t.initConversations;
                            if (e) return this.Ll(e), void (this.Al = !1);
                            var i = t.loadExternalDependency;
                            if (!i) return void this.Ol($e444d6404c095fa5$var$Er);
                            i(this._instance, "conversations", (e)=>{
                                e || !t.initConversations ? this.Ol("Could not load conversations script", e) : this.Ll(t.initConversations), this.Al = !1;
                            });
                        } catch (t) {
                            this.Ol("Error initializing conversations", t), this.Al = !1;
                        }
                    } else $e444d6404c095fa5$var$Ul.error("Conversations enabled but missing token in remote config.");
                }
            }
        }
        Ll(t) {
            if (this.Fl) try {
                this._conversationsManager = t(this.Fl, this._instance), $e444d6404c095fa5$var$Ul.info("Conversations loaded successfully");
            } catch (t) {
                this.Ol("Error completing conversations initialization", t);
            }
            else $e444d6404c095fa5$var$Ul.error("Cannot complete initialization: remote config is null");
        }
        Ol(t, e) {
            $e444d6404c095fa5$var$Ul.error(t, e), this._conversationsManager = null, this.Al = !1;
        }
        show() {
            this._conversationsManager ? this._conversationsManager.show() : $e444d6404c095fa5$var$Ul.warn("Conversations not loaded yet.");
        }
        hide() {
            this._conversationsManager && this._conversationsManager.hide();
        }
        isAvailable() {
            return !0 === this.Rl && !$e444d6404c095fa5$var$Q(this._conversationsManager);
        }
        isVisible() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.isVisible()) && void 0 !== t && t;
        }
        sendMessage(t, e, i) {
            var r = this;
            return $e444d6404c095fa5$var$p(function*() {
                return r._conversationsManager ? r._conversationsManager.sendMessage(t, e, i) : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        getMessages(t, e) {
            var i = this;
            return $e444d6404c095fa5$var$p(function*() {
                return i._conversationsManager ? i._conversationsManager.getMessages(t, e) : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        markAsRead(t) {
            var e = this;
            return $e444d6404c095fa5$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.markAsRead(t) : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        getTickets(t) {
            var e = this;
            return $e444d6404c095fa5$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.getTickets(t) : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        requestRestoreLink(t) {
            var e = this;
            return $e444d6404c095fa5$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.requestRestoreLink(t) : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        restoreFromToken(t) {
            var e = this;
            return $e444d6404c095fa5$var$p(function*() {
                return e._conversationsManager ? e._conversationsManager.restoreFromToken(t) : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        restoreFromUrlToken() {
            var t = this;
            return $e444d6404c095fa5$var$p(function*() {
                return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : ($e444d6404c095fa5$var$Ul.warn($e444d6404c095fa5$var$Ll), null);
            })();
        }
        getCurrentTicketId() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.getCurrentTicketId()) && void 0 !== t ? t : null;
        }
        getWidgetSessionId() {
            var t, e;
            return null !== (t = null == (e = this._conversationsManager) ? void 0 : e.getWidgetSessionId()) && void 0 !== t ? t : null;
        }
        Yn() {
            var t;
            null == (t = this._conversationsManager) || t.setIdentity();
        }
        Xn() {
            var t;
            null == (t = this._conversationsManager) || t.clearIdentity();
        }
    }
}, $e444d6404c095fa5$var$eu = {
    logs: class {
        constructor(e){
            var i, r = this;
            this.Dl = !1, this.$l = !1, this.rt = $e444d6404c095fa5$var$bi("[logs]"), this.Nl = $e444d6404c095fa5$var$_({}, this.rt, {
                error () {
                    for(var t = arguments.length, e = new Array(t), i = 0; t > i; i++)e[i] = arguments[i];
                    e.some($e444d6404c095fa5$var$Hl) || r.rt.error(...e);
                }
            }), this.er = [], this.ql = [], this.ya = 0, this.jl = ()=>{
                var t, e;
                this.ya = 0, null == (t = this.Bl) || t.onReconnect(), null == (e = this.Hl) || e.onReconnect();
            }, this._instance = e, this._instance && null != (i = this._instance.config.logs) && i.captureConsoleLogs && (this.Dl = !0), $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$t, "online", this.jl);
        }
        Ul(t, e, i, r) {
            var s, n = function(t, e) {
                var i, r, s, n, o, a, l, u = null !== (i = null == t ? void 0 : t.flushIntervalMs) && void 0 !== i ? i : 3e3, h = null !== (r = null == t ? void 0 : t.maxBufferSize) && void 0 !== r ? r : 100, d = null != e && e.consoleCapture ? void 0 : null !== (s = null == t ? void 0 : t.maxLogsPerInterval) && void 0 !== s ? s : 1e3, v = $e444d6404c095fa5$var$K(d) ? Math.max(h, 2048) : Math.max(h, d), c = null == t ? void 0 : t.resourceAttributes;
                return {
                    serviceName: null !== (n = null !== (o = null == c ? void 0 : c["service.name"]) && void 0 !== o ? o : null == t ? void 0 : t.serviceName) && void 0 !== n ? n : null == e ? void 0 : e.serviceNameDefault,
                    serviceVersion: null !== (a = null == c ? void 0 : c["service.version"]) && void 0 !== a ? a : null == t ? void 0 : t.serviceVersion,
                    environment: null !== (l = null == c ? void 0 : c["deployment.environment"]) && void 0 !== l ? l : null == t ? void 0 : t.environment,
                    resourceAttributes: c,
                    beforeSend: null == t ? void 0 : t.beforeSend,
                    flushIntervalMs: u,
                    maxBufferSize: h,
                    maxQueueSize: v,
                    maxBatchRecordsPerPost: 100,
                    rateCapWindowMs: u,
                    maxLogsPerInterval: d,
                    backgroundFlushBudgetMs: 0,
                    terminationFlushBudgetMs: 0
                };
            }(null == (s = this._instance) || null == (s = s.config) ? void 0 : s.logs, i);
            return [
                new $e444d6404c095fa5$var$Ce(this.zl(t, e), n, this.Nl, ()=>this.Wl(), (t)=>t(), void 0, r),
                n
            ];
        }
        Vl() {
            var t, e = null == (t = this._instance) || null == (t = t.config) ? void 0 : t.logs;
            if (!this.Bl || this.Zl !== e) {
                var i;
                null == (i = this.Bl) || i.reset(), this.Zl = e;
                var r = this.Ul(()=>this.er, (t)=>{
                    this.er = t;
                });
                this.Bl = r[0], this.Gl = r[1];
            }
            return this.Bl;
        }
        Ql() {
            var t, e = null == (t = this._instance) || null == (t = t.config) ? void 0 : t.logs;
            if (!this.Hl || this.Kl !== e) {
                var i;
                null == (i = this.Hl) || i.reset(), this.Kl = e;
                var r = this.Ul(()=>this.ql, (t)=>{
                    this.ql = t;
                }, {
                    serviceNameDefault: "posthog-browser-logs",
                    consoleCapture: !0
                }, $e444d6404c095fa5$var$jl);
                this.Hl = r[0], this.Jl = r[1];
            }
            return this.Hl;
        }
        initialize() {
            this.loadIfEnabled();
        }
        onRemoteConfig(t) {
            var e;
            if (t.ok) {
                var i = null == (e = t.config.logs) ? void 0 : e.captureConsoleLogs;
                !$e444d6404c095fa5$var$X(i) && i && (this.Dl = !0, this.loadIfEnabled());
            }
        }
        reset() {
            var t, e;
            this.er = [], null == (t = this.Bl) || t.reset(), this.ql = [], null == (e = this.Hl) || e.reset(), this.ya = 0;
        }
        captureLog(t) {
            this.Vl().captureLog(t);
        }
        he(t) {
            this.Ql().captureLog(t);
        }
        get logger() {
            return this.Yl || (this.Yl = {
                trace: (t, e)=>this.captureLog({
                        body: t,
                        level: "trace",
                        attributes: e
                    }),
                debug: (t, e)=>this.captureLog({
                        body: t,
                        level: "debug",
                        attributes: e
                    }),
                info: (t, e)=>this.captureLog({
                        body: t,
                        level: "info",
                        attributes: e
                    }),
                warn: (t, e)=>this.captureLog({
                        body: t,
                        level: "warn",
                        attributes: e
                    }),
                error: (t, e)=>this.captureLog({
                        body: t,
                        level: "error",
                        attributes: e
                    }),
                fatal: (t, e)=>this.captureLog({
                        body: t,
                        level: "fatal",
                        attributes: e
                    })
            }), this.Yl;
        }
        flushLogs(t) {
            t ? this.Xl(t) : (this.Bl && this.Bl.flush().catch((t)=>this.tu(t)), this.Hl && this.Hl.flush().catch((t)=>this.tu(t)));
        }
        tu(t) {
            $e444d6404c095fa5$var$Hl(t) || this.rt.error("PostHog logs flush failed:", t);
        }
        loadIfEnabled() {
            if (this.Dl && !this.$l) {
                var t = null == $e444d6404c095fa5$var$v ? void 0 : $e444d6404c095fa5$var$v.__PosthogExtensions__;
                if (t) {
                    var e = t.loadExternalDependency;
                    e ? e(this._instance, "logs", (e)=>{
                        var i;
                        e || null == (i = t.logs) || !i.initializeLogs ? this.rt.error("Could not load logs script", e) : (t.logs.initializeLogs(this._instance), this.$l = !0);
                    }) : this.rt.error($e444d6404c095fa5$var$Er);
                } else this.rt.error("PostHog Extensions not found.");
            }
        }
        zl(t, e) {
            var i = this._instance;
            return {
                get isDisabled () {
                    return !1;
                },
                get optedOut () {
                    return !i.is_capturing();
                },
                getPersistedProperty: (e)=>e === $e444d6404c095fa5$var$E.LogsQueue ? t() : void 0,
                setPersistedProperty (t, i) {
                    var r;
                    t === $e444d6404c095fa5$var$E.LogsQueue && e(null !== (r = i) && void 0 !== r ? r : []);
                },
                Ot: (t)=>this.Ot(t),
                getLibraryId: ()=>$e444d6404c095fa5$var$c.LIB_NAME,
                getLibraryVersion: ()=>$e444d6404c095fa5$var$c.LIB_VERSION
            };
        }
        Ot(t) {
            return new Promise((e)=>{
                if ($e444d6404c095fa5$var$bn(this.ya, 3)) e({
                    kind: "fatal",
                    error: $e444d6404c095fa5$var$zl(void 0, "logs endpoint is unreachable, dropping batch")
                });
                else {
                    var i = !1, r = (t)=>{
                        i || (i = !0, clearTimeout(s), e(t));
                    }, s = setTimeout(()=>{
                        this.rt.warn("Logs request timed out before receiving a response"), r({
                            kind: "retry-later",
                            error: $e444d6404c095fa5$var$zl(void 0, "logs request timed out")
                        });
                    }, 9e4);
                    this._instance._send_request({
                        method: "POST",
                        url: this.eu(),
                        data: t,
                        compression: "best-available",
                        batchKey: "logs",
                        fireCallbackOnDrop: !0,
                        callback: (t)=>{
                            var e = t.statusCode;
                            if (this.iu(e), e >= 200 && 300 > e) r({
                                kind: "ok"
                            });
                            else if (413 === e) r({
                                kind: "too-large"
                            });
                            else if (0 !== e && 429 !== e && 500 > e) r({
                                kind: "fatal",
                                error: new Error("logs request failed with status " + e)
                            });
                            else {
                                var i;
                                0 === e ? (t.error || this.rt.warn("Logs request failed before receiving an HTTP response"), r({
                                    kind: "retry-later",
                                    error: $e444d6404c095fa5$var$zl(t.error, "logs request failed before receiving an HTTP response")
                                })) : r({
                                    kind: "retry-later",
                                    error: null !== (i = t.error) && void 0 !== i ? i : new Error("logs request failed with status " + e)
                                });
                            }
                        }
                    });
                }
            });
        }
        iu(t) {
            (0 !== t || this._instance.__loaded) && (this.ya = $e444d6404c095fa5$var$yn(t, this.ya, 3, ()=>this.rt.warn("Log requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped sending logs; will try again when connectivity changes.")));
        }
        Xl(t) {
            this.er.length > 0 && this.ru(t, this.er, this.Gl, $e444d6404c095fa5$var$c.LIB_NAME, (t)=>{
                this.er = t;
            }), this.ql.length > 0 && this.ru(t, this.ql, this.Jl, $e444d6404c095fa5$var$jl, (t)=>{
                this.ql = t;
            });
        }
        ru(t, e, i, r, s) {
            if (0 !== e.length) {
                var n = e.map((t)=>t.record);
                s([]);
                var o = $e444d6404c095fa5$var$Ie(n, $e444d6404c095fa5$var$Oe(i, $e444d6404c095fa5$var$c.LIB_NAME, $e444d6404c095fa5$var$c.LIB_VERSION), r, $e444d6404c095fa5$var$c.LIB_VERSION);
                this._instance._send_request({
                    method: "POST",
                    url: this.eu(),
                    data: o,
                    compression: "best-available",
                    batchKey: "logs",
                    transport: t
                });
            }
        }
        eu() {
            return this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
        }
        Wl() {
            var t, e = {};
            if (e.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
                var i = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0), r = i.windowId, s = i.sessionStartTimestamp, n = i.lastActivityTimestamp;
                e.sessionId = i.sessionId, e.windowId = r, $e444d6404c095fa5$var$X(s) || (e.sessionStartTimestamp = s), $e444d6404c095fa5$var$X(n) || (e.lastActivityTimestamp = n);
            }
            if (null != $e444d6404c095fa5$var$v && null != (t = $e444d6404c095fa5$var$v.location) && t.href && (e.currentUrl = this._instance.config.disable_capture_url_hashes ? $e444d6404c095fa5$var$ye($e444d6404c095fa5$var$v.location.href) : $e444d6404c095fa5$var$v.location.href), this._instance.featureFlags) {
                var o = this._instance.featureFlags.getFlags();
                o && o.length > 0 && (e.activeFeatureFlags = o);
            }
            return e;
        }
    }
}, $e444d6404c095fa5$var$iu = {
    metrics: class {
        constructor(t){
            this.rt = $e444d6404c095fa5$var$bi("[metrics]"), this._instance = t;
        }
        initialize() {}
        Vl() {
            var t, e, i = null == (t = this._instance) || null == (t = t.config) ? void 0 : t.metrics;
            return this.Bl && this.Zl === i || (null == (e = this.Bl) || e.reset(), this.Zl = i, this.Bl = new $e444d6404c095fa5$var$De(this.zl(), function(t) {
                var e, i, r, s, n, o = null == t ? void 0 : t.resourceAttributes;
                return {
                    serviceName: null !== (e = null == o ? void 0 : o["service.name"]) && void 0 !== e ? e : null == t ? void 0 : t.serviceName,
                    serviceVersion: null !== (i = null == o ? void 0 : o["service.version"]) && void 0 !== i ? i : null == t ? void 0 : t.serviceVersion,
                    environment: null !== (r = null == o ? void 0 : o["deployment.environment"]) && void 0 !== r ? r : null == t ? void 0 : t.environment,
                    resourceAttributes: o,
                    beforeSend: null == t ? void 0 : t.beforeSend,
                    flushIntervalMs: null !== (s = null == t ? void 0 : t.flushIntervalMs) && void 0 !== s ? s : 1e4,
                    maxSeriesPerFlush: null !== (n = null == t ? void 0 : t.maxSeriesPerFlush) && void 0 !== n ? n : 1e3
                };
            }(i), this.rt)), this.Bl;
        }
        count(t, e, i) {
            void 0 === e && (e = 1), this.Vl().count(t, e, i);
        }
        gauge(t, e, i) {
            this.Vl().gauge(t, e, i);
        }
        histogram(t, e, i) {
            this.Vl().histogram(t, e, i);
        }
        flush(t) {
            if (!this.Bl) return Promise.resolve();
            if (t) {
                var e = this.Bl.drainWindow();
                return e && this.Jt(e, t), Promise.resolve();
            }
            return this.Bl.flush().catch((t)=>this.rt.error("PostHog metrics flush failed:", t));
        }
        reset() {
            var t;
            null == (t = this.Bl) || t.reset();
        }
        zl() {
            var t = this._instance, e = this;
            return {
                get isDisabled () {
                    return !1;
                },
                get optedOut () {
                    return !t.is_capturing();
                },
                Jt: (t)=>e.Jt(t),
                getLibraryId: ()=>$e444d6404c095fa5$var$c.LIB_NAME,
                getLibraryVersion: ()=>$e444d6404c095fa5$var$c.LIB_VERSION
            };
        }
        Jt(t, e) {
            return new Promise((i)=>{
                var r = !1, s = (t)=>{
                    r || (r = !0, clearTimeout(n), i(t));
                }, n = setTimeout(()=>s({
                        kind: "retry-later",
                        error: new Error("metrics request timed out")
                    }), 9e4);
                this._instance._send_request($e444d6404c095fa5$var$_({
                    method: "POST",
                    url: this.nu(),
                    data: t,
                    compression: "best-available",
                    batchKey: "metrics"
                }, e && {
                    transport: e
                }, {
                    fireCallbackOnDrop: !0,
                    callback (t) {
                        var e = t.statusCode;
                        if (e >= 200 && 300 > e) s({
                            kind: "ok"
                        });
                        else if (413 === e) s({
                            kind: "too-large"
                        });
                        else if (0 !== e && 429 !== e && 500 > e) s({
                            kind: "fatal",
                            error: new Error("metrics request failed with status " + e)
                        });
                        else {
                            var i;
                            s({
                                kind: "retry-later",
                                error: null !== (i = t.error) && void 0 !== i ? i : new Error("metrics request failed with status " + e)
                            });
                        }
                    }
                }));
            });
        }
        nu() {
            return this._instance.requestRouter.endpointFor("api", "/i/v1/metrics") + "?token=" + encodeURIComponent(this._instance.config.token);
        }
    }
}, $e444d6404c095fa5$var$ru = $e444d6404c095fa5$var$_({}, $e444d6404c095fa5$var$ql, $e444d6404c095fa5$var$Vl, $e444d6404c095fa5$var$Wl, $e444d6404c095fa5$var$Gl, $e444d6404c095fa5$var$Kl, $e444d6404c095fa5$var$Jl, $e444d6404c095fa5$var$Ql, $e444d6404c095fa5$var$Yl, $e444d6404c095fa5$var$Xl, $e444d6404c095fa5$var$Zl, $e444d6404c095fa5$var$tu, $e444d6404c095fa5$var$eu, $e444d6404c095fa5$var$iu);
$e444d6404c095fa5$export$a9d6b9cbf49b8241.__defaultExtensionClasses = $e444d6404c095fa5$var$_({}, $e444d6404c095fa5$var$ru);
var $e444d6404c095fa5$export$2e2bcd8739ae039 = function() {
    $e444d6404c095fa5$var$c.SDK_DIST_CHANNEL = "npm";
    var e = $e444d6404c095fa5$var$Fa[$e444d6404c095fa5$var$Ha] = new $e444d6404c095fa5$export$a9d6b9cbf49b8241;
    return function() {
        function e() {
            e.done || (e.done = !0, $e444d6404c095fa5$var$qa = !1, $e444d6404c095fa5$var$Dr($e444d6404c095fa5$var$Fa, function(t) {
                t._dom_loaded();
            }));
        }
        null != $e444d6404c095fa5$var$r && $e444d6404c095fa5$var$r.addEventListener ? "complete" === $e444d6404c095fa5$var$r.readyState ? e() : $e444d6404c095fa5$var$qr($e444d6404c095fa5$var$r, "DOMContentLoaded", e, {
            capture: !1
        }) : $e444d6404c095fa5$var$t && $e444d6404c095fa5$var$mi.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
    }(), e;
}();



var $acw62 = parcelRequire("acw62");
var $c76f8c8d12a9d64a$var$defaultPostHogInstance;
function $c76f8c8d12a9d64a$var$setDefaultPostHogInstance(instance) {
    $c76f8c8d12a9d64a$var$defaultPostHogInstance = instance;
}
function $c76f8c8d12a9d64a$var$getDefaultPostHogInstance() {
    return $c76f8c8d12a9d64a$var$defaultPostHogInstance;
}
var $c76f8c8d12a9d64a$export$ef76d7336c7309f5 = (0, $acw62.createContext)({
    get client () {
        return $c76f8c8d12a9d64a$var$getDefaultPostHogInstance();
    },
    bootstrap: undefined
});
function $c76f8c8d12a9d64a$var$isDeepEqual(obj1, obj2, visited) {
    if (visited === void 0) visited = new WeakMap();
    if (obj1 === obj2) return true;
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) return false;
    if (visited.has(obj1) && visited.get(obj1) === obj2) return true;
    visited.set(obj1, obj2);
    var keys1 = Object.keys(obj1);
    var keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for(var _i = 0, keys1_1 = keys1; _i < keys1_1.length; _i++){
        var key = keys1_1[_i];
        if (!keys2.includes(key)) return false;
        if (!$c76f8c8d12a9d64a$var$isDeepEqual(obj1[key], obj2[key], visited)) return false;
    }
    return true;
}
function $c76f8c8d12a9d64a$export$4d1dc63dbef5194f(_a) {
    var _b, _c;
    var children = _a.children, client = _a.client, apiKey = _a.apiKey, options = _a.options;
    var previousInitializationRef = (0, $acw62.useRef)(null);
    var posthog = (0, $acw62.useMemo)(function() {
        if (client) {
            if (apiKey) console.warn('[PostHog.js] You have provided both `client` and `apiKey` to `PostHogProvider`. `apiKey` will be ignored in favour of `client`.');
            if (options) console.warn('[PostHog.js] You have provided both `client` and `options` to `PostHogProvider`. `options` will be ignored in favour of `client`.');
            return client;
        }
        var defaultInstance = $c76f8c8d12a9d64a$var$getDefaultPostHogInstance();
        if (apiKey) return defaultInstance;
        console.warn('[PostHog.js] No `apiKey` or `client` were provided to `PostHogProvider`. Using default global `window.posthog` instance. You must initialize it manually. This is not recommended behavior.');
        return defaultInstance;
    }, [
        client,
        apiKey,
        JSON.stringify(options)
    ]);
    (0, $acw62.useEffect)(function() {
        if (client || !apiKey) return;
        var defaultInstance = $c76f8c8d12a9d64a$var$getDefaultPostHogInstance();
        var previousInitialization = previousInitializationRef.current;
        if (!previousInitialization) {
            if (defaultInstance.__loaded) console.warn('[PostHog.js] `posthog` was already loaded elsewhere. This may cause issues.');
            defaultInstance.init(apiKey, options);
            previousInitializationRef.current = {
                apiKey: apiKey,
                options: options !== null && options !== void 0 ? options : {}
            };
        } else {
            if (apiKey !== previousInitialization.apiKey) console.warn("[PostHog.js] You have provided a different `apiKey` to `PostHogProvider` than the one that was already initialized. This is not supported by our provider and we'll keep using the previous key. If you need to toggle between API Keys you need to control the `client` yourself and pass it in as a prop rather than an `apiKey` prop.");
            if (options && !$c76f8c8d12a9d64a$var$isDeepEqual(options, previousInitialization.options)) defaultInstance.set_config(options);
            previousInitializationRef.current = {
                apiKey: apiKey,
                options: options !== null && options !== void 0 ? options : {}
            };
        }
    }, [
        client,
        apiKey,
        JSON.stringify(options)
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c76f8c8d12a9d64a$export$ef76d7336c7309f5.Provider, {
        value: {
            client: posthog,
            bootstrap: (_b = options === null || options === void 0 ? void 0 : options.bootstrap) !== null && _b !== void 0 ? _b : (_c = client === null || client === void 0 ? void 0 : client.config) === null || _c === void 0 ? void 0 : _c.bootstrap
        }
    }, children);
}
var $c76f8c8d12a9d64a$var$isFunction = function(f) {
    return typeof f === 'function';
};
var $c76f8c8d12a9d64a$var$isUndefined = function(x) {
    return x === void 0;
};
var $c76f8c8d12a9d64a$var$isNull = function(x) {
    return x === null;
};
function $c76f8c8d12a9d64a$export$e9beec7734875ebd(flag, defaultValue) {
    var _a, _b;
    var _c = (0, $acw62.useContext)($c76f8c8d12a9d64a$export$ef76d7336c7309f5), client = _c.client, bootstrap = _c.bootstrap;
    var _d = (0, $acw62.useState)(function() {
        return client.isFeatureEnabled(flag);
    }), featureEnabled = _d[0], setFeatureEnabled = _d[1];
    (0, $acw62.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureEnabled(client.isFeatureEnabled(flag));
        });
    }, [
        client,
        flag
    ]);
    var bootstrapped = (_a = bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags) === null || _a === void 0 ? void 0 : _a[flag];
    if (!((_b = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _b === void 0 ? void 0 : _b.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) return $c76f8c8d12a9d64a$var$isUndefined(bootstrapped) ? defaultValue : !!bootstrapped;
    return $c76f8c8d12a9d64a$var$isUndefined(featureEnabled) ? defaultValue : featureEnabled;
}
function $c76f8c8d12a9d64a$export$21b3a717c06e8b6d(flag) {
    var _a;
    var _b = (0, $acw62.useContext)($c76f8c8d12a9d64a$export$ef76d7336c7309f5), client = _b.client, bootstrap = _b.bootstrap;
    var _c = (0, $acw62.useState)(function() {
        var _a;
        return (_a = client.getFeatureFlagResult(flag, {
            send_event: false
        })) === null || _a === void 0 ? void 0 : _a.payload;
    }), featureFlagPayload = _c[0], setFeatureFlagPayload = _c[1];
    (0, $acw62.useEffect)(function() {
        return client.onFeatureFlags(function() {
            var _a;
            setFeatureFlagPayload((_a = client.getFeatureFlagResult(flag, {
                send_event: false
            })) === null || _a === void 0 ? void 0 : _a.payload);
        });
    }, [
        client,
        flag
    ]);
    if (!((_a = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _a === void 0 ? void 0 : _a.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlagPayloads)) return bootstrap.featureFlagPayloads[flag];
    return featureFlagPayload;
}
function $c76f8c8d12a9d64a$export$c11c930e7ba4738(flag) {
    var _a, _b;
    var _c = (0, $acw62.useContext)($c76f8c8d12a9d64a$export$ef76d7336c7309f5), client = _c.client, bootstrap = _c.bootstrap;
    var _d = (0, $acw62.useState)(function() {
        return client.getFeatureFlagResult(flag);
    }), result = _d[0], setResult = _d[1];
    (0, $acw62.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setResult(client.getFeatureFlagResult(flag));
        });
    }, [
        client,
        flag
    ]);
    if (!((_a = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _a === void 0 ? void 0 : _a.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) {
        var bootstrappedValue = bootstrap.featureFlags[flag];
        if ($c76f8c8d12a9d64a$var$isUndefined(bootstrappedValue)) return undefined;
        return {
            key: flag,
            enabled: typeof bootstrappedValue === 'string' ? true : !!bootstrappedValue,
            variant: typeof bootstrappedValue === 'string' ? bootstrappedValue : undefined,
            payload: (_b = bootstrap.featureFlagPayloads) === null || _b === void 0 ? void 0 : _b[flag]
        };
    }
    return result;
}
function $c76f8c8d12a9d64a$export$31a96876dff98722() {
    var _a;
    var _b = (0, $acw62.useContext)($c76f8c8d12a9d64a$export$ef76d7336c7309f5), client = _b.client, bootstrap = _b.bootstrap;
    var _c = (0, $acw62.useState)(function() {
        return client.featureFlags.getFlags();
    }), featureFlags = _c[0], setFeatureFlags = _c[1];
    (0, $acw62.useEffect)(function() {
        return client.onFeatureFlags(function(flags) {
            setFeatureFlags(flags);
        });
    }, [
        client
    ]);
    if (!((_a = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _a === void 0 ? void 0 : _a.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) return Object.entries(bootstrap.featureFlags).filter(function(_a) {
        var value = _a[1];
        return value;
    }).map(function(_a) {
        var key = _a[0];
        return key;
    });
    return featureFlags;
}
function $c76f8c8d12a9d64a$export$446efd8c49462bdd(flag) {
    var _a;
    var _b = (0, $acw62.useContext)($c76f8c8d12a9d64a$export$ef76d7336c7309f5), client = _b.client, bootstrap = _b.bootstrap;
    var _c = (0, $acw62.useState)(function() {
        return client.getFeatureFlag(flag);
    }), featureFlagVariantKey = _c[0], setFeatureFlagVariantKey = _c[1];
    (0, $acw62.useEffect)(function() {
        return client.onFeatureFlags(function() {
            setFeatureFlagVariantKey(client.getFeatureFlag(flag));
        });
    }, [
        client,
        flag
    ]);
    if (!((_a = client === null || client === void 0 ? void 0 : client.featureFlags) === null || _a === void 0 ? void 0 : _a.hasLoadedFlags) && (bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.featureFlags)) return bootstrap.featureFlags[flag];
    return featureFlagVariantKey;
}
var $c76f8c8d12a9d64a$export$ba1c575d7c165008 = function() {
    var client = (0, $acw62.useContext)($c76f8c8d12a9d64a$export$ef76d7336c7309f5).client;
    return client;
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $c76f8c8d12a9d64a$var$extendStatics = function(d, b) {
    $c76f8c8d12a9d64a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c76f8c8d12a9d64a$var$extendStatics(d, b);
};
function $c76f8c8d12a9d64a$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c76f8c8d12a9d64a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c76f8c8d12a9d64a$var$__assign = function() {
    $c76f8c8d12a9d64a$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c76f8c8d12a9d64a$var$__assign.apply(this, arguments);
};
function $c76f8c8d12a9d64a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
function $c76f8c8d12a9d64a$var$VisibilityAndClickTracker(_a) {
    var children = _a.children, onIntersect = _a.onIntersect, onClick = _a.onClick, trackView = _a.trackView, options = _a.options, props = $c76f8c8d12a9d64a$var$__rest(_a, [
        "children",
        "onIntersect",
        "onClick",
        "trackView",
        "options"
    ]);
    var ref = (0, $acw62.useRef)(null);
    var observerOptions = (0, $acw62.useMemo)(function() {
        return $c76f8c8d12a9d64a$var$__assign({
            threshold: 0.1
        }, options);
    }, [
        options === null || options === void 0 ? void 0 : options.threshold,
        options === null || options === void 0 ? void 0 : options.root,
        options === null || options === void 0 ? void 0 : options.rootMargin
    ]);
    (0, $acw62.useEffect)(function() {
        if ($c76f8c8d12a9d64a$var$isNull(ref.current) || !trackView) return;
        var observer = new IntersectionObserver(function(_a) {
            var entry = _a[0];
            return onIntersect(entry);
        }, observerOptions);
        observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, [
        observerOptions,
        trackView,
        onIntersect
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $c76f8c8d12a9d64a$var$__assign({
        ref: ref
    }, props, {
        onClick: onClick
    }), children);
}
function $c76f8c8d12a9d64a$var$VisibilityAndClickTrackers(_a) {
    var children = _a.children, trackInteraction = _a.trackInteraction, trackView = _a.trackView, options = _a.options, onInteract = _a.onInteract, onView = _a.onView, props = $c76f8c8d12a9d64a$var$__rest(_a, [
        "children",
        "trackInteraction",
        "trackView",
        "options",
        "onInteract",
        "onView"
    ]);
    var clickTrackedRef = (0, $acw62.useRef)(false);
    var visibilityTrackedRef = (0, $acw62.useRef)(false);
    var cachedOnClick = (0, $acw62.useCallback)(function() {
        if (!clickTrackedRef.current && trackInteraction && onInteract) {
            onInteract();
            clickTrackedRef.current = true;
        }
    }, [
        trackInteraction,
        onInteract
    ]);
    var onIntersect = function(entry) {
        if (!visibilityTrackedRef.current && entry.isIntersecting && onView) {
            onView();
            visibilityTrackedRef.current = true;
        }
    };
    var trackedChildren = (0, $acw62.Children).map(children, function(child) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c76f8c8d12a9d64a$var$VisibilityAndClickTracker, $c76f8c8d12a9d64a$var$__assign({
            onClick: cachedOnClick,
            onIntersect: onIntersect,
            trackView: trackView,
            options: options
        }, props), child);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, trackedChildren);
}
function $c76f8c8d12a9d64a$export$3d3d20183fb62861(_a) {
    var flag = _a.flag, match = _a.match, children = _a.children, fallback = _a.fallback, visibilityObserverOptions = _a.visibilityObserverOptions, trackInteraction = _a.trackInteraction, trackView = _a.trackView, props = $c76f8c8d12a9d64a$var$__rest(_a, [
        "flag",
        "match",
        "children",
        "fallback",
        "visibilityObserverOptions",
        "trackInteraction",
        "trackView"
    ]);
    var payload = $c76f8c8d12a9d64a$export$21b3a717c06e8b6d(flag);
    var variant = $c76f8c8d12a9d64a$export$446efd8c49462bdd(flag);
    var posthog = $c76f8c8d12a9d64a$export$ba1c575d7c165008();
    var shouldTrackInteraction = trackInteraction !== null && trackInteraction !== void 0 ? trackInteraction : true;
    var shouldTrackView = trackView !== null && trackView !== void 0 ? trackView : true;
    if (!$c76f8c8d12a9d64a$var$isUndefined(variant)) {
        if ($c76f8c8d12a9d64a$var$isUndefined(match) || variant === match) {
            var childNode = $c76f8c8d12a9d64a$var$isFunction(children) ? children(payload) : children;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c76f8c8d12a9d64a$var$VisibilityAndClickTrackers, $c76f8c8d12a9d64a$var$__assign({
                flag: flag,
                options: visibilityObserverOptions,
                trackInteraction: shouldTrackInteraction,
                trackView: shouldTrackView,
                onInteract: function() {
                    return $c76f8c8d12a9d64a$export$ba6bf30fc5e87e6b({
                        flag: flag,
                        posthog: posthog,
                        flagVariant: variant
                    });
                },
                onView: function() {
                    return $c76f8c8d12a9d64a$export$6b51b07da624385a({
                        flag: flag,
                        posthog: posthog,
                        flagVariant: variant
                    });
                }
            }, props), childNode);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, fallback);
}
function $c76f8c8d12a9d64a$var$captureFeatureEvent(event, _a) {
    var _b;
    var flag = _a.flag, posthog = _a.posthog, flagVariant = _a.flagVariant;
    var properties = {
        feature_flag: flag,
        $set: (_b = {}, _b["".concat(event, "/").concat(flag)] = flagVariant !== null && flagVariant !== void 0 ? flagVariant : true, _b)
    };
    if (typeof flagVariant === 'string') properties.feature_flag_variant = flagVariant;
    posthog.capture(event, properties);
}
function $c76f8c8d12a9d64a$export$ba6bf30fc5e87e6b(options) {
    $c76f8c8d12a9d64a$var$captureFeatureEvent('$feature_interaction', options);
}
function $c76f8c8d12a9d64a$export$6b51b07da624385a(options) {
    $c76f8c8d12a9d64a$var$captureFeatureEvent('$feature_view', options);
}
function $c76f8c8d12a9d64a$var$TrackedChild(_a) {
    var child = _a.child, index = _a.index, name = _a.name, properties = _a.properties, observerOptions = _a.observerOptions;
    var trackedRef = (0, $acw62.useRef)(false);
    var posthog = $c76f8c8d12a9d64a$export$ba1c575d7c165008();
    var onIntersect = (0, $acw62.useCallback)(function(entry) {
        if (entry.isIntersecting && !trackedRef.current) {
            posthog.capture('$element_viewed', $c76f8c8d12a9d64a$var$__assign({
                element_name: name,
                child_index: index
            }, properties));
            trackedRef.current = true;
        }
    }, [
        posthog,
        name,
        index,
        properties
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c76f8c8d12a9d64a$var$VisibilityAndClickTracker, {
        onIntersect: onIntersect,
        trackView: true,
        options: observerOptions
    }, child);
}
function $c76f8c8d12a9d64a$export$d71f98ecbc156fe3(_a) {
    var name = _a.name, properties = _a.properties, observerOptions = _a.observerOptions, trackAllChildren = _a.trackAllChildren, children = _a.children, props = $c76f8c8d12a9d64a$var$__rest(_a, [
        "name",
        "properties",
        "observerOptions",
        "trackAllChildren",
        "children"
    ]);
    var trackedRef = (0, $acw62.useRef)(false);
    var posthog = $c76f8c8d12a9d64a$export$ba1c575d7c165008();
    var onIntersect = (0, $acw62.useCallback)(function(entry) {
        if (entry.isIntersecting && !trackedRef.current) {
            posthog.capture('$element_viewed', $c76f8c8d12a9d64a$var$__assign({
                element_name: name
            }, properties));
            trackedRef.current = true;
        }
    }, [
        posthog,
        name,
        properties
    ]);
    if (trackAllChildren) {
        var trackedChildren = (0, $acw62.Children).map(children, function(child, index) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c76f8c8d12a9d64a$var$TrackedChild, {
                key: index,
                child: child,
                index: index,
                name: name,
                properties: properties,
                observerOptions: observerOptions
            });
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $c76f8c8d12a9d64a$var$__assign({}, props), trackedChildren);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c76f8c8d12a9d64a$var$VisibilityAndClickTracker, $c76f8c8d12a9d64a$var$__assign({
        onIntersect: onIntersect,
        trackView: true,
        options: observerOptions
    }, props), children);
}
var $c76f8c8d12a9d64a$var$INITIAL_STATE = {
    componentStack: null,
    exceptionEvent: null,
    error: null
};
var $c76f8c8d12a9d64a$var$__POSTHOG_ERROR_MESSAGES = {
    INVALID_FALLBACK: '[PostHog.js][PostHogErrorBoundary] Invalid fallback prop, provide a valid React element or a function that returns a valid React element.'
};
var $c76f8c8d12a9d64a$export$2413edf479be8fff = function(_super) {
    $c76f8c8d12a9d64a$var$__extends(PostHogErrorBoundary, _super);
    function PostHogErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = $c76f8c8d12a9d64a$var$INITIAL_STATE;
        return _this;
    }
    PostHogErrorBoundary.prototype.componentDidCatch = function(error, errorInfo) {
        var additionalProperties = this.props.additionalProperties;
        var currentProperties;
        if ($c76f8c8d12a9d64a$var$isFunction(additionalProperties)) currentProperties = additionalProperties(error);
        else if (typeof additionalProperties === 'object') currentProperties = additionalProperties;
        var client = this.context.client;
        var exceptionEvent = client.captureException(error, currentProperties);
        var componentStack = errorInfo.componentStack;
        this.setState({
            error: error,
            componentStack: componentStack !== null && componentStack !== void 0 ? componentStack : null,
            exceptionEvent: exceptionEvent
        });
    };
    PostHogErrorBoundary.prototype.render = function() {
        var _a = this.props, children = _a.children, fallback = _a.fallback;
        var state = this.state;
        if (state.componentStack == null) return $c76f8c8d12a9d64a$var$isFunction(children) ? children() : children;
        var element = $c76f8c8d12a9d64a$var$isFunction(fallback) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            exceptionEvent: state.exceptionEvent
        }) : fallback;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) return element;
        console.warn($c76f8c8d12a9d64a$var$__POSTHOG_ERROR_MESSAGES.INVALID_FALLBACK);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    };
    PostHogErrorBoundary.contextType = $c76f8c8d12a9d64a$export$ef76d7336c7309f5;
    return PostHogErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $c76f8c8d12a9d64a$export$700501ebbde1ec89 = function(client, callback) {
    return function(error, errorInfo) {
        var event = client.captureException(error);
        if (callback) callback(event, error, errorInfo);
    };
};
$c76f8c8d12a9d64a$var$setDefaultPostHogInstance((0, $e444d6404c095fa5$export$2e2bcd8739ae039));


const $d42f71309343a94b$export$e955abb82869dc84 = ()=>{
    const posthog = (0, $c76f8c8d12a9d64a$export$ba1c575d7c165008)();
    const trackEvent = (eventName, properties = {})=>{
        if (posthog) posthog.capture(eventName, {
            timestamp: new Date().toISOString(),
            ...properties
        });
    };
    const identifyUser = (userId, userProperties = {})=>{
        if (posthog) posthog.identify(userId, userProperties);
    };
    const trackPageView = (pageName, properties = {})=>{
        trackEvent('page_view', {
            page: pageName,
            ...properties
        });
    };
    const trackClick = (element, additionalProps = {})=>{
        trackEvent('click', {
            element: element,
            ...additionalProps
        });
    };
    const trackProjectView = (projectTitle, projectId)=>{
        trackEvent('project_viewed', {
            project_title: projectTitle,
            project_id: projectId
        });
    };
    const trackBlogRead = (blogId, blogTitle, blogSlug)=>{
        // Session-based deduplication key
        const sessionKey = `blog_read_${blogId}_${posthog?.get_session_id() || 'unknown'}`;
        // Check if already tracked in this session
        if (typeof window !== 'undefined' && window.sessionStorage) {
            if (window.sessionStorage.getItem(sessionKey)) {
                console.log(`\u{1F504} Blog ${blogId} already tracked in this session, skipping duplicate`);
                return;
            }
            // Mark as tracked in this session
            window.sessionStorage.setItem(sessionKey, Date.now().toString());
        }
        trackEvent('blog_read', {
            blog_id: blogId,
            blog_title: blogTitle,
            blog_slug: blogSlug,
            timestamp: new Date().toISOString(),
            session_id: posthog?.get_session_id() || 'unknown'
        });
        console.log(`\u{1F4CA} Blog read tracked: ID=${blogId}, Title="${blogTitle}"`);
    };
    const trackContactInteraction = (type, value)=>{
        trackEvent('contact_interaction', {
            interaction_type: type,
            value: value
        });
    };
    const trackSocialClick = (platform, url)=>{
        trackEvent('social_click', {
            platform: platform,
            url: url
        });
    };
    const trackCVDownload = ()=>{
        trackEvent('cv_download', {
            download_time: new Date().toISOString()
        });
    };
    const trackNavigation = (fromSection, toSection)=>{
        trackEvent('navigation', {
            from_section: fromSection,
            to_section: toSection
        });
    };
    const trackBlogEngagement = (blogId, blogSlug, engagementType, additionalData = {})=>{
        trackEvent('blog_engagement', {
            blog_id: blogId,
            blog_slug: blogSlug,
            engagement_type: engagementType,
            timestamp: new Date().toISOString(),
            ...additionalData
        });
    };
    return {
        trackEvent: trackEvent,
        identifyUser: identifyUser,
        trackPageView: trackPageView,
        trackClick: trackClick,
        trackProjectView: trackProjectView,
        trackBlogRead: trackBlogRead,
        trackContactInteraction: trackContactInteraction,
        trackSocialClick: trackSocialClick,
        trackCVDownload: trackCVDownload,
        trackNavigation: trackNavigation,
        trackBlogEngagement: trackBlogEngagement,
        posthog: posthog
    };
};
var $d42f71309343a94b$export$2e2bcd8739ae039 = $d42f71309343a94b$export$e955abb82869dc84;


/**
 * React hook for fetching blog analytics data from PostHog
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * PostHog Analytics Service
 *
 * Fetches real analytics data via a Netlify Function proxy.
 * The PostHog Personal API Key never leaves the server.
 */ const $b19003e819ce4d23$var$PROXY_BASE = '/.netlify/functions/posthog-proxy';
class $b19003e819ce4d23$var$PostHogAnalyticsService {
    constructor(){
        this.cache = new Map();
        this.cacheTimeout = 300000; // 5 minutes
        this.proxyAvailable = null; // null = unknown, true/false after first call
    }
    /**
   * Call the serverless proxy with caching.
   * Returns null when the proxy is unavailable (e.g. local dev without netlify dev).
   */ async executeQuery(queryType, params = {}) {
        // Once we know the proxy is down, skip all further requests this session
        if (this.proxyAvailable === false) return null;
        const cacheKey = JSON.stringify({
            queryType: queryType,
            params: params
        });
        const cached = this.cache.get(cacheKey);
        if (cached && Date.now() - cached.timestamp < this.cacheTimeout) return cached.data;
        try {
            const searchParams = new URLSearchParams({
                query: queryType,
                ...params
            });
            const response = await fetch(`${$b19003e819ce4d23$var$PROXY_BASE}?${searchParams}`);
            // Detect missing proxy (Parcel/dev server returns HTML 404)
            const contentType = response.headers.get('content-type') || '';
            if (!response.ok || !contentType.includes('application/json')) {
                if (response.status === 404 || contentType.includes('text/html')) {
                    console.warn("PostHog proxy not available \u2014 analytics data will be skipped.");
                    this.proxyAvailable = false;
                    return null;
                }
                const errorBody = await response.json().catch(()=>({}));
                throw new Error(errorBody.error || `Proxy error: ${response.status}`);
            }
            this.proxyAvailable = true;
            const data = await response.json();
            this.cache.set(cacheKey, {
                data: data.results,
                timestamp: Date.now()
            });
            return data.results;
        } catch (error) {
            // Network errors (fetch itself fails) — proxy unreachable
            if (error instanceof TypeError && error.message.includes('fetch')) {
                console.warn("PostHog proxy unreachable \u2014 analytics data will be skipped.");
                this.proxyAvailable = false;
                return null;
            }
            console.error('PostHog Analytics Service Error:', error);
            throw error;
        }
    }
    /**
   * Get view count for a specific blog post by ID or slug
   */ async getBlogViewCount(blogIdentifier, useId = false) {
        try {
            const results = await this.executeQuery('blogViewCount', {
                blogIdentifier: blogIdentifier,
                useId: useId
            });
            if (!results) return 0;
            return results.length > 0 ? results[0][0] : 0;
        } catch (error) {
            console.warn(`Failed to fetch view count for blog ${blogIdentifier}:`, error);
            return 0;
        }
    }
    /**
   * Get view count for a specific blog post by ID (preferred method)
   */ async getBlogViewCountById(blogId) {
        return this.getBlogViewCount(blogId, true);
    }
    /**
   * Get view counts for all blog posts
   */ async getAllBlogViewCounts() {
        try {
            const results = await this.executeQuery('allBlogViewCounts');
            if (!results) return {};
            const viewCounts = {};
            results.forEach(([blogId, slug, count])=>{
                if (slug) viewCounts[slug] = (viewCounts[slug] || 0) + count;
            });
            return viewCounts;
        } catch (error) {
            console.warn('Failed to fetch all blog view counts:', error);
            return {};
        }
    }
    /**
   * Get total page views for the site
   */ async getTotalPageViews(days = 30) {
        try {
            const results = await this.executeQuery('totalPageViews', {
                days: days
            });
            if (!results) return 0;
            return results.length > 0 ? results[0][0] : 0;
        } catch (error) {
            console.warn('Failed to fetch total page views:', error);
            return null;
        }
    }
    /**
   * Get popular blog posts by view count
   */ async getPopularBlogPosts(limit = 5) {
        try {
            const results = await this.executeQuery('popularBlogPosts', {
                limit: limit
            });
            if (!results) return [];
            return results.map(([blogId, slug, title, count])=>({
                    id: blogId && blogId !== 'null' ? blogId : null,
                    slug: slug,
                    title: title,
                    viewCount: count
                }));
        } catch (error) {
            console.warn('Failed to fetch popular blog posts:', error);
            return [];
        }
    }
    /**
   * Get daily blog views for the last N days
   */ async getDailyBlogViews(days = 7) {
        try {
            const results = await this.executeQuery('dailyBlogViews', {
                days: days
            });
            if (!results) return [];
            return results.map(([date, count])=>({
                    date: date,
                    views: count
                }));
        } catch (error) {
            console.warn('Failed to fetch daily blog views:', error);
            return [];
        }
    }
    /**
   * Clear the cache
   */ clearCache() {
        this.cache.clear();
    }
}
const $b19003e819ce4d23$export$f7139c3b557440a5 = new $b19003e819ce4d23$var$PostHogAnalyticsService();
var $b19003e819ce4d23$export$2e2bcd8739ae039 = $b19003e819ce4d23$export$f7139c3b557440a5;


const $d4d0c408c580b9ca$export$305af693ced9c540 = (blogSlug)=>{
    const [viewCount, setViewCount] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const fetchViewCount = async ()=>{
            if (!blogSlug) {
                setLoading(false);
                return;
            }
            try {
                setLoading(true);
                setError(null);
                const count = await (0, $b19003e819ce4d23$export$2e2bcd8739ae039).getBlogViewCount(blogSlug);
                if (isMounted) setViewCount(count);
            } catch (err) {
                if (isMounted) {
                    setError(err.message);
                    console.warn(`Failed to fetch view count for ${blogSlug}:`, err);
                }
            } finally{
                if (isMounted) setLoading(false);
            }
        };
        fetchViewCount();
        return ()=>{
            isMounted = false;
        };
    }, [
        blogSlug
    ]);
    return {
        viewCount: viewCount,
        loading: loading,
        error: error
    };
};
const $d4d0c408c580b9ca$export$49ebdf47eb43791a = ()=>{
    const [viewCounts, setViewCounts] = (0, $acw62.useState)({});
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const fetchAllViewCounts = async ()=>{
            try {
                setLoading(true);
                setError(null);
                const counts = await (0, $b19003e819ce4d23$export$2e2bcd8739ae039).getAllBlogViewCounts();
                if (isMounted) setViewCounts(counts);
            } catch (err) {
                if (isMounted) {
                    setError(err.message);
                    console.warn('Failed to fetch all blog view counts:', err);
                }
            } finally{
                if (isMounted) setLoading(false);
            }
        };
        fetchAllViewCounts();
        return ()=>{
            isMounted = false;
        };
    }, []);
    return {
        viewCounts: viewCounts,
        loading: loading,
        error: error
    };
};
const $d4d0c408c580b9ca$export$db78bd7210a194de = (blogSlug, fallbackCount = 0)=>{
    const { viewCount: viewCount, loading: loading, error: error } = $d4d0c408c580b9ca$export$305af693ced9c540(blogSlug);
    // Return real count if available, fallback count if error, or loading state
    const displayCount = error ? fallbackCount : viewCount !== null ? viewCount : fallbackCount;
    return {
        viewCount: displayCount,
        loading: loading,
        error: error,
        isRealData: viewCount !== null && !error
    };
};
const $d4d0c408c580b9ca$export$ce5d4fe877500761 = (limit = 5)=>{
    const [popularPosts, setPopularPosts] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const fetchPopularPosts = async ()=>{
            try {
                setLoading(true);
                setError(null);
                const posts = await (0, $b19003e819ce4d23$export$2e2bcd8739ae039).getPopularBlogPosts(limit);
                if (isMounted) setPopularPosts(posts);
            } catch (err) {
                if (isMounted) {
                    setError(err.message);
                    console.warn('Failed to fetch popular blog posts:', err);
                }
            } finally{
                if (isMounted) setLoading(false);
            }
        };
        fetchPopularPosts();
        return ()=>{
            isMounted = false;
        };
    }, [
        limit
    ]);
    return {
        popularPosts: popularPosts,
        loading: loading,
        error: error
    };
};



var $acw62 = parcelRequire("acw62");
/**
 * Custom hook to manage scroll position restoration
 * Saves and restores scroll positions for different routes/sections
 */ const $5999fc9953960d3a$var$useScrollPosition = ()=>{
    const scrollPositions = (0, $acw62.useRef)(new Map());
    // Save current scroll position with a key
    const saveScrollPosition = (0, $acw62.useCallback)((key = 'default')=>{
        const position = {
            x: window.pageXOffset || document.documentElement.scrollLeft,
            y: window.pageYOffset || document.documentElement.scrollTop
        };
        scrollPositions.current.set(key, position);
        // Optional: Store in sessionStorage for persistence across page refreshes
        try {
            sessionStorage.setItem(`scroll_${key}`, JSON.stringify(position));
        } catch (error) {
            // Silently handle storage errors
            console.warn('Failed to save scroll position to sessionStorage:', error);
        }
    }, []);
    // Restore scroll position for a key
    const restoreScrollPosition = (0, $acw62.useCallback)((key = 'default', options = {})=>{
        const { behavior: behavior = 'auto', fallbackSelector: fallbackSelector = null, delay: delay = 0 // Delay in ms before restoration
         } = options;
        const restore = ()=>{
            let position = scrollPositions.current.get(key);
            // Try to get from sessionStorage if not in memory
            if (!position) try {
                const stored = sessionStorage.getItem(`scroll_${key}`);
                if (stored) position = JSON.parse(stored);
            } catch (error) {
                console.warn('Failed to restore scroll position from sessionStorage:', error);
            }
            if (position) window.scrollTo({
                left: position.x,
                top: position.y,
                behavior: behavior
            });
            else if (fallbackSelector) {
                // Fallback to scrolling to a specific element
                const element = document.querySelector(fallbackSelector);
                if (element) element.scrollIntoView({
                    behavior: behavior
                });
            }
        };
        if (delay > 0) setTimeout(restore, delay);
        else restore();
    }, []);
    // Clear saved position for a key
    const clearScrollPosition = (0, $acw62.useCallback)((key = 'default')=>{
        scrollPositions.current.delete(key);
        try {
            sessionStorage.removeItem(`scroll_${key}`);
        } catch (error) {
            console.warn('Failed to clear scroll position from sessionStorage:', error);
        }
    }, []);
    // Clear all saved positions
    const clearAllScrollPositions = (0, $acw62.useCallback)(()=>{
        scrollPositions.current.clear();
        // Clear from sessionStorage
        try {
            const keys = Object.keys(sessionStorage);
            keys.forEach((key)=>{
                if (key.startsWith('scroll_')) sessionStorage.removeItem(key);
            });
        } catch (error) {
            console.warn('Failed to clear scroll positions from sessionStorage:', error);
        }
    }, []);
    // Get current scroll position without saving
    const getCurrentScrollPosition = (0, $acw62.useCallback)(()=>{
        return {
            x: window.pageXOffset || document.documentElement.scrollLeft,
            y: window.pageYOffset || document.documentElement.scrollTop
        };
    }, []);
    // Check if we have a saved position for a key
    const hasSavedPosition = (0, $acw62.useCallback)((key = 'default')=>{
        if (scrollPositions.current.has(key)) return true;
        try {
            return sessionStorage.getItem(`scroll_${key}`) !== null;
        } catch (error) {
            return false;
        }
    }, []);
    return {
        saveScrollPosition: saveScrollPosition,
        restoreScrollPosition: restoreScrollPosition,
        clearScrollPosition: clearScrollPosition,
        clearAllScrollPositions: clearAllScrollPositions,
        getCurrentScrollPosition: getCurrentScrollPosition,
        hasSavedPosition: hasSavedPosition
    };
};
var $5999fc9953960d3a$export$2e2bcd8739ae039 = $5999fc9953960d3a$var$useScrollPosition;


/**
 * PostHog Event Testing Utility
 * 
 * This file contains helper functions to test PostHog event tracking
 * in your development environment.
 */ // Test function to manually trigger events for debugging
const $be89f21e2291903e$export$eacc4c25adc587ad = (posthog)=>{
    if (!posthog) {
        console.warn('PostHog not initialized');
        return;
    }
    console.log("\uD83E\uDDEA Testing PostHog Events...");
    // Test basic event
    posthog.capture('test_event', {
        test_property: 'test_value',
        timestamp: new Date().toISOString()
    });
    // Test page view
    posthog.capture('page_view', {
        page: 'test_page',
        timestamp: new Date().toISOString()
    });
    // Test user identify
    posthog.identify('test_user_' + Date.now(), {
        email: 'test@example.com',
        name: 'Test User'
    });
    console.log("\u2705 Test events sent to PostHog");
    console.log("\uD83D\uDCCA Check your PostHog dashboard in a few minutes to see the events");
};
const $be89f21e2291903e$export$9831e49a37c39f7e = (posthog)=>{
    if (!posthog) {
        console.log("\u274C PostHog not initialized");
        return false;
    }
    console.log("\u2705 PostHog initialized successfully");
    console.log("\uD83D\uDD11 API Key:", 'Set');
    console.log("\uD83C\uDFE0 Host:", "https://us.i.posthog.com");
    console.log("\uD83D\uDC1B Debug mode:", 'Disabled');
    return true;
};
// Add to window for browser console testing
if (typeof window !== 'undefined') {
    window.testPostHog = $be89f21e2291903e$export$eacc4c25adc587ad;
    window.checkPostHogStatus = $be89f21e2291903e$export$9831e49a37c39f7e;
}


/**
 * PostHog Debug Utilities
 * Helper functions to debug and monitor PostHog events
 */ const $a82bf1aea4d43773$export$14a3c3504e6e0a1f = (eventName, properties = {})=>{};
const $a82bf1aea4d43773$export$3de3cf2dbd1c5d = (posthog)=>{
    if (!posthog) {
        console.warn('PostHog not initialized');
        return;
    }
    console.group("\uD83E\uDDEA Testing Blog View Tracking (New ID-based System)");
    // Test new blog read event with blog ID
    const testBlogId = 99;
    const testBlogSlug = 'test-blog-tracking';
    const testBlogTitle = 'Test Blog Tracking System';
    posthog.capture('blog_read', {
        blog_id: testBlogId,
        blog_title: testBlogTitle,
        blog_slug: testBlogSlug,
        timestamp: new Date().toISOString(),
        session_id: posthog.get_session_id() || 'unknown',
        test_event: true
    });
    console.log("\u2705 Test blog_read event sent with blog ID");
    console.log('Event data:', {
        blog_id: testBlogId,
        blog_title: testBlogTitle,
        blog_slug: testBlogSlug,
        session_id: posthog.get_session_id()
    });
    // Test engagement event with blog ID
    posthog.capture('blog_engagement', {
        blog_id: testBlogId,
        blog_slug: testBlogSlug,
        engagement_type: 'reading_time',
        reading_time_seconds: 30,
        blog_title: testBlogTitle,
        timestamp: new Date().toISOString(),
        test_event: true
    });
    console.log("\u2705 Test blog_engagement event sent with blog ID");
    // Test session deduplication
    console.log("\uD83D\uDD04 Testing session deduplication...");
    const sessionKey = `blog_read_${testBlogId}_${posthog.get_session_id() || 'unknown'}`;
    if (window.sessionStorage.getItem(sessionKey)) console.log("\u2705 Session deduplication working - duplicate would be blocked");
    else console.log("\u2139\uFE0F First test in session - would create sessionStorage entry");
    console.groupEnd();
};
const $a82bf1aea4d43773$export$9a93168bab0dd537 = (posthog)=>{
    posthog;
    return;
    // Log all events being captured
    const originalCapture = posthog.capture;
    posthog.capture = function(eventName, properties) {
        $a82bf1aea4d43773$export$14a3c3504e6e0a1f(eventName, properties);
        return originalCapture.call(this, eventName, properties);
    };
    console.log("\uD83D\uDD0D PostHog event monitoring enabled");
};
const $a82bf1aea4d43773$export$cc3a8ccd15a2d300 = (posthog)=>{
    console.group("\uD83D\uDD27 PostHog Configuration Check");
    if (!posthog) {
        console.error("\u274C PostHog not initialized");
        console.groupEnd();
        return false;
    }
    console.log("\u2705 PostHog initialized");
    console.log('Config:', {
        api_host: posthog.config?.api_host,
        project_api_key: posthog.config?.token ? '***' + posthog.config.token.slice(-4) : 'missing',
        session_id: posthog.get_session_id(),
        distinct_id: posthog.get_distinct_id()
    });
    // Check if events are being queued
    const queueLength = posthog._requestQueue?.length || 0;
    if (queueLength > 0) console.warn(`\u{26A0}\u{FE0F} ${queueLength} events in queue (waiting to be sent)`);
    else console.log("\u2705 Event queue is empty (events being sent immediately)");
    console.groupEnd();
    return true;
};




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");
const $87fac848458df235$export$ec1acb4261485f12 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$229c2a4b55a611f4 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
            })
        ]
    });
const $87fac848458df235$export$4e54df4252b4a99c = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$69387b41dfc808f7 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$9a9e0252a352cccf = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"
        })
    });
const $87fac848458df235$export$3b889a6533231d2c = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$1e450c42b77127b1 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$46e1d66043f363e6 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$cae179f078f4b4a4 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$16f03ed71cfb60c9 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$52cd484a7ef4f2b9 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$40148c7db598e4e0 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"
        })
    });
const $87fac848458df235$export$93cb139c864b0aec = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z"
        })
    });
const $87fac848458df235$export$8afed21ef5c2afa5 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$8099ab97743c966c = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$4b2c798a70974642 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 12a2 2 0 100-4 2 2 0 000 4z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
                clipRule: "evenodd"
            })
        ]
    });
const $87fac848458df235$export$471fc58157231e0e = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
        })
    });
const $87fac848458df235$export$ed8d35002378103b = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"
        })
    });
const $87fac848458df235$export$ef2cff5e0698103f = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
            clipRule: "evenodd"
        })
    });
const $87fac848458df235$export$5bee1749c5489db9 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.36-.034-.47 0-.92.015-1.36.034.44-.572.895-1.096 1.36-1.564zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.563-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.36.034.47 0 .92-.015 1.36-.034-.44.572-.895 1.095-1.36 1.56-.465-.467-.92-.990-1.36-1.56z"
        })
    });
const $87fac848458df235$export$1c8a36276cc546bb = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 256 317",
        xmlSpace: "preserve",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                type: "text/css",
                children: `.flutter-st0{fill:#47C5FB;}
        .flutter-st1{fill:url(#flutter-SVGID_1_);fillOpacity:0.8;}
        .flutter-st2{fill:#00569E;}
        .flutter-st3{fill:#00B5F8;}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        className: "flutter-st0",
                        points: "157.67,0 0,157.67 48.8,206.47 255.27,0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        className: "flutter-st0",
                        points: "156.57,145.4 72.15,229.82 121.13,279.53 169.84,230.82 255.27,145.4"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        className: "flutter-st2",
                        points: "121.13,279.53 158.21,316.61 255.27,316.61 169.84,230.82"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        className: "flutter-st3",
                        points: "71.6,230.36 120.4,181.56 169.84,230.82 121.13,279.53"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                        id: "flutter-SVGID_1_",
                        gradientUnits: "userSpaceOnUse",
                        x1: "-173.6875",
                        y1: "548.7979",
                        x2: "-172.968",
                        y2: "548.5386",
                        gradientTransform: "matrix(44.5891 0 0 -44.5901 7866.5254 24720.502)",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "0",
                                style: {
                                    stopColor: "#000000"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                offset: "1",
                                style: {
                                    stopColor: "#000000",
                                    stopOpacity: 0
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        className: "flutter-st1",
                        points: "121.13,279.53 161.69,266.07 165.72,234.94"
                    })
                ]
            })
        ]
    });
const $87fac848458df235$export$24456da02f66a480 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M0 0h24v24H0V0zm22.034 18.276c-.175-1.095-.888-2.015-3.003-2.873-.736-.345-1.554-.585-1.797-1.14-.091-.33-.105-.51-.046-.705.15-.646.915-.84 1.515-.66.39.12.75.42.976.9 1.034-.676 1.034-.676 1.755-1.125-.27-.42-.404-.601-.586-.78-.63-.705-1.469-1.065-2.834-1.034l-.705.089c-.676.165-1.32.525-1.71 1.005-1.14 1.291-.811 3.541.569 4.471 1.365 1.02 3.361 1.244 3.616 2.205.24 1.17-.87 1.545-1.966 1.41-.811-.18-1.26-.586-1.755-1.336l-1.83 1.051c.21.48.45.689.81 1.109 1.74 1.756 6.09 1.666 6.871-1.004.029-.09.24-.705.074-1.65l.046.067zm-8.983-7.245h-2.248c0 1.938-.009 3.864-.009 5.805 0 1.232.063 2.363-.138 2.711-.33.689-1.18.601-1.566.48-.396-.196-.597-.466-.83-.855-.063-.105-.11-.196-.127-.196l-1.825 1.125c.305.63.75 1.172 1.324 1.517.855.51 2.004.675 3.207.405.783-.226 1.458-.691 1.811-1.411.51-.93.402-2.07.397-3.346.012-2.054 0-4.109 0-6.179l.004-.056z"
        })
    });
const $87fac848458df235$export$18aa9156f3e7edee = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.25.18l.9.2.73.26.59.3.45.32.34.34.25.34.16.33.1.3.04.26.02.2-.01.13V8.5l-.05.63-.13.55-.21.46-.26.38-.3.31-.33.25-.35.19-.35.14-.33.1-.3.07-.26.04-.21.02H8.77l-.69.05-.59.14-.5.22-.41.27-.33.32-.27.35-.2.36-.15.37-.1.35-.07.32-.04.27-.02.21v3.06H3.17l-.21-.03-.28-.07-.32-.12-.35-.18-.36-.26-.36-.36-.35-.46-.32-.59-.28-.73-.21-.88-.14-1.05-.05-1.23.06-1.22.16-1.04.24-.87.32-.71.36-.57.4-.44.42-.33.42-.24.4-.16.36-.1.32-.05.24-.01h.16l.06.01h8.16v-.83H6.18l-.01-2.75-.02-.37.05-.34.11-.31.17-.28.25-.26.31-.23.38-.2.44-.18.51-.15.58-.12.64-.1.71-.06.77-.04.84-.02 1.27.05zm-6.3 1.98l-.23.33-.08.41.08.41.23.34.33.22.41.09.41-.09.33-.22.23-.34.08-.41-.08-.41-.23-.33-.33-.22-.41-.09-.41.09zm13.09 3.95l.28.06.32.12.35.18.36.27.36.35.35.47.32.59.28.73.21.88.14 1.04.05 1.23-.06 1.23-.16 1.04-.24.86-.32.71-.36.57-.4.45-.42.33-.42.24-.4.16-.36.09-.32.05-.24.02-.16-.01h-8.22v.82h5.84l.01 2.76.02.36-.05.34-.11.31-.17.29-.25.25-.31.24-.38.2-.44.17-.51.15-.58.13-.64.09-.71.07-.77.04-.84.01-1.27-.04-1.07-.14-.9-.2-.73-.25-.59-.3-.45-.33-.34-.34-.25-.34-.16-.33-.1-.3-.04-.25-.02-.2.01-.13v-5.34l.05-.64.13-.54.21-.46.26-.38.3-.32.33-.24.35-.2.35-.14.33-.1.3-.06.26-.04.21-.02.13-.01h5.84l.69-.05.59-.14.5-.21.41-.28.33-.32.27-.35.2-.36.15-.36.1-.35.07-.32.04-.28.02-.21V6.07h2.09l.14.01zm-6.47 14.25l-.23.33-.08.41.08.41.23.33.33.23.41.08.41-.08.33-.23.23-.33.08-.41-.08-.41-.23-.33-.33-.23-.41-.08-.41.08z"
        })
    });
const $87fac848458df235$export$3862c70b7a76799f = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.998,24c-0.321,0-0.641-0.084-0.922-0.247l-2.936-1.737c-0.438-0.245-0.224-0.332-0.08-0.383 c0.585-0.203,0.703-0.25,1.328-0.604c0.065-0.037,0.151-0.023,0.218,0.017l2.256,1.339c0.082,0.045,0.197,0.045,0.272,0l8.795-5.076 c0.082-0.047,0.134-0.141,0.134-0.238V6.921c0-0.099-0.053-0.192-0.137-0.242l-8.791-5.072c-0.081-0.047-0.189-0.047-0.271,0 L3.075,6.68C2.99,6.729,2.936,6.825,2.936,6.921v10.15c0,0.097,0.054,0.189,0.139,0.235l2.409,1.392 c1.307,0.654,2.108-0.116,2.108-0.89V7.787c0-0.142,0.114-0.253,0.256-0.253h1.115c0.139,0,0.255,0.112,0.255,0.253v10.021 c0,1.745-0.95,2.745-2.604,2.745c-0.508,0-0.909,0-2.026-0.551L2.28,18.675c-0.57-0.329-0.922-0.945-0.922-1.604V6.921 c0-0.659,0.353-1.275,0.922-1.603l8.795-5.082c0.557-0.315,1.296-0.315,1.848,0l8.794,5.082c0.57,0.329,0.924,0.944,0.924,1.603 v10.15c0,0.659-0.354,1.273-0.924,1.604l-8.794,5.078C12.643,23.916,12.324,24,11.998,24z M19.099,13.993 c0-1.9-1.284-2.406-3.987-2.763c-2.731-0.361-3.009-0.548-3.009-1.187c0-0.528,0.235-1.233,2.258-1.233 c1.807,0,2.473,0.389,2.747,1.607c0.024,0.115,0.129,0.199,0.247,0.199h1.141c0.071,0,0.138-0.031,0.186-0.081 c0.048-0.054,0.074-0.123,0.067-0.196c-0.177-2.098-1.571-3.076-4.388-3.076c-2.508,0-4.004,1.058-4.004,2.833 c0,1.925,1.488,2.457,3.895,2.695c2.88,0.282,3.103,0.703,3.103,1.269c0,0.983-0.789,1.402-2.642,1.402 c-2.327,0-2.839-0.584-3.011-1.742c-0.02-0.124-0.126-0.215-0.253-0.215h-1.137c-0.141,0-0.254,0.112-0.254,0.253 c0,1.482,0.806,3.248,4.655,3.248C17.501,17.007,19.099,15.91,19.099,13.993z"
        })
    });
const $87fac848458df235$export$32aa0ab441834671 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        fill: "none",
        viewBox: "0 0 73 91",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22.5752 87.933C26.3634 89.4568 30.4722 90.3615 34.7873 90.5132C40.6261 90.717 46.1816 89.5089 51.1455 87.2147C45.1923 84.8757 39.8009 81.4554 35.1974 77.2024C32.2171 81.9798 27.805 85.7506 22.5752 87.933Z",
                fill: "#FF9100"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M35.1996 77.2049C24.6952 67.4909 18.3219 53.4295 18.8613 38.0059C18.8787 37.5063 18.906 37.0042 18.9359 36.5046C17.0542 36.0174 15.0905 35.7216 13.0697 35.6495C10.1764 35.5476 7.37501 35.908 4.73026 36.6512C1.92643 41.5629 0.233686 47.1979 0.0224039 53.2356C-0.521958 68.8158 8.90619 82.4273 22.5749 87.9331C27.8047 85.7532 32.2168 81.9849 35.1996 77.2049Z",
                fill: "#FFC400"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M35.1998 77.2047C37.6433 73.2973 39.1222 68.7137 39.2962 63.7772C39.7486 50.792 31.019 39.6214 18.9361 36.5044C18.9063 37.004 18.8789 37.5061 18.8615 38.0057C18.3246 53.4268 24.6954 67.4883 35.1998 77.2047Z",
                fill: "#FF9100"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M37.9435 0C31.0632 5.51321 25.6271 12.7813 22.341 21.1555C20.4594 25.9529 19.2762 31.1032 18.9307 36.5045C31.0135 39.6216 39.7432 50.7922 39.2883 63.7798C39.1168 68.7163 37.6304 73.2949 35.1919 77.2074C39.7929 81.4653 45.1868 84.8806 51.14 87.2196C63.0911 81.6965 71.5697 69.81 72.0594 55.7511C72.3775 46.6411 68.8777 38.5229 63.9337 31.6699C58.7113 24.4242 37.9435 0 37.9435 0Z",
                fill: "#DD2C00"
            })
        ]
    });
const $87fac848458df235$export$7dbf5e59bc7d2ee0 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.193 9.555c-1.264-5.58-4.252-7.414-4.573-8.115-.28-.394-.53-.954-.735-1.44-.036.495-.055.685-.523 1.184-.723.566-4.438 3.682-4.74 10.02-.282 5.912 4.27 9.435 4.888 9.884l.07.05A73.49 73.49 0 0111.91 24h.481c.114-3.032.284-3.015.322-3.194.265-.986.49-1.849 1.48-2.58 0 0 3.915-2.493 3.915-8.671 0 0-.084-1.034-.915-1z"
        })
    });
const $87fac848458df235$export$664fa484b9ce23b6 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M23.546 10.93L13.067.452c-.604-.603-1.582-.603-2.188 0L8.708 2.627l2.76 2.76c.645-.215 1.379-.07 1.889.441.516.515.658 1.258.438 1.9l2.658 2.66c.645-.223 1.387-.078 1.9.435.721.72.721 1.884 0 2.604-.719.719-1.881.719-2.6 0-.539-.541-.674-1.337-.404-1.996L12.86 8.955v6.525c.176.086.342.203.488.348.713.721.713 1.883 0 2.6-.719.721-1.889.721-2.609 0-.719-.719-.719-1.879 0-2.598.182-.18.387-.316.605-.406V8.835c-.217-.091-.424-.222-.6-.401-.545-.545-.676-1.342-.396-2.009L7.636 3.7.45 10.881c-.6.605-.6 1.584 0 2.189l10.48 10.477c.604.604 1.582.604 2.186 0l10.43-10.43c.605-.603.605-1.582 0-2.187"
        })
    });
const $87fac848458df235$export$72cfa1900d921686 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438L1.5 0zm7.031 9.75l-.232-2.718 10.059.003.23-2.622L5.412 4.41l.698 8.01h9.126l-.326 3.426-2.91.804-2.955-.81-.188-2.11H6.248l.33 4.171L12 19.351l5.379-1.443.744-8.157H8.531z"
        })
    });
const $87fac848458df235$export$85fe877eee1aed33 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M1.5 0h21l-1.91 21.563L11.977 24l-8.565-2.438L1.5 0zm17.09 4.413L5.41 4.41l.213 2.622 10.125.002-.255 2.716h-6.64l.24 2.573h6.182l-.366 3.523-2.91.804-2.956-.81-.188-2.11h-2.61l.29 3.855L12 19.288l5.373-1.53L18.59 4.414z"
        })
    });
const $87fac848458df235$export$d83b1b07e955b386 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 0C5.375 0 0 5.375 0 12c0 6.627 5.375 12 12 12 6.627 0 12-5.373 12-12 0-6.625-5.373-12-12-12zm-.624 21.62v-7.528H7.19L13.203 2.38v7.528h4.186L11.376 21.62z"
        })
    });
const $87fac848458df235$export$6af071b6f7c332ac = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z"
        })
    });
const $87fac848458df235$export$6d136f81875310a1 = ({ className: className = "w-4 h-4" })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 24 25",
        fill: "none",
        lang: "en",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M9 17.5V7.5H13C13.7956 7.5 14.5587 7.81607 15.1213 8.37868C15.6839 8.94129 16 9.70435 16 10.5C16 11.2956 15.6839 12.0587 15.1213 12.6213C14.5587 13.1839 13.7956 13.5 13 13.5H9",
                stroke: "white",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 3.25C19.4 3.25 21.25 5.1 21.25 12.5C21.25 19.9 19.4 21.75 12 21.75C4.6 21.75 2.75 19.9 2.75 12.5C2.75 5.1 4.6 3.25 12 3.25Z",
                stroke: "white",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });


const $38859a0fd15e9552$var$Navbar = ({ currentPage: currentPage, navigateToPage: navigateToPage, personalInfo: personalInfo })=>{
    const [isDrawerOpen, setIsDrawerOpen] = (0, $acw62.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $acw62.useState)(false);
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const location = (0, $ee6d600502474136$export$45d76561a5302f2b)();
    const navItems = [
        {
            id: 'about',
            label: 'About'
        },
        {
            id: 'work',
            label: 'Work'
        },
        {
            id: 'experience',
            label: 'Experience'
        },
        // { id: 'education', label: 'Education' },
        {
            id: 'blog',
            label: 'Blog'
        },
        {
            id: 'shelf',
            label: 'Shelf'
        }
    ];
    const handleNavItem = (item)=>{
        if (item.route) {
            navigate(item.route);
            setIsDrawerOpen(false);
        } else scrollToSection(item.id);
    };
    const isNavItemActive = (item)=>{
        if (item.route) return location.pathname === item.route;
        return currentPage === item.id && location.pathname === '/';
    };
    // Track scroll for visibility and shadow effect
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            setIsScrolled(window.scrollY > 100);
        };
        window.addEventListener('scroll', handleScroll);
        return ()=>window.removeEventListener('scroll', handleScroll);
    }, []);
    const scrollToSection = (sectionId)=>{
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(()=>{
                const element = document.getElementById(sectionId);
                if (element) element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        } else {
            const element = document.getElementById(sectionId);
            if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        navigateToPage(sectionId);
        setIsDrawerOpen(false);
    };
    const scrollToTop = ()=>{
        if (location.pathname !== '/') navigate('/');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        navigateToPage('intro');
    };
    const toggleDrawer = ()=>{
        setIsDrawerOpen(!isDrawerOpen);
    };
    const closeDrawer = ()=>{
        setIsDrawerOpen(false);
    };
    (0, $acw62.useEffect)(()=>{
        const handleEscape = (e)=>{
            if (e.key === 'Escape' && isDrawerOpen) closeDrawer();
        };
        document.addEventListener('keydown', handleEscape);
        return ()=>document.removeEventListener('keydown', handleEscape);
    }, [
        isDrawerOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isDrawerOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'unset';
        return ()=>{
            document.body.style.overflow = 'unset';
        };
    }, [
        isDrawerOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: `hidden lg:block fixed left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ${isScrolled ? 'top-4 opacity-100 translate-y-0' : 'top-4 opacity-0 -translate-y-4 pointer-events-none'}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `bg-white border border-border-light rounded-full px-3 py-2 flex items-center gap-1 transition-all duration-300 ${isScrolled ? 'shadow-medium' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: scrollToTop,
                            className: "flex items-center gap-2 px-3 py-1.5 rounded-full hover:bg-cream-200 transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-white text-xs font-semibold",
                                        children: "M"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "font-medium text-charcoal-900 text-sm",
                                    children: "Manav Gupta"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-px h-6 bg-border-light mx-2"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center",
                            children: navItems.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>handleNavItem(item),
                                    className: `px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 ${isNavItemActive(item) ? 'text-charcoal-900 bg-cream-200' : 'text-charcoal-600 hover:text-charcoal-900 hover:bg-cream-100'}`,
                                    children: item.label
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "w-px h-6 bg-border-light mx-2"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: personalInfo?.resume || '/resume.pdf',
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "flex items-center gap-2 px-4 py-1.5 bg-coral-500 text-white rounded-full text-sm font-medium hover:bg-coral-600 transition-colors",
                            children: [
                                "Resume",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    className: "w-3.5 h-3.5",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: `hidden md:block lg:hidden fixed left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 ${isScrolled ? 'top-4 opacity-100 translate-y-0' : 'top-4 opacity-0 -translate-y-4 pointer-events-none'}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `bg-white border border-border-light rounded-full px-4 py-2.5 flex items-center gap-4 transition-all duration-300 ${isScrolled ? 'shadow-medium' : ''}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: scrollToTop,
                            className: "flex items-center gap-2",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-white text-xs font-semibold",
                                    children: "M"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center gap-1",
                            children: navItems.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>handleNavItem(item),
                                    className: `px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 ${isNavItemActive(item) ? 'text-charcoal-900 bg-cream-200' : 'text-charcoal-600 hover:text-charcoal-900'}`,
                                    children: item.label
                                }, item.id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: personalInfo?.resume || '/resume.pdf',
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "flex items-center gap-1.5 px-3 py-1.5 bg-coral-500 text-white rounded-full text-sm font-medium hover:bg-coral-600 transition-colors",
                            children: [
                                "CV",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    className: "w-3 h-3",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: toggleDrawer,
                className: `md:hidden fixed top-4 right-4 z-50 bg-white border border-border-light rounded-full p-3 text-charcoal-700 hover:text-charcoal-900 transition-all duration-300 ${isScrolled ? 'opacity-100 translate-y-0 shadow-medium' : 'opacity-0 -translate-y-4 pointer-events-none'}`,
                "aria-label": "Toggle navigation menu",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$46e1d66043f363e6), {
                    className: "w-5 h-5"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: scrollToTop,
                className: `md:hidden fixed top-4 left-4 z-50 bg-white border border-border-light rounded-full px-3 py-2.5 flex items-center gap-2 transition-all duration-300 ${isScrolled ? 'opacity-100 translate-y-0 shadow-medium' : 'opacity-0 -translate-y-4 pointer-events-none'}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-white text-xs font-semibold",
                        children: "M"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: scrollToTop,
                className: `md:hidden fixed bottom-6 right-6 z-40 w-11 h-11 bg-white border border-border-light rounded-full flex items-center justify-center text-charcoal-600 hover:bg-coral-50 hover:text-coral-600 transition-all duration-300 ${isScrolled ? 'opacity-100 translate-y-0 shadow-medium' : 'opacity-0 translate-y-4 pointer-events-none'}`,
                "aria-label": "Go to top",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    className: "w-5 h-5",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                    })
                })
            }),
            isDrawerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "md:hidden fixed inset-0 bg-charcoal-900/30 backdrop-blur-sm z-40 transition-opacity duration-300",
                onClick: closeDrawer,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `md:hidden fixed top-0 right-0 h-full w-80 max-w-[85vw] bg-white border-l border-border-light z-50 transform transition-transform duration-300 ease-out ${isDrawerOpen ? 'translate-x-0' : 'translate-x-full'}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-between p-6 border-b border-border-light",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-8 h-8 bg-coral-500 rounded-full flex items-center justify-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-white text-sm font-semibold",
                                            children: "M"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "font-serif text-lg text-charcoal-900",
                                        children: "Menu"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: closeDrawer,
                                className: "text-charcoal-500 hover:text-charcoal-900 transition-colors p-1",
                                "aria-label": "Close navigation menu",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$cae179f078f4b4a4), {
                                    className: "w-5 h-5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                        className: "p-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-2",
                                children: navItems.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>handleNavItem(item),
                                            className: `w-full text-left py-3 px-4 rounded-xl font-medium transition-all duration-200 ${isNavItemActive(item) ? 'bg-coral-50 text-coral-600' : 'text-charcoal-700 hover:bg-cream-100 hover:text-charcoal-900'}`,
                                            children: item.label
                                        })
                                    }, item.id))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mt-8 pt-6 border-t border-border-light",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: personalInfo?.resume || '/resume.pdf',
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "flex items-center justify-center gap-2 w-full py-3 bg-coral-500 text-white rounded-full font-medium hover:bg-coral-600 transition-colors",
                                    children: [
                                        "Download Resume",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            className: "w-4 h-4",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $38859a0fd15e9552$export$2e2bcd8739ae039 = $38859a0fd15e9552$var$Navbar;




var $acw62 = parcelRequire("acw62");
const $019513e9c48f5471$export$91bfd9bdbb33b473 = {
    personalInfo: {
        name: "Manav Gupta",
        title: "Software Engineer",
        location: "Hyderabad, India",
        phone: "+91-9070507555",
        email: "manav_guptaa@outlook.com",
        avatar: "/images/profile/image.webp",
        bio: "I'm a passionate software engineer with experience building scalable mobile and web applications. I specialize in Flutter for cross-platform mobile development, React for modern web interfaces, and have expertise in full-stack development.",
        fullBio: "As a dedicated software engineer, I bring expertise in mobile-first thinking and full-stack development to every project. My journey began with a fascination for creating seamless user experiences across platforms, leading me to specialize in Flutter development where I've built applications for various industries including real estate, automotive, and education. My experience spans from frontend development with React to building robust mobile applications with Flutter, always focusing on clean code, performance optimization, and staying current with emerging technologies.",
        resume: "/images/resume/Manav_Gupta_Resume.pdf",
        socialLinks: {
            github: "https://github.com/manavg005",
            linkedin: "https://linkedin.com/in/manavg005",
            twitter: "https://twitter.com/manavg005",
            medium: "https://medium.com/@manavguptamg1990",
            instagram: "https://instagram.com/manavgupta"
        },
        beyondOffice: {
            tagline: "Engineer by day, wanderer by weekends",
            description: [
                "When the laptop shuts, a different side of me takes over - road trips, gym sessions, and good music. I like exploring places that aren't on the first page of Google, with a growing list of \"next time for sure\" destinations.",
                "Nothing resets me quite like the mountains. My legs have taken me up to 14,500 ft - high enough to question my life choices, low enough to still brag about it at sea level.",
                "Sunrises, sunsets, and the moon still manage to stop me mid-scroll. I'll never not look up."
            ],
            signOff: "Fuelled by curiosity, coffee, and a healthy disregard for comfort zones.",
            interests: [
                {
                    name: "Fitness",
                    icon: "\uD83D\uDCAA"
                },
                {
                    name: "Music",
                    icon: "\uD83C\uDFB5"
                },
                {
                    name: "Mountains",
                    icon: "\uD83C\uDFD4\uFE0F"
                },
                {
                    name: "Reading",
                    icon: "\uD83D\uDCDA"
                },
                {
                    name: "Coffee",
                    icon: "\u2615"
                },
                {
                    name: "Mindfulness",
                    icon: "\uD83E\uDDD8"
                }
            ],
            gallery: [
                {
                    src: "/images/personal/travel1.webp",
                    alt: "Mountain adventure",
                    emoji: "\uD83C\uDFD4\uFE0F"
                },
                {
                    src: "/images/personal/travel2.webp",
                    alt: "City exploration",
                    emoji: "\uD83C\uDF06"
                },
                {
                    src: "/images/personal/travel3.webp",
                    alt: "Road trip vibes",
                    emoji: "\uD83D\uDEE3\uFE0F"
                },
                {
                    src: "/images/personal/travel4.webp",
                    alt: "Sunset moments",
                    emoji: "\uD83C\uDF05"
                },
                {
                    src: "/images/personal/travel5.webp",
                    alt: "Local discoveries",
                    emoji: "\uD83D\uDCCD"
                }
            ],
            stats: [
                {
                    label: "Cities",
                    value: "6+"
                },
                {
                    label: "Countries",
                    value: "1"
                },
                {
                    label: "Coffee/Day",
                    value: "\u221E"
                }
            ]
        }
    },
    workExperience: [
        {
            id: 1,
            company: "Grarri Pvt Ltd",
            position: "Software Engineer",
            duration: "Nov 2024 - Present",
            location: "Hyderabad, India",
            type: "Full-time",
            description: "Leading product development and technical architecture for the company's flagship real estate application.",
            achievements: [
                "Own the end-to-end product and tech architecture for the company's main real estate app",
                "Built a smart home planning tool with a budget calculator that factors in location and realistic costs",
                "Designed a system for verified, non-repeated property listings with full details, monthly updates, pricing, and floor plans",
                "Built a user journey system that lets users save, share, and track property options, and personal notes"
            ],
            technologies: [
                "Flutter",
                "Dart",
                "Bloc",
                "Firebase",
                "Proptech",
                "CRM Systems"
            ]
        },
        {
            id: 2,
            company: "Appventurez Mobitech",
            position: "Software Developer",
            duration: "June 2023 - Oct 2024",
            location: "Noida, India",
            type: "Full-time",
            description: "Built Flutter applications for Android and iOS with REST API integrations for real-time data.",
            achievements: [
                "Developed cross-platform Flutter apps handling real-time data through REST APIs",
                "Improved delivery times by 20% by optimising location services with Google Maps SDK",
                "Implemented offline functionality using Hive and SQLite for local storage",
                "Used Provider and Bloc for scalable state management across multiple apps",
                "Integrated Twilio Voice SDK, boosting user engagement by 30%"
            ],
            technologies: [
                "Flutter",
                "REST APIs",
                "Google Maps SDK",
                "Hive",
                "SQLite",
                "Provider",
                "Bloc",
                "Twilio"
            ]
        },
        {
            id: 3,
            company: "JaKeGA, JKIT",
            position: "Software Developer Intern",
            duration: "Dec 2022 - June 2023",
            location: "Jammu, India",
            type: "Internship",
            description: "Built and maintained ICT solutions for J&K UT government departments.",
            achievements: [
                "Developed ICT-based solutions used across J&K UT departments",
                "Built an Attendance Management App in Flutter that cut manual effort by 50%",
                "Added geofencing and face recognition for streamlined attendance tracking"
            ],
            technologies: [
                "Flutter",
                "Geofencing",
                "Face Recognition",
                "ICT Solutions"
            ]
        },
        {
            id: 4,
            company: "Devsnest",
            position: "Software Developer Intern",
            duration: "April 2021 - Dec 2021",
            location: "Gurugram, India",
            type: "Internship",
            description: "Built the frontend for an ed-tech platform using React, improving user experience and engagement.",
            achievements: [
                "Developed the React frontend for an ed-tech platform used by students",
                "Automated Discord group management through SQS, reducing overhead by 40%",
                "Built a Monaco-based code editor with real-time testing \u2014 retention up 15%, visits up 20%"
            ],
            technologies: [
                "React",
                "Discord API",
                "SQS",
                "Monaco Editor",
                "Real-time Testing"
            ]
        }
    ],
    projects: [
        {
            id: 1,
            title: "SimpSocial GoCRM",
            description: "Automotive Dealership CRM - An AI-powered, cross-platform CRM to optimize sales processes for automotive dealerships.",
            longDescription: "Developed an AI-powered, cross-platform CRM to optimize sales processes for automotive dealerships, boosting customer engagement and sales conversions. Integrated communication tools, real-time lead management, and a bilingual conversational AI to streamline operations and enhance productivity.",
            image: "/images/projects/simpsocial.webp",
            cardImage: "/images/projects/simpsocial_project_card.webp",
            technologies: [
                "Flutter",
                "Twilio",
                "JitsiMeet",
                "Intercom",
                "AI",
                "CRM"
            ],
            playstore: "https://play.google.com/store/apps/details?id=com.simpsocial.mobileApp&pcampaignid=web_share",
            appstore: "https://apps.apple.com/in/app/simpsocial-gocrm/id6502897000",
            featured: false,
            status: "completed",
            year: "2024"
        },
        {
            id: 2,
            title: "Football Lounge",
            description: "Sports & Social App - A mobile application that simulates real-time football conversations and knowledge-based games among friends.",
            longDescription: "Developed a mobile application that simulates real-time football conversations and knowledge-based games among friends. Implemented features for creating and managing tournaments, a point-based scoring system for correct predictions, and a chatroom with multimedia sharing to enhance user engagement.",
            // cardImage: "https://play-lh.googleusercontent.com/mttSG2nLj_MOiSBRzhlUyrgukqtAaGsqTJYS5nn_0Uv1vu4QbiN_hURYbx2tCnL_oYM=w416-h235-rw",
            cardImage: "/images/projects/football_lounge_card.webp",
            image: "/images/projects/football_lounge.webp",
            technologies: [
                "Flutter",
                "Firebase",
                "Socket.io",
                "Real-time Chat",
                "Gaming"
            ],
            playstore: "https://play.google.com/store/apps/details?id=com.football_lounge.app&pcampaignid=web_share&pli=1",
            appstore: "https://apps.apple.com/in/app/football-lounge/id6479597032",
            featured: false,
            status: "completed",
            year: "2024"
        },
        {
            id: 3,
            title: "Navigate Bharat",
            description: "Video gateway of India - A mobile app providing public access to official Government of India videos.",
            longDescription: "Built a mobile app to provide public access to official Government of India videos, increasing information accessibility by 40%. Enhanced video playback with features like resolution adjustment, speed control, and offline viewing.",
            image: "/images/projects/navbharatlogo.png",
            technologies: [
                "Flutter",
                "Better Player",
                "Video Streaming",
                "Offline Viewing"
            ],
            github: "https://github.com/manavgupta/navigate-bharat",
            live: "https://navigatebharat.gov.in/home",
            featured: false,
            status: "completed",
            year: "2023"
        },
        {
            id: 4,
            title: "Sanatana: The Eternal Living",
            description: "Daily Gita & Ramayana wisdom app - Timeless shlokas with clear explanations, soothing background music, and multilingual support for a daily spiritual habit.",
            longDescription: 'Begin each day with timeless wisdom from the Bhagavad Gita and Ramayana. Sanatana brings the sacred shlokas to life with clear explanations, soothing background music, and support for multiple languages \u2014 so ancient teachings feel personal, practical, and easy to understand. Whether a lifelong devotee or just beginning a spiritual journey, Sanatana helps build a simple daily habit of reflection and learning.\n\nA verse for every day: receive a thoughtfully chosen shloka each day, the same verse shared by the whole community, along with its meaning and a practical lesson to carry into daily life.\n\nDeep, easy-to-understand explanations: every verse comes with context and interpretation that make profound teachings accessible \u2014 no Sanskrit degree required.\n\nA calming atmosphere: soothing background music plays while you read, perfect for a morning routine, commute, or quiet reflection.\n\nRead in your language: explore content in English, Hindi, Sanskrit, and Telugu, with the original Sanskrit shloka alongside translations.\n\nExplore the full scriptures: browse chapter by chapter through the Bhagavad Gita and Ramayana, and search by chapter and verse (like "chapter 2" or "2:47").\n\nTrack your journey: bookmark verses, revisit reading history, and keep a daily practice going with streaks and progress tracking.\n\nUse it your way: start instantly as a guest with no account needed, or sign in with Google to keep bookmarks and progress in sync.\n\nBuilt with Flutter and Firebase for a smooth cross-platform experience, with Gemini AI powering contextual verse explanations and a conversational "Ask the Gita" feature.',
            image: "/images/projects/sanatana.png",
            cardImage: "/images/projects/sanatana_card.png",
            technologies: [
                "Flutter",
                "Firebase",
                "Gemini AI"
            ],
            playstore: "https://play.google.com/store/apps/details?id=com.sanatana.app",
            featured: true,
            status: "completed",
            year: "2026"
        }
    ],
    skills: {
        frontend: [
            "React",
            "JavaScript",
            "HTML5",
            "CSS3",
            "Flutter",
            "Dart"
        ],
        backend: [
            "Firebase",
            "REST APIs",
            "MongoDB",
            "SQLite",
            "Hive",
            "ObjectBox"
        ],
        frameworks: [
            "Flutter",
            "ReactJS"
        ],
        database: [
            "MongoDB",
            "SQLite",
            "Hive",
            "ObjectBox",
            "Firebase"
        ],
        tools: [
            "Git",
            "GitHub",
            "GitLab",
            "Postman",
            "Visual Studio Code",
            "Xcode",
            "Android Studio",
            "SonarQube"
        ],
        mobile: [
            "Flutter",
            "Dart",
            "Android Development",
            "iOS Development",
            "Cross-platform"
        ],
        thirdParty: [
            "Firebase",
            "Twilio",
            "Jitsi Meet",
            "Intercom",
            "Azure",
            "AWS",
            "Google Maps SDK"
        ]
    },
    stack: [
        {
            name: "Flutter",
            category: "Mobile Framework",
            icon: "\uD83D\uDCF1"
        },
        {
            name: "ReactJS",
            category: "Web Framework",
            icon: "\u269B\uFE0F"
        },
        {
            name: "HTML",
            category: "Markup Language",
            icon: "\uD83C\uDF10"
        },
        {
            name: "CSS",
            category: "Styling Language",
            icon: "\uD83C\uDFA8"
        },
        {
            name: "Git",
            category: "Version Control",
            icon: "\uD83D\uDCCB"
        },
        {
            name: "FastAPI",
            category: "Backend Framework",
            icon: "\u26A1"
        },
        {
            name: "Firebase",
            category: "Backend Service",
            icon: "\uD83D\uDD25"
        },
        {
            name: "MongoDB",
            category: "Database",
            icon: "\uD83C\uDF43"
        }
    ],
    education: [
        {
            id: 1,
            institution: "Government College of Engineering & Technology",
            degree: "Bachelor of Engineering in Computer Engineering",
            duration: "2019 - 2023",
            location: "Jammu, J&K",
            grade: "8.7 CGPA",
            description: "Focused on software engineering principles, data structures, algorithms, and mobile application development.",
            achievements: [
                "Graduated with 8.7 CGPA",
                "Specialized in software engineering and mobile development",
                "Active participant in coding competitions and tech events"
            ]
        }
    ],
    testimonials: [
        {
            id: 1,
            name: "Rahul Sharma",
            position: "Senior Developer at Grarri",
            company: "Grarri Pvt Ltd",
            content: "Manav is an exceptional developer with strong technical skills in Flutter and mobile development. His ability to deliver high-quality code and lead technical architecture makes him a valuable team member.",
            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
            rating: 5
        },
        {
            id: 2,
            name: "Priya Patel",
            position: "Project Manager at Appventurez",
            company: "Appventurez Mobitech",
            content: "Working with Manav has been a pleasure. He consistently delivers projects on time and his attention to detail is remarkable. His Flutter expertise helped us launch several successful mobile applications.",
            avatar: "https://images.unsplash.com/photo-1494790108755-2616b332c265?w=150&h=150&fit=crop&crop=face",
            rating: 5
        }
    ],
    blogCategories: [
        {
            id: "tech",
            name: "Technology",
            color: "bg-blue-500"
        },
        {
            id: "tutorial",
            name: "Tutorial",
            color: "bg-green-500"
        },
        {
            id: "career",
            name: "Career",
            color: "bg-purple-500"
        },
        {
            id: "mobile",
            name: "Mobile Dev",
            color: "bg-orange-500"
        }
    ],
    blogPosts: [
        {
            id: 1,
            title: "Building Scalable Flutter Apps: Lessons from Real-World Projects",
            slug: "building-scalable-flutter-apps-real-world-lessons",
            excerpt: "Learn how to build Flutter applications that scale efficiently with proper architecture, state management, and performance optimization techniques from my experience building apps for various industries.",
            author: "Manav Gupta",
            publishedAt: "2024-01-15",
            readTime: "8 min read",
            category: "mobile",
            tags: [
                "flutter",
                "mobile-development",
                "performance",
                "architecture"
            ],
            featured: true,
            image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&h=400&fit=crop",
            likes: 245,
            comments: 18
        },
        {
            id: 2,
            title: "Flutter State Management: Provider vs Bloc in Practice",
            slug: "flutter-state-management-provider-vs-bloc",
            excerpt: "A comprehensive comparison of Provider and Bloc state management solutions in Flutter, based on hands-on experience building production applications.",
            author: "Manav Gupta",
            publishedAt: "2024-01-08",
            readTime: "12 min read",
            category: "tutorial",
            tags: [
                "flutter",
                "state-management",
                "provider",
                "bloc"
            ],
            featured: true,
            image: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=800&h=400&fit=crop",
            likes: 189,
            comments: 25
        },
        {
            id: 3,
            title: "My Journey from Student to Software Engineer",
            slug: "journey-student-to-software-engineer",
            excerpt: "Reflecting on my path from computer science student to professional software engineer, including challenges, learnings, and career milestones.",
            author: "Manav Gupta",
            publishedAt: "2024-01-01",
            readTime: "6 min read",
            category: "career",
            tags: [
                "career",
                "journey",
                "software-engineering",
                "advice"
            ],
            featured: false,
            image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop",
            likes: 156,
            comments: 32
        },
        {
            id: 4,
            title: "Integrating Real-time Features in Flutter with Socket.io",
            slug: "flutter-realtime-features-socketio",
            excerpt: "A practical guide to implementing real-time communication features in Flutter applications using Socket.io, based on my experience building Football Lounge.",
            author: "Manav Gupta",
            publishedAt: "2023-12-28",
            readTime: "10 min read",
            category: "tutorial",
            tags: [
                "flutter",
                "socket.io",
                "real-time",
                "communication"
            ],
            featured: false,
            image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=800&h=400&fit=crop",
            likes: 203,
            comments: 47
        }
    ],
    shelf: {
        books: [
            {
                id: 1,
                title: "The Pragmatic Programmer",
                author: "David Thomas & Andrew Hunt"
            },
            {
                id: 2,
                title: "Clean Code",
                author: "Robert C. Martin"
            },
            {
                id: 3,
                title: "Atomic Habits",
                author: "James Clear"
            },
            {
                id: 4,
                title: "Deep Work",
                author: "Cal Newport"
            },
            {
                id: 5,
                title: "Zero to One",
                author: "Peter Thiel"
            },
            {
                id: 6,
                title: "Designing Data-Intensive Applications",
                author: "Martin Kleppmann"
            },
            {
                id: 7,
                title: "The Psychology of Money",
                author: "Morgan Housel"
            },
            {
                id: 8,
                title: "Shoe Dog",
                author: "Phil Knight"
            },
            {
                id: 9,
                title: "Thinking, Fast and Slow",
                author: "Daniel Kahneman"
            },
            {
                id: 10,
                title: "The Almanack of Naval Ravikant",
                author: "Eric Jorgenson"
            }
        ],
        papers: [
            {
                id: 1,
                title: "Attention Is All You Need",
                authors: "Vaswani et al.",
                venue: "NeurIPS 2017",
                url: "https://arxiv.org/abs/1706.03762"
            },
            {
                id: 2,
                title: "MapReduce: Simplified Data Processing on Large Clusters",
                authors: "Dean & Ghemawat",
                venue: "OSDI 2004",
                url: "https://research.google/pubs/mapreduce-simplified-data-processing-on-large-clusters/"
            },
            {
                id: 3,
                title: "Dynamo: Amazon's Highly Available Key-value Store",
                authors: "DeCandia et al.",
                venue: "SOSP 2007",
                url: "https://www.allthingsdistributed.com/files/amazon-dynamo-sosp2007.pdf"
            },
            {
                id: 4,
                title: "The Google File System",
                authors: "Ghemawat, Gobioff & Leung",
                venue: "SOSP 2003",
                url: "https://research.google/pubs/the-google-file-system/"
            },
            {
                id: 5,
                title: "A Flutter-based Approach to Cross-platform Development",
                authors: "Stoll & Gon\xe7alves",
                venue: "IEEE 2020",
                url: "https://ieeexplore.ieee.org/document/9226427"
            }
        ]
    }
};




const $55e366559c5db4f9$var$HeroSection = ()=>{
    const { trackPageView: trackPageView, trackCVDownload: trackCVDownload, trackContactInteraction: trackContactInteraction, trackSocialClick: trackSocialClick } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(()=>{
        trackPageView('hero_section');
    }, [
        trackPageView
    ]);
    const handleCVDownload = ()=>{
        trackCVDownload();
        const link = document.createElement('a');
        link.href = '/images/resume/Manav_Gupta_Resume.pdf';
        link.download = 'Manav_Gupta_Resume.pdf';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleEmailClick = ()=>{
        trackContactInteraction('email', (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email);
    };
    const handleSocialClick = (platform, url)=>{
        trackSocialClick(platform, url);
    };
    const socialLinks = [
        {
            platform: 'github',
            icon: (0, $87fac848458df235$export$1e450c42b77127b1),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks.github
        },
        {
            platform: 'linkedin',
            icon: (0, $87fac848458df235$export$3b889a6533231d2c),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks.linkedin
        },
        {
            platform: 'twitter',
            icon: (0, $87fac848458df235$export$9a9e0252a352cccf),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks.twitter
        },
        {
            platform: 'medium',
            icon: (0, $87fac848458df235$export$6af071b6f7c332ac),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks.medium
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "relative min-h-screen flex flex-col justify-center px-6 pt-24 pb-16 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute top-20 right-0 w-[500px] h-[500px] gradient-blob gradient-blob-coral animate-float-slow opacity-40"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute bottom-20 left-0 w-[400px] h-[400px] gradient-blob gradient-blob-peach animate-float-slower opacity-50"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-4xl mx-auto w-full text-center relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-6 animate-fadeInUp",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            className: "label-text inline-flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "w-2 h-2 bg-coral-500 rounded-full"
                                }),
                                "Software Engineer"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "text-hero text-charcoal-900 mb-6 animate-fadeInUp",
                        style: {
                            animationDelay: '0.1s'
                        },
                        children: [
                            "Building products,",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                className: "italic-emphasis",
                                children: "one feature"
                            }),
                            " at a time."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-lg md:text-xl text-charcoal-600 max-w-2xl mx-auto mb-10 leading-relaxed animate-fadeInUp",
                        style: {
                            animationDelay: '0.2s'
                        },
                        children: [
                            "I'm ",
                            (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name,
                            ", a software engineer who builds scalable mobile and web apps with Flutter, React, and modern tech. I care about clean code and great user experiences."
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 animate-fadeInUp",
                        style: {
                            animationDelay: '0.3s'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                href: `mailto:${(0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email}`,
                                onClick: handleEmailClick,
                                className: "btn-primary",
                                children: [
                                    "Let's Build Something",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        className: "w-4 h-4",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: handleCVDownload,
                                className: "btn-secondary",
                                children: [
                                    "Download CV",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        className: "w-4 h-4",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 2,
                                            d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "animate-fadeInUp",
                        style: {
                            animationDelay: '0.4s'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 bg-white border border-border-light rounded-2xl p-4 sm:pr-8 shadow-soft",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-4 sm:gap-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.avatar,
                                            alt: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name,
                                            className: "w-14 h-14 sm:w-16 sm:h-16 rounded-xl object-cover"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "font-serif text-base sm:text-lg text-charcoal-900",
                                                    children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-charcoal-500",
                                                    children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.location
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center gap-3 pt-3 sm:pt-0 sm:ml-4 sm:pl-6 border-t sm:border-t-0 sm:border-l border-border-light w-full sm:w-auto justify-center sm:justify-start",
                                    children: socialLinks.map(({ platform: platform, icon: Icon, url: url })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: ()=>handleSocialClick(platform, url),
                                            className: "w-9 h-9 flex items-center justify-center rounded-full bg-cream-100 text-charcoal-600 hover:bg-coral-50 hover:text-coral-600 transition-all duration-200",
                                            "aria-label": platform,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                className: "w-4 h-4"
                                            })
                                        }, platform))
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $55e366559c5db4f9$export$2e2bcd8739ae039 = $55e366559c5db4f9$var$HeroSection;




var $acw62 = parcelRequire("acw62");

/**
 * Dynamic Personal Images Loader
 *
 * This utility loads all images from public/images/personal/ folder.
 *
 * USAGE: Simply add any image file (jpg, jpeg, png, webp, gif) to
 * the public/images/personal/ folder and it will automatically
 * appear in the card stack.
 *
 * NOTE: Since Create React App serves public folder statically,
 * we maintain a manifest file that gets updated. For fully dynamic
 * loading, you would need a backend or build-time script.
 *
 * To add new images:
 * 1. Add image to public/images/personal/
 * 2. Run: npm run update-images (or manually add to the list below)
 */ // Manifest of images in public/images/personal/
// This list is the source of truth - add your image filenames here
const $7642048f12f2534e$var$IMAGE_MANIFEST = [
    'zkfzmeerbv7kie9bysq2.webp',
    'ajndyatovaj0cp1hfxc4.webp',
    'ao4ghr2aj6gabktwrjmf.webp',
    'f15nsdb5eicwe8ma9xza.webp',
    'reorhmtuu1ui9icydmuu.webp',
    'c7ausiydnbx7zdbwy7ap.webp',
    'rydxamiyamspkbywcigf.webp',
    'taoflmxvuovcrzwrmkn2.webp',
    'u8gqdlv9hfpkqitn1oio.webp',
    'vrx0ywdydj7rjzitwyqb.webp',
    'wa0xofu9zxpu01ezytau.webp',
    'wjfolinqsgfcxvyzzot8.webp',
    'xvrzkgmgoqzo9y40n5fi.webp',
    'mountain-trek-1.webp',
    'mountain-trek-2.webp',
    'mountain-trek-3.webp',
    'mountain-trek-4.webp',
    'mountain-trek-5.webp',
    'mountain-trek-6.webp',
    'sunset-moon.webp',
    'sunset-city.webp',
    'sunset-street.webp',
    'cloud-peak.webp',
    'sunrise-trees.webp',
    'sunset-silhouette.webp'
];
// Shuffle array using Fisher-Yates algorithm
const $7642048f12f2534e$var$shuffleArray = (array)=>{
    const shuffled = [
        ...array
    ];
    for(let i = shuffled.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [
            shuffled[j],
            shuffled[i]
        ];
    }
    return shuffled;
};
const $7642048f12f2534e$export$dbe275f3d0fa06ad = (options = {})=>{
    const { shuffle: shuffle = true, limit: limit = null } = options;
    let images = $7642048f12f2534e$var$IMAGE_MANIFEST.map((filename, index)=>({
            src: `/images/personal/${filename}`,
            alt: `Personal moment ${index + 1}`,
            filename: filename
        }));
    if (shuffle) images = $7642048f12f2534e$var$shuffleArray(images);
    if (limit && limit > 0) images = images.slice(0, limit);
    return images;
};
const $7642048f12f2534e$export$8c98d15fbfec5da6 = '/images/personal/';
var $7642048f12f2534e$export$2e2bcd8739ae039 = $7642048f12f2534e$export$dbe275f3d0fa06ad;


const $547dcd7931d7675a$var$CardStack = ({ images: images, isVisible: isVisible })=>{
    const [currentIndex, setCurrentIndex] = (0, $acw62.useState)(0);
    const [showHint, setShowHint] = (0, $acw62.useState)(false);
    const [wiggle, setWiggle] = (0, $acw62.useState)(false);
    const [loadedImages, setLoadedImages] = (0, $acw62.useState)({});
    const hasInteracted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const handleImageLoad = (0, $acw62.useCallback)((index)=>{
        setLoadedImages((prev)=>({
                ...prev,
                [index]: true
            }));
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isVisible && !hasInteracted.current) {
            const hintTimer = setTimeout(()=>{
                setShowHint(true);
                setWiggle(true);
            }, 400);
            const hideTimer = setTimeout(()=>{
                setShowHint(false);
                setWiggle(false);
            }, 3000);
            return ()=>{
                clearTimeout(hintTimer);
                clearTimeout(hideTimer);
            };
        }
    }, [
        isVisible
    ]);
    const handleClick = ()=>{
        hasInteracted.current = true;
        setShowHint(false);
        setWiggle(false);
        setCurrentIndex((prev)=>(prev + 1) % images.length);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative w-full h-full cursor-pointer group",
        onClick: handleClick,
        children: [
            images.map((image, index)=>{
                const offset = (index - currentIndex + images.length) % images.length;
                const isActive = offset === 0;
                const isNext = offset === 1;
                const isPrev = offset === images.length - 1;
                if (offset > 2 && offset < images.length - 1) return null;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `absolute inset-0 rounded-2xl overflow-hidden transition-all duration-500 ease-out shadow-lg border border-border-light ${isActive && wiggle ? 'animate-card-nudge' : ''}`,
                    style: {
                        transform: isActive ? 'translateX(0) rotate(0deg) scale(1)' : isNext ? 'translateX(8px) translateY(8px) rotate(2deg) scale(0.98)' : isPrev ? 'translateX(-8px) translateY(8px) rotate(-2deg) scale(0.98)' : 'translateX(16px) translateY(16px) rotate(4deg) scale(0.96)',
                        zIndex: isActive ? 30 : isNext ? 20 : isPrev ? 20 : 10,
                        opacity: isActive ? 1 : offset <= 2 || isPrev ? 0.6 : 0
                    },
                    children: [
                        !loadedImages[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "absolute inset-0 bg-gradient-to-br from-coral-100 to-cream-200 flex flex-col items-center justify-center gap-3 z-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-8 h-8 border-2 border-charcoal-300 border-t-charcoal-600 rounded-full animate-spin"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-charcoal-500 font-medium tracking-wide",
                                    children: "Quality takes time"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: image.src,
                            alt: image.alt,
                            onLoad: ()=>handleImageLoad(index),
                            className: `w-full h-full object-cover transition-opacity duration-500 ${loadedImages[index] ? 'opacity-100' : 'opacity-0'}`
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `absolute bottom-4 right-4 z-40 flex items-center gap-2 px-3 py-1.5 bg-white/90 backdrop-blur-sm rounded-full text-xs text-charcoal-600 shadow-sm transition-all duration-500 ${showHint ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0'}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        className: "w-3.5 h-3.5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "Click to flip"
                    })
                ]
            })
        ]
    });
};
const $547dcd7931d7675a$var$AboutSection = ()=>{
    const [activeView, setActiveView] = (0, $acw62.useState)('professional');
    const { beyondOffice: beyondOffice } = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo;
    const personalImages = (0, $acw62.useMemo)(()=>(0, $7642048f12f2534e$export$dbe275f3d0fa06ad)({
            shuffle: true
        }), []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "section relative overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute -top-20 -left-40 w-[400px] h-[400px] gradient-blob gradient-blob-peach opacity-30"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "section-heading text-charcoal-900 mb-12",
                        children: [
                            "About ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                className: "italic-emphasis",
                                children: "me"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>setActiveView('professional'),
                                className: `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border ${activeView === 'professional' ? 'border-charcoal-900 text-charcoal-900 bg-charcoal-900/5' : 'border-charcoal-300 text-charcoal-500 hover:border-charcoal-500 hover:text-charcoal-700'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "\uD83D\uDCBC"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Professional"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>setActiveView('beyond'),
                                className: `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 border ${activeView === 'beyond' ? 'border-charcoal-900 text-charcoal-900 bg-charcoal-900/5' : 'border-charcoal-300 text-charcoal-500 hover:border-charcoal-500 hover:text-charcoal-700'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "\uD83C\uDF34"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Beyond Office"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid lg:grid-cols-2 gap-12 lg:gap-16 items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-col order-2 lg:order-1",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1 relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `transition-all duration-400 ease-in-out ${activeView === 'professional' ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 absolute inset-0 pointer-events-none'}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-lg text-charcoal-700 leading-relaxed",
                                                        children: [
                                                            "Hello, I'm ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-charcoal-900 font-semibold",
                                                                children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name
                                                            }),
                                                            ", a software engineer with 3+ years of experience building clean, user-friendly digital products."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-charcoal-600 leading-relaxed",
                                                        children: "My journey into software began with curiosity about how things work, why they break, and how to make them better. Over the years, that curiosity turned into hands-on experience across Flutter mobile development and React web applications, building products used by thousands of users."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-charcoal-600 leading-relaxed",
                                                        children: "I care about clean architecture, maintainable code, and thoughtful user experiences. I enjoy working closely with the product, understanding actual problems and turning them into reliable, scalable solutions."
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-charcoal-600 leading-relaxed",
                                                        children: [
                                                            "Curious about what I do",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>setActiveView('beyond'),
                                                                className: "underline text-charcoal-800 hover:text-charcoal-900 transition-colors",
                                                                children: "beyond the office"
                                                            }),
                                                            "?"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-wrap gap-8 pt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "font-serif text-3xl text-charcoal-900",
                                                                        children: "3+"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-sm text-charcoal-500",
                                                                        children: "Years Experience"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "font-serif text-3xl text-charcoal-900",
                                                                        children: "10+"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-sm text-charcoal-500",
                                                                        children: "Projects Delivered"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "font-serif text-3xl text-charcoal-900",
                                                                        children: "10K+"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-sm text-charcoal-500",
                                                                        children: "Users Served"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: `transition-all duration-400 ease-in-out ${activeView === 'beyond' ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 absolute inset-0 pointer-events-none'}`,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xl text-charcoal-800 font-medium leading-relaxed",
                                                        children: beyondOffice.tagline
                                                    }),
                                                    beyondOffice.description.map((para, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-charcoal-600 leading-relaxed",
                                                            children: para
                                                        }, index)),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-charcoal-700 italic font-medium",
                                                        children: [
                                                            '"',
                                                            beyondOffice.signOff,
                                                            '"'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex flex-wrap gap-2 pt-2",
                                                        children: beyondOffice.interests.map((interest, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "flex items-center gap-1.5 px-3 py-1.5 bg-cream-200 rounded-full text-sm text-charcoal-700 border border-border-light",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: interest.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        children: interest.name
                                                                    })
                                                                ]
                                                            }, index))
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex flex-wrap gap-8 pt-2",
                                                        children: beyondOffice.stats.map((stat, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "font-serif text-3xl text-charcoal-900",
                                                                        children: stat.value
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "text-sm text-charcoal-500",
                                                                        children: stat.label
                                                                    })
                                                                ]
                                                            }, index))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "relative flex items-center order-1 lg:order-2",
                                children: activeView === 'professional' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-full aspect-[5/7] max-h-[520px] rounded-2xl overflow-hidden bg-gradient-to-br from-cream-200 to-cream-300 border border-border-light",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.avatar,
                                                alt: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name,
                                                className: "w-full h-full object-cover object-top"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-card border border-border-light",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-10 h-10 bg-green-100 rounded-full flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "w-3 h-3 bg-green-500 rounded-full animate-pulse"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-sm font-medium text-charcoal-900",
                                                                children: "Available for work"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-xs text-charcoal-500",
                                                                children: "Open to opportunities"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-full aspect-[3/4] max-h-[720px]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($547dcd7931d7675a$var$CardStack, {
                                                images: personalImages,
                                                isVisible: activeView === 'beyond'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute -top-6 -left-6 bg-white rounded-xl p-4 shadow-card border border-border-light z-50",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-10 h-10 bg-coral-100 rounded-full flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-lg",
                                                            children: "\uD83E\uDDED"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-sm font-medium text-charcoal-900",
                                                                children: "Always exploring"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "text-xs text-charcoal-500",
                                                                children: "New places & ideas"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $547dcd7931d7675a$export$2e2bcd8739ae039 = $547dcd7931d7675a$var$AboutSection;




var $acw62 = parcelRequire("acw62");




const $7c9bf90e29a13b0d$var$ProjectCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(({ project: project, featured: featured = false, detailed: detailed = false })=>{
    const { trackProjectView: trackProjectView, trackClick: trackClick } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const { saveScrollPosition: saveScrollPosition } = (0, $5999fc9953960d3a$export$2e2bcd8739ae039)();
    const handleProjectClick = ()=>{
        saveScrollPosition('homepage');
        trackProjectView(project.title, project.id);
        navigate(`/projects/${project.id}`);
    };
    const handleLinkClick = (linkType, url)=>{
        trackClick(`project_${linkType}`, {
            project_title: project.title,
            project_id: project.id,
            url: url
        });
    };
    // Featured large card
    if (featured) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "group cursor-pointer bg-white border border-border-light rounded-2xl overflow-hidden hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300",
        onClick: handleProjectClick,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "grid md:grid-cols-2 gap-0",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "aspect-[4/3] md:aspect-auto bg-cream-100 overflow-hidden",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: project.cardImage || project.image,
                        alt: project.title,
                        className: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "p-6 md:p-8 flex flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 mb-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "px-2.5 py-1 bg-coral-100 text-coral-600 text-xs font-medium rounded-full",
                                            children: "Featured"
                                        }),
                                        project.year && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-xs text-charcoal-400",
                                            children: project.year
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "font-serif text-2xl text-charcoal-900 mb-3 group-hover:text-coral-600 transition-colors",
                                    children: project.title
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-charcoal-600 mb-4 line-clamp-3",
                                    children: project.description
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-wrap gap-2 mb-6",
                                    children: [
                                        project.technologies.slice(0, 4).map((tech, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "px-2.5 py-1 bg-cream-100 text-charcoal-700 text-xs rounded-full",
                                                children: tech
                                            }, index)),
                                        project.technologies.length > 4 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "px-2.5 py-1 bg-cream-100 text-charcoal-500 text-xs rounded-full",
                                            children: [
                                                "+",
                                                project.technologies.length - 4
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-4 pt-4 border-t border-border-light",
                            children: [
                                project.github && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: project.github,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleLinkClick('github', project.github);
                                    },
                                    className: "flex items-center gap-1.5 text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$1e450c42b77127b1), {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Code"
                                        })
                                    ]
                                }),
                                project.live && !project.playstore && !project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: project.live,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleLinkClick('live', project.live);
                                    },
                                    className: "flex items-center gap-1.5 text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$ef2cff5e0698103f), {
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Live"
                                        })
                                    ]
                                }),
                                project.playstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: project.playstore,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleLinkClick('playstore', project.playstore);
                                    },
                                    className: "flex items-center gap-1.5 text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/images/projects/google-play.svg",
                                            alt: "",
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Play Store"
                                        })
                                    ]
                                }),
                                project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: project.appstore,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleLinkClick('appstore', project.appstore);
                                    },
                                    className: "flex items-center gap-1.5 text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/images/projects/apple-store-app.svg",
                                            alt: "",
                                            className: "w-4 h-4"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "App Store"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "ml-auto text-charcoal-400 group-hover:text-coral-500 transition-colors",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        className: "w-5 h-5",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeWidth: 1.5,
                                            d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    // Standard card
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "group cursor-pointer bg-white border border-border-light rounded-2xl overflow-hidden hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 h-full flex flex-col",
        onClick: handleProjectClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "aspect-[16/10] bg-cream-100 overflow-hidden",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: project.cardImage || project.image,
                    alt: project.title,
                    className: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-5 flex flex-col flex-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex items-center gap-2 mb-2",
                        children: project.year && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs text-charcoal-400",
                            children: project.year
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "font-serif text-lg text-charcoal-900 mb-2 group-hover:text-coral-600 transition-colors",
                        children: project.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-charcoal-600 mb-4 line-clamp-2 flex-1",
                        children: project.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap gap-1.5 mb-4",
                        children: [
                            project.technologies.slice(0, 3).map((tech, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "px-2 py-0.5 bg-cream-100 text-charcoal-600 text-xs rounded-full",
                                    children: tech
                                }, index)),
                            project.technologies.length > 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "px-2 py-0.5 bg-cream-100 text-charcoal-400 text-xs rounded-full",
                                children: [
                                    "+",
                                    project.technologies.length - 3
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3 pt-3 border-t border-border-light mt-auto",
                        children: [
                            project.github && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: project.github,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleLinkClick('github', project.github);
                                },
                                className: "text-xs text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                children: "GitHub"
                            }),
                            project.live && !project.playstore && !project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                href: project.live,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleLinkClick('live', project.live);
                                },
                                className: "text-xs text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                children: "Live"
                            }),
                            project.playstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                href: project.playstore,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleLinkClick('playstore', project.playstore);
                                },
                                className: "flex items-center gap-1 text-xs text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: "/images/projects/google-play.svg",
                                        alt: "",
                                        className: "w-3.5 h-3.5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "Play Store"
                                    })
                                ]
                            }),
                            project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                href: project.appstore,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleLinkClick('appstore', project.appstore);
                                },
                                className: "flex items-center gap-1 text-xs text-charcoal-500 hover:text-charcoal-900 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: "/images/projects/apple-store-app.svg",
                                        alt: "",
                                        className: "w-3.5 h-3.5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "App Store"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "ml-auto text-charcoal-400 group-hover:text-coral-500 transition-colors",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    className: "w-4 h-4",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: 2,
                                        d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var $7c9bf90e29a13b0d$export$2e2bcd8739ae039 = $7c9bf90e29a13b0d$var$ProjectCard;




var $acw62 = parcelRequire("acw62");




const $b63760bb348a45ad$var$ProjectDetail = ({ project: project, onClose: onClose })=>{
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const { trackProjectView: trackProjectView, trackClick: trackClick } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    const { restoreScrollPosition: restoreScrollPosition } = (0, $5999fc9953960d3a$export$2e2bcd8739ae039)();
    (0, $acw62.useEffect)(()=>{
        if (project) trackProjectView(`${project.title}_detail`, project.id);
    }, [
        project,
        trackProjectView
    ]);
    (0, $acw62.useEffect)(()=>{
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);
    const handleLinkClick = (linkType, url)=>{
        trackClick(`project_detail_${linkType}`, {
            project_title: project.title,
            project_id: project.id,
            url: url
        });
    };
    const handleClose = ()=>{
        if (onClose) onClose();
        else {
            // Restore scroll position when navigating back to homepage
            restoreScrollPosition('homepage', {
                delay: 100
            });
            navigate('/');
        }
    };
    if (!project) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen bg-cream-100 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "font-serif text-2xl font-medium text-charcoal-900 mb-4",
                    children: "Project not found"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: handleClose,
                    className: "btn-primary",
                    children: "Back to Home"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-cream-100",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 bg-cream-100/95 backdrop-blur-md border-b border-border-light z-50",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: handleClose,
                            className: "flex items-center space-x-2 text-charcoal-600 hover:text-charcoal-900 transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$8afed21ef5c2afa5), {
                                    className: "w-5 h-5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "hidden sm:inline",
                                    children: "Back to Projects"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sm:hidden",
                                    children: "Back"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center space-x-3",
                            children: [
                                project.year && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-charcoal-500 text-sm",
                                    children: project.year
                                }),
                                project.featured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "bg-coral-500 text-white text-xs px-3 py-1 rounded-full font-medium",
                                    children: "Featured"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-8 sm:mb-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-charcoal-900 mb-4",
                                children: project.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg md:text-xl text-charcoal-600 mb-8 leading-relaxed",
                                children: project.description
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap gap-3 sm:gap-4",
                                children: [
                                    project.github && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: project.github,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('github', project.github),
                                        className: "btn-secondary",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$1e450c42b77127b1), {
                                                className: "w-5 h-5"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "View Code"
                                            })
                                        ]
                                    }),
                                    project.live && !project.playstore && !project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: project.live,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('live', project.live),
                                        className: "btn-primary",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$ef2cff5e0698103f), {
                                                className: "w-5 h-5"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: "Live Demo"
                                            })
                                        ]
                                    }),
                                    project.playstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: project.playstore,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('playstore', project.playstore),
                                        className: "inline-block hover:opacity-80 transition-opacity",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/images/projects/download-playstore.svg",
                                            alt: "Get it on Google Play",
                                            className: "h-[44px] w-[148px] object-contain"
                                        })
                                    }),
                                    project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: project.appstore,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('appstore', project.appstore),
                                        className: "inline-block hover:opacity-80 transition-opacity",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: "/images/projects/download-appstore.svg",
                                            alt: "Download on the App Store",
                                            className: "h-[44px] w-[148px] object-contain"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-8 sm:mb-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "bg-white rounded-2xl overflow-hidden border border-border-light shadow-soft",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: project.image,
                                alt: project.title,
                                className: "w-full h-auto object-contain"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "grid md:grid-cols-3 gap-8 md:gap-12 mb-8 sm:mb-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "font-serif text-xl md:text-2xl font-medium text-charcoal-900 mb-4",
                                        children: "Technologies Used"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-wrap gap-2",
                                        children: project.technologies.map((tech, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "px-3 py-2 bg-cream-200 text-sm rounded-full text-charcoal-700 border border-border-light hover:bg-coral-50 hover:text-coral-600 hover:border-coral-200 transition-colors",
                                                children: tech
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "font-serif text-xl md:text-2xl font-medium text-charcoal-900 mb-4",
                                        children: "Project Info"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-4",
                                        children: [
                                            project.year && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-charcoal-500 text-sm",
                                                        children: "Year"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-charcoal-900 font-medium",
                                                        children: project.year
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-charcoal-500 text-sm",
                                                        children: "Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-charcoal-900 font-medium capitalize",
                                                        children: project.status || 'Completed'
                                                    })
                                                ]
                                            }),
                                            project.featured && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-charcoal-500 text-sm",
                                                        children: "Recognition"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-coral-600 font-medium",
                                                        children: "Featured Project"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    project.longDescription && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-8 sm:mb-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "font-serif text-xl md:text-2xl font-medium text-charcoal-900 mb-4",
                                children: "About This Project"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "prose prose-lg max-w-none",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-charcoal-600 text-base md:text-lg leading-relaxed whitespace-pre-line",
                                    children: project.longDescription
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white rounded-2xl p-6 sm:p-8 border border-border-light shadow-soft",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "font-serif text-xl md:text-2xl font-medium text-charcoal-900 mb-6",
                                children: "Project Links"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "grid sm:grid-cols-2 gap-4",
                                children: [
                                    project.github && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: project.github,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('github', project.github),
                                        className: "flex items-center space-x-3 p-4 bg-cream-100 hover:bg-cream-200 rounded-xl transition-colors border border-border-light",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-10 h-10 flex items-center justify-center rounded-full bg-charcoal-900 text-white",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$1e450c42b77127b1), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-medium text-charcoal-900",
                                                        children: "Source Code"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-charcoal-500",
                                                        children: "View on GitHub"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    project.live && !project.playstore && !project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: project.live,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('live', project.live),
                                        className: "flex items-center space-x-3 p-4 bg-cream-100 hover:bg-cream-200 rounded-xl transition-colors border border-border-light",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-10 h-10 flex items-center justify-center rounded-full bg-coral-500 text-white",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$ef2cff5e0698103f), {
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-medium text-charcoal-900",
                                                        children: "Live Demo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-charcoal-500",
                                                        children: "Try it out"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    project.playstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: project.playstore,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('playstore', project.playstore),
                                        className: "flex items-center space-x-3 p-4 bg-cream-100 hover:bg-cream-200 rounded-xl transition-colors border border-border-light",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-10 h-10 flex items-center justify-center rounded-full bg-cream-200",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: "/images/projects/google-play.svg",
                                                    alt: "",
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-medium text-charcoal-900",
                                                        children: "Google Play Store"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-charcoal-500",
                                                        children: "Download for Android"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    project.appstore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: project.appstore,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: ()=>handleLinkClick('appstore', project.appstore),
                                        className: "flex items-center space-x-3 p-4 bg-cream-100 hover:bg-cream-200 rounded-xl transition-colors border border-border-light",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-10 h-10 flex items-center justify-center rounded-full bg-cream-200",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: "/images/projects/apple-store-app.svg",
                                                    alt: "",
                                                    className: "w-5 h-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-medium text-charcoal-900",
                                                        children: "Apple App Store"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-charcoal-500",
                                                        children: "Download for iOS"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $b63760bb348a45ad$export$2e2bcd8739ae039 = $b63760bb348a45ad$var$ProjectDetail;




var $acw62 = parcelRequire("acw62");
// Centralized Blog Management System
// This file contains all blog data and provides easy methods to manage blog content
const $6b28091c93789046$export$d5c98a2985f912a0 = [
    {
        id: 'flutter',
        name: 'Flutter',
        color: 'bg-blue-500'
    },
    {
        id: 'react',
        name: 'React',
        color: 'bg-cyan-500'
    },
    {
        id: 'javascript',
        name: 'JavaScript',
        color: 'bg-yellow-500'
    },
    {
        id: 'python',
        name: 'Python',
        color: 'bg-green-500'
    },
    {
        id: 'mobile',
        name: 'Mobile Dev',
        color: 'bg-purple-500'
    },
    {
        id: 'web',
        name: 'Web Dev',
        color: 'bg-indigo-500'
    },
    {
        id: 'performance',
        name: 'Performance',
        color: 'bg-red-500'
    },
    {
        id: 'tutorial',
        name: 'Tutorial',
        color: 'bg-orange-500'
    },
    {
        id: 'tips',
        name: 'Tips & Tricks',
        color: 'bg-pink-500'
    }
];
const $6b28091c93789046$export$d09847bb5c97319b = [
    {
        id: 1,
        title: "Your App is Freezing? A Beginner's Guide to Flutter Concurrency \uD83D\uDE80",
        slug: "flutter-concurrency-guide",
        excerpt: "Ever built a Flutter app that stutters or freezes the moment it needs to do some heavy lifting? Learn how to use Flutter's secret weapon\u2014Isolates\u2014to keep everything running smoothly.",
        content: `
            <div class="blog-content">
                <p class="lead">Ever built a Flutter app that stutters or freezes the moment it needs to do some heavy lifting, like processing a large file or making a complex calculation? It's a common problem, but Flutter has a powerful and elegant solution: <strong>concurrency</strong>.</p>
                
                <p>This guide will break down Flutter's approach to concurrency in simple terms. You'll learn why your app's UI freezes and how to use Flutter's secret weapon\u{2014}Isolates\u{2014}to keep everything running smoothly, complete with code examples you can try yourself.</p>

                <h2>Why Your Smooth App Suddenly Gets "Janky"</h2>
                
                <p>Imagine your app's user interface (UI) is a single, incredibly focused worker. This worker has one job: to paint the screen so fast that the user sees a silky-smooth animation. For a 60 frames-per-second (FPS) display, this worker has only <strong>16 milliseconds</strong> to get each frame ready.</p>
                
                <p>If you give this worker a big, time-consuming task\u{2014}like decoding a huge JSON file\u{2014}it gets stuck. It can't update the screen because it's busy with the other task. The result? Your app freezes, frames get dropped, and your users see annoying "jank." This is called <strong>blocking the UI thread</strong>.</p>

                <h2>Meet the Isolate: Flutter's Secret Weapon \u{1F9E0}</h2>
                
                <p>So how do we perform heavy work without freezing the UI? Flutter's solution is brilliant: <strong>don't give the heavy work to the UI worker!</strong> Instead, delegate it.</p>
                
                <p>This is where <strong>Isolates</strong> come in. Think of your app as a restaurant kitchen:</p>
                
                <ul>
                    <li><strong>The Main Isolate (UI Thread):</strong> This is your head chef. Their only job is to assemble the final plates (the UI) and make sure they look perfect and get out to the customer on time.</li>
                    <li><strong>A Background Isolate:</strong> This is a prep cook working at a separate station. The head chef can hand them a ticket (a message) saying, "Chop these 500 onions!" (process this large dataset).</li>
                </ul>
                
                <p>Crucially, each isolate is an independent entity with its own memory and event loop. They don't share memory, which means the prep cook can't accidentally spill sauce on the head chef's finished plate. They communicate only by passing copies of messages back and forth. This design completely eliminates a whole category of complex bugs like race conditions that plague traditional multi-threaded programming.</p>

                <h2>Your Concurrency Toolkit: Which Tool Should You Use?</h2>
                
                <p>Flutter gives you a few tools to handle concurrency. Choosing the right one is key.</p>
                
                <h3>async/await with Futures</h3>
                <p>This is your go-to for I/O operations\u{2014}things where you're waiting for something from outside your app, like a network request. It frees up the UI thread to do other things while it waits, but the work itself doesn't run in parallel.</p>
                
                <pre><code class="language-dart">Future&lt;void&gt; fetchUserData() async {
  print("Fetching user data...");
  // Await frees the UI thread while waiting for the network response.
  final response = await http.get(Uri.parse('https://api.example.com/user'));
  print("Data fetched!");
  // Continue with the response data...
}</code></pre>

                <h3>Isolate.run()</h3>
                <p>This is the modern, recommended way to handle short-lived, CPU-intensive tasks. It spins up a new isolate, runs your heavy function there, and returns the result. It's perfect for that one-off, heavy calculation that would otherwise freeze your UI.</p>
                
                <pre><code class="language-dart">// A "heavy" function that would block the UI thread.
String complexCalculation(int value) {
  int total = 0;
  for (var i = 0; i < value; i++) {
    total += i; // Simulating heavy work
  }
  return "Result: $total";
}

// Run it in an isolate to keep the UI smooth.
final result = await Isolate.run(() => complexCalculation(1000000000));
print(result);</code></pre>

                <h2>Practical Example: Fixing a Frozen UI</h2>
                
                <p>Let's look at a real-world scenario. Research shows that parsing a JSON dataset larger than 1MB on the main thread will consistently cause frame drops.</p>
                
                <p>Here is a simple app with two buttons. One demonstrates the wrong way (blocking the UI), and the other shows the correct way using an isolate.</p>
                
                <pre><code class="language-dart">import 'dart:isolate';
import 'package:flutter/material.dart';
import 'dart:convert';

// This function simulates a heavy task, like parsing a giant JSON file.
// It must be a top-level function or a static method to be used in an isolate.
String parseLargeJson(String jsonString) {
  // Simulate a delay to represent heavy processing.
  var total = 0;
  for (var i = 0; i < 1000000000; i++) {
    total += i;
  }
  // In a real app, you would do: final data = jsonDecode(jsonString);
  return "JSON Parsed Successfully!";
}

class ConcurrencyExample extends StatefulWidget {
  const ConcurrencyExample({super.key});

  @override
  State&lt;ConcurrencyExample&gt; createState() => _ConcurrencyExampleState();
}

class _ConcurrencyExampleState extends State&lt;ConcurrencyExample&gt; {
  String _statusText = "Ready";

  Future&lt;void&gt; _runOnMainThread() async {
    setState(() {
      _statusText = "Processing on Main Thread... UI will freeze!";
    });
    // This blocks the UI thread. Try clicking around the app while this runs.
    final result = parseLargeJson("some_huge_json_string");
    setState(() {
      _statusText = result;
    });
  }

  Future&lt;void&gt; _runInIsolate() async {
    setState(() {
      _statusText = "Processing in Isolate... UI is responsive!";
    });
    // This offloads the work to another isolate and awaits the result.
    // The UI remains completely responsive.
    final result = await Isolate.run(() => parseLargeJson("some_huge_json_string"));
    setState(() {
      _statusText = result;
    });
  }

  @override
  Widget build(BuildContext context) {
    return Scaffold(
      appBar: AppBar(title: const Text("Concurrency Demo")),
      body: Center(
        child: Column(
          mainAxisAlignment: MainAxisAlignment.center,
          children: [
            Text(_statusText, style: Theme.of(context).textTheme.headlineSmall),
            const SizedBox(height: 20),
            ElevatedButton(
              onPressed: _runOnMainThread,
              child: const Text("Run on Main Thread (Bad)"),
            ),
            const SizedBox(height: 10),
            ElevatedButton(
              onPressed: _runInIsolate,
              child: const Text("Run in Isolate (Good)"),
            ),
            const SizedBox(height: 20),
            const CircularProgressIndicator(), // You'll see this freeze with the "Bad" button!
          ],
        ),
      ),
    );
  }
}</code></pre>
                
                <p>When you run this code and tap the "Bad" button, you'll notice the entire UI, including the loading indicator, freezes solid. Tap the "Good" button, and the app remains perfectly smooth while the work happens in the background.</p>

                <h2>How to Spot Performance Issues \u{1F575}\u{FE0F}</h2>
                
                <p>You don't have to guess where your app is slow. Flutter provides amazing tools to help you.</p>
                
                <ul>
                    <li><strong>Flutter DevTools:</strong> Use the Performance view to identify "janky frames" and find out exactly what caused them.</li>
                    <li><strong>Profile in Release Mode:</strong> Always test performance on a physical device in release mode. Debug mode adds significant overhead that can give you misleading results.</li>
                </ul>

                <h2>Conclusion: Work Smart, Not Hard</h2>
                
                <p>Flutter's concurrency model may seem different, but it's designed for safety and simplicity. By understanding its core ideas, you can build incredibly performant and responsive applications.</p>
                
                <p>Remember the key takeaways:</p>
                <ol>
                    <li>Your UI runs on a single main isolate and must not be blocked.</li>
                    <li>For any heavy computation, delegate it to a background isolate using Isolate.run().</li>
                    <li>Keep your app smooth, your users happy, and your code clean.</li>
                </ol>
                
                <p><strong>Happy coding!</strong> \u{1F680}</p>
            </div>
        `,
        category: 'flutter',
        tags: [
            'Flutter',
            'Performance',
            'Concurrency',
            'Isolates',
            'Mobile Development'
        ],
        author: 'Manav Gupta',
        publishedAt: '2025-08-04T10:00:00Z',
        updatedAt: '2025-08-04T10:00:00Z',
        readTime: '8 min read',
        featured: false,
        image: '/images/blog/isolates_cover.png',
        likes: 45,
        comments: 12,
        views: 555,
        seo: {
            metaTitle: "Flutter Concurrency Guide: Fix Freezing Apps with Isolates",
            metaDescription: "Learn how to fix freezing Flutter apps using Isolates. Complete guide to Flutter concurrency with practical examples and best practices.",
            keywords: [
                "Flutter",
                "Concurrency",
                "Isolates",
                "Performance",
                "Mobile Development",
                "Dart"
            ]
        }
    },
    {
        id: 2,
        title: "\u2728 Flutter App Branding: Transform Your App with Custom Icons & Splash Screens",
        slug: "flutter-app-branding-icons-splash-screens",
        excerpt: "First impressions matter in the competitive world of mobile apps. Learn how to transform your Flutter app from generic to gorgeous with custom icons and splash screens using automated tools.",
        content: `
            <div class="blog-content">
                <p class="lead">First impressions matter\u{2014}especially in the competitive world of mobile apps. When users download your Flutter application, the very first elements they encounter are your app icon on their home screen and the initial splash screen that greets them during launch. These seemingly small details can make or break that crucial first impression.</p>
                
                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/split-screen-comparison.png" alt="Split screen showing generic Flutter app vs professionally branded app" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Split screen showing generic Flutter app vs professionally branded app with custom icon and splash</p>
                </div>

                <p>A polished app icon doesn't just identify your application; it's a powerful branding tool that helps your app stand out in a sea of competitors. Meanwhile, a thoughtfully designed splash screen transforms what could be an awkward loading moment into an opportunity to reinforce your brand and create anticipation for your app's content.</p>

                <p>But here's the challenge: manually creating and configuring all the different icon sizes for Android and iOS, along with setting up native splash screens, can be incredibly tedious and error-prone. Each platform has its own maze of requirements for image dimensions, formats, and naming conventions.</p>

                <p>Fear not! Today, we'll explore two game-changing packages that automate this entire process: <code>flutter_launcher_icons</code> and <code>flutter_native_splash</code>. By the end of this guide, you'll have transformed your app from generic to gorgeous in just a few simple steps.</p>

                <h2>\u{1F680} Part 1: Master Your App's Launcher Icon</h2>
                
                <p>Your app icon is your brand's ambassador on every user's device. The <code>flutter_launcher_icons</code> package eliminates the tedious manual work by automatically generating all required icon sizes from a single, high-resolution source image.</p>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/icon-generation-diagram.png" alt="Diagram showing one source icon being transformed into multiple sizes" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Diagram showing one source icon being transformed into multiple sizes for different platforms</p>
                </div>

                <h3>Step 1: Add the Dependency</h3>
                
                <p>First, add <code>flutter_launcher_icons</code> to your <code>dev_dependencies</code> in your <code>pubspec.yaml</code> file. We use <code>dev_dependencies</code> because this is a development tool\u{2014}its code won't be included in your production build.</p>

                <pre><code class="language-yaml">dev_dependencies:
  flutter_test:
    sdk: flutter
  flutter_launcher_icons: "^0.13.1"</code></pre>

                <h3>Step 2: Prepare Your Icon Asset</h3>
                
                <p>Before configuring the package, ensure you have a high-quality source icon ready:</p>
                
                <ul>
                    <li><strong>Resolution</strong>: 1024x1024 pixels minimum</li>
                    <li><strong>Format</strong>: PNG with transparent background</li>
                    <li><strong>Design</strong>: Simple, recognizable, and scalable</li>
                    <li><strong>Location</strong>: Store it in <code>assets/icon/icon.png</code></li>
                </ul>

                <div class="video-container bg-gray-800 rounded-lg overflow-hidden my-6">
                    <div class="aspect-video">
                        <iframe 
                            src="https://www.youtube.com/embed/oa_LYHAAbIk" 
                            title="Icon Design Principles by Michael Flarup"
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowfullscreen
                            class="w-full h-full"
                        ></iframe>
                    </div>
                    <p class="text-sm text-gray-400 mt-2 px-4 pb-4">Icon design principles by Michael Flarup - learn professional icon design techniques</p>
                </div>

                <div class="bg-blue-900/30 border border-blue-700 rounded-lg p-4 my-6">
                    <p class="text-blue-200 font-semibold mb-2">\u{1F4A1} Pro Tip:</p>
                    <p class="text-blue-100">For iOS, consider creating a version without transparency, as iOS sometimes handles opaque icons better for certain use cases.</p>
                </div>

                <h3>Step 3: Configure Your Icons (Recommended Approach)</h3>
                
                <p>Create a separate configuration file for cleaner project organization:</p>
                
                <p>Create <code>flutter_launcher_icons.yaml</code> in your project root:</p>

                <pre><code class="language-yaml"># flutter_launcher_icons.yaml
flutter_launcher_icons:
  # Generate icons for both platforms
  android: "launcher_icon"
  ios: true
  image_path: "assets/icon/icon.png"
  
  # Minimum Android SDK version for compatibility
  min_sdk_android: 21
  
  # Modern Android adaptive icons (optional but recommended)
  adaptive_icon_background: "#ffffff"
  adaptive_icon_foreground: "assets/icon/foreground.png"
  
  # Remove old launcher icon (clean up)
  remove_alpha_ios: true</code></pre>

                <p><strong>Understanding Adaptive Icons:</strong> Android's adaptive icons consist of two layers\u{2014}background and foreground. This allows the system to apply different shapes and visual effects.</p>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/adaptive-icons-explanation.png" alt="Visual explanation of Android adaptive icons" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Visual explanation of Android adaptive icons - background + foreground = final icon with different shapes</p>
                </div>

                <h3>Step 4: Generate Your Icons</h3>
                
                <p>Run these commands in your terminal:</p>

                <pre><code class="language-bash"># Install dependencies
flutter pub get

# Generate icons using your configuration file
dart run flutter_launcher_icons -f flutter_launcher_icons.yaml</code></pre>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/terminal-success-output.png" alt="Terminal screenshot showing successful icon generation" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Terminal screenshot showing successful icon generation output</p>
                </div>

                <p>That's it! Your custom icons are now generated and placed in the correct directories for both Android and iOS.</p>

                <h3>Step 5: Test Your New Icons</h3>
                
                <ol>
                    <li><strong>Uninstall</strong> your app from the device/emulator</li>
                    <li><strong>Run</strong> <code>flutter clean</code></li>
                    <li><strong>Reinstall</strong> the app: <code>flutter run</code></li>
                    <li><strong>Check</strong> your home screen for the new icon</li>
                </ol>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{1F4F1} Before/After Comparison</div>
                    <p class="text-gray-400">Your home screen will show the transformation from the default Flutter icon to your custom branded icon after following these steps.</p>
                </div>

                <h2>\u{1F30A} Part 2: Create a Stunning Native Splash Screen</h2>
                
                <p>The splash screen is your app's opening act. A well-designed splash screen transforms loading time from a frustration into an opportunity to showcase your brand and build anticipation.</p>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{1F30A} Splash Screen Transformation</div>
                    <p class="text-gray-400">Transform the default white loading screen into a branded splash screen that reflects your app's identity and creates a professional first impression.</p>
                </div>

                <h3>Step 1: Add the Dependency</h3>
                
                <p>Add <code>flutter_native_splash</code> to your regular dependencies:</p>

                <pre><code class="language-yaml">dependencies:
  flutter:
    sdk: flutter
  flutter_native_splash: ^2.4.0</code></pre>

                <h3>Step 2: Design Your Splash Assets</h3>
                
                <p>Create your splash screen assets:</p>
                <ul>
                    <li><strong>Main image</strong>: <code>assets/splash.png</code> (recommended size: 400x400px)</li>
                    <li><strong>Dark mode image</strong>: <code>assets/splash_dark.png</code> (optional)</li>
                    <li><strong>Background color</strong>: Choose colors that match your brand</li>
                </ul>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/splash-assets-example.png" alt="Example splash screen assets - light and dark mode versions" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Example splash screen assets - light and dark mode versions</p>
                </div>

                <h3>Step 3: Configure Your Splash Screen</h3>
                
                <p>Create <code>flutter_native_splash.yaml</code> in your project root:</p>

                <pre><code class="language-yaml"># flutter_native_splash.yaml
flutter_native_splash:
  # Background color (hex format)
  color: "#FFFFFF"
  image: assets/splash.png
  
  # Dark mode support (optional but recommended)
  color_dark: "#121212"
  image_dark: assets/splash_dark.png
  
  # Android 12+ support (crucial for modern devices)
  android_12:
    image: assets/splash.png
    icon_background_color: "#FFFFFF"
    image_dark: assets/splash_dark.png
    icon_background_color_dark: "#121212"
    
  # Web support (optional)
  web: false
  
  # Image positioning
  android_gravity: center
  ios_content_mode: center
  
  # Full screen splash (removes status bar)
  fullscreen: true</code></pre>

                <p><strong>Understanding Android 12+ Requirements:</strong> Google introduced new splash screen APIs in Android 12, requiring specific configuration for modern devices.</p>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/android-12-splash-structure.png" alt="Diagram showing Android 12 splash screen structure" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Diagram showing Android 12 splash screen structure</p>
                </div>

                <h3>Step 4: Generate Your Splash Screen</h3>

                <pre><code class="language-bash"># Install dependencies
flutter pub get

# Generate splash screen files
dart run flutter_native_splash:create --path=flutter_native_splash.yaml</code></pre>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/splash-terminal-output.png" alt="Terminal output showing successful splash screen generation" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Terminal output showing successful splash screen generation</p>
                </div>

                <h3>Step 5: Advanced Control (Optional)</h3>
                
                <p>For apps that need initialization time, you can control when the splash screen disappears:</p>
                
                <p>Update your <code>main.dart</code>:</p>

                <pre><code class="language-dart">import 'package:flutter/material.dart';
import 'package:flutter_native_splash/flutter_native_splash.dart';

void main() {
  // Preserve splash screen until initialization is complete
  WidgetsBinding widgetsBinding = WidgetsFlutterBinding.ensureInitialized();
  FlutterNativeSplash.preserve(widgetsBinding: widgetsBinding);
  
  runApp(const MyApp());
}

class MyApp extends StatelessWidget {
  const MyApp({super.key});

  @override
  Widget build(BuildContext context) {
    return MaterialApp(
      title: 'My App',
      home: const SplashHandler(),
    );
  }
}

class SplashHandler extends StatefulWidget {
  const SplashHandler({super.key});

  @override
  State&lt;SplashHandler&gt; createState() => _SplashHandlerState();
}

class _SplashHandlerState extends State&lt;SplashHandler&gt; {
  @override
  void initState() {
    super.initState();
    _initializeApp();
  }

  void _initializeApp() async {
    // Perform your initialization tasks here
    await Future.wait([
      _loadUserPreferences(),
      _initializeDatabase(),
      _fetchInitialData(),
    ]);
    
    // Remove splash screen when ready
    FlutterNativeSplash.remove();
  }

  Future&lt;void&gt; _loadUserPreferences() async {
    // Simulate loading user preferences
    await Future.delayed(const Duration(seconds: 1));
  }

  Future&lt;void&gt; _initializeDatabase() async {
    // Simulate database initialization
    await Future.delayed(const Duration(seconds: 1));
  }

  Future&lt;void&gt; _fetchInitialData() async {
    // Simulate API call
    await Future.delayed(const Duration(seconds: 1));
  }

  @override
  Widget build(BuildContext context) {
    return const HomeScreen();
  }
}</code></pre>

                <div class="image-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <img src="/images/blog/flutter-branding/splash-lifecycle-diagram.png" alt="Flow diagram showing splash screen lifecycle with initialization steps" class="w-full rounded-lg" />
                    <p class="text-sm text-gray-400 mt-2">Flow diagram showing splash screen lifecycle with initialization steps</p>
                </div>

                <h2>\u{1F9EA} Testing Your Branding Changes</h2>
                
                <h3>Comprehensive Testing Checklist:</h3>
                
                <ol>
                    <li><strong>Platform Testing</strong>
                        <ul>
                            <li>Test on both Android and iOS devices</li>
                            <li>Verify different screen densities and sizes</li>
                            <li>Check tablet and phone layouts</li>
                        </ul>
                    </li>
                    <li><strong>Mode Testing</strong>
                        <ul>
                            <li>Test light and dark themes</li>
                            <li>Verify splash screen in both modes</li>
                            <li>Check system UI integration</li>
                        </ul>
                    </li>
                </ol>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{1F9EA} Multi-Device Testing</div>
                    <p class="text-gray-400">Test your branding changes across different devices, screen sizes, orientations, and both light/dark modes to ensure consistency.</p>
                </div>

                <h3>Common Issues & Quick Fixes:</h3>
                
                <div class="bg-yellow-900/30 border border-yellow-700 rounded-lg p-4 my-4">
                    <p class="text-yellow-200 font-semibold">\u{1F527} Icons not updating?</p>
                    <pre><code class="language-bash">flutter clean
flutter pub get
# Uninstall app from device
flutter run</code></pre>
                </div>

                <div class="bg-yellow-900/30 border border-yellow-700 rounded-lg p-4 my-4">
                    <p class="text-yellow-200 font-semibold">\u{1F527} Splash screen not appearing on iOS?</p>
                    <ul class="text-yellow-100 mt-2">
                        <li>Verify iOS deployment target is 11.0+</li>
                        <li>Check Info.plist modifications</li>
                        <li>Rebuild the entire project</li>
                    </ul>
                </div>

                <div class="bg-yellow-900/30 border border-yellow-700 rounded-lg p-4 my-4">
                    <p class="text-yellow-200 font-semibold">\u{1F527} Android 12+ splash issues?</p>
                    <ul class="text-yellow-100 mt-2">
                        <li>Ensure <code>android_12</code> section is properly configured</li>
                        <li>Verify target SDK version is 31+</li>
                        <li>Test on actual Android 12+ device</li>
                    </ul>
                </div>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{1F527} Troubleshooting Guide</div>
                    <p class="text-gray-400">Compare your results with expected outcomes. Issues are usually resolved by cleaning your build, uninstalling the app, and rebuilding from scratch.</p>
                </div>

                <h2>\u{1F3A8} Design Best Practices</h2>
                
                <h3>Icon Design Guidelines:</h3>
                
                <ol>
                    <li><strong>Simplicity is Key</strong>
                        <ul>
                            <li>Use simple, recognizable shapes</li>
                            <li>Avoid text in icons (it becomes unreadable at small sizes)</li>
                            <li>Ensure good contrast and visibility</li>
                        </ul>
                    </li>
                    <li><strong>Platform Considerations</strong>
                        <ul>
                            <li>iOS prefers filled, rounded designs</li>
                            <li>Android works well with adaptive icons</li>
                            <li>Consider how icons look with different wallpapers</li>
                        </ul>
                    </li>
                </ol>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{1F3A8} Icon Design Examples</div>
                    <p class="text-gray-400">Good icons are simple, recognizable at small sizes, and use clear contrast. Avoid text, complex details, and ensure visibility on different backgrounds.</p>
                </div>

                <h3>Splash Screen Design Tips:</h3>
                
                <ol>
                    <li><strong>Brand Consistency</strong>
                        <ul>
                            <li>Use your brand colors and typography</li>
                            <li>Include your logo or key brand element</li>
                            <li>Maintain consistency with your app's UI theme</li>
                        </ul>
                    </li>
                    <li><strong>Loading Experience</strong>
                        <ul>
                            <li>Keep animations subtle and non-distracting</li>
                            <li>Consider showing progress indicators for longer loads</li>
                            <li>Ensure smooth transition to main app</li>
                        </ul>
                    </li>
                </ol>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{2728} Splash Design Inspiration</div>
                    <p class="text-gray-400">Study popular apps for inspiration. Great splash screens use brand colors, simple animations, and create anticipation while loading.</p>
                </div>

                <h2>\u{1F3AF} Conclusion</h2>
                
                <p>Congratulations! You've successfully transformed your Flutter app from generic to professionally branded. Your custom icon now represents your brand on users' home screens, while your splash screen creates a polished first impression that sets the tone for the entire user experience.</p>

                <p><strong>Key Takeaways:</strong></p>
                <ul>
                    <li>Professional branding starts with the first user interaction</li>
                    <li>Automation tools save time and reduce errors</li>
                    <li>Testing across platforms and modes is crucial</li>
                    <li>Good design principles apply to both icons and splash screens</li>
                </ul>

                <div class="info-placeholder bg-gray-800 rounded-lg p-8 text-center my-6">
                    <div class="text-gray-300 text-lg font-semibold mb-2">\u{1F389} Final Transformation</div>
                    <p class="text-gray-400">Your app now has professional branding! Compare your before/after results - from generic Flutter defaults to a polished, branded experience.</p>
                </div>

                <h3>What's Next?</h3>
                
                <p>Consider extending your branding efforts to:</p>
                <ul>
                    <li>App store screenshots and metadata</li>
                    <li>In-app UI consistency</li>
                    <li>Push notification icons</li>
                    <li>App widgets and shortcuts</li>
                </ul>

                <hr class="border-gray-700 my-8" />

                <h3>Resources & References:</h3>
                
                <ul>
                    <li><a href="https://pub.dev/packages/flutter_launcher_icons" class="text-blue-400 hover:text-blue-300">flutter_launcher_icons package</a></li>
                    <li><a href="https://pub.dev/packages/flutter_native_splash" class="text-blue-400 hover:text-blue-300">flutter_native_splash package</a></li>
                    <li><a href="https://material.io/design/iconography/product-icons.html" class="text-blue-400 hover:text-blue-300">Material Design Icon Guidelines</a></li>
                    <li><a href="https://developer.apple.com/design/human-interface-guidelines/app-icons" class="text-blue-400 hover:text-blue-300">iOS Human Interface Guidelines</a></li>
                </ul>

                <div class="bg-gray-800 rounded-lg p-6 mt-8">
                    <p class="text-gray-300 italic">Found this tutorial helpful? Share it with your fellow Flutter developers and let me know in the comments what branding challenges you've faced with your Flutter apps!</p>
                </div>
            </div>
        `,
        category: 'flutter',
        tags: [
            'Flutter',
            'App Design',
            'Branding',
            'Tutorial',
            'Icons',
            'Splash Screen',
            'Mobile Development'
        ],
        author: 'Manav Gupta',
        publishedAt: '2025-09-02T10:00:00Z',
        updatedAt: '2025-09-02T10:00:00Z',
        readTime: '12 min read',
        featured: true,
        image: '/images/blog/flutter-branding/cover.png',
        likes: 0,
        comments: 0,
        views: 0,
        seo: {
            metaTitle: "Flutter App Branding: Transform Your App with Custom Icons & Splash Screens",
            metaDescription: "Learn how to transform your Flutter app from generic to gorgeous with custom icons and splash screens using automated tools. Complete guide with step-by-step instructions.",
            keywords: [
                "Flutter",
                "App Branding",
                "Custom Icons",
                "Splash Screens",
                "Mobile Development",
                "flutter_launcher_icons",
                "flutter_native_splash",
                "App Design"
            ]
        }
    }
];
class $6b28091c93789046$export$facabe505213462b {
    // Get all published blog posts
    static getAllPosts() {
        return $6b28091c93789046$export$d09847bb5c97319b.filter((post)=>post.publishedAt);
    }
    // Get featured blog posts
    static getFeaturedPosts() {
        return $6b28091c93789046$export$d09847bb5c97319b.filter((post)=>post.featured && post.publishedAt);
    }
    // Get blog post by slug
    static getPostBySlug(slug) {
        return $6b28091c93789046$export$d09847bb5c97319b.find((post)=>post.slug === slug);
    }
    // Get blog post by ID
    static getPostById(id) {
        return $6b28091c93789046$export$d09847bb5c97319b.find((post)=>post.id === id);
    }
    // Get posts by category
    static getPostsByCategory(categoryId) {
        return $6b28091c93789046$export$d09847bb5c97319b.filter((post)=>post.category === categoryId && post.publishedAt);
    }
    // Get posts by tag
    static getPostsByTag(tag) {
        return $6b28091c93789046$export$d09847bb5c97319b.filter((post)=>post.tags.includes(tag) && post.publishedAt);
    }
    // Get recent posts
    static getRecentPosts(limit = 5) {
        return $6b28091c93789046$export$d09847bb5c97319b.filter((post)=>post.publishedAt).sort((a, b)=>new Date(b.publishedAt) - new Date(a.publishedAt)).slice(0, limit);
    }
    // Search posts
    static searchPosts(query) {
        const searchTerm = query.toLowerCase();
        return $6b28091c93789046$export$d09847bb5c97319b.filter((post)=>{
            return post.publishedAt && (post.title.toLowerCase().includes(searchTerm) || post.excerpt.toLowerCase().includes(searchTerm) || post.tags.some((tag)=>tag.toLowerCase().includes(searchTerm)));
        });
    }
    // Get category by ID
    static getCategoryById(id) {
        return $6b28091c93789046$export$d5c98a2985f912a0.find((cat)=>cat.id === id);
    }
    // Get all categories
    static getAllCategories() {
        return $6b28091c93789046$export$d5c98a2985f912a0;
    }
    // Get categories with post counts
    static getCategoriesWithCounts() {
        return $6b28091c93789046$export$d5c98a2985f912a0.map((category)=>({
                ...category,
                postCount: this.getPostsByCategory(category.id).length
            }));
    }
}
const $6b28091c93789046$export$59045a6a19b9998 = (postData)=>{
    const newPost = {
        id: Math.max(...$6b28091c93789046$export$d09847bb5c97319b.map((p)=>p.id)) + 1,
        slug: postData.title.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-'),
        publishedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        author: 'Manav Gupta',
        likes: 0,
        comments: 0,
        views: 0,
        featured: false,
        ...postData
    };
    $6b28091c93789046$export$d09847bb5c97319b.push(newPost);
    return newPost;
};
const $6b28091c93789046$export$2f3a3db780156302 = {
    posts: $6b28091c93789046$export$d09847bb5c97319b,
    categories: $6b28091c93789046$export$d5c98a2985f912a0
};






parcelRequire("acw62");


const $4ec3ac4fc62c3a07$var$NotFound = ({ type: type = 'page' })=>{
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const handleGoHome = ()=>{
        navigate('/');
    };
    const getMessage = ()=>{
        switch(type){
            case 'blog':
                return {
                    title: "Blog Post Not Found",
                    description: "The blog post you're looking for doesn't exist or has been moved.",
                    suggestion: "Check out our latest blog posts instead."
                };
            default:
                return {
                    title: "Page Not Found",
                    description: "The page you're looking for doesn't exist.",
                    suggestion: "Return to the main portfolio."
                };
        }
    };
    const message = getMessage();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-screen bg-cream-100 flex items-center justify-center px-4",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center max-w-md",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "font-serif text-8xl font-medium text-coral-500/30 mb-2 select-none",
                    children: "404"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "font-serif text-2xl md:text-3xl font-medium text-charcoal-900 mb-4",
                    children: message.title
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-charcoal-600 mb-2",
                    children: message.description
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-charcoal-500 text-sm mb-8",
                    children: message.suggestion
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col sm:flex-row items-center justify-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: handleGoHome,
                            className: "btn-primary w-full sm:w-auto",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$8afed21ef5c2afa5), {
                                    className: "w-4 h-4"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "Go to Portfolio"
                                })
                            ]
                        }),
                        type === 'blog' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>navigate('/#blog'),
                            className: "btn-secondary w-full sm:w-auto",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "View All Blogs"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $4ec3ac4fc62c3a07$export$2e2bcd8739ae039 = $4ec3ac4fc62c3a07$var$NotFound;


const $342ef3d50c583ce5$var$BlogDetail = ({ slug: slug, onClose: onClose })=>{
    const [blog, setBlog] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [startTime, setStartTime] = (0, $acw62.useState)(null);
    const { trackBlogRead: trackBlogRead, trackPageView: trackPageView, trackBlogEngagement: trackBlogEngagement } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    // Use the same approach as homepage for consistency
    const { viewCounts: viewCounts, loading: viewCountsLoading } = (0, $d4d0c408c580b9ca$export$49ebdf47eb43791a)();
    // Calculate view count using same logic as homepage blog cards
    const viewCount = blog && viewCounts[blog.slug] !== undefined ? viewCounts[blog.slug] : blog?.views || 0;
    const isRealData = blog && viewCounts[blog.slug] !== undefined;
    (0, $acw62.useEffect)(()=>{
        const fetchBlog = ()=>{
            setLoading(true);
            // Simulate API call delay
            setTimeout(()=>{
                const blogPost = (0, $6b28091c93789046$export$facabe505213462b).getPostBySlug(slug);
                setBlog(blogPost);
                setLoading(false);
                // Track blog view event when blog loads successfully
                if (blogPost) {
                    trackBlogRead(blogPost.id, blogPost.title, slug);
                    trackPageView(`blog_detail_${blogPost.id}`, {
                        blog_id: blogPost.id,
                        blog_title: blogPost.title,
                        blog_slug: slug,
                        blog_category: blogPost.category
                    });
                    setStartTime(Date.now());
                }
            }, 100);
        };
        if (slug) fetchBlog();
    }, [
        slug
    ]); // Removed trackBlogRead and trackPageView from dependencies
    // Track reading time when component unmounts or user navigates away
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (startTime && blog) {
                const readingTime = Math.round((Date.now() - startTime) / 1000); // in seconds
                if (readingTime > 5) trackBlogEngagement(blog.id, slug, 'reading_time', {
                    reading_time_seconds: readingTime,
                    blog_title: blog.title
                });
            }
        };
    }, [
        startTime,
        blog,
        slug
    ]); // Removed trackBlogEngagement from dependencies
    const handleShare = async ()=>{
        if (navigator.share && blog) try {
            await navigator.share({
                title: blog.title,
                text: blog.excerpt,
                url: window.location.href
            });
            trackBlogEngagement(blog.id, slug, 'shared', {
                share_method: 'native_share',
                blog_title: blog.title
            });
        } catch (err) {
            // Fallback to clipboard
            navigator.clipboard.writeText(window.location.href);
            trackBlogEngagement(blog.id, slug, 'shared', {
                share_method: 'clipboard',
                blog_title: blog.title
            });
        }
        else {
            // Fallback to clipboard
            navigator.clipboard.writeText(window.location.href);
            trackBlogEngagement(blog.id, slug, 'shared', {
                share_method: 'clipboard',
                blog_title: blog.title
            });
        }
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-cream-100 z-50 flex items-center justify-center",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "animate-spin rounded-full h-12 w-12 border-b-2 border-coral-500"
        })
    });
    if (!blog) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ec3ac4fc62c3a07$export$2e2bcd8739ae039), {
        type: "blog"
    });
    const category = (0, $6b28091c93789046$export$facabe505213462b).getCategoryById(blog.category);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "fixed inset-0 bg-cream-100 z-50 overflow-y-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 bg-cream-100/95 backdrop-blur-md border-b border-border-light z-10",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: onClose,
                            className: "flex items-center space-x-2 text-charcoal-600 hover:text-charcoal-900 transition-colors",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$8afed21ef5c2afa5), {
                                    className: "w-5 h-5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "hidden sm:inline",
                                    children: "Back to Home"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "sm:hidden",
                                    children: "Back"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center space-x-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: handleShare,
                                className: "flex items-center space-x-2 px-3 py-2 rounded-full text-charcoal-600 hover:text-charcoal-900 hover:bg-cream-200 transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$40148c7db598e4e0), {
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "hidden sm:inline",
                                        children: "Share"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                className: "max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                        className: "mb-8 sm:mb-12",
                        children: [
                            category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "inline-block px-3 py-1 text-sm font-medium text-white rounded-full bg-coral-500",
                                    children: category.name
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-charcoal-900 mb-6 leading-tight",
                                children: blog.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg sm:text-xl text-charcoal-600 mb-6 leading-relaxed",
                                children: blog.excerpt
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-4 sm:gap-6 text-sm text-charcoal-500 mb-8 pb-8 border-b border-border-light",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center space-x-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: "/images/profile/image.webp",
                                                alt: blog.author,
                                                className: "w-8 h-8 object-cover rounded-lg"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium text-charcoal-700",
                                                children: blog.author
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center space-x-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$8099ab97743c966c), {
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: blog.readTime
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center space-x-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$4b2c798a70974642), {
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: viewCountsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "animate-pulse",
                                                    children: "Loading..."
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        (viewCount || 0).toLocaleString(),
                                                        " views",
                                                        isRealData && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-coral-500 ml-1 text-xs",
                                                            children: "\u2022"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("time", {
                                        dateTime: blog.publishedAt,
                                        className: "text-charcoal-500",
                                        children: new Date(blog.publishedAt).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })
                                    })
                                ]
                            }),
                            blog.image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "mb-8 sm:mb-12 rounded-2xl overflow-hidden border border-border-light",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: blog.image,
                                    alt: blog.title,
                                    className: "w-full h-64 md:h-96 object-cover"
                                })
                            }),
                            blog.tags && blog.tags.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-wrap gap-2 mb-8",
                                children: blog.tags.map((tag, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "px-3 py-1 bg-cream-200 text-charcoal-700 text-sm rounded-full hover:bg-coral-50 hover:text-coral-600 transition-colors",
                                        children: [
                                            "#",
                                            tag
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "prose prose-lg max-w-none prose-headings:font-serif prose-headings:text-charcoal-900 prose-headings:font-medium prose-p:text-charcoal-800 prose-p:leading-relaxed prose-a:text-coral-600 prose-a:no-underline hover:prose-a:text-coral-700 prose-strong:text-charcoal-900 prose-code:text-coral-600 prose-code:bg-cream-200 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-pre:bg-charcoal-900 prose-pre:text-cream-100 prose-blockquote:border-l-coral-500 prose-blockquote:text-charcoal-700 prose-blockquote:italic prose-li:text-charcoal-800 prose-img:rounded-xl prose-img:border prose-img:border-border-light [&>p]:text-charcoal-800 [&>ul]:text-charcoal-800 [&>ol]:text-charcoal-800",
                        dangerouslySetInnerHTML: {
                            __html: blog.content
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
                        className: "mt-12 sm:mt-16 pt-8 border-t border-border-light",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center space-x-2 text-charcoal-500",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$4b2c798a70974642), {
                                            className: "w-5 h-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: viewCountsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "animate-pulse",
                                                children: "Loading..."
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    (viewCount || 0).toLocaleString(),
                                                    " views",
                                                    isRealData && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-coral-500 ml-1 text-xs",
                                                        children: "\u2022 Live"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: handleShare,
                                    className: "flex items-center space-x-2 px-4 py-2 rounded-full border border-border-light text-charcoal-600 hover:text-charcoal-900 hover:border-charcoal-900 hover:bg-charcoal-900 hover:text-white transition-all",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$40148c7db598e4e0), {
                                            className: "w-5 h-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Share Article"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $342ef3d50c583ce5$export$2e2bcd8739ae039 = $342ef3d50c583ce5$var$BlogDetail;




var $acw62 = parcelRequire("acw62");




const $9028fc189c229d5b$var$Shelf = ()=>{
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const { trackPageView: trackPageView } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    const { books: books, papers: papers } = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).shelf;
    (0, $acw62.useEffect)(()=>{
        window.scrollTo(0, 0);
        trackPageView('shelf');
    }, [
        trackPageView
    ]);
    const handleBack = ()=>{
        navigate('/');
        setTimeout(()=>{
            const el = document.getElementById('shelf');
            if (el) el.scrollIntoView({
                behavior: 'smooth'
            });
        }, 100);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-cream-100",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "sticky top-0 z-10 bg-cream-100/90 backdrop-blur-sm border-b border-border-light",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "max-w-3xl mx-auto px-6 h-14 flex items-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: handleBack,
                        className: "flex items-center gap-2 text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$8afed21ef5c2afa5), {
                                className: "w-4 h-4"
                            }),
                            "Back"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-3xl mx-auto px-6 py-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                        className: "font-serif text-4xl text-charcoal-900 mb-12",
                        children: [
                            "My ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                className: "italic-emphasis",
                                children: "shelf"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "mb-14",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "font-serif text-2xl text-charcoal-900 mb-6",
                                children: [
                                    "Bookshelf ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-charcoal-400 font-sans text-lg font-normal",
                                        children: [
                                            "(",
                                            books.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-3 list-disc list-inside",
                                children: books.map((book)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        className: "text-charcoal-700 text-base leading-relaxed",
                                        children: [
                                            book.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: book.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-coral-600 hover:underline",
                                                children: book.title
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-charcoal-900",
                                                children: book.title
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-charcoal-500",
                                                children: [
                                                    " by ",
                                                    book.author
                                                ]
                                            })
                                        ]
                                    }, book.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "font-serif text-2xl text-charcoal-900 mb-6",
                                children: [
                                    "Papershelf ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-charcoal-400 font-sans text-lg font-normal",
                                        children: [
                                            "(",
                                            papers.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "space-y-3 list-disc list-inside",
                                children: papers.map((paper)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        className: "text-charcoal-700 text-base leading-relaxed",
                                        children: [
                                            paper.url ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                                href: paper.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-coral-600 hover:underline",
                                                children: paper.title
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-charcoal-900",
                                                children: paper.title
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-charcoal-500",
                                                children: [
                                                    " by ",
                                                    paper.authors
                                                ]
                                            }),
                                            paper.venue && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-charcoal-400 text-sm",
                                                children: [
                                                    " \xb7 ",
                                                    paper.venue
                                                ]
                                            })
                                        ]
                                    }, paper.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9028fc189c229d5b$export$2e2bcd8739ae039 = $9028fc189c229d5b$var$Shelf;




parcelRequire("acw62");



const $d5c7001fb908dd0e$var$Footer = ()=>{
    const { trackSocialClick: trackSocialClick, trackContactInteraction: trackContactInteraction } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    const currentYear = new Date().getFullYear();
    const handleSocialClick = (platform, url)=>{
        trackSocialClick(`footer_${platform}`, url);
    };
    const handleEmailClick = ()=>{
        trackContactInteraction('footer_email', (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email);
    };
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const socialLinks = [
        {
            name: 'GitHub',
            icon: (0, $87fac848458df235$export$1e450c42b77127b1),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks?.github
        },
        {
            name: 'LinkedIn',
            icon: (0, $87fac848458df235$export$3b889a6533231d2c),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks?.linkedin
        },
        {
            name: 'Twitter',
            icon: (0, $87fac848458df235$export$9a9e0252a352cccf),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks?.twitter
        },
        {
            name: 'Medium',
            icon: (0, $87fac848458df235$export$6af071b6f7c332ac),
            url: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks?.medium
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "bg-white border-t border-border-light pt-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "container py-20 px-6 md:px-8 lg:px-12",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "grid md:grid-cols-2 lg:grid-cols-4 gap-12  pb-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "lg:col-span-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-10 h-10 bg-coral-500 rounded-full flex items-center justify-center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-white font-semibold",
                                                children: "M"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-serif text-xl text-charcoal-900",
                                            children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-charcoal-600 mb-6 max-w-md",
                                    children: "Software Engineer building scalable mobile and web applications. Let's build something together."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex items-center gap-3",
                                    children: socialLinks.map(({ name: name, icon: Icon, url: url })=>url && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: ()=>handleSocialClick(name.toLowerCase(), url),
                                            className: "w-10 h-10 flex items-center justify-center rounded-full bg-cream-100 text-charcoal-600 hover:bg-coral-50 hover:text-coral-600 transition-all duration-200",
                                            "aria-label": name,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                                className: "w-4 h-4"
                                            })
                                        }, name))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "font-serif text-lg text-charcoal-900 mb-4",
                                    children: "Quick Links"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                                    className: "space-y-3",
                                    children: [
                                        'About',
                                        'Work',
                                        'Experience',
                                        'Education',
                                        'Blog'
                                    ].map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: `#${item.toLowerCase()}`,
                                            className: "block text-charcoal-600 hover:text-coral-600 transition-colors",
                                            children: item
                                        }, item))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                    className: "font-serif text-lg text-charcoal-900 mb-4",
                                    children: "Get in Touch"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                            href: `mailto:${(0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email}`,
                                            onClick: handleEmailClick,
                                            className: "flex items-center gap-2 text-charcoal-600 hover:text-coral-600 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                    className: "w-4 h-4",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        strokeWidth: 1.5,
                                                        d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex items-center gap-2 text-charcoal-500",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                    className: "w-4 h-4",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 1.5,
                                                            d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            strokeWidth: 1.5,
                                                            d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-sm",
                                                    children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.location
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "border-t border-border-light",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "container py-8 px-6 md:px-8 lg:px-12",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col md:flex-row justify-between items-center gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-sm text-charcoal-500",
                                children: [
                                    "\xa9 ",
                                    currentYear,
                                    " ",
                                    (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.name,
                                    ". All rights reserved."
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-sm text-charcoal-500 flex items-center gap-1",
                                        children: [
                                            "Made with",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: "/gif/beating_heart.gif",
                                                alt: "love",
                                                className: "w-5 h-4",
                                                onError: (e)=>{
                                                    e.target.style.display = 'none';
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: scrollToTop,
                                        className: "w-9 h-9 flex items-center justify-center rounded-full bg-cream-100 text-charcoal-600 hover:bg-coral-50 hover:text-coral-600 transition-all duration-200",
                                        "aria-label": "Scroll to top",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                            className: "w-4 h-4",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            stroke: "currentColor",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: 2,
                                                d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $d5c7001fb908dd0e$export$2e2bcd8739ae039 = $d5c7001fb908dd0e$var$Footer;






// Blog Detail Route Component
const $4c8cda5d2c6d1d8b$var$BlogDetailRoute = ()=>{
    const { slug: slug } = (0, $ee6d600502474136$export$99eaa27ddbbb95ef)();
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const { restoreScrollPosition: restoreScrollPosition } = (0, $5999fc9953960d3a$export$2e2bcd8739ae039)();
    const handleClose = ()=>{
        navigate('/');
        // Restore scroll position after navigation with a slight delay
        setTimeout(()=>{
            restoreScrollPosition('homepage', {
                behavior: 'auto',
                fallbackSelector: '#blog',
                delay: 50 // Additional delay to ensure DOM is ready
            });
        }, 100);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $342ef3d50c583ce5$export$2e2bcd8739ae039), {
        slug: slug,
        onClose: handleClose
    });
};
// Project Detail Route Component
const $4c8cda5d2c6d1d8b$var$ProjectDetailRoute = ()=>{
    const { id: id } = (0, $ee6d600502474136$export$99eaa27ddbbb95ef)();
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    // Find project by id
    const project = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).projects.find((p)=>p.id === parseInt(id));
    const handleClose = ()=>{
        navigate('/');
        // Scroll to projects section after navigation
        setTimeout(()=>{
            const projectsSection = document.getElementById('work');
            if (projectsSection) projectsSection.scrollIntoView({
                behavior: 'smooth'
            });
        }, 100);
    };
    // If project not found, redirect to home
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (id && !project) navigate('/', {
            replace: true
        });
    }, [
        id,
        project,
        navigate
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b63760bb348a45ad$export$2e2bcd8739ae039), {
        project: project,
        onClose: handleClose
    });
};
// Main Portfolio Component
const $4c8cda5d2c6d1d8b$var$Portfolio = ()=>{
    const [currentPage, setCurrentPage] = (0, $acw62.useState)('intro');
    const navigate = (0, $ee6d600502474136$export$9770f232ac06a008)();
    const { posthog: posthog } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
    const { saveScrollPosition: saveScrollPosition } = (0, $5999fc9953960d3a$export$2e2bcd8739ae039)();
    // Development testing - check PostHog initialization
    (0, $acw62.useEffect)(()=>{}, [
        posthog
    ]);
    const navigateToPage = (pageId)=>{
        setCurrentPage(pageId);
    };
    // Scroll-based active section detection
    (0, $acw62.useEffect)(()=>{
        const sections = [
            'intro',
            'about',
            'work',
            'experience',
            'stack',
            'education',
            'blog',
            'shelf',
            'contact'
        ];
        const updateActiveSection = ()=>{
            const scrollPosition = window.scrollY + 80; // Account for navbar height
            let activeSection = sections[0]; // Default to first section
            // Find the section that contains the current scroll position
            for(let i = 0; i < sections.length; i++){
                const element = document.getElementById(sections[i]);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    const elementTop = rect.top + window.scrollY;
                    // If we're past this section's start, it could be active
                    if (scrollPosition >= elementTop) activeSection = sections[i];
                    else break;
                }
            }
            setCurrentPage(activeSection);
        };
        // Debounced scroll handler to prevent excessive updates
        let timeoutId = null;
        const handleScroll = ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(updateActiveSection, 10);
        };
        // Add scroll listener
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        // Initial check
        updateActiveSection();
        return ()=>{
            window.removeEventListener('scroll', handleScroll);
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    const openBlogDetail = (blogSlug)=>{
        // Save current scroll position before navigating
        saveScrollPosition('homepage');
        // Navigation only - blog view tracking happens in BlogDetail component
        navigate(`/blogs/${blogSlug}`);
    };
    // Work Section Component
    const WorkSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        const featuredProjects = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).projects.filter((p)=>p.featured);
        const otherProjects = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).projects.filter((p)=>!p.featured);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "section relative overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute top-40 -right-40 w-[500px] h-[500px] gradient-blob gradient-blob-coral opacity-20"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "container relative z-10",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "section-heading text-charcoal-900 mb-12",
                            children: [
                                "Selected ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    className: "italic-emphasis",
                                    children: "work"
                                })
                            ]
                        }),
                        featuredProjects.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-8",
                            children: featuredProjects.map((project)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c9bf90e29a13b0d$export$2e2bcd8739ae039), {
                                    project: project,
                                    featured: true
                                }, project.id))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid md:grid-cols-2 lg:grid-cols-3 gap-6",
                            children: otherProjects.map((project)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c9bf90e29a13b0d$export$2e2bcd8739ae039), {
                                    project: project
                                }, project.id))
                        })
                    ]
                })
            ]
        });
    });
    // Experience Section Component
    const ExperienceSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
            className: "section bg-white",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "section-heading text-charcoal-900 mb-12",
                        children: [
                            "Work ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                className: "italic-emphasis",
                                children: "experience"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "absolute left-3 top-0 bottom-0 w-px bg-border-light hidden md:block"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "space-y-8",
                                children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).workExperience.map((job, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "relative flex gap-8",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "hidden md:flex flex-col items-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-6 h-6 bg-coral-500 rounded-full flex items-center justify-center z-10",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "w-2 h-2 bg-white rounded-full"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex-1 bg-cream-50 rounded-2xl p-6 md:p-8 border border-border-light hover:shadow-card transition-all duration-300",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                        className: "font-serif text-xl text-charcoal-900",
                                                                        children: job.position
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-coral-600 font-medium",
                                                                        children: job.company
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "text-sm text-charcoal-500",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "font-medium",
                                                                        children: job.duration
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        children: job.location
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-charcoal-600 mb-4",
                                                        children: job.description
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                className: "text-sm font-medium text-charcoal-900 mb-2",
                                                                children: "Key Achievements"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                className: "space-y-1",
                                                                children: job.achievements.slice(0, 5).map((achievement, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                        className: "flex items-start gap-2 text-sm text-charcoal-600",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                className: "w-1 h-1 bg-coral-400 rounded-full mt-2 flex-shrink-0"
                                                                            }),
                                                                            achievement
                                                                        ]
                                                                    }, i))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex flex-wrap gap-2",
                                                        children: job.technologies.map((tech, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "px-2.5 py-1 bg-white text-xs text-charcoal-600 rounded-full border border-border-light",
                                                                children: tech
                                                            }, i))
                                                    })
                                                ]
                                            })
                                        ]
                                    }, job.id))
                            })
                        ]
                    })
                ]
            })
        });
    });
    // Tech Stack Section Component
    const TechStackSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        const getTechConfig = (skill)=>{
            const techMap = {
                'Flutter': {
                    icon: (0, $87fac848458df235$export$1c8a36276cc546bb),
                    hasOwnColors: true
                },
                'ReactJS': {
                    icon: (0, $87fac848458df235$export$5bee1749c5489db9),
                    hasOwnColors: false
                },
                'HTML': {
                    icon: (0, $87fac848458df235$export$72cfa1900d921686),
                    hasOwnColors: false
                },
                'CSS': {
                    icon: (0, $87fac848458df235$export$85fe877eee1aed33),
                    hasOwnColors: false
                },
                'Git': {
                    icon: (0, $87fac848458df235$export$664fa484b9ce23b6),
                    hasOwnColors: false
                },
                'FastAPI': {
                    icon: (0, $87fac848458df235$export$d83b1b07e955b386),
                    hasOwnColors: false
                },
                'Firebase': {
                    icon: (0, $87fac848458df235$export$32aa0ab441834671),
                    hasOwnColors: true
                },
                'MongoDB': {
                    icon: (0, $87fac848458df235$export$7dbf5e59bc7d2ee0),
                    hasOwnColors: false
                }
            };
            return techMap[skill] || {
                icon: (0, $87fac848458df235$export$5bee1749c5489db9),
                hasOwnColors: false
            };
        };
        // Group skills by category
        const groupedSkills = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).stack.reduce((acc, tech)=>{
            const category = tech.category || 'Other';
            if (!acc[category]) acc[category] = [];
            acc[category].push(tech);
            return acc;
        }, {});
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "section relative overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute -bottom-20 -left-40 w-[400px] h-[400px] gradient-blob gradient-blob-peach opacity-30"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "container relative z-10",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                            className: "section-heading text-charcoal-900 mb-12",
                            children: [
                                "Tech ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                    className: "italic-emphasis",
                                    children: "stack"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "grid grid-cols-2 gap-3 md:hidden",
                            children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).stack.map((tech, index)=>{
                                const techConfig = getTechConfig(tech.name);
                                const IconComponent = techConfig.icon;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "bg-white border border-border-light rounded-xl p-4 flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-10 h-10 bg-cream-100 rounded-lg flex items-center justify-center shrink-0",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconComponent, {
                                                className: "w-6 h-6"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-sm font-medium text-charcoal-900",
                                            children: tech.name
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-4",
                            children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).stack.map((tech, index)=>{
                                const techConfig = getTechConfig(tech.name);
                                const IconComponent = techConfig.icon;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "group bg-white border border-border-light rounded-xl p-5 hover:shadow-card hover:-translate-y-1 transition-all duration-300",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "w-12 h-12 bg-cream-100 rounded-xl flex items-center justify-center group-hover:bg-coral-50 transition-all duration-300",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconComponent, {
                                                    className: "w-7 h-7 transition-transform duration-300 group-hover:rotate-12"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-medium text-charcoal-900",
                                                        children: tech.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-charcoal-500",
                                                        children: tech.category
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            ]
        });
    });
    // Education Section Component
    const EducationSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
            className: "section bg-white",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "section-heading text-charcoal-900 mb-12",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                            className: "italic-emphasis",
                            children: "Education"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "space-y-8",
                        children: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).education.map((edu)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-cream-50 rounded-2xl p-6 md:p-8 border border-border-light hover:shadow-card transition-all duration-300",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-serif text-xl text-charcoal-900",
                                                        children: edu.degree
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-coral-600 font-medium",
                                                        children: edu.institution
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-sm text-charcoal-500 md:text-right",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "font-medium",
                                                        children: edu.duration
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            edu.location,
                                                            " \u2022 ",
                                                            edu.grade
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-full h-px bg-gradient-to-r from-transparent via-border-light to-transparent mb-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-charcoal-600 mb-4",
                                        children: edu.description
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "text-sm font-medium text-charcoal-900 mb-2",
                                                children: "Achievements"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "space-y-1",
                                                children: edu.achievements.map((achievement, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                        className: "flex items-start gap-2 text-sm text-charcoal-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "w-1 h-1 bg-coral-400 rounded-full mt-2 flex-shrink-0"
                                                            }),
                                                            achievement
                                                        ]
                                                    }, index))
                                            })
                                        ]
                                    })
                                ]
                            }, edu.id))
                    })
                ]
            })
        });
    });
    // Blog Section Component
    const BlogSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        const blogPosts = (0, $6b28091c93789046$export$facabe505213462b).getRecentPosts(4);
        const { viewCounts: viewCounts, loading: viewCountsLoading } = (0, $d4d0c408c580b9ca$export$49ebdf47eb43791a)();
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
            className: "section bg-white",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "section-heading text-charcoal-900",
                                children: [
                                    "Latest ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                        className: "italic-emphasis",
                                        children: "articles"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "text-sm text-charcoal-500",
                                children: [
                                    (0, $6b28091c93789046$export$facabe505213462b).getAllPosts().length,
                                    " articles"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid md:grid-cols-2 gap-6",
                        children: blogPosts.map((post)=>{
                            const category = (0, $6b28091c93789046$export$facabe505213462b).getCategoryById(post.category);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("article", {
                                className: "group cursor-pointer bg-cream-50 border border-border-light rounded-2xl overflow-hidden hover:shadow-card hover:-translate-y-1 transition-all duration-300",
                                onClick: ()=>openBlogDetail(post.slug),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "aspect-[16/9] overflow-hidden bg-cream-100",
                                        children: post.image ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: post.image,
                                            alt: post.title,
                                            className: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-full h-full flex items-center justify-center bg-gradient-to-br from-coral-100 to-cream-200",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-serif text-3xl text-coral-400",
                                                children: post.title.split(' ').map((word)=>word[0]).join('').slice(0, 2)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "p-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-3 mb-3",
                                                children: [
                                                    category && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "px-2.5 py-1 bg-coral-50 text-coral-600 text-xs font-medium rounded-full",
                                                        children: category.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-charcoal-400 text-xs",
                                                        children: post.readTime
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "font-serif text-xl text-charcoal-900 mb-2 group-hover:text-coral-600 transition-colors line-clamp-2",
                                                children: post.title
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-charcoal-600 text-sm mb-4 line-clamp-2",
                                                children: post.excerpt
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center justify-between text-xs text-charcoal-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: new Date(post.publishedAt).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "flex items-center gap-1",
                                                        children: viewCountsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "animate-pulse",
                                                            children: "..."
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87fac848458df235$export$4b2c798a70974642), {
                                                                    className: "w-3 h-3"
                                                                }),
                                                                (viewCounts[post.slug] !== undefined ? viewCounts[post.slug] : post.views)?.toLocaleString()
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, post.id);
                        })
                    })
                ]
            })
        });
    });
    // Shelf Section Component
    const ShelfSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        const previewBooks = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).shelf.books.slice(0, 3);
        const total = (0, $019513e9c48f5471$export$91bfd9bdbb33b473).shelf.books.length + (0, $019513e9c48f5471$export$91bfd9bdbb33b473).shelf.papers.length;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
            className: "section bg-white",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "section-heading text-charcoal-900 mb-6",
                        children: [
                            "My ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                className: "italic-emphasis",
                                children: "shelf"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        className: "space-y-0 mb-8",
                        children: previewBooks.map((book, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                className: `py-5 ${i < previewBooks.length - 1 ? 'border-b border-border-light' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "font-serif text-lg text-charcoal-900",
                                        children: book.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-charcoal-500 mt-0.5",
                                        children: book.author
                                    })
                                ]
                            }, book.id))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>{
                            saveScrollPosition('homepage');
                            navigate('/shelf');
                        },
                        className: "flex items-center gap-2 text-sm font-medium text-charcoal-600 hover:text-coral-600 transition-colors group",
                        children: [
                            "Browse the full shelf",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                className: "w-4 h-4 group-hover:translate-x-0.5 transition-transform",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                strokeWidth: 2,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    });
    // Contact Section Component
    const ContactSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(()=>{
        const { trackContactInteraction: trackContactInteraction, trackSocialClick: trackSocialClick } = (0, $d42f71309343a94b$export$2e2bcd8739ae039)();
        const handleEmailClick = ()=>{
            trackContactInteraction('email_contact', (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email);
        };
        const handleLinkedInClick = ()=>{
            trackSocialClick('linkedin_contact', (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks.linkedin);
        };
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
            className: "section relative overflow-hidden",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute top-0 left-1/4 w-[400px] h-[400px] gradient-blob gradient-blob-coral opacity-20"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "absolute bottom-0 right-1/4 w-[300px] h-[300px] gradient-blob gradient-blob-peach opacity-30"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "container relative z-10",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "max-w-2xl mx-auto text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-display text-charcoal-900 mb-6",
                                children: [
                                    "Let's ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                        className: "italic-emphasis",
                                        children: "connect"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-lg text-charcoal-600 mb-10",
                                children: "I'm always open to interesting opportunities and projects. If you think we'd work well together, I'd love to hear from you."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row gap-4 justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: `mailto:${(0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.email}`,
                                        onClick: handleEmailClick,
                                        className: "btn-primary",
                                        children: [
                                            "Get In Touch",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                className: "w-4 h-4",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                stroke: "currentColor",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M14 5l7 7m0 0l-7 7m7-7H3"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                        href: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo.socialLinks.linkedin,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        onClick: handleLinkedInClick,
                                        className: "btn-secondary",
                                        children: "Connect on LinkedIn"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    });
    // Define sections for sticky navigation
    const sections = [
        'intro',
        'about',
        'work',
        'experience',
        'stack',
        'education',
        'blog',
        'shelf',
        'contact'
    ];
    // Removed hero parallax for clean scrolling experience
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-cream-100 text-charcoal-900 relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38859a0fd15e9552$export$2e2bcd8739ae039), {
                currentPage: currentPage,
                navigateToPage: navigateToPage,
                personalInfo: (0, $019513e9c48f5471$export$91bfd9bdbb33b473).personalInfo
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "relative z-10",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "intro",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55e366559c5db4f9$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "about",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $547dcd7931d7675a$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "work",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(WorkSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "experience",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ExperienceSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "education",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(EducationSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "stack",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TechStackSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "blog",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BlogSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "shelf",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ShelfSection, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        id: "contact",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ContactSection, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d5c7001fb908dd0e$export$2e2bcd8739ae039), {})
        ]
    });
};
// Main App Component with Routing
function $4c8cda5d2c6d1d8b$var$App() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6d600502474136$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ee6d600502474136$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6d600502474136$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4c8cda5d2c6d1d8b$var$Portfolio, {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6d600502474136$export$e7b0ac011bb776c6), {
                    path: "/projects/:id",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4c8cda5d2c6d1d8b$var$ProjectDetailRoute, {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6d600502474136$export$e7b0ac011bb776c6), {
                    path: "/blogs/:slug",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4c8cda5d2c6d1d8b$var$BlogDetailRoute, {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6d600502474136$export$e7b0ac011bb776c6), {
                    path: "/shelf",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9028fc189c229d5b$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee6d600502474136$export$e7b0ac011bb776c6), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ec3ac4fc62c3a07$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;



const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root'));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c76f8c8d12a9d64a$export$4d1dc63dbef5194f), {
        apiKey: "phc_jL63jBEuP8FPcYjP0GqOfK74hwj6aqfUJ7JIfAthiNx",
        options: {
            api_host: "https://us.i.posthog.com",
            ui_host: 'https://us.posthog.com',
            defaults: '2026-05-30',
            person_profiles: 'identified_only',
            capture_pageviews: true,
            capture_pageleaves: true,
            autocapture: true,
            capture_exceptions: true,
            debug: false,
            loaded: (posthog)=>{}
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=repo.7dea08cc.js.map
